(function () {
  const arreglo = [
    {
      anio: 2018,
      fila_archivo: 2,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/26/2018",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-26",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 3,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/26/2018",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-26",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 4,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/26/2018",
      mes_fecha: 11,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-26",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 6,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "JESUS MARIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/9/2018",
      mes_fecha: 2,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-09",
      anio_mes: "2018-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 7,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/30/2018",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-30",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 9,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/21/2018",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-21",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 11,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/3/2018",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-03",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "15/03/2018",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 12,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/16/2018",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-16",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 15,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/22/2018",
      mes_fecha: 10,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-22",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 17,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/3/2018",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-03",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "14/06/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 19,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/29/2018",
      mes_fecha: 8,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-29",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 20,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/2/2018",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-02",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 21,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/2/2018",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-02",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "02/02/2005",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 22,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/2/2018",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-02",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 23,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "PABERLLON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/21/2018",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-21",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "23/04/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 25,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/26/2018",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-26",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 26,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/2/2018",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-02",
      anio_mes: "2018-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 27,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/2/2018",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-02",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "27/03/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 28,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/22/2018",
      mes_fecha: 10,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-22",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "23/04/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 29,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/22/2018",
      mes_fecha: 10,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-22",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "01/04/2018",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 30,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/22/2018",
      mes_fecha: 10,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-22",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "23/04/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 33,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "EL LLANO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/4/2018",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-04",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 34,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/22/2018",
      mes_fecha: 10,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-22",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 35,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/22/2018",
      mes_fecha: 10,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-22",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 36,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/7/2018",
      mes_fecha: 12,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-07",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 37,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/17/2018",
      mes_fecha: 5,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-17",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 38,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/17/2018",
      mes_fecha: 5,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-17",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 39,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/17/2018",
      mes_fecha: 5,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-17",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 40,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/17/2018",
      mes_fecha: 5,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-17",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 42,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/29/2018",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-29",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "01/01/2017",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 44,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/24/2018",
      mes_fecha: 9,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-24",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 45,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/13/2018",
      mes_fecha: 9,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-13",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 46,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/12/2018",
      mes_fecha: 11,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-12",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 48,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/29/2018",
      mes_fecha: 8,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-29",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 50,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "SAN FRANSCO DE LOS ROMO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/14/2018",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-14",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 51,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "SAN FRANSCO DE LOS ROMO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/4/2018",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-04",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "31/08/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 54,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/27/2018",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-27",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 57,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/12/2018",
      mes_fecha: 11,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-12",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 60,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/25/2018",
      mes_fecha: 12,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-25",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 62,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/15/2018",
      mes_fecha: 10,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-15",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 63,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "CALVILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/12/2018",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-12",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 64,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/10/2018",
      mes_fecha: 5,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-10",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "16/04/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 65,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "JESUS MARIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/17/2018",
      mes_fecha: 5,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-17",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06/04/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 66,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/2/2018",
      mes_fecha: 10,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-02",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 70,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/21/2018",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-21",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 74,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/19/2018",
      mes_fecha: 4,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-19",
      anio_mes: "2018-04",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/2/2016",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 75,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/16/2018",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-16",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 77,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/2/2018",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-02",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 78,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/12/2018",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-12",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 79,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/15/2018",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-15",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 80,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TECATE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/17/2018",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-17",
      anio_mes: "2018-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 82,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/18/2018",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-18",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 83,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/8/2018",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-08",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 88,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/27/2018",
      mes_fecha: 7,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-27",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 90,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/13/2018",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-13",
      anio_mes: "2018-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "1/26/2012",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 93,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/9/2018",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-09",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/13/2018",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 94,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/15/2018",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-15",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 95,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/2/2018",
      mes_fecha: 10,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-02",
      anio_mes: "2018-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 96,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/14/2018",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-14",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 100,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/27/2018",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-27",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 101,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/9/2018",
      mes_fecha: 1,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-09",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 102,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/11/2018",
      mes_fecha: 12,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-11",
      anio_mes: "2018-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/12/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 103,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/28/2018",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-28",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 105,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/13/2018",
      mes_fecha: 12,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-13",
      anio_mes: "2018-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/22/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 107,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/12/2018",
      mes_fecha: 1,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-12",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 108,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/30/2018",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-30",
      anio_mes: "2018-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 109,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/17/2018",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-17",
      anio_mes: "2018-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 110,
      edad: "55",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/24/2018",
      mes_fecha: 5,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-24",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 112,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/31/2018",
      mes_fecha: 5,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-31",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 116,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/27/2018",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-27",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 118,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/14/2018",
      mes_fecha: 11,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-14",
      anio_mes: "2018-11",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "8/14/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 121,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/11/2018",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-11",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 124,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "PLAYAS DE ROSARITO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/7/2018",
      mes_fecha: 6,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-07",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 6,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 126,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/26/2018",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-26",
      anio_mes: "2018-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 127,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/20/2018",
      mes_fecha: 12,
      dia_fecha: 20,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-20",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/5/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 129,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/12/2018",
      mes_fecha: 1,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-12",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 130,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/30/2018",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-30",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 131,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/13/2018",
      mes_fecha: 12,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-13",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "6/1/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 132,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/25/2018",
      mes_fecha: 1,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-25",
      anio_mes: "2018-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 133,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/18/2018",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-18",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 134,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/10/2018",
      mes_fecha: 10,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-10",
      anio_mes: "2018-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 136,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/22/2018",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-22",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 137,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/6/2018",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-06",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 138,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/14/2018",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-14",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 139,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/21/2018",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-21",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 140,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "PLAYAS DE ROSARITO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/10/2019",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-10",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 141,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/6/2018",
      mes_fecha: 12,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-06",
      anio_mes: "2018-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/21/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 143,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/26/2018",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-26",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 146,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/15/2018",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-15",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 147,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/22/2018",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-22",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 148,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/19/2018",
      mes_fecha: 11,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-19",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 149,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/1/2018",
      mes_fecha: 2,
      dia_fecha: 1,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-01",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 152,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/3/2018",
      mes_fecha: 12,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-03",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 154,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/28/2018",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-28",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 156,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/23/2018",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-23",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 158,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/26/2018",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-26",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 159,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/11/2018",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-11",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 160,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/29/2018",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-29",
      anio_mes: "2018-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 162,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/7/2018",
      mes_fecha: 6,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-07",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "5/24/2018",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 164,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CHAMPOTON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/22/2018",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-22",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 166,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "ESCARCEGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/9/2018",
      mes_fecha: 1,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-09",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 173,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/10/2018",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-10",
      anio_mes: "2018-07",
      institucion_notificacion: 7,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "03/08/2016",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 179,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/10/2018",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-10",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 181,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLAFLORES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/23/2018",
      mes_fecha: 11,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-23",
      anio_mes: "2018-11",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/1/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 182,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "PIJIJIAPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/21/2018",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-21",
      anio_mes: "2018-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 183,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SUCHIAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/24/2018",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-24",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 184,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SUCHIAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/24/2018",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-24",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 185,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COMITAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/17/2018",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-17",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 187,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CACAHOATAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/19/2018",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-19",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 188,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUZANTAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/5/2018",
      mes_fecha: 6,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-05",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "10/26/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 190,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/12/2018",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-12",
      anio_mes: "2018-09",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 192,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/18/2018",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-18",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 6,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 193,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TAPACHULA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/16/2018",
      mes_fecha: 7,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-16",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 195,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOZOCUAUTLA DE ESPINOSA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/23/2018",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-23",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 197,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MARGARITAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/1/2018",
      mes_fecha: 10,
      dia_fecha: 1,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-01",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 200,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COMITAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/2/2018",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-02",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 201,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/19/2018",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-19",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 202,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LA CONCORDIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/5/2018",
      mes_fecha: 9,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-05",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 203,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/19/2018",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-19",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 208,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MARGARITAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/3/2018",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-03",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 209,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/2/2018",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-02",
      anio_mes: "2018-07",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/11/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 213,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COMITAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/14/2018",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-14",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 215,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TAPACHULA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/27/2018",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-27",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 216,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/2/2018",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-02",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 218,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ACAPETAHUA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/8/2018",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-08",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 233,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/21/2018",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-21",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 251,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/4/2018",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-04",
      anio_mes: "2018-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 252,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/15/2018",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-15",
      anio_mes: "2018-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 258,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/18/2018",
      mes_fecha: 1,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-18",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 262,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CARICHI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/13/2018",
      mes_fecha: 4,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-13",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 266,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/21/2018",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-21",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 274,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/20/2019",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-20",
      anio_mes: "2019-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 296,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/17/2018",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-17",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 304,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/14/2018",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-14",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 306,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/24/2018",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-24",
      anio_mes: "2018-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 311,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/16/2018",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-16",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 315,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/23/2018",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-23",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 316,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ARTEAGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/11/2018",
      mes_fecha: 12,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-11",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 320,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/8/2018",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-08",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 321,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/6/2018",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-06",
      anio_mes: "2018-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 325,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/30/2018",
      mes_fecha: 3,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-30",
      anio_mes: "2018-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 326,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/27/2018",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-27",
      anio_mes: "2018-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "02/03/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 327,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/17/2018",
      mes_fecha: 5,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-17",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 328,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/11/2018",
      mes_fecha: 12,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-11",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 329,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ARTEAGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/3/2019",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-03",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 330,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/18/2018",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-18",
      anio_mes: "2018-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 332,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/7/2019",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-07",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "04/09/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 336,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/12/2018",
      mes_fecha: 1,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-12",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 338,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ALLENDE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/20/2018",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-20",
      anio_mes: "2018-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 344,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/31/2018",
      mes_fecha: 5,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-31",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 345,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/6/2018",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-06",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 347,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/7/2018",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-07",
      anio_mes: "2018-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 349,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/7/2018",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-07",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 353,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/5/2018",
      mes_fecha: 1,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-05",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 357,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/1/2018",
      mes_fecha: 2,
      dia_fecha: 1,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-01",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 358,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/13/2018",
      mes_fecha: 4,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-13",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 359,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/24/2019",
      mes_fecha: 9,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-24",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 361,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "RAMOS ARIZPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/10/2018",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-10",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 363,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/4/2018",
      mes_fecha: 1,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-04",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 364,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "RAMOS ARIZPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/21/2018",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-21",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 365,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/8/2019",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-08",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 366,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "FRONTERA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/27/2018",
      mes_fecha: 4,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-27",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 369,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SAN PEDRO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/8/2019",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-08",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 374,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COLIMA",
      municipio_residencia: "VILLA DE ALVAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/22/2018",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-22",
      anio_mes: "2018-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 377,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/6/2018",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-06",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 379,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COLIMA",
      municipio_residencia: "TECOMÁN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/19/2018",
      mes_fecha: 4,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-19",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 382,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/27/2018",
      mes_fecha: 7,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-27",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/2/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 384,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MAGDALENA CONTRERAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/12/2018",
      mes_fecha: 12,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-12",
      anio_mes: "2018-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 388,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/10/2018",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-10",
      anio_mes: "2018-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/17/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 389,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/4/2018",
      mes_fecha: 7,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-04",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/14/2018",
      tipo_vacuna: "2",
      complicaciones: 6,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 390,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/27/2018",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-27",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/16/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 392,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/13/2018",
      mes_fecha: 9,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-13",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "IGN",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 395,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/7/2018",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-07",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/19/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 396,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/13/2018",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-13",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "NO RECUERDA FECHA",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 397,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/3/2018",
      mes_fecha: 12,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-03",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 400,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/2/2018",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-02",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/6/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 402,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/22/2018",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-22",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 404,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/24/2018",
      mes_fecha: 8,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-24",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 405,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/30/2018",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-30",
      anio_mes: "2018-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 406,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/15/2018",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-15",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 407,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/4/2018",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-04",
      anio_mes: "2018-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/23/2018",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 408,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/14/2018",
      mes_fecha: 10,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-14",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 410,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/15/2018",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-15",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/18/2018",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 413,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/19/2018",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-19",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 414,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/2/2018",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-02",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 416,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/18/2018",
      mes_fecha: 5,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-18",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 417,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/17/2018",
      mes_fecha: 12,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-17",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 419,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MILPA ALTA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/4/2018",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-04",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/26/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 420,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/20/2018",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-20",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 421,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/8/2018",
      mes_fecha: 3,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-08",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 422,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/14/2018",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-14",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 427,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/24/2018",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-24",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/28/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 428,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MAGDALENA CONTRERAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/16/2018",
      mes_fecha: 10,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-16",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 430,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/6/2018",
      mes_fecha: 4,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-06",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/7/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 433,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/6/2018",
      mes_fecha: 11,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-06",
      anio_mes: "2018-11",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/4/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 434,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/4/2018",
      mes_fecha: 5,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-04",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/16/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 436,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/11/2018",
      mes_fecha: 12,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-11",
      anio_mes: "2018-12",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/28/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 439,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/28/2018",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-28",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/26/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 440,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/18/2018",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-18",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/20/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 441,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/3/2018",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-03",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 448,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/12/2018",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-12",
      anio_mes: "2018-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/20/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 455,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/9/2018",
      mes_fecha: 10,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-09",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 459,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/13/2018",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-13",
      anio_mes: "2018-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 462,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MAGDALENA CONTRERAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/15/2018",
      mes_fecha: 8,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-15",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 464,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/18/2018",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-18",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/9/2018",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 467,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/15/2018",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-15",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 471,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/13/2018",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-13",
      anio_mes: "2018-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/13/2005",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 472,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/26/2018",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-26",
      anio_mes: "2018-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 474,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/18/2018",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-18",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 475,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLAHUAC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/18/2018",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-18",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/25/2016",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 477,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/13/2018",
      mes_fecha: 7,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-13",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "IGN",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 479,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/24/2018",
      mes_fecha: 12,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-24",
      anio_mes: "2018-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/14/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 480,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/18/2018",
      mes_fecha: 5,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-18",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 481,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/10/2018",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-10",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/16/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 483,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/13/2018",
      mes_fecha: 12,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-13",
      anio_mes: "2018-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/18/1970",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 485,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/11/2018",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-11",
      anio_mes: "2018-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 490,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/3/2018",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-03",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 491,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/19/2018",
      mes_fecha: 1,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-19",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/31/2016",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 492,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLAHUAC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/12/2018",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-12",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/14/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 493,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/10/2018",
      mes_fecha: 8,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-10",
      anio_mes: "2018-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 497,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/8/2018",
      mes_fecha: 11,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-08",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 498,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/4/2018",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-04",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 499,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/4/2018",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-04",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 500,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/11/2018",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-11",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 501,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/23/2018",
      mes_fecha: 11,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-23",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 502,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2018",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-23",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 505,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2018",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-23",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 509,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "VICENTE GUERRERO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/30/2018",
      mes_fecha: 10,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-30",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "6/1/2018",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 510,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/9/2018",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-09",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "3/15/2018",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 511,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/6/2018",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-06",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "3/15/2018",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 512,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/2/2018",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-02",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "9",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 513,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/9/2018",
      mes_fecha: 10,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-09",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/27/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 514,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "MEZQUITAL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/17/2018",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-17",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "9",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 518,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "SANTIAGO PAPASQUIARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/27/2018",
      mes_fecha: 9,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-27",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "9",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 520,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GOMEZ PALACIO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/14/2018",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-14",
      anio_mes: "2018-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 522,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GOMEZ PALACIO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/22/2018",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-22",
      anio_mes: "2018-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 524,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/5/2018",
      mes_fecha: 11,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-05",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/9/2018",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 525,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/6/2018",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-06",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 526,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "PUEBLO NUEVO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/2/2018",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-02",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "9",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 528,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/12/2018",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-12",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/7/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 539,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/16/2018",
      mes_fecha: 10,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-16",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 540,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/18/2018",
      mes_fecha: 10,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-18",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 545,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/9/2018",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-09",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 546,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/27/2018",
      mes_fecha: 4,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-27",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 549,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/31/2018",
      mes_fecha: 10,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-31",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 551,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/17/2018",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-17",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 555,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "COMONFORT",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/19/2018",
      mes_fecha: 4,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-19",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 3,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 556,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "COMONFORT",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/3/2018",
      mes_fecha: 8,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-03",
      anio_mes: "2018-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 561,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/13/2018",
      mes_fecha: 12,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-13",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 562,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/29/2018",
      mes_fecha: 6,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-29",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 564,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ROMITA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/11/2018",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-11",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "19/01/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 566,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/8/2018",
      mes_fecha: 12,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-08",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 568,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/7/2018",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-07",
      anio_mes: "2018-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/21/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 571,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/24/2018",
      mes_fecha: 9,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-24",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/1/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 572,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/5/2018",
      mes_fecha: 11,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-05",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 584,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "URIANGATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/29/2018",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-29",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 585,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALAMANCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/15/2018",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-15",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 586,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/11/2018",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-11",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 587,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/27/2018",
      mes_fecha: 7,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-27",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 591,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/24/2018",
      mes_fecha: 8,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-24",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 592,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/9/2018",
      mes_fecha: 8,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-09",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 598,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CORTAZAR",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/12/2018",
      mes_fecha: 4,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-12",
      anio_mes: "2018-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 613,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/10/2019",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-10",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "9/1/1982",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 620,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/1/2018",
      mes_fecha: 10,
      dia_fecha: 1,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-01",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 628,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/10/2018",
      mes_fecha: 12,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-10",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 633,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "VALLE DE SANTIAGO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/2/2018",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-02",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 635,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/16/2018",
      mes_fecha: 10,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-16",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 648,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALAMANCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/31/2018",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-31",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 655,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JUVENTINO ROSAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/20/2018",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-20",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 674,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/29/2018",
      mes_fecha: 6,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-29",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "01/06/2009",
      tipo_vacuna: "3",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 675,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/13/2018",
      mes_fecha: 7,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-13",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 676,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/14/2018",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-14",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/13/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 679,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/26/2018",
      mes_fecha: 10,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-26",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 680,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALAMANCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/21/2018",
      mes_fecha: 11,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-21",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 682,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/22/2018",
      mes_fecha: 11,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-22",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 684,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/21/2018",
      mes_fecha: 12,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-21",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 691,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JUVENTINO ROSAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/29/2018",
      mes_fecha: 11,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-29",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 692,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/4/2018",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-04",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 693,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/4/2018",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-04",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 694,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/5/2018",
      mes_fecha: 11,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-05",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 701,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/25/2018",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-25",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 702,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/10/2018",
      mes_fecha: 12,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-10",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 703,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/23/2018",
      mes_fecha: 12,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-23",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 704,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/13/2018",
      mes_fecha: 12,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-13",
      anio_mes: "2018-12",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 712,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/19/2018",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-19",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 716,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/12/2018",
      mes_fecha: 11,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-12",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 725,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/13/2018",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-13",
      anio_mes: "2018-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 729,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/10/2018",
      mes_fecha: 5,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-10",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "30/04/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 731,
      edad: "74",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/12/2018",
      mes_fecha: 7,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-12",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 735,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/7/2018",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-07",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "8/1/2018",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 744,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ABASOLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/24/2018",
      mes_fecha: 7,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-24",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 746,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/7/2018",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-07",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 747,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/15/2018",
      mes_fecha: 11,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-15",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 750,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/2/2018",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-02",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 751,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ABASOLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/21/2018",
      mes_fecha: 12,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-21",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 755,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/7/2018",
      mes_fecha: 11,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-07",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 765,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/26/2018",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-26",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 766,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/7/2018",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-07",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 768,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "COMONFORT",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/15/2018",
      mes_fecha: 8,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-15",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 772,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/24/2018",
      mes_fecha: 8,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-24",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/10/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 775,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/24/2018",
      mes_fecha: 8,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-24",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 777,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/23/2018",
      mes_fecha: 10,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-23",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 784,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/4/2018",
      mes_fecha: 12,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-04",
      anio_mes: "2018-12",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 785,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/10/2019",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-10",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 787,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALAMANCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/20/2018",
      mes_fecha: 8,
      dia_fecha: 20,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-20",
      anio_mes: "2018-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 791,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/15/2018",
      mes_fecha: 11,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-15",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 794,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/26/2018",
      mes_fecha: 10,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-26",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 6,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 799,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/29/2018",
      mes_fecha: 8,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-29",
      anio_mes: "2018-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 803,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JERECUARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/14/2018",
      mes_fecha: 11,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-14",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 812,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/30/2018",
      mes_fecha: 11,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-30",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 819,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/9/2018",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-09",
      anio_mes: "2018-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 820,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/7/2018",
      mes_fecha: 11,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-07",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 823,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/6/2018",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-06",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 824,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALAMANCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/30/2018",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-30",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "28/12/2013",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 826,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ABASOLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/30/2018",
      mes_fecha: 3,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-30",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 833,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/30/2018",
      mes_fecha: 11,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-30",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 840,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN FRANCISCO DEL RINCON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/28/2018",
      mes_fecha: 12,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-28",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 842,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/3/2018",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-03",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 846,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/27/2018",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-27",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 847,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JUVENTINO ROSAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/26/2018",
      mes_fecha: 10,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-26",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 848,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/10/2018",
      mes_fecha: 12,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-10",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 849,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/10/2018",
      mes_fecha: 12,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-10",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 850,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/30/2018",
      mes_fecha: 11,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-30",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 859,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/5/2018",
      mes_fecha: 11,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-05",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 860,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/21/2018",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-21",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 865,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALAMANCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/1/2018",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-01",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 870,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/29/2018",
      mes_fecha: 10,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-29",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 876,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/30/2018",
      mes_fecha: 11,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-30",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 885,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALAMANCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/7/2018",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-07",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 892,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/6/2018",
      mes_fecha: 12,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-06",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 898,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "M DOBLADO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/27/2018",
      mes_fecha: 11,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-27",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "23/07/2015",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 902,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN FRANCISCO DEL RINCON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/5/2018",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-05",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 903,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "URIANGATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/29/2018",
      mes_fecha: 9,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-29",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/09/2018",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 911,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/9/2018",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-09",
      anio_mes: "2018-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 914,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/10/2019",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-10",
      anio_mes: "2019-01",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/20/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 920,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/14/2018",
      mes_fecha: 11,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-14",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 921,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/23/2018",
      mes_fecha: 12,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-23",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 956,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "MINERAL DE LA REFORMA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/31/2018",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-31",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 960,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TEPEHUACAN DE GUERRERO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/10/2018",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-10",
      anio_mes: "2018-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/5/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 963,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "CUAUTEPEC DE HINOJOSA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/30/2018",
      mes_fecha: 9,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-30",
      anio_mes: "2018-09",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 964,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "CUAUTEPEC DE HINOJOSA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/30/2018",
      mes_fecha: 9,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-30",
      anio_mes: "2018-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "9/24/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 966,
      edad: "55",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "MINERAL DE LA REFORMA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/31/2018",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-31",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 967,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/14/2018",
      mes_fecha: 10,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-14",
      anio_mes: "2018-10",
      institucion_notificacion: 6,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 968,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ZEMPOALA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/26/2018",
      mes_fecha: 12,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-26",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 975,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TECOZAUTLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/3/2018",
      mes_fecha: 8,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-03",
      anio_mes: "2018-08",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/20/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 979,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/31/2018",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-31",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/22/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 980,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/18/2018",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-18",
      anio_mes: "2018-03",
      institucion_notificacion: 6,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 987,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/7/2018",
      mes_fecha: 12,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-07",
      anio_mes: "2018-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/23/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1001,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1004,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/3/2018",
      mes_fecha: 5,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-03",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1010,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LA HUERTA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/12/2018",
      mes_fecha: 4,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-12",
      anio_mes: "2018-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "21/08/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1014,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TALA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/13/2018",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-13",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1015,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "27/01/2018",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1021,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "23/07/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1027,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/27/2018",
      mes_fecha: 9,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-27",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1028,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/22/2018",
      mes_fecha: 10,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-22",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1034,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "AMATITAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/12/2018",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-12",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1042,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1044,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/8/2018",
      mes_fecha: 9,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-08",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1045,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/18/2018",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-18",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1047,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "26/02/2015",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1050,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1MES",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1052,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2018",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-23",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1053,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN IGNACIO CERRO GORDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/8/2018",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-08",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1059,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/20/2018",
      mes_fecha: 8,
      dia_fecha: 20,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-20",
      anio_mes: "2018-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1061,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/16/2018",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-16",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1070,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "OCOTLAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/12/2018",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-12",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1095,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAQUEPAQUE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/15/2018",
      mes_fecha: 12,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-15",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1104,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOTLANEJO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1105,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/21/2018",
      mes_fecha: 6,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-21",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1122,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/28/2018",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-28",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1135,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/30/2018",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-30",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1146,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAQUEPAQUE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/4/2019",
      mes_fecha: 1,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-04",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1149,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/8/2019",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-08",
      anio_mes: "2019-01",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1151,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/26/2018",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-26",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "08/02/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1154,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAYULITA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/14/2018",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-14",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1159,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/21/2018",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-21",
      anio_mes: "2018-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1160,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1163,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAQUEPAQUE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/25/2018",
      mes_fecha: 1,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-25",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1171,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/24/2018",
      mes_fecha: 11,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-24",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1173,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TALA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1175,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TALA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1176,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/21/2018",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-21",
      anio_mes: "2018-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1180,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1184,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/14/2018",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-14",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1188,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/28/2018",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-28",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1189,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/10/2018",
      mes_fecha: 12,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-10",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1191,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "CIHUATLAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/28/2018",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-28",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1193,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAQUEPAQUE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/2/2018",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-02",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1195,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ARANDAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/29/2018",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-29",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1196,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1205,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAQUEPAQUE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/4/2018",
      mes_fecha: 12,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-04",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1206,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/5/2018",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-05",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1209,
      edad: "64",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/10/2018",
      mes_fecha: 12,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-10",
      anio_mes: "2018-12",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1210,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAQUEPAQUE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/4/2019",
      mes_fecha: 1,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-04",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1215,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAQUEPAQUE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/24/2018",
      mes_fecha: 9,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-24",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1219,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TENANGO DEL AIRE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/17/2018",
      mes_fecha: 12,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-17",
      anio_mes: "2018-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "01/06/2017",
      tipo_vacuna: "2",
      complicaciones: 6,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1223,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/30/2018",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-30",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1224,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE CHALCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/5/2018",
      mes_fecha: 1,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-05",
      anio_mes: "2018-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1225,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/10/2018",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-10",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "IGN",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1226,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/5/2018",
      mes_fecha: 7,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-05",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1227,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/5/2018",
      mes_fecha: 11,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-05",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/10/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1230,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/17/2018",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-17",
      anio_mes: "2018-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "22/11/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1231,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SA SIMON DE GUERRERO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/11/2018",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-11",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1232,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/5/2018",
      mes_fecha: 12,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-05",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1233,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SANTIAGO TIANGUISTENCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/1/2018",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-01",
      anio_mes: "2018-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1234,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "COYOTEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/1/2018",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-01",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1242,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CUAUTITLAN IZCALLI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/6/2018",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-06",
      anio_mes: "2018-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1244,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC DE MORELOS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/21/2018",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-21",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1246,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NAUCALPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/4/2018",
      mes_fecha: 7,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-04",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1247,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC DE MORELOS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/12/2018",
      mes_fecha: 12,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-12",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1248,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/5/2018",
      mes_fecha: 12,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-05",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1251,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEXCOCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/22/2018",
      mes_fecha: 11,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-22",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1252,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NAUCALPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/15/2018",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-15",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1254,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEXCOCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/5/2018",
      mes_fecha: 10,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-05",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1258,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEZOYUCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/27/2018",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-27",
      anio_mes: "2018-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1260,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TULTITLAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/16/2018",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-16",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1261,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CD NEZAHUALCOYOTL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/2/2018",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-02",
      anio_mes: "2018-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/9/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1262,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC DE MORELOS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/11/2018",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-11",
      anio_mes: "2018-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/18/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1264,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC DE MORELOS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/30/2018",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-30",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "IGN",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1265,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/26/2018",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-26",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1266,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/5/2018",
      mes_fecha: 12,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-05",
      anio_mes: "2018-12",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1267,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/17/2018",
      mes_fecha: 12,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-17",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "20/09/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1270,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "LOS REYES LA PAZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/10/2018",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-10",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1272,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "13/11/201/8",
      mes_fecha: 13,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-11",
      anio_mes: "2018-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "05/11/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1276,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEMASCALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/27/2018",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-27",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "27/05/2018",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1279,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/12/2018",
      mes_fecha: 11,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-12",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1280,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VILLA NICOLAS ROMERO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/31/2018",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-31",
      anio_mes: "2018-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1281,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/17/2018",
      mes_fecha: 8,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-17",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "ABRIL",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1283,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/14/2018",
      mes_fecha: 12,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-14",
      anio_mes: "2018-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 6,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1290,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/6/2018",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-06",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/3/2004",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1291,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE CHALCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/23/2018",
      mes_fecha: 11,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-23",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1293,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/17/2018",
      mes_fecha: 8,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-17",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1294,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CUAUTITLAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/9/2018",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-09",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1295,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/14/2018",
      mes_fecha: 12,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-14",
      anio_mes: "2018-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 6,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1296,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/14/2018",
      mes_fecha: 11,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-14",
      anio_mes: "2018-11",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1298,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/1/2018",
      mes_fecha: 6,
      dia_fecha: 1,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-01",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1300,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ATIZAPAN DE ZARAGOZA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/10/2018",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-10",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "IGN",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1301,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/5/2018",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-05",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1303,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/2/2018",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-02",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1310,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/25/2018",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-25",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "14/10/2016",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1314,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LOS REYES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/15/2018",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-15",
      anio_mes: "2018-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1315,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/3/2018",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-03",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1316,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/9/2018",
      mes_fecha: 10,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-09",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1318,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "TACÁMBARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/5/2018",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-05",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "---",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1320,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "CHERAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/30/2018",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-30",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "---",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1323,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "QUIROGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/22/2018",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-22",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "--",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1325,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/31/2018",
      mes_fecha: 12,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-31",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1326,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/23/2018",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-23",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1328,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/15/2018",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-15",
      anio_mes: "2018-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1329,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/15/2018",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-15",
      anio_mes: "2018-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1331,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "INDAPARAPEO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/14/2018",
      mes_fecha: 12,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-14",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1333,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/7/2018",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-07",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1334,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LOS REYES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/12/2018",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-12",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1336,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/14/2018",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-14",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1339,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/12/2018",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-12",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1341,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/24/2018",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-24",
      anio_mes: "2018-04",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1343,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/14/2018",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-14",
      anio_mes: "2018-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1345,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/31/2018",
      mes_fecha: 8,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-31",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1346,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/28/2018",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-28",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "--",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1348,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/24/2018",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-24",
      anio_mes: "2018-04",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1351,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZITACUARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/20/2018",
      mes_fecha: 9,
      dia_fecha: 20,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-20",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1352,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZITACUARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/20/2018",
      mes_fecha: 9,
      dia_fecha: 20,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-20",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 6,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1353,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "NAHUATZEN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/7/2018",
      mes_fecha: 10,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-07",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1354,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "QUIROGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/26/2018",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-26",
      anio_mes: "2018-02",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1356,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "TANCITARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/17/2018",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-17",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1358,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "QUIROGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/26/2018",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-26",
      anio_mes: "2018-02",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1365,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TOTOLAPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/3/2018",
      mes_fecha: 5,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-03",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1366,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "YAUTEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/16/2018",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-16",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1368,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TEMIXCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/27/2018",
      mes_fecha: 12,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-27",
      anio_mes: "2018-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/26/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1371,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TEMIXCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/9/2018",
      mes_fecha: 8,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-09",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/16/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1372,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/28/2018",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-28",
      anio_mes: "2018-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/24/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1373,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/1/2018",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-01",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/16/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1379,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/7/2018",
      mes_fecha: 6,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-07",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1386,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "EMILIANO ZAPATA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/8/2018",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-08",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/20/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1388,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "MIACATLAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/8/2019",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-08",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 6,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1389,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "AXOCHIAPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/2/2018",
      mes_fecha: 10,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-02",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1391,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "SANTA MARIA DEL ORO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/29/2018",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-29",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1394,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "COMPOSTELA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/13/2018",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-13",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "9/9/2017",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1396,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "RUIZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/5/2018",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-05",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1398,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/20/2018",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-20",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1402,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/19/2018",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-19",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1408,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/13/2018",
      mes_fecha: 7,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-13",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1412,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/30/2018",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-30",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1413,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/9/2018",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-09",
      anio_mes: "2018-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/20/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1414,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/29/2018",
      mes_fecha: 8,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-29",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1415,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/31/2018",
      mes_fecha: 5,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-31",
      anio_mes: "2018-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/1/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1417,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/27/2018",
      mes_fecha: 7,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-27",
      anio_mes: "2018-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1422,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/3/2018",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-03",
      anio_mes: "2018-09",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1424,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/7/2018",
      mes_fecha: 6,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-07",
      anio_mes: "2018-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1432,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/9/2018",
      mes_fecha: 2,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-09",
      anio_mes: "2018-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/30/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1434,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/2/2018",
      mes_fecha: 11,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-02",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1443,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/28/2018",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-28",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1446,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/22/2018",
      mes_fecha: 6,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-22",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1447,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/2/2018",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-02",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1448,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/22/2018",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-22",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1453,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/4/2018",
      mes_fecha: 5,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-04",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1454,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MIER Y NORIEGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/11/2018",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-11",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1460,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/17/2018",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-17",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1463,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/15/2018",
      mes_fecha: 8,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-15",
      anio_mes: "2018-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1466,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/15/2018",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-15",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1469,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/31/2018",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-31",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1470,
      edad: "61",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/5/2018",
      mes_fecha: 9,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-05",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1472,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/15/2018",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-15",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1476,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/9/2018",
      mes_fecha: 8,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-09",
      anio_mes: "2018-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1478,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/19/2018",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-19",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1481,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/22/2018",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-22",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/3/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1483,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/24/2018",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-24",
      anio_mes: "2018-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1485,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/19/2018",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-19",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1488,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN PEDRO GARZA GARCIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/4/2018",
      mes_fecha: 12,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-04",
      anio_mes: "2018-12",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1490,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/26/2018",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-26",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1492,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/25/2018",
      mes_fecha: 5,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-25",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1497,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/27/2018",
      mes_fecha: 7,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-27",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1498,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/21/2018",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-21",
      anio_mes: "2018-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/12/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1508,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/10/2018",
      mes_fecha: 12,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-10",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1511,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/2/2018",
      mes_fecha: 8,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-02",
      anio_mes: "2018-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1516,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/29/2018",
      mes_fecha: 6,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-29",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1517,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/6/2018",
      mes_fecha: 7,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-06",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/2/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1518,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/30/2018",
      mes_fecha: 9,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-30",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1523,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/25/2018",
      mes_fecha: 7,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-25",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1524,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTIAGO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/12/2018",
      mes_fecha: 12,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-12",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1525,
      edad: "76",
      grupo_edad: "75 - 79",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTIAGO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/12/2018",
      mes_fecha: 12,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-12",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1527,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/9/2018",
      mes_fecha: 1,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-09",
      anio_mes: "2018-01",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "11/1/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1529,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/28/2018",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-28",
      anio_mes: "2018-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1531,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/5/2018",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-05",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/3/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1535,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "ARAMBERRI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/28/2018",
      mes_fecha: 10,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-28",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/13/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1538,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/30/2018",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-30",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1541,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/15/2018",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-15",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/22/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1546,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/14/2018",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-14",
      anio_mes: "2018-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1550,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/15/2018",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-15",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/11/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1555,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/2/2018",
      mes_fecha: 11,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-02",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1557,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/6/2018",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-06",
      anio_mes: "2018-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/13/2018",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1561,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/30/2018",
      mes_fecha: 3,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-30",
      anio_mes: "2018-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1565,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/26/2018",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-26",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1566,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/2/2018",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-02",
      anio_mes: "2018-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1569,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/16/2018",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-16",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/20/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1570,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/18/2018",
      mes_fecha: 5,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-18",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/12/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1578,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/2/2018",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-02",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1579,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/28/2018",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-28",
      anio_mes: "2018-08",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2016",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1582,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "LINARES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/24/2018",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-24",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1584,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/10/2018",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-10",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/21/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1589,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/16/2018",
      mes_fecha: 11,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-16",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1593,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/9/2019",
      mes_fecha: 1,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-09",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1594,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/10/2018",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-10",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1595,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/8/2018",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-08",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1599,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/22/2018",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-22",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1601,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/2/2018",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-02",
      anio_mes: "2018-05",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1613,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/10/2018",
      mes_fecha: 12,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-10",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1617,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/4/2018",
      mes_fecha: 8,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-04",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "7/23/2018",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1618,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/10/2018",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-10",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1619,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/31/2018",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-31",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1623,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/19/2018",
      mes_fecha: 4,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-19",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1624,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/1/2018",
      mes_fecha: 5,
      dia_fecha: 1,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-01",
      anio_mes: "2018-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/16/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1626,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/12/2018",
      mes_fecha: 11,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-12",
      anio_mes: "2018-11",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1629,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/15/2018",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-15",
      anio_mes: "2018-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1634,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/25/2018",
      mes_fecha: 11,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-25",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1636,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/1/2018",
      mes_fecha: 6,
      dia_fecha: 1,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-01",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1637,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/18/2018",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-18",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1638,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/14/2018",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-14",
      anio_mes: "2018-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/18/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1639,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/2/2018",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-02",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1641,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZUAZUA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/14/2018",
      mes_fecha: 11,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-14",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1649,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/7/2018",
      mes_fecha: 6,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-07",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/15/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1654,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/25/2018",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-25",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1657,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN LUCAS ZOOQUIAPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/30/2018",
      mes_fecha: 10,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-30",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1659,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "VILLA DE TUTUTEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/18/2018",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-18",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1660,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/30/2018",
      mes_fecha: 10,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-30",
      anio_mes: "2018-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1661,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "ACATLAN DE PEREZ FIGUEROA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/16/2018",
      mes_fecha: 7,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-16",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1663,
      edad: "68",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO PINOTEPA NACIONAL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/19/2018",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-19",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1664,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO PINOTEPA NACIONAL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/19/2018",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-19",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/15/2014",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1666,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/10/2018",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-10",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1667,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA CRUZ XOXOCOTLAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/28/2018",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-28",
      anio_mes: "2018-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1670,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO PINOTEPA NACIONAL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/19/2018",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-19",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1671,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO PINOTEPA NACIONAL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/19/2018",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-19",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1672,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO PINOTEPA NACIONAL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/19/2018",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-19",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/5/2015",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1675,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO PINOTEPA NACIONAL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/19/2018",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-19",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1676,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO PINOTEPA NACIONAL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/17/2018",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-17",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1677,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO MATATLAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/17/2018",
      mes_fecha: 12,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-17",
      anio_mes: "2018-12",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1678,
      edad: "62",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO MATATLAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/11/2019",
      mes_fecha: 1,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-11",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1679,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2018",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-23",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1680,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN SEBASTIAN TUTLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/7/2018",
      mes_fecha: 9,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-07",
      anio_mes: "2018-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1681,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO TLAZOYALTEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/16/2018",
      mes_fecha: 7,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-16",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1682,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN ANDRES HUAYAPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/11/2018",
      mes_fecha: 12,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-11",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1684,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "VILLA DE TUTUTEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/19/2018",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-19",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1686,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "REYES ETLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/24/2018",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-24",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1688,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "JUCHITAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/22/2018",
      mes_fecha: 11,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-22",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1690,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PABLO HUIXTEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/10/2018",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-10",
      anio_mes: "2018-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1691,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PABLO HUIXTEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/18/2018",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-18",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/10/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1693,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "JUCHITAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/5/2018",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-05",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1694,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PEDRO MIXTEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/11/2018",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-11",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "8/16/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1695,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PEDRO MIXTEPEC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/11/2018",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-11",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1697,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "TEHUACAN PUEBLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/19/2018",
      mes_fecha: 12,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-19",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1704,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "CHICHIQUILA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/21/2018",
      mes_fecha: 11,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-21",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1707,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "ESPERANZA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/4/2019",
      mes_fecha: 1,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-04",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1721,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/24/2018",
      mes_fecha: 5,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-24",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/8/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1724,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/3/2019",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-03",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/30/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1727,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/8/2019",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-08",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1728,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/2/2019",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-02",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1730,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CORREGIDORA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/27/2018",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-27",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/23/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1736,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/4/2018",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-04",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/6/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1739,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/22/2018",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-22",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1741,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "TEQUISQUIAPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/3/2018",
      mes_fecha: 2,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-03",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1744,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/16/2019",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-16",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1745,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/16/2019",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-16",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1753,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "COLON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/5/2018",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-05",
      anio_mes: "2018-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1755,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/26/2018",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-26",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/14/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1756,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "PEDRO ESCOBEDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/16/2018",
      mes_fecha: 8,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-16",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1757,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MAQUES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/4/2018",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-04",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1758,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/13/2018",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-13",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1760,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/24/2018",
      mes_fecha: 12,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-24",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/11/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1761,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/3/2019",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-03",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/18/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1762,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/18/2018",
      mes_fecha: 11,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-18",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1765,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/12/2018",
      mes_fecha: 1,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-12",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1770,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CORREGIDORA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/14/2018",
      mes_fecha: 11,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-14",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1775,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/13/2018",
      mes_fecha: 11,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-13",
      anio_mes: "2018-11",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/10/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1776,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/8/2019",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-08",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "NO RECUERDA",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1778,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CORREGIDORA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/26/2018",
      mes_fecha: 10,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-26",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/10/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1788,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P BLANCO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/25/2018",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-25",
      anio_mes: "2018-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1791,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "SOLIDARIDAD",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/22/2018",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-22",
      anio_mes: "2018-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/9/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1801,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/4/2018",
      mes_fecha: 10,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-04",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/15/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1811,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/17/2018",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-17",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1812,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/9/2018",
      mes_fecha: 10,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-09",
      anio_mes: "2018-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/21/2017",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1813,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/20/2018",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-20",
      anio_mes: "2018-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1822,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "TAMAZUNCHALE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/18/2018",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-18",
      anio_mes: "2018-07",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1825,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SANTA MARIA DEL RIO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/7/2018",
      mes_fecha: 12,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-07",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1828,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN MARTIN CHALCHICOAUTLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/24/2018",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-24",
      anio_mes: "2018-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1834,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/31/2018",
      mes_fecha: 10,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-31",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1842,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/8/2018",
      mes_fecha: 6,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-08",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/19/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1851,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/28/2018",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-28",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1868,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN NICOLAS TOLENTINO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/14/2018",
      mes_fecha: 11,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-14",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "28/11/2014",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1875,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/11/2018",
      mes_fecha: 10,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-11",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1878,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/30/2018",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-30",
      anio_mes: "2018-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1882,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/12/2018",
      mes_fecha: 7,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-12",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1885,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "GUADALCAZAR",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/8/2018",
      mes_fecha: 6,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-08",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1890,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CD VALLES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/3/2018",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-03",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1894,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "RIOVERDE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/24/2018",
      mes_fecha: 8,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-24",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "07/08/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1895,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/18/2018",
      mes_fecha: 5,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-18",
      anio_mes: "2018-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/14/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1898,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/9/2018",
      mes_fecha: 2,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-09",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1901,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/23/2018",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-23",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/10/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1903,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/29/2018",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-29",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/23/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1908,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MATEHUALA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/16/2018",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-16",
      anio_mes: "2018-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/26/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1916,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "GUADALCAZAR",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/9/2018",
      mes_fecha: 12,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-09",
      anio_mes: "2018-12",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "17/11/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1918,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CATORCE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/7/2018",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-07",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1921,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/28/2018",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-28",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "07/08/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1923,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/9/2018",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-09",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1948,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE REYES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/7/2018",
      mes_fecha: 12,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-07",
      anio_mes: "2018-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1952,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SALINAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/13/2018",
      mes_fecha: 9,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-13",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1954,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "AQUISMON",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/18/2018",
      mes_fecha: 12,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-18",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "23/11/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1956,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/8/2018",
      mes_fecha: 6,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-08",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1958,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/27/2018",
      mes_fecha: 9,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-27",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1959,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/12/2018",
      mes_fecha: 10,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-12",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "17/08/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1961,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/23/2018",
      mes_fecha: 10,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-23",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1967,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "LOS MOCHIS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/27/2018",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-27",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1984,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "AHOME",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/7/2018",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-07",
      anio_mes: "2018-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1985,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACÁN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/19/2018",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-19",
      anio_mes: "2018-02",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "08/02/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1986,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "NAVOLATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/10/2018",
      mes_fecha: 10,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-10",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1987,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "NAVOLATO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/25/2018",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-25",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 1996,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACÁN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/5/2018",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-05",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "20/03/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2003,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "GUASAVE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/6/2018",
      mes_fecha: 9,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-06",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2035,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "GUAYMAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/22/2018",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-22",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2036,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "GUAYMAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/26/2018",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-26",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2052,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/11/2018",
      mes_fecha: 5,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-11",
      anio_mes: "2018-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2078,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/22/2018",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-22",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "15/02/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2079,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/23/2018",
      mes_fecha: 2,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-23",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "15/02/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2080,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/26/2018",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-26",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2094,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/8/2018",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-08",
      anio_mes: "2018-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2096,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/23/2018",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-23",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2113,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/24/2018",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-24",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2114,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/24/2018",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-24",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2127,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NAVOJOA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/23/2018",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-23",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "02/03/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2142,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "PARAISO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/4/2018",
      mes_fecha: 11,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-04",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2145,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CENTRO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/25/2018",
      mes_fecha: 10,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-25",
      anio_mes: "2018-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2146,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "MACUSPANA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/5/2018",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-05",
      anio_mes: "2018-04",
      institucion_notificacion: 7,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/11/2016",
      tipo_vacuna: "2",
      complicaciones: 6,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2149,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "HUIMANGUILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/18/2018",
      mes_fecha: 1,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-18",
      anio_mes: "2018-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/4/2017",
      tipo_vacuna: "2",
      complicaciones: 6,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2154,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "VICTORIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/10/2018",
      mes_fecha: 8,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-10",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "19/06/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2157,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "ALTAMIRA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/27/2018",
      mes_fecha: 4,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-27",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2161,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "NUEVO LAREDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/4/2018",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-04",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "18/10/2017",
      tipo_vacuna: "2",
      complicaciones: 6,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2165,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "TULA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/10/2018",
      mes_fecha: 8,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-10",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/07/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2170,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MADERO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/29/2018",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-29",
      anio_mes: "2018-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2171,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/29/2018",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-29",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "31/01/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2173,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/29/2018",
      mes_fecha: 6,
      dia_fecha: 29,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-29",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/06/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2174,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/26/2018",
      mes_fecha: 4,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-26",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2175,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/27/2018",
      mes_fecha: 7,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-27",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/04/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2176,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "VICTORIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/13/2018",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-13",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2184,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "VICTORIA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/20/2018",
      mes_fecha: 7,
      dia_fecha: 20,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-20",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "25/06/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2186,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "ALTAMIRA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/18/2018",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-18",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 3,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2189,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/6/2018",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-06",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "04/06/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2197,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "NUEVO LAREDO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/13/2018",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-13",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2206,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/2/2018",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-02",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 6,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2210,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/31/2018",
      mes_fecha: 10,
      dia_fecha: 31,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-31",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2215,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "RIO BRAVO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/15/2018",
      mes_fecha: 8,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-15",
      anio_mes: "2018-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2219,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "VALLE HERMOSO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/8/2019",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-08",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2225,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "SAN CARLOS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/27/2018",
      mes_fecha: 12,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-27",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2226,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "TAMPICO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/10/2019",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-10",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2230,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "BUSTAMANTE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/24/2018",
      mes_fecha: 9,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-24",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/17/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2232,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TENANZINGO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/30/2018",
      mes_fecha: 11,
      dia_fecha: 30,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-30",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "-",
      tipo_vacuna: "-",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2235,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/12/2018",
      mes_fecha: 10,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-12",
      anio_mes: "2018-10",
      institucion_notificacion: 6,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/3/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2237,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "IGNACIO ZARAGOZA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/11/2018",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-11",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 5,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2241,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "ACUAMANALA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/24/2018",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-24",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2242,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUAMANTLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/8/2018",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-08",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2243,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "NANACAMILPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/22/2018",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-22",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2247,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUAMANTLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/12/2018",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-12",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "24/01/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2248,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "XALOZTOC",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/3/2018",
      mes_fecha: 8,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-03",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/02/2016",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2249,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/16/2018",
      mes_fecha: 3,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-16",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/03/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2251,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SANTIAGO SOCHIAPAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/5/2018",
      mes_fecha: 11,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-05",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2252,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/27/2018",
      mes_fecha: 7,
      dia_fecha: 27,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-27",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2253,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SOLEDAD ATZOMPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/22/2018",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-22",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2254,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SOLEDAD ATZOMPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/26/2018",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-26",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2261,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XOXOCOTLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/3/2018",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-03",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/2/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2264,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "IXTACZOQUITLÁN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/7/2018",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-07",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2265,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZACOALCOS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/12/2018",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-12",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2266,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CARRILLO PUERTO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/13/2018",
      mes_fecha: 11,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-13",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2267,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "FORTIN DE LAS FLORES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/17/2018",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-17",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2269,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CIUDAD MENDOZA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/2/2019",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-02",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2274,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LA PERLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/4/2018",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-04",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2278,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CORDOBA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/12/2018",
      mes_fecha: 11,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-12",
      anio_mes: "2018-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2279,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN ANDRES TUXTLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/14/2018",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-14",
      anio_mes: "2018-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/3/2016",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2280,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MINATITLAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/15/2018",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-15",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2281,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TIERRA BLANCA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/11/2018",
      mes_fecha: 5,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-11",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/19/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2294,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LAS CHOAPAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/6/2018",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-06",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2295,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PEROTE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/3/2018",
      mes_fecha: 8,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-03",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/20/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2301,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZACOALCOS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/1/2018",
      mes_fecha: 2,
      dia_fecha: 1,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-01",
      anio_mes: "2018-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "11/30/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2303,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TEZONAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/24/2018",
      mes_fecha: 5,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-24",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2304,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ORIZABA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/12/2018",
      mes_fecha: 7,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-12",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2306,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/22/2018",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-22",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2309,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CHINAMPA DE GOROSTIZA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/24/2018",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-24",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2317,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/6/2018",
      mes_fecha: 11,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-06",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2318,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/16/2018",
      mes_fecha: 7,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-16",
      anio_mes: "2018-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2319,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN ANDRES TUXTLA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/6/2018",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-06",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2322,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "KANASIN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/11/2018",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-11",
      anio_mes: "2018-07",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "16/05/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2325,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/22/2018",
      mes_fecha: 6,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-22",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2326,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TECOH",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/5/2018",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-05",
      anio_mes: "2018-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2330,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/5/2018",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-05",
      anio_mes: "2018-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2331,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TICUL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/26/2018",
      mes_fecha: 10,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-26",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2332,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/8/2018",
      mes_fecha: 3,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-08",
      anio_mes: "2018-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2335,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "IZAMAL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/25/2018",
      mes_fecha: 1,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-25",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2337,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/3/2018",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-03",
      anio_mes: "2018-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2339,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/28/2018",
      mes_fecha: 9,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-28",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2340,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIXPEHUAL",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/20/2018",
      mes_fecha: 12,
      dia_fecha: 20,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-20",
      anio_mes: "2018-12",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "22/11/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2342,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/12/2018",
      mes_fecha: 7,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-12",
      anio_mes: "2018-07",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2345,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/20/2018",
      mes_fecha: 7,
      dia_fecha: 20,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-20",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2348,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "CHEMAX",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/13/2018",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-13",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "14/09/2016",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 5,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2349,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "CHICHIMILA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/21/2018",
      mes_fecha: 11,
      dia_fecha: 21,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-21",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2350,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/25/2018",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-25",
      anio_mes: "2018-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2352,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "CACALCHEN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/18/2018",
      mes_fecha: 12,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-18",
      anio_mes: "2018-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "20/11/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2354,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "CHEMAX",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/19/2018",
      mes_fecha: 12,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-19",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2358,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/7/2018",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-07",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "20/04/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2359,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "CUZAMA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/8/2018",
      mes_fecha: 11,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-08",
      anio_mes: "2018-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2360,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/23/2018",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-23",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2361,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/17/2018",
      mes_fecha: 10,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-17",
      anio_mes: "2018-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2362,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/7/2018",
      mes_fecha: 7,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-07",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2364,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIXKOKOB",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/13/2018",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-13",
      anio_mes: "2018-03",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2366,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "HALACHO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/22/2018",
      mes_fecha: 6,
      dia_fecha: 22,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-22",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2367,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "PETO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/7/2018",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-07",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2369,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "HOCTUN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/12/2018",
      mes_fecha: 7,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-12",
      anio_mes: "2018-07",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "21/05/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2372,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TECOH",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/19/2018",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-19",
      anio_mes: "2018-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2373,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/18/2018",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-18",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2378,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/26/2018",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-26",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2381,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "SAIN ALTO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/16/2018",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-16",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2383,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/8/2018",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-08",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2385,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/5/2018",
      mes_fecha: 10,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-05",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2389,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/16/2018",
      mes_fecha: 11,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-16",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2392,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/4/2018",
      mes_fecha: 5,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-04",
      anio_mes: "2018-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/26/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2396,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "TRANCOSO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "9/4/2018",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-09-04",
      anio_mes: "2018-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2398,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VETAGRANDE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/23/2018",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-23",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2399,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/5/2018",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-05",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2400,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "4/19/2018",
      mes_fecha: 4,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-04-19",
      anio_mes: "2018-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/7/2017",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2401,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/16/2018",
      mes_fecha: 8,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-16",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2403,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "OJOCALIENTE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/17/2018",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-17",
      anio_mes: "2018-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2404,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/15/2018",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-15",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2405,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "6/4/2018",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2018,
      fecha_notificacion: "2018-06-04",
      anio_mes: "2018-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2407,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA GONZALEZ ORTEGA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/7/2018",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-07",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/27/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2409,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "12/18/2018",
      mes_fecha: 12,
      dia_fecha: 18,
      anio_fecha: 2018,
      fecha_notificacion: "2018-12-18",
      anio_mes: "2018-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2410,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "2/6/2018",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2018,
      fecha_notificacion: "2018-02-06",
      anio_mes: "2018-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2411,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "5/7/2018",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2018,
      fecha_notificacion: "2018-05-07",
      anio_mes: "2018-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2413,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "10/10/2018",
      mes_fecha: 10,
      dia_fecha: 10,
      anio_fecha: 2018,
      fecha_notificacion: "2018-10-10",
      anio_mes: "2018-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2416,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "NOCHISTLAN",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/3/2019",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-03",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2417,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/2/2018",
      mes_fecha: 11,
      dia_fecha: 2,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-02",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2418,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/1/2018",
      mes_fecha: 3,
      dia_fecha: 1,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-01",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2419,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA DE COS",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "3/19/2018",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-03-19",
      anio_mes: "2018-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2424,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "JEREZ",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "8/28/2018",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2018,
      fecha_notificacion: "2018-08-28",
      anio_mes: "2018-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2430,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "CALERA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "11/12/2018",
      mes_fecha: 11,
      dia_fecha: 12,
      anio_fecha: 2018,
      fecha_notificacion: "2018-11-12",
      anio_mes: "2018-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "SD",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2431,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "7/19/2018",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2018,
      fecha_notificacion: "2018-07-19",
      anio_mes: "2018-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/1/2018",
      tipo_vacuna: "2",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2018,
      fila_archivo: 2434,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "PANFILO NATERA",
      estado_notificacion: "SIN DATO",
      municipio_notificacion: "SIN DATO",
      fecha_texto: "1/8/2019",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-08",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/14/2019",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-14",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 6,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/28/2019",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-28",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/11/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 7,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "PABELLON DE ARTEAGA",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/6/2019",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-06",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "21/01/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 10,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "7/5/2019",
      mes_fecha: 7,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-05",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "09/11/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 12,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "PABELLON DE ARTEAGA",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "CALVILLO",
      fecha_texto: "2/5/2019",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-05",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 20,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "5/7/2019",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-07",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 22,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "PABELLON DE ARTEAGA",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "PABELLON DE ARTEAGA",
      fecha_texto: "2/13/2019",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-13",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 23,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "5/3/2019",
      mes_fecha: 5,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-03",
      anio_mes: "2019-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "22/04/2019",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 24,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/4/2019",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-04",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 25,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/4/2019",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-04",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 32,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "SAN FRANCISCO DE LOS ROMO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "PABELLON DE ARTEAGA",
      fecha_texto: "2/15/2019",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-15",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 40,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/25/2019",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-25",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 41,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "TEPEZALA",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/8/2019",
      mes_fecha: 3,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-08",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 45,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/14/2019",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-14",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 46,
      edad: "65",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/14/2019",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-14",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 47,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "SAN FRANCISCO DE LOS ROMO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/5/2019",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-05",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 52,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "COSIO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "RINCON DE ROMOS",
      fecha_texto: "2/7/2019",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-07",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "29/12/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 55,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/25/2019",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-25",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 56,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/25/2019",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-25",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 63,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "JESUS MARIA",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/28/2019",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-28",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 67,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/4/2019",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-04",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 71,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "RINCON DE ROMOS",
      fecha_texto: "3/4/2019",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-04",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "15/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 74,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "SAN FRANCISCO DE LOS ROMO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/5/2019",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-05",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 79,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/16/2019",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-16",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 82,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/4/2019",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-04",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 84,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/28/2019",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-28",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 88,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/21/2019",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-21",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 89,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "8/12/2019",
      mes_fecha: 8,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-12",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 94,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "7/5/2019",
      mes_fecha: 7,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-05",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 115,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "4/16/2019",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-16",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 125,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "5/7/2019",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-07",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 128,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "PLAYAS DE ROSARITO",
      fecha_texto: "6/4/2019",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-04",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 129,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "12/17/2019",
      mes_fecha: 12,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-17",
      anio_mes: "2019-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/19/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 133,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "6/25/2019",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-25",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 140,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "5/29/2019",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-29",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/15/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 144,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "4/5/2019",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-05",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 145,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "8/19/2019",
      mes_fecha: 8,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-19",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 148,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "7/16/2019",
      mes_fecha: 7,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-16",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 156,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "4/11/2019",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-11",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/29/2019",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 158,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "PLAYAS DE ROSARITO",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "PLAYAS DE ROSARITO",
      fecha_texto: "7/31/2019",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-31",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 159,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "8/26/2019",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-26",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 161,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "7/3/2019",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-03",
      anio_mes: "2019-07",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 165,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "2/5/2019",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-05",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 179,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "10/25/2019",
      mes_fecha: 10,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-25",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 180,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "1/6/2020",
      mes_fecha: 1,
      dia_fecha: 6,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-06",
      anio_mes: "2020-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 183,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TECATE",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "4/8/2019",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-08",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 196,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "11/4/2019",
      mes_fecha: 11,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-04",
      anio_mes: "2019-11",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/31/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 198,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "5/20/2019",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-20",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/1/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 204,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "5/9/2019",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-09",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 210,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "5/16/2019",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-16",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 213,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ROSARITO",
      fecha_texto: "7/26/2019",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-26",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 219,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "7/8/2019",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-08",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 220,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "4/8/2019",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-08",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 221,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "5/31/2019",
      mes_fecha: 5,
      dia_fecha: 31,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-31",
      anio_mes: "2019-05",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 223,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "10/10/2019",
      mes_fecha: 10,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-10",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 226,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "11/29/2019",
      mes_fecha: 11,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-29",
      anio_mes: "2019-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 231,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "1/15/2019",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-15",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 232,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "COMONDU",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "12/10/2019",
      mes_fecha: 12,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-10",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "16/10/2019",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 234,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "12/11/2019",
      mes_fecha: 12,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-11",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 237,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "11/11/2019",
      mes_fecha: 11,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-11",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 241,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "1/8/2019",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-08",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/06/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 243,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "COMONDU",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "COMONDU",
      fecha_texto: "1/31/2019",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-31",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 245,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "12/9/2019",
      mes_fecha: 12,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-09",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 246,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "6/28/2019",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-28",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "05/06/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 248,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "6/4/2019",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-04",
      anio_mes: "2019-06",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "06/06/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 258,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CD.CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CD.CARMEN",
      fecha_texto: "10/8/2019",
      mes_fecha: 10,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-08",
      anio_mes: "2019-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/09/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 260,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHIAPA DE CORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/1/2019",
      mes_fecha: 2,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-01",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 261,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHIAPA DE CORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/1/2019",
      mes_fecha: 2,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-01",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 265,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/10/2019",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-10",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 269,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BERRIOZABAL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/16/2019",
      mes_fecha: 3,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-16",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 270,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BERRIOZABAL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/17/2019",
      mes_fecha: 3,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-17",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 271,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "8/10/2019",
      mes_fecha: 8,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-10",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 275,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "1/11/2019",
      mes_fecha: 1,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-11",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 278,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COPAINALA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "4/6/2019",
      mes_fecha: 4,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-06",
      anio_mes: "2019-04",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 279,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "HUEHUETAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "3/9/2019",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-09",
      anio_mes: "2019-03",
      institucion_notificacion: 9,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 280,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "11/11/2019",
      mes_fecha: 11,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-11",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 284,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLAFLORES",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "7/21/2019",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-21",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 286,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "8/2/2019",
      mes_fecha: 8,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-02",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 288,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "9/25/2019",
      mes_fecha: 9,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-25",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 290,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/22/2019",
      mes_fecha: 3,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-22",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 292,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ESCUINTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "6/12/2019",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-12",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 294,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COPAINALA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "9/20/2019",
      mes_fecha: 9,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-20",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 297,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BERRIOZABAL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "OCOZOCOAUTLA DE ESPINOSA",
      fecha_texto: "4/15/2019",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-15",
      anio_mes: "2019-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 306,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "8/10/2019",
      mes_fecha: 8,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-10",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06/06/2019",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 307,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHIAPA DE CORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "9/16/2019",
      mes_fecha: 9,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-16",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 308,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "1/11/2019",
      mes_fecha: 1,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-11",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 310,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOZOCOAUTLA DE ESPINOSA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "OCOZOCOAUTLA DE ESPINOSA",
      fecha_texto: "4/15/2019",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-15",
      anio_mes: "2019-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 314,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "5/5/2019",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-05",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 317,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "1/4/2019",
      mes_fecha: 1,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-04",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 318,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CINTALAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "1/26/2019",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-26",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 319,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "1/4/2019",
      mes_fecha: 1,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-04",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 320,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/15/2019",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-15",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 321,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/15/2019",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-15",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 323,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TAPACHULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "7/25/2019",
      mes_fecha: 7,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-25",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 324,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLAFLORES",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "9/4/2019",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-04",
      anio_mes: "2019-09",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 325,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COPAINALA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "9/20/2019",
      mes_fecha: 9,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-20",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 327,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "HUEHUETAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "HUIXTLA",
      fecha_texto: "9/6/2019",
      mes_fecha: 9,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-06",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 330,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "10/1/2019",
      mes_fecha: 10,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-01",
      anio_mes: "2019-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/09/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 331,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "USUMACINTA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "1/9/2019",
      mes_fecha: 1,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-09",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 333,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/22/2019",
      mes_fecha: 3,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-22",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 336,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COPAINALA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "4/6/2019",
      mes_fecha: 4,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-06",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 338,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "8/6/2019",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-06",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 339,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CACAHOATAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "9/20/2019",
      mes_fecha: 9,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-20",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 340,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "8/8/2019",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-08",
      anio_mes: "2019-08",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 341,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MEZCALAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "11/7/2019",
      mes_fecha: 11,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-07",
      anio_mes: "2019-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 342,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "10/18/2019",
      mes_fecha: 10,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-18",
      anio_mes: "2019-10",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 346,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "9/24/2019",
      mes_fecha: 9,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-24",
      anio_mes: "2019-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 362,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BALLEZA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "PARRAL",
      fecha_texto: "10/15/2019",
      mes_fecha: 10,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-15",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 363,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUACHOCHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "GUACHOCHI",
      fecha_texto: "9/28/2019",
      mes_fecha: 9,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-28",
      anio_mes: "2019-09",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 373,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CARICHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "7/24/2019",
      mes_fecha: 7,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-24",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 379,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/6/2019",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-06",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 381,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NUEVO CASAS GRANDES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "9/13/2019",
      mes_fecha: 9,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-13",
      anio_mes: "2019-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 386,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GALEANA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "8/2/2019",
      mes_fecha: 8,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-02",
      anio_mes: "2019-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 413,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "5/8/2019",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-08",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 425,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "6/14/2019",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-14",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 432,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "8/12/2019",
      mes_fecha: 8,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-12",
      anio_mes: "2019-08",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 433,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "1/30/2019",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-30",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 446,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "2/25/2019",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-25",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 448,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "3/26/2019",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-26",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 452,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "3/27/2019",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-27",
      anio_mes: "2019-03",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 453,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "8/14/2019",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-14",
      anio_mes: "2019-08",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "22/04/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 454,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "4/26/2019",
      mes_fecha: 4,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-26",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "17/04/2019",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 456,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACCAN",
      fecha_texto: "6/28/2019",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-28",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 457,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "6/25/2019",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-25",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 465,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "2/28/2019",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-28",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 470,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MILPA ALTA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "11/7/2019",
      mes_fecha: 11,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-07",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 471,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "2/27/2019",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-27",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 472,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "7/5/2019",
      mes_fecha: 7,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-05",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 481,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/6/2019",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-06",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "23/05/2017",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 482,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "3/26/2019",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-26",
      anio_mes: "2019-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 483,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "11/28/2019",
      mes_fecha: 11,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-28",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 486,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MAGDALENA CONTRERAS",
      fecha_texto: "3/7/2019",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-07",
      anio_mes: "2019-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 487,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "6/25/2019",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-25",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 491,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "1/26/2019",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-26",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 493,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "8/29/2019",
      mes_fecha: 8,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-29",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06/08/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 495,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "11/20/2019",
      mes_fecha: 11,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-20",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 498,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "12/4/2019",
      mes_fecha: 12,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-04",
      anio_mes: "2019-12",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 500,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "2/13/2019",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-13",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 503,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "10/24/2019",
      mes_fecha: 10,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-24",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 505,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MAGDALENA CONTRERAS",
      fecha_texto: "7/9/2019",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-09",
      anio_mes: "2019-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 507,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "5/6/2019",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-06",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 511,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "9/10/2019",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-10",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 519,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MILPA ALTA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "8/24/2019",
      mes_fecha: 8,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-24",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 521,
      edad: "73",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MAGDALENA CONTRERAS",
      fecha_texto: "2/28/2019",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-28",
      anio_mes: "2019-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 524,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "6/3/2019",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-03",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "01/09/2018",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 526,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/26/2019",
      mes_fecha: 4,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-26",
      anio_mes: "2019-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/04/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 530,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "11/29/2019",
      mes_fecha: 11,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-29",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 531,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/19/2019",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-19",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 534,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "10/18/2019",
      mes_fecha: 10,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-18",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 535,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "11/1/2019",
      mes_fecha: 11,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-01",
      anio_mes: "2019-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 541,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "1/25/2019",
      mes_fecha: 1,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-25",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 543,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "10/29/2019",
      mes_fecha: 10,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-29",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 546,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "11/20/2019",
      mes_fecha: 11,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-20",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 551,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "9/12/2019",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-12",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 553,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "9/18/2019",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-18",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 555,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "2/4/2019",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-04",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 562,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "12/12/2019",
      mes_fecha: 12,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-12",
      anio_mes: "2019-12",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 565,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "2/25/2019",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-25",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 566,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLAHUAC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "XOCHIMILCO",
      fecha_texto: "3/20/2019",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-20",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 572,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "6/20/2019",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-20",
      anio_mes: "2019-06",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "24/05/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 573,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "1/6/2020",
      mes_fecha: 1,
      dia_fecha: 6,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-06",
      anio_mes: "2020-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 575,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "2/25/2019",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-25",
      anio_mes: "2019-02",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 578,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "1/28/2019",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-28",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 581,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "4/15/2019",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-15",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/01/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 585,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "7/31/2019",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-31",
      anio_mes: "2019-07",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "18/07/2019",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 589,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "6/27/2019",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-27",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 591,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "9/17/2019",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-17",
      anio_mes: "2019-09",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "02/09/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 594,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "11/22/2019",
      mes_fecha: 11,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-22",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 598,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "3/7/2019",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-07",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 599,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "1/7/2019",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-07",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 600,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 605,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "11/15/2019",
      mes_fecha: 11,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-15",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 606,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "1/14/2019",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-14",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 609,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "11/11/2019",
      mes_fecha: 11,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-11",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/3/2019",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 611,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/13/2019",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-13",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 612,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "7/19/2019",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-19",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 613,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "1/10/2019",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-10",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 615,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "4/15/2019",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-15",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 620,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MAGDALENA CONTRERAS",
      fecha_texto: "5/14/2019",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-14",
      anio_mes: "2019-05",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 624,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "10/22/2019",
      mes_fecha: 10,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-22",
      anio_mes: "2019-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 627,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/22/2019",
      mes_fecha: 3,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-22",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 633,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "4/22/2019",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-22",
      anio_mes: "2019-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 634,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/28/2019",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-28",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 635,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/12/2019",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-12",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 640,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/13/2019",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-13",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 644,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "10/7/2019",
      mes_fecha: 10,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-07",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 648,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "RAMOS ARIZPE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "6/2/2019",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-02",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 652,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "1/2/2020",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-02",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 653,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/27/2019",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-27",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "8",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 654,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREÓN",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREÓN",
      fecha_texto: "3/15/2019",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-15",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 655,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "6/20/2019",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-20",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 656,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/29/2019",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-29",
      anio_mes: "2019-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 665,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/14/2019",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-14",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 668,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "CUATRO CIENEGAS",
      fecha_texto: "8/5/2019",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-05",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 670,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREÓN",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "4/8/2019",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-08",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 671,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "7/9/2019",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-09",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "30/06/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 672,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "1/2/2020",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-02",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 674,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "9/30/2019",
      mes_fecha: 9,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-30",
      anio_mes: "2019-09",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 675,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "7/10/2019",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-10",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 676,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREÓN",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "4/1/2019",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-01",
      anio_mes: "2019-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 678,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/27/2019",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-27",
      anio_mes: "2019-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 682,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "8/26/2019",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-26",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 683,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "1/2/2020",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-02",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 686,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/13/2019",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-13",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "24/04/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 688,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "1/2/2020",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-02",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 691,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "1/2/2020",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-02",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 694,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "1/2/2020",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-02",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 698,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/25/2019",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-25",
      anio_mes: "2019-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 700,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/13/2019",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-13",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 703,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREÓN",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/29/2019",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-29",
      anio_mes: "2019-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 704,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "6/13/2019",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-13",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 707,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREÓN",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "5/17/2019",
      mes_fecha: 5,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-17",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "03/01/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 708,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREÓN",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "5/17/2019",
      mes_fecha: 5,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-17",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "03/01/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 710,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "COAHUILA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "7/8/2019",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-08",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 711,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "CUATRO CIENEGAS",
      fecha_texto: "7/16/2019",
      mes_fecha: 7,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-16",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 714,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/26/2019",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-26",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 717,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "5/27/2019",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-27",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/04/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 720,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "4/4/2019",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-04",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "21/05/2013",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 721,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/6/2019",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-06",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 723,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "7/23/2019",
      mes_fecha: 7,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-23",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 724,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "GENERAL CEPEDA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/26/2019",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-26",
      anio_mes: "2019-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 727,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREÓN",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "4/2/2019",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-02",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 729,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "RAMOS ARIZPE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "7/26/2019",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-26",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 731,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "7/9/2019",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-09",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 734,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "1/2/2019",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-02",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 739,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREÓN",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "4/2/2019",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-02",
      anio_mes: "2019-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 757,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "MAPIMÍ",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "LERDO",
      fecha_texto: "5/2/2019",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-02",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 758,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "LERDO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "4/23/2019",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-23",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/03/2019",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 760,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "10/16/2019",
      mes_fecha: 10,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-16",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 761,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "10/16/2019",
      mes_fecha: 10,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-16",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 764,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "2/6/2019",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-06",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 765,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GÓMEZ PALACIO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "6/11/2019",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-11",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "05/06/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 767,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/23/2019",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-23",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 768,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "1/15/2019",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-15",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 769,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GÓMEZ PALACIO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "5/6/2019",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-06",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "09/04/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 772,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "LERDO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "LERDO",
      fecha_texto: "3/11/2019",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-11",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 773,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "MAPIMÍ",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "2/20/2019",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-20",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "28/01/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 774,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "SANTIAGO PAPASQUIARO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "12/3/2019",
      mes_fecha: 12,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-03",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "05/10/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 775,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GÓMEZ PALACIO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "2/13/2019",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-13",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 776,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GÓMEZ PALACIO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "4/8/2019",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-08",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "06/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 777,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "3/16/2019",
      mes_fecha: 3,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-16",
      anio_mes: "2019-03",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 778,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "SANTIAGO PAPASQUIARO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "SANTIAGO PAPASQUIARO",
      fecha_texto: "9/27/2019",
      mes_fecha: 9,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-27",
      anio_mes: "2019-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "21/06/2019",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 779,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "3/13/2019",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-13",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 780,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/15/2019",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-15",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 782,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "6/11/2019",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-11",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 786,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/23/2019",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-23",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 791,
      edad: "#REF!",
      grupo_edad: "#REF!",
      demografia_edad: "",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CORTAZAR",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CORTAZAR",
      fecha_texto: "1/31/2019",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-31",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 793,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "3/13/2019",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-13",
      anio_mes: "2019-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "04/01/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 801,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/6/2019",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-06",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 807,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "5/10/2019",
      mes_fecha: 5,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-10",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 808,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/30/2019",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-30",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 810,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/12/2019",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-12",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 820,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/11/2019",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-11",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "18/12/2018",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 824,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/17/2019",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-17",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "29/01/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 836,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "5/31/2019",
      mes_fecha: 5,
      dia_fecha: 31,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-31",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "21/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 845,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN MIGUEL DE ALLENDE",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN MIGUEL DE ALLENDE",
      fecha_texto: "8/27/2019",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-27",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "08/08/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 846,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN FELIPE",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "6/4/2019",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-04",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/04/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 851,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "PURISIMA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "PURISIMA",
      fecha_texto: "3/7/2019",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-07",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "01/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 852,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "PURISIMA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "PURISIMA",
      fecha_texto: "3/12/2019",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-12",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 853,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "GUANAJUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "1/30/2019",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-30",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 856,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/15/2019",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-15",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "03/12/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 867,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "2/25/2019",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-25",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 874,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/10/2019",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-10",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 886,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALAMANCA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SALAMANCA",
      fecha_texto: "2/1/2019",
      mes_fecha: 2,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-01",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 890,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/13/2019",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-13",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "15/04/2019",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 891,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ROMITA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ROMITA",
      fecha_texto: "2/1/2019",
      mes_fecha: 2,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-01",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/01/2019",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 899,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/25/2019",
      mes_fecha: 1,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-25",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 900,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/6/2019",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-06",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 917,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "2/7/2019",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-07",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 935,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ABASOLO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "5/24/2019",
      mes_fecha: 5,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-24",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 937,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/1/2019",
      mes_fecha: 2,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-01",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 943,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "4/24/2019",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-24",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 944,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/10/2019",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-10",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 960,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN FELIPE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/2/2019",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-02",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 965,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/8/2019",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-08",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 966,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/11/2019",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-11",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "01/06/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 972,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "3/13/2019",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-13",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 973,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/14/2019",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-14",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 978,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/17/2019",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-17",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 982,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/5/2019",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-05",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 991,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/26/2019",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-26",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 992,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "6/22/2019",
      mes_fecha: 6,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-22",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1002,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "3/18/2019",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-18",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1015,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALAMANCA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SALAMANCA",
      fecha_texto: "4/16/2019",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-16",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1022,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "3/22/2019",
      mes_fecha: 3,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-22",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1024,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "GUANAJUATO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "10/11/2019",
      mes_fecha: 10,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-11",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/21/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1027,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/5/2019",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-05",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "01/01/1992",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1029,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/19/2019",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-19",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "15/12/2017",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1047,
      edad: "#REF!",
      grupo_edad: "#REF!",
      demografia_edad: "",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JUVENTINO ROSAS",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JUVENTINO ROSAS",
      fecha_texto: "1/22/2019",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-22",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "28/12/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1048,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/5/2019",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-05",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "01/01/1992",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1050,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "11/22/2019",
      mes_fecha: 11,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-22",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1051,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "10/30/2019",
      mes_fecha: 10,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-30",
      anio_mes: "2019-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1062,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/11/2019",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-11",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1065,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/16/2019",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-16",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1067,
      edad: "#REF!",
      grupo_edad: "#REF!",
      demografia_edad: "",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "VILLAGRAN",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "VILLAGRAN",
      fecha_texto: "2/15/2019",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-15",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "18/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1068,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/14/2019",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-14",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1073,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ROMITA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ROMITA",
      fecha_texto: "11/21/2019",
      mes_fecha: 11,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-21",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "26/07/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1078,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/1/2019",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-01",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "09/02/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1080,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN FELIPE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "9/20/2019",
      mes_fecha: 9,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-20",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1094,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/18/2019",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-18",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1106,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/28/2019",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-28",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1109,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/13/2019",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-13",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1118,
      edad: "#REF!",
      grupo_edad: "#REF!",
      demografia_edad: "",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "COMONFORT",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "7/18/2019",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-18",
      anio_mes: "2019-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1119,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "COMONFORT",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "7/18/2019",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-18",
      anio_mes: "2019-07",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "31/10/2014",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1132,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/19/2019",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-19",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1140,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/18/2019",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-18",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1147,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "GUANAJUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "GUANAJUATO",
      fecha_texto: "1/16/2019",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-16",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1160,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "4/30/2019",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-30",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1162,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/26/2019",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-26",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1164,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/22/2019",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-22",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/01/2019",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1174,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/5/2019",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-05",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "01/01/2004",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1185,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "7/1/2019",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-01",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1186,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "4/16/2019",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-16",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "23/03/2019",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1187,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "GUANAJUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "4/1/2019",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-01",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1213,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "12/8/2019",
      mes_fecha: 12,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-08",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1227,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/29/2019",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-29",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1231,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "TECPAN DE GALEANA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "10/24/2019",
      mes_fecha: 10,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-24",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1297,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TIZAYUCA",
      fecha_texto: "6/10/2019",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-10",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1329,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "MINERAL DE LA REFORMA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA",
      fecha_texto: "7/17/2019",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-17",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1339,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA",
      fecha_texto: "6/26/2019",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-26",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1349,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULANCINGO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "5/2/2019",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-02",
      anio_mes: "2019-05",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1354,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "12/13/2019",
      mes_fecha: 12,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-13",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1356,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "4/22/2019",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-22",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1370,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "10/28/2019",
      mes_fecha: 10,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-28",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "22/02/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1376,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "11/13/2019",
      mes_fecha: 11,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-13",
      anio_mes: "2019-11",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "07/06/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1377,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "9/20/2019",
      mes_fecha: 9,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-20",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "19/08/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1378,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "BOLAÑOS",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "COLOTLAN",
      fecha_texto: "8/29/2019",
      mes_fecha: 8,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-29",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "25/11/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1387,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "BOLAÑOS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "JEREZ",
      fecha_texto: "8/19/2019",
      mes_fecha: 8,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-19",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/06/2019",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1391,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "10/22/2019",
      mes_fecha: 10,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-22",
      anio_mes: "2019-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1397,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PONCITLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/1/2019",
      mes_fecha: 2,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-01",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1403,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/15/2019",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-15",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1411,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "10/25/2019",
      mes_fecha: 10,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-25",
      anio_mes: "2019-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1412,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "2/8/2019",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-08",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1414,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PONCITLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/16/2019",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-16",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1418,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/20/2019",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-20",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1439,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/18/2019",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-18",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1441,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAJOMULCO DE ZÚÑIGA",
      fecha_texto: "2/5/2019",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-05",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1445,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "7/10/2019",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-10",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1461,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/17/2019",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-17",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "20/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1464,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "AUTLAN DE NAVARRO",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "1/22/2019",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-22",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1465,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/13/2019",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-13",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1471,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "7/12/2019",
      mes_fecha: 7,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-12",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "07/06/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1475,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/27/2019",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-27",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/01/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1488,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/5/2019",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-05",
      anio_mes: "2019-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "30/06/1905",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1489,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/24/2019",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-24",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1492,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "6/3/2019",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-03",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1502,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/13/2019",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-13",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1503,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/11/2019",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-11",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1509,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/5/2019",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-05",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1514,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/31/2019",
      mes_fecha: 5,
      dia_fecha: 31,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-31",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/04/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1521,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAJOMULCO DE ZÚÑIGA",
      fecha_texto: "3/6/2019",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-06",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1529,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "EL SALTO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/19/2019",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-19",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1535,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/19/2019",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-19",
      anio_mes: "2019-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1537,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "6/18/2019",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-18",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1540,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "JALOSTOTITLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "JALOSTOTITLAN",
      fecha_texto: "6/26/2019",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-26",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1542,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/26/2019",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-26",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1550,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "8/10/2019",
      mes_fecha: 8,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-10",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1551,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/27/2019",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-27",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1556,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/1/2019",
      mes_fecha: 2,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-01",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1559,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "OJUELOS DE JALISCO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "OJUELOS DE JALISCO",
      fecha_texto: "4/24/2019",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-24",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1565,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/17/2019",
      mes_fecha: 3,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-17",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1569,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PONCITLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/29/2019",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-29",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1575,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/15/2019",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-15",
      anio_mes: "2019-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1576,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "1/7/2019",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-07",
      anio_mes: "2019-01",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1577,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/28/2019",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-28",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1579,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TUXCUECA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "8/4/2019",
      mes_fecha: 8,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-04",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1588,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "4/2/2019",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-02",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1589,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZUMPANGO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TECAMAC",
      fecha_texto: "5/3/2019",
      mes_fecha: 5,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-03",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1590,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZUMPANGO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TECAMAC",
      fecha_texto: "5/3/2019",
      mes_fecha: 5,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-03",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1591,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NEZAHUALCOYOTL",
      fecha_texto: "3/13/2019",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-13",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1592,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NEZAHUALCOYOTL",
      fecha_texto: "3/13/2019",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-13",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1594,
      edad: "69",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "5/8/2019",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-08",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1595,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TENANCINGO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TENANCINGO",
      fecha_texto: "4/17/2019",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-17",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1597,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NEZAHUALCOYOTL",
      fecha_texto: "5/30/2019",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-30",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1602,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZUMPANGO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA",
      fecha_texto: "4/2/2019",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-02",
      anio_mes: "2019-04",
      institucion_notificacion: 6,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1604,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "4/1/2019",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-01",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1605,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC DE MORELOS",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "1/8/2019",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-08",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1608,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "4/26/2019",
      mes_fecha: 4,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-26",
      anio_mes: "2019-04",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1609,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TECAMAC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "6/24/2019",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-24",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1612,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TLLNEPANTLA",
      fecha_texto: "1/18/2019",
      mes_fecha: 1,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-18",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1615,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "OZUMBA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "6/13/2019",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-13",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1617,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "MELCHOR OCAMPO",
      estado_notificacion: "CDMX",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "1/25/2019",
      mes_fecha: 1,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-25",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1619,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "6/20/2019",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-20",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1620,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC DE MORELOS",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "7/3/2019",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-03",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1625,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "8/19/2019",
      mes_fecha: 8,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-19",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1626,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZINACANTEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ZINACANTEPEC",
      fecha_texto: "3/15/2019",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-15",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "20/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1628,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "HUEHUETOCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ZUMPANGO",
      fecha_texto: "10/8/2019",
      mes_fecha: 10,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-08",
      anio_mes: "2019-10",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1629,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "JILOTZINGO",
      estado_notificacion: "CDMX",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "3/20/2019",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-20",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1630,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "1/6/2019",
      mes_fecha: 1,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-06",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "24/10/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1631,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CUAUTITLAN IZCALLI",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CUAUTITLAN I",
      fecha_texto: "3/21/2019",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-21",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "31/01/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1633,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TULTITLAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "9/12/2019",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-12",
      anio_mes: "2019-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1634,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TULTITLAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "10/2/2019",
      mes_fecha: 10,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-02",
      anio_mes: "2019-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1636,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "COCOTITLAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "9/19/2019",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-19",
      anio_mes: "2019-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1638,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "LOS REYES LA PAZ",
      estado_notificacion: "CDMX",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "4/10/2019",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-10",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1640,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "VALLE DE CHALCO",
      fecha_texto: "2/8/2019",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-08",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1641,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "3/22/2019",
      mes_fecha: 3,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-22",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1642,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GAM",
      fecha_texto: "5/23/2019",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-23",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "19/04/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1643,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "HUEHUETOCAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CUAUTITLAN",
      fecha_texto: "6/11/2019",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-11",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1646,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "1/25/2019",
      mes_fecha: 1,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-25",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1648,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "7/3/2019",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-03",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1652,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZUMPANGO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TECAMAC",
      fecha_texto: "5/3/2019",
      mes_fecha: 5,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-03",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1653,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEXCOCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TEXCOCO",
      fecha_texto: "2/28/2019",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-28",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1655,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "10/18/2019",
      mes_fecha: 10,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-18",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1657,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "3/5/2019",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-05",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1659,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "OTZOLOTEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "OTZOLOTEPEC",
      fecha_texto: "3/21/2019",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-21",
      anio_mes: "2019-03",
      institucion_notificacion: 6,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1660,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "1/8/2019",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-08",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1664,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NAUCALPAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NAUCALPAN",
      fecha_texto: "2/6/2019",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-06",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1675,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC DE MORELOS",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "7/1/2019",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-01",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "27/05/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1677,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "4/26/2019",
      mes_fecha: 4,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-26",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1679,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "9/5/2019",
      mes_fecha: 9,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-05",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1680,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VILLA VICTORIA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "9/14/2019",
      mes_fecha: 9,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-14",
      anio_mes: "2019-09",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1685,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "7/30/2019",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-30",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1687,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "HUEHUETOCA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "1/1/2019",
      mes_fecha: 1,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-01",
      anio_mes: "2019-01",
      institucion_notificacion: 8,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1694,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "6/18/2019",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-18",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1699,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC DE MORELOS",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "7/31/2019",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-31",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1701,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC DE MORELOS",
      estado_notificacion: "CDMX",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "3/5/2019",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-05",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1704,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "HUIXQUILUCAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "6/25/2019",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-25",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1707,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC DE MORELOS",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "3/19/2019",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-19",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1711,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NAUCALPAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NAUCALPAN",
      fecha_texto: "1/22/2019",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-22",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "07/01/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1712,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "XONACATLAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "6/6/2019",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-06",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1721,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TECAMAC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TECAMAC",
      fecha_texto: "4/24/2019",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-24",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1722,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "LOS REYES LA PAZ",
      fecha_texto: "6/4/2019",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-04",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1723,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEZOYUCA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "8/6/2019",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-06",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1731,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "9/19/2019",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-19",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1743,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "2/4/2019",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-04",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "28/01/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1744,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "10/4/2019",
      mes_fecha: 10,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-04",
      anio_mes: "2019-10",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1747,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "CARACUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "3/28/2019",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-28",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1748,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "CARACUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "3/28/2019",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-28",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1757,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "1/15/2019",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-15",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/12/2018",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1761,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "2/4/2019",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-04",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1762,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "TARIMBARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "3/27/2019",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-27",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1766,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "10/28/2019",
      mes_fecha: 10,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-28",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1769,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "YURECUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "YURECUARO",
      fecha_texto: "10/15/2019",
      mes_fecha: 10,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-15",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1773,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "4/26/2019",
      mes_fecha: 4,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-26",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1774,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "3/26/2019",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-26",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/05/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1780,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "PATZCUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "2/7/2019",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-07",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "02/01/2019",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1781,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "JACONA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "JACONA",
      fecha_texto: "10/6/2019",
      mes_fecha: 10,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-06",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1782,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "10/2/2019",
      mes_fecha: 10,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-02",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1792,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "2/25/2019",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-25",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "28/01/2019",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1795,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "TLALPUJAHUA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MARAVATIO",
      fecha_texto: "9/6/2019",
      mes_fecha: 9,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-06",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1798,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "1/28/2019",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-28",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "08/01/1900",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1800,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "9/19/2019",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-19",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1805,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "HIDALGO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "10/20/2019",
      mes_fecha: 10,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-20",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1807,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "7/24/2019",
      mes_fecha: 7,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-24",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1811,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "QUIROGA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "12/16/2019",
      mes_fecha: 12,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-16",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1815,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "COENEO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "COENEO",
      fecha_texto: "3/21/2019",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-21",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1817,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "3/26/2019",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-26",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1821,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TEMIXCO",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "TEMIXCO",
      fecha_texto: "1/16/2019",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-16",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/02/2014",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1828,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "4/1/2019",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-01",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/03/2019",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1833,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "JIUTEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "10/21/2019",
      mes_fecha: 10,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-21",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1837,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "MAZATEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "TETECALA",
      fecha_texto: "3/19/2019",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-19",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "14/03/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1838,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "1/28/2019",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-28",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "30/10/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1840,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "YAUTEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "3/20/2019",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-20",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "31/01/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1845,
      edad: "63",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "1/28/2019",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-28",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1846,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "MIACATLAN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "6/5/2019",
      mes_fecha: 6,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-05",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1847,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "AYALA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "JONACATEPEC",
      fecha_texto: "9/12/2019",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-12",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1850,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "YAUTEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "4/10/2019",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-10",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1852,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "ZACATEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUARNAVACA",
      fecha_texto: "10/9/2019",
      mes_fecha: 10,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-09",
      anio_mes: "2019-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "06/10/2018",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1855,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "3/4/2019",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-04",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1856,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "JIUTEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "1/28/2019",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-28",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1857,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "1/29/2019",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-29",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1858,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "COATETELCO",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "3/27/2019",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-27",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1866,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "5/28/2019",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-28",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1872,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "JALA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "11/17/2019",
      mes_fecha: 11,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-17",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1875,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "SAN BLAS",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "7/9/2019",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-09",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1876,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "4/16/2019",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-16",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1877,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "COMPOSTELA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "COMPOSTELA",
      fecha_texto: "12/3/2019",
      mes_fecha: 12,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-03",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "22/11/2019",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1879,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "SANTIAGO IXCUINTLA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "SANTIAGO IXCUINTLA",
      fecha_texto: "11/21/2019",
      mes_fecha: 11,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-21",
      anio_mes: "2019-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1886,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "7/3/2019",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-03",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1888,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/6/2019",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-06",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1892,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "6/3/2019",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-03",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1894,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/24/2019",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-24",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1895,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/19/2019",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-19",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "15/05/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1897,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "HIDALGO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/22/2019",
      mes_fecha: 6,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-22",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1900,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "2/6/2019",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-06",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1905,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "9/2/2019",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-02",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1910,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/6/2019",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-06",
      anio_mes: "2019-05",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1911,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/27/2019",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-27",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1912,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "1/16/2019",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-16",
      anio_mes: "2019-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1916,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/22/2019",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-22",
      anio_mes: "2019-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "20/12/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1921,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "2/6/2019",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-06",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1923,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/21/2019",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-21",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1924,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/18/2019",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-18",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1926,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/4/2019",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-04",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1929,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GENERAL ESCOBEDO",
      fecha_texto: "1/16/2019",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-16",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1930,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/15/2019",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-15",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "01/04/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1931,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/25/2019",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-25",
      anio_mes: "2019-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1932,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/3/2019",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-03",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "05/11/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1933,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "3/12/2019",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-12",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1940,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "2/7/2019",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-07",
      anio_mes: "2019-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 6,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1941,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/28/2019",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-28",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1944,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/6/2019",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-06",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1948,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZUAZUA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "6/25/2019",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-25",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "04/06/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1949,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/21/2019",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-21",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1950,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "4/16/2019",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-16",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1952,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/1/2019",
      mes_fecha: 6,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-01",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1957,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/12/2019",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-12",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "26/04/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1963,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/26/2019",
      mes_fecha: 4,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-26",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1965,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/4/2019",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-04",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1966,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/13/2019",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-13",
      anio_mes: "2019-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "05/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1973,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "12/30/2019",
      mes_fecha: 12,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-30",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1975,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZUAZUA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "6/14/2019",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-14",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1977,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/13/2019",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-13",
      anio_mes: "2019-05",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1978,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/20/2019",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-20",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1979,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CIENEGA DE FLORES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/5/2019",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-05",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1980,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZUAZUA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "11/21/2019",
      mes_fecha: 11,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-21",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1983,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/16/2019",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-16",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1984,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "HIDALGO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/18/2019",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-18",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1985,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/3/2019",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-03",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1990,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN PEDRO GARZA GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "11/25/2019",
      mes_fecha: 11,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-25",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 1998,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/12/2019",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-12",
      anio_mes: "2019-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2007,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "1/27/2019",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-27",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2011,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "6/18/2019",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-18",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/04/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2014,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/1/2019",
      mes_fecha: 3,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-01",
      anio_mes: "2019-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2015,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "6/24/2019",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-24",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2022,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "3/29/2019",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-29",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2025,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTEMORELOS",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTEMORELOS",
      fecha_texto: "5/19/2019",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-19",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2026,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/3/2019",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-03",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "22/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2028,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/10/2019",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-10",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2029,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "7/8/2019",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-08",
      anio_mes: "2019-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2032,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/11/2019",
      mes_fecha: 5,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-11",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2035,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "3/20/2019",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-20",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2037,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/17/2019",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-17",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2038,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "10/18/2019",
      mes_fecha: 10,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-18",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2040,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "LOS HERRERA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "CERRALVO",
      fecha_texto: "7/15/2019",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-15",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2041,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/19/2019",
      mes_fecha: 8,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-19",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2046,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "2/4/2019",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-04",
      anio_mes: "2019-02",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2051,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/26/2019",
      mes_fecha: 4,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-26",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2053,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/1/2019",
      mes_fecha: 6,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-01",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2058,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/20/2019",
      mes_fecha: 8,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-20",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2059,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/28/2019",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-28",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2061,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "8/14/2019",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-14",
      anio_mes: "2019-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2067,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/2/2019",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-02",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/10/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2072,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "8/21/2019",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-21",
      anio_mes: "2019-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2073,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/17/2019",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-17",
      anio_mes: "2019-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2076,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "11/1/2019",
      mes_fecha: 11,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-01",
      anio_mes: "2019-11",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2078,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/20/2019",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-20",
      anio_mes: "2019-05",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2079,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/30/2019",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-30",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "29/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2080,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/24/2019",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-24",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2086,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "4/22/2019",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-22",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2087,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/14/2019",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-14",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2091,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "2/25/2019",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-25",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "14/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2094,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/29/2019",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-29",
      anio_mes: "2019-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2095,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/6/2019",
      mes_fecha: 4,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-06",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "15/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2105,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CIENEGA DE FLORES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/25/2019",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-25",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2107,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/25/2019",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-25",
      anio_mes: "2019-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2108,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/15/2019",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-15",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "05/04/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2110,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "8/15/2019",
      mes_fecha: 8,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-15",
      anio_mes: "2019-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2111,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "CERRALVO",
      fecha_texto: "9/16/2019",
      mes_fecha: 9,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-16",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2115,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "11/27/2019",
      mes_fecha: 11,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-27",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2119,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/8/2019",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-08",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "02/05/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2122,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/14/2019",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-14",
      anio_mes: "2019-06",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2123,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/4/2019",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-04",
      anio_mes: "2019-06",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06/05/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2128,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/6/2019",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-06",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2133,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "4/3/2019",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-03",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "04/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2137,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/29/2019",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-29",
      anio_mes: "2019-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "06/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2149,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "9/17/2019",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-17",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2151,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "7/8/2019",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-08",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2152,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "8/18/2019",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-18",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2153,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "HIDALGO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "5/15/2019",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-15",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2154,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/2/2019",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-02",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2157,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "1/21/2019",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-21",
      anio_mes: "2019-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2160,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/2/2019",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-02",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "15/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2163,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GALEANA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GALEANA",
      fecha_texto: "6/25/2019",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-25",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2165,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL TERAN",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTEMORELOS",
      fecha_texto: "2/26/2019",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-26",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "07/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2168,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/2/2019",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-02",
      anio_mes: "2019-05",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2175,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/13/2019",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-13",
      anio_mes: "2019-05",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2182,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/6/2019",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-06",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2183,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/6/2019",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-06",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2185,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/7/2019",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-07",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2194,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/6/2019",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-06",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "22/04/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2197,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "8/14/2019",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-14",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2204,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/20/2019",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-20",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2205,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/1/2019",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-01",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2211,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/25/2019",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-25",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2212,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/18/2019",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-18",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2213,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "7/10/2019",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-10",
      anio_mes: "2019-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2214,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CIENEGA DE FLORES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/27/2019",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-27",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2218,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/22/2019",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-22",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2220,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "5/3/2019",
      mes_fecha: 5,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-03",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "26/03/2019",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2225,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "4/9/2019",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-09",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2227,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "12/11/2019",
      mes_fecha: 12,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-11",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2233,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "DOCTOR ARROYO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/3/2020",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-03",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2234,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "10/13/2019",
      mes_fecha: 10,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-13",
      anio_mes: "2019-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "05/10/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2236,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "7/21/2019",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-21",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2237,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "10/22/2019",
      mes_fecha: 10,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-22",
      anio_mes: "2019-10",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/09/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2241,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "2/27/2019",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-27",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2243,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTEMORELOS",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTEMORELOS",
      fecha_texto: "5/28/2019",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-28",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "03/07/2017",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2246,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "7/30/2019",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-30",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "22/05/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2250,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/14/2019",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-14",
      anio_mes: "2019-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "15/04/2019",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2252,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/29/2019",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-29",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "02/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2256,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "ALLENDE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTEMORELOS",
      fecha_texto: "10/30/2019",
      mes_fecha: 10,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-30",
      anio_mes: "2019-10",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2270,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/27/2019",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-27",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "01/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2272,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "5/24/2019",
      mes_fecha: 5,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-24",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2278,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "HUAJUAPAN DE LEON",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "HUAJUAPAN DE LEON",
      fecha_texto: "2/11/2019",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-11",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2279,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "ZAACHILA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "ZAACHILA",
      fecha_texto: "2/18/2019",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-18",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2280,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA",
      fecha_texto: "1/18/2019",
      mes_fecha: 1,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-18",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2282,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "PINOTEPA DE DON LUIS",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "PINOTEPA DE DON LUIS",
      fecha_texto: "6/13/2019",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-13",
      anio_mes: "2019-06",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2283,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN JACINTO AMILPAS",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "7/15/2019",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-15",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2287,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN ANTONIO SINICAHUA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "TLAXIACO",
      fecha_texto: "11/25/2019",
      mes_fecha: 11,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-25",
      anio_mes: "2019-11",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2289,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "STA CRUZ XOXOCOTLAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA",
      fecha_texto: "6/6/2019",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-06",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2290,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA MARIA CHILCHOTLA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "HUAUTLA DE JIMENEZ",
      fecha_texto: "7/23/2019",
      mes_fecha: 7,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-23",
      anio_mes: "2019-07",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2292,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN FELIPE TEJALAPAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN FELIPE TEJALAPAN",
      fecha_texto: "7/17/2019",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-17",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2294,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "JUXTLAHUACA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO JUXTLAHUACA",
      fecha_texto: "9/18/2019",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-18",
      anio_mes: "2019-09",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2295,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "MIAHUATLAN DE PORFIRIO DIAZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "2/7/2019",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-07",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2297,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PEDRO MIXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN PEDRO MIXTEPEC",
      fecha_texto: "3/27/2019",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-27",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2298,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO JAMILTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO JAMILTEPEC",
      fecha_texto: "1/12/2019",
      mes_fecha: 1,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-12",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2299,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN AGUSTIN YATARENI",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "2/19/2019",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-19",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2300,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA MARIA PEÑOLES",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTA MARIA PEÑOLES",
      fecha_texto: "8/30/2019",
      mes_fecha: 8,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-30",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2302,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN MIGUEL PERAS",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO JUXTLAHUACA",
      fecha_texto: "11/26/2019",
      mes_fecha: 11,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-26",
      anio_mes: "2019-11",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2304,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO AYUQUILILLA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO AYUQULILLA",
      fecha_texto: "2/15/2019",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-15",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2308,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "JUXTLAHUACA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO JUXTLAHUACA",
      fecha_texto: "8/30/2019",
      mes_fecha: 8,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-30",
      anio_mes: "2019-08",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2309,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "PINOTEPA DE DON LUIS",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "PINOTEPA DE DON LUIS",
      fecha_texto: "11/25/2019",
      mes_fecha: 11,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-25",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2310,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN NICOLAS HIDALGO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN NICOLAS HIDALGO",
      fecha_texto: "7/17/2019",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-17",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2311,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PEDRO MIXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN PEDRO MIXTEPEC",
      fecha_texto: "3/27/2019",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-27",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2312,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "STA MARIA TONAMECA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA",
      fecha_texto: "6/6/2019",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-06",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2313,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA MARIA PEÑOLES",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA",
      fecha_texto: "6/24/2019",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-24",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2315,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA CRUZ XOXOCOTLAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTA CRUZ XOXOCOTLAN",
      fecha_texto: "7/14/2019",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-14",
      anio_mes: "2019-07",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/8/2019",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2316,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA LUCIA DEL CAMINO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA",
      fecha_texto: "8/3/2019",
      mes_fecha: 8,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-03",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2317,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "STO DOMINGO TEOJOMULCO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "VILLA SOLA DE VEGA",
      fecha_texto: "6/10/2019",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-10",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2321,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "CONSTANCIA ROSARIO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "PUTLA DE GUERRERO",
      fecha_texto: "11/28/2019",
      mes_fecha: 11,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-28",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/5/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2323,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "TEZOATLAN DE SEGURA Y LUNA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "TEZOATLAN DE SEGURA Y LUNA",
      fecha_texto: "2/26/2019",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-26",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2324,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA CRUZ MIXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN PABLO HUIXTEPEC",
      fecha_texto: "7/5/2019",
      mes_fecha: 7,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-05",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2328,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "HUAUCHINANGO",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "HUAUCHINANGO",
      fecha_texto: "2/20/2019",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-20",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "06/02/2019",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2329,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "TEHUACAN",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "TEHUACAN",
      fecha_texto: "1/15/2019",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-15",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2334,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "NAUPAN",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "NAUPAN",
      fecha_texto: "1/10/2019",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-10",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2345,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "CHIGNAHUAPAN",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "CHIGNAHUAPAN",
      fecha_texto: "1/13/2019",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-13",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2346,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "CHILCHOTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "5/6/2019",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-06",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2351,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "5/27/2019",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-27",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2352,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "9/30/2019",
      mes_fecha: 9,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-30",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2355,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "8/20/2019",
      mes_fecha: 8,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-20",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "27/05/2019",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2356,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "COLON",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "9/9/2019",
      mes_fecha: 9,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-09",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2357,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "AMEALCO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "11/21/2019",
      mes_fecha: 11,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-21",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2360,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "6/30/2019",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-30",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2362,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "PEDRO ESCOBEDO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "8/12/2019",
      mes_fecha: 8,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-12",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2364,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "5/19/2019",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-19",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2366,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "6/3/2019",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-03",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2374,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "3/20/2019",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-20",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2378,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/29/2019",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-29",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2384,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "PEDRO ESCOBEDO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "10/14/2019",
      mes_fecha: 10,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-14",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2385,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "3/20/2019",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-20",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2389,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "TEQUISQUIAPAN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "2/4/2019",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-04",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "18/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2391,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/1/2019",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-01",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2392,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "7/19/2019",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-19",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2395,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JOAQUIN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "2/22/2019",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-22",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "03/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2397,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "12/8/2019",
      mes_fecha: 12,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-08",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2400,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "3/6/2019",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-06",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2403,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "10/25/2019",
      mes_fecha: 10,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-25",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2406,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/26/2019",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-26",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2409,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EZEQUIEL MONTES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "3/27/2019",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-27",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2412,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "8/17/2019",
      mes_fecha: 8,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-17",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "24/07/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2413,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "7/25/2019",
      mes_fecha: 7,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-25",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2417,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "COLON",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "11/7/2019",
      mes_fecha: 11,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-07",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2420,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "9/3/2019",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-03",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "01/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2423,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/18/2019",
      mes_fecha: 1,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-18",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2426,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/6/2019",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-06",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2427,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/24/2019",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-24",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2433,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "7/5/2019",
      mes_fecha: 7,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-05",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2436,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/16/2019",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-16",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2438,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/6/2020",
      mes_fecha: 1,
      dia_fecha: 6,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-06",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2442,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/8/2019",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-08",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2443,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "HUIMILPAN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/24/2019",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-24",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "19/12/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2456,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "7/11/2019",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-11",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2457,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "6/25/2019",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-25",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2464,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/24/2019",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-24",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2467,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/15/2019",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-15",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2470,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/16/2018",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2018,
      fecha_notificacion: "2018-01-16",
      anio_mes: "2018-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2473,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "9/5/2019",
      mes_fecha: 9,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-05",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2478,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "COZUMEL",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "COZUMEL",
      fecha_texto: "6/10/2019",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-10",
      anio_mes: "2019-06",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "03/06/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2479,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "COZUMEL",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "COZUMEL",
      fecha_texto: "6/10/2019",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-10",
      anio_mes: "2019-06",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "XX/XX/1961",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2487,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "SOLIDARIDAD",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "SOLIDARIDAD",
      fecha_texto: "10/1/2019",
      mes_fecha: 10,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-01",
      anio_mes: "2019-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "30/06/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2488,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "9/30/2019",
      mes_fecha: 9,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-30",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2506,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "10/11/2019",
      mes_fecha: 10,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-11",
      anio_mes: "2019-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "28/08/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2529,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "TAMASOPO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "4/4/2019",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-04",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/25/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2530,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "8/2/2019",
      mes_fecha: 8,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-02",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2545,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/20/2019",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-20",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2553,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "2/7/2019",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-07",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2562,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE REYES",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "1/30/2019",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-30",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2567,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CERRITOS",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CERRITOS",
      fecha_texto: "1/15/2019",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-15",
      anio_mes: "2019-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2574,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/17/2019",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-17",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/1/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2580,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "2/21/2019",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-21",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/31/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2620,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "8/6/2019",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-06",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2621,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "AHUALULCO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "10/11/2019",
      mes_fecha: 10,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-11",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2626,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE REYES",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "1/8/2019",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-08",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/23/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2628,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MATLAPA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "MATLAPA",
      fecha_texto: "12/3/2019",
      mes_fecha: 12,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-03",
      anio_mes: "2019-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "11/26/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2637,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SALINAS",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SALINAS",
      fecha_texto: "5/29/2019",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-29",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2655,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "RIOVERDE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "3/28/2019",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-28",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2680,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "1/7/2019",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-07",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/21/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2681,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "2/22/2019",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-22",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/21/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2682,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "1/18/2019",
      mes_fecha: 1,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-18",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2695,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CERRITOS",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "2/7/2019",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-07",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2701,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "5/28/2019",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-28",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2706,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/12/2019",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-12",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2709,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "HUEHUETLA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CD VALLES",
      fecha_texto: "3/7/2019",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-07",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/12/2019",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2716,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "TAMUIN",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CD VALLES",
      fecha_texto: "5/16/2019",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-16",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2731,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE ARISTA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "1/8/2019",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-08",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/13/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2733,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MATEHUALA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "MATEHUALA",
      fecha_texto: "9/13/2019",
      mes_fecha: 9,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-13",
      anio_mes: "2019-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2763,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "AHOME",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "AHOME",
      fecha_texto: "11/25/2019",
      mes_fecha: 11,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-25",
      anio_mes: "2019-11",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "15/11/2019",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2769,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "11/25/2019",
      mes_fecha: 11,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-25",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2770,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "9/3/2019",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-03",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "14/08/2019",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2801,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "ETCHOJOA",
      estado_notificacion: "SONORA",
      municipio_notificacion: "ETCHOJOA",
      fecha_texto: "9/10/2019",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-10",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2803,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "ALAMOS",
      estado_notificacion: "SONORA",
      municipio_notificacion: "ALAMOS",
      fecha_texto: "1/22/2019",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-22",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2807,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "7/2/2019",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-02",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2812,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/15/2019",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-15",
      anio_mes: "2019-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "21/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2816,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/1/2019",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-01",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2817,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/1/2019",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-01",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2819,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "12/30/2019",
      mes_fecha: 12,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-30",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2829,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "11/4/2019",
      mes_fecha: 11,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-04",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "28/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2837,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "8/22/2019",
      mes_fecha: 8,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-22",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "19/05/2017",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2842,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "5/14/2019",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-14",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "24/04/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2846,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "8/22/2019",
      mes_fecha: 8,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-22",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "07/09/2014",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2847,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "8/22/2019",
      mes_fecha: 8,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-22",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "03/05/2016",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2848,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HUATABAMPO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NAVOJOA",
      fecha_texto: "5/27/2019",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-27",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2855,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/25/2019",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-25",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "07/03/2019",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2858,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NAVOJOA",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NAVOJOA",
      fecha_texto: "7/30/2019",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-30",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "15/05/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2865,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/12/2019",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-12",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2867,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "6/24/2019",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-24",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2868,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "GUAYMAS",
      estado_notificacion: "SONORA",
      municipio_notificacion: "GUAYMAS",
      fecha_texto: "12/16/2019",
      mes_fecha: 12,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-16",
      anio_mes: "2019-12",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2874,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/5/2019",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-05",
      anio_mes: "2019-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "14/11/2017",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2877,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "12/4/2019",
      mes_fecha: 12,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-04",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2878,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "4/13/2019",
      mes_fecha: 4,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-13",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2884,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/11/2019",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-11",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2887,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "12/27/2019",
      mes_fecha: 12,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-27",
      anio_mes: "2019-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2888,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "EMPALME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "GUAYMAS",
      fecha_texto: "8/15/2019",
      mes_fecha: 8,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-15",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2891,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "12/27/2019",
      mes_fecha: 12,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-27",
      anio_mes: "2019-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2894,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "GUAYMAS",
      estado_notificacion: "SONORA",
      municipio_notificacion: "GUAYMAS",
      fecha_texto: "6/27/2019",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-27",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/02/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2901,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "CUMPAS",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "12/9/2019",
      mes_fecha: 12,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-09",
      anio_mes: "2019-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2905,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HUATABAMPO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "4/10/2019",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-10",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "20/03/2019",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2911,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "12/12/2019",
      mes_fecha: 12,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-12",
      anio_mes: "2019-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2913,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "8/5/2019",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-05",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2917,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HUATABAMPO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NAVOJOA",
      fecha_texto: "4/24/2019",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-24",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2918,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "5/9/2019",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-09",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2924,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "10/14/2019",
      mes_fecha: 10,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-14",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2929,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "1/8/2020",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-08",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2934,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "8/20/2019",
      mes_fecha: 8,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-20",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2935,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "4/29/2019",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-29",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2936,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "8/5/2019",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-05",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2940,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NAVOJOA",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NAVOJOA",
      fecha_texto: "8/30/2019",
      mes_fecha: 8,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-30",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2942,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "12/30/2019",
      mes_fecha: 12,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-30",
      anio_mes: "2019-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2945,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "1/21/2019",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-21",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2951,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "10/23/2019",
      mes_fecha: 10,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-23",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2952,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "11/5/2019",
      mes_fecha: 11,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-05",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "8",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2954,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "5/30/2019",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-30",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2957,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "EMPALME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "GUAYMAS",
      fecha_texto: "7/12/2019",
      mes_fecha: 7,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-12",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "03/06/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2963,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "5/16/2019",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-16",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06/05/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2970,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "CABORCA",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/22/2019",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-22",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2974,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "6/29/2019",
      mes_fecha: 6,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-29",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2979,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "7/8/2019",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-08",
      anio_mes: "2019-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "14/06/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 2982,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TABASCO",
      municipio_residencia: "HUIMANGUILLO",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "12/18/2019",
      mes_fecha: 12,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-18",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3006,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "VICTORIA",
      fecha_texto: "1/14/2020",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-14",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "20/12/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3011,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "4/3/2019",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-03",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3013,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "4/8/2019",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-08",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "30/01/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3030,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "ALTAMIRA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "TAMPICO",
      fecha_texto: "5/29/2019",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-29",
      anio_mes: "2019-05",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3032,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "PADILLA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "VICTORIA",
      fecha_texto: "3/22/2019",
      mes_fecha: 3,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-22",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3038,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "3/20/2019",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-20",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3040,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "9/18/2019",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-18",
      anio_mes: "2019-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3045,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "VICTORIA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "VICTORIA",
      fecha_texto: "7/22/2019",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-22",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3048,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "3/31/2019",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-31",
      anio_mes: "2019-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3053,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "3/19/2019",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-19",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3056,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "2/14/2019",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-14",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3062,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "1/7/2019",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-07",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3064,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "VICTORIA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "VICTORIA",
      fecha_texto: "7/22/2019",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-22",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3067,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "1/31/2019",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-31",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3070,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "4/25/2019",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-25",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3074,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "ANTONIO CARVAJAL",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "2/6/2019",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-06",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/09/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3075,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "ANTONIO CARVAJAL",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "4/7/2019",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-07",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3076,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUAMANTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "HUAMANTLA",
      fecha_texto: "10/18/2019",
      mes_fecha: 10,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-18",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3078,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "APIZACO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "5/8/2019",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-08",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3086,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUAMANTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "6/18/2019",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-18",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3090,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "XICOTZINCO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ANTONIO CARBAJAL",
      fecha_texto: "11/19/2019",
      mes_fecha: 11,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-19",
      anio_mes: "2019-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3094,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/25/2019",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-25",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "20/12/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3096,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "APIZACO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "5/24/2019",
      mes_fecha: 5,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-24",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3100,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "ANTONIO CARVAJAL",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "4/7/2019",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-07",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3103,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TOTOLAC",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "12/11/2019",
      mes_fecha: 12,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-11",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "28/08/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3105,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUAMANTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "HUAMANTLA",
      fecha_texto: "10/3/2019",
      mes_fecha: 10,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-03",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3113,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUAMANTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "6/19/2019",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-19",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "14/07/2019",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3116,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CORDOBA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "CORDOBA",
      fecha_texto: "1/24/2019",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-24",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3118,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TANTOYUCA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "8/2/2019",
      mes_fecha: 8,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-02",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3126,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TATAHUICAPAN DE JUAREZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "MECAYAPAN",
      fecha_texto: "2/13/2019",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-13",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3130,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TEXHUACAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ORIZABA",
      fecha_texto: "11/25/2019",
      mes_fecha: 11,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-25",
      anio_mes: "2019-11",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3133,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LAS CHOAPAS",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "LAS CHOAPAS",
      fecha_texto: "10/19/2019",
      mes_fecha: 10,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-19",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3137,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZACOALCOS",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COATZACOALCOS",
      fecha_texto: "5/10/2019",
      mes_fecha: 5,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-10",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3142,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CORDOBA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "6/26/2019",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-26",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3147,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "EL HIGO",
      estado_notificacion: "TAMPICO",
      municipio_notificacion: "TAMPICO",
      fecha_texto: "4/15/2019",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-15",
      anio_mes: "2019-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3152,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "5/27/2019",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-27",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3153,
      edad: "57",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ORIZABA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ORIZABA",
      fecha_texto: "8/26/2019",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-26",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3154,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TLACOLULAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "9/10/2019",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-10",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "24/04/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3157,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "EMILIANO ZAPATA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/13/2019",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-13",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3161,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "7/22/2019",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-22",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06/07/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3164,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MARTINEZ DE LA TORRE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "8/20/2019",
      mes_fecha: 8,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-20",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3165,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "OMEALCA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "CORDOBA",
      fecha_texto: "9/4/2019",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-04",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3170,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PLAYA VICENTE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "PLAYA VICENTE",
      fecha_texto: "12/11/2019",
      mes_fecha: 12,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-11",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3174,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "5/23/2019",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-23",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3180,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "6/25/2019",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-25",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3181,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ORIZABA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "8/6/2019",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-06",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/07/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3185,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MINATITLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "MINATITLAN",
      fecha_texto: "7/8/2019",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-08",
      anio_mes: "2019-07",
      institucion_notificacion: 7,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3189,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TANTOYUCA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TUXPAN",
      fecha_texto: "10/23/2019",
      mes_fecha: 10,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-23",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3190,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN RAFAEL",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "7/3/2019",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-03",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3191,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MALTRATA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "9/10/2019",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-10",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3192,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZACOALCOS",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COATZACOALCOS",
      fecha_texto: "3/10/2019",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-10",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3197,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COTAXTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "4/30/2019",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-30",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3199,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ALPATLAHUAC",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COSCOMATEPEC",
      fecha_texto: "8/5/2019",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-05",
      anio_mes: "2019-08",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3200,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "12/5/2019",
      mes_fecha: 12,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-05",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3201,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TEZONAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TEZONAPA",
      fecha_texto: "1/16/2019",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-16",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3202,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "NOGALES",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "NOGALES",
      fecha_texto: "2/13/2019",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-13",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3205,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "RIO BLANCO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ORIZABA",
      fecha_texto: "5/15/2019",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-15",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "22/04/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3206,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TAMIAHUA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TUXPAN",
      fecha_texto: "8/11/2019",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-11",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3211,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XICO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "9/4/2019",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-04",
      anio_mes: "2019-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "24/06/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3215,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CORDOBA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "CORDOBA",
      fecha_texto: "8/16/2019",
      mes_fecha: 8,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-16",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "16/07/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3217,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TEQUILA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "8/7/2019",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-07",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3219,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/26/2019",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-26",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3220,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COTAXTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "CORDOBA",
      fecha_texto: "11/21/2019",
      mes_fecha: 11,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-21",
      anio_mes: "2019-11",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3221,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZACOALCOS",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COATZACOALCOS",
      fecha_texto: "12/27/2019",
      mes_fecha: 12,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-27",
      anio_mes: "2019-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "04/12/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3226,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ISLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ISLA",
      fecha_texto: "9/4/2019",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-04",
      anio_mes: "2019-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3230,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/30/2019",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-30",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3234,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MUXUPIP",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/1/2019",
      mes_fecha: 6,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-01",
      anio_mes: "2019-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "18/04/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3235,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "HALACHO",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/9/2019",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-09",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3238,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "10/8/2019",
      mes_fecha: 10,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-08",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3239,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MOTUL",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "2/24/2019",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-24",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3241,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "CHEMAX",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "VALLADOLID",
      fecha_texto: "4/30/2019",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-30",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3242,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "4/14/2019",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-14",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3244,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "BUCTZOTZ",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "2/4/2019",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-04",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3246,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "CHEMAX",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "VALLADOLID",
      fecha_texto: "8/5/2019",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-05",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "25/05/2009",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3248,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MUNA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "8/5/2019",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-05",
      anio_mes: "2019-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/07/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3250,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "PETO",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "1/22/2019",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-22",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3253,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "DZONCAUICH",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "2/7/2019",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-07",
      anio_mes: "2019-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3254,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TICUL",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/6/2019",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-06",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3261,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "1/14/2019",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-14",
      anio_mes: "2019-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3265,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "10/9/2019",
      mes_fecha: 10,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-10-09",
      anio_mes: "2019-10",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3266,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "UCU",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "11/5/2019",
      mes_fecha: 11,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-11-05",
      anio_mes: "2019-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3269,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MOTUL",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MOTUL",
      fecha_texto: "9/2/2019",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-02",
      anio_mes: "2019-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3271,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/23/2019",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-23",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3273,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "DZITAS",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "VALLADOLID",
      fecha_texto: "6/9/2019",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-09",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/05/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3281,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "1/8/2020",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-08",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3283,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "HUNUCMA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/9/2019",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-09",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3291,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "9/11/2019",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-09-11",
      anio_mes: "2019-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3292,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "HOMUN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "1/3/2020",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-03",
      anio_mes: "2020-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3293,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIXCACALCUPUL",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "VALLADOLID",
      fecha_texto: "5/16/2019",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-16",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "21/01/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3295,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "2/26/2019",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-26",
      anio_mes: "2019-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3296,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "KINCHIL",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/9/2019",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-09",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3298,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "IZAMAL",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "12/24/2019",
      mes_fecha: 12,
      dia_fecha: 24,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-24",
      anio_mes: "2019-12",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3304,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIXCACALCUPUL",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "VALLADOLID",
      fecha_texto: "1/26/2019",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-26",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "21/09/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3305,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "2/27/2019",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-27",
      anio_mes: "2019-02",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/05/2006",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3310,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "RIO GRANDE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "1/18/2019",
      mes_fecha: 1,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-18",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3311,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "5/9/2019",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-09",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3315,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "5/20/2019",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-20",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "23/04/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3318,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VETAGRANDE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "4/14/2019",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-14",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3320,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "5/5/2019",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-05",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3324,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "RIO GRANDE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "RIO GRANDE",
      fecha_texto: "3/26/2019",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-26",
      anio_mes: "2019-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "15/03/2019",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3326,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "PINOS",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "5/8/2019",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-08",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3328,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "6/11/2019",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-11",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3329,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "TEPETONGO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "JEREZ",
      fecha_texto: "6/6/2019",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-06",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3330,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "PANUCO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/17/2019",
      mes_fecha: 3,
      dia_fecha: 17,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-17",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3333,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "5/21/2019",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-21",
      anio_mes: "2019-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3334,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "2/12/2019",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-12",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3335,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "2/28/2019",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-28",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3337,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "4/25/2019",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-25",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3342,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "CALERA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "4/7/2019",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-07",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3346,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "6/11/2019",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-11",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3350,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "TRANCOSO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "12/9/2019",
      mes_fecha: 12,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-12-09",
      anio_mes: "2019-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3354,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA DE COS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/18/2019",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2019,
      fecha_notificacion: "2019-03-18",
      anio_mes: "2019-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3355,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "OJCALIENTE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "6/9/2019",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-09",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3359,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "MORELOS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "4/9/2019",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-09",
      anio_mes: "2019-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3362,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "2/8/2019",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-08",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3365,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "2/19/2019",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-19",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3375,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "PANFILO NATERA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "GENERAL PANFILO NATERA",
      fecha_texto: "8/9/2019",
      mes_fecha: 8,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-08-09",
      anio_mes: "2019-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3376,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "TLALTENANGO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "JEREZ",
      fecha_texto: "5/31/2019",
      mes_fecha: 5,
      dia_fecha: 31,
      anio_fecha: 2019,
      fecha_notificacion: "2019-05-31",
      anio_mes: "2019-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3378,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "PINOS",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "1/30/2019",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2019,
      fecha_notificacion: "2019-01-30",
      anio_mes: "2019-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3379,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA DE COS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "4/1/2019",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2019,
      fecha_notificacion: "2019-04-01",
      anio_mes: "2019-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3381,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "2/20/2019",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-20",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3388,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "2/27/2019",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-27",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3395,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "TEPECHITLAN",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "JEREZ",
      fecha_texto: "7/9/2019",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2019,
      fecha_notificacion: "2019-07-09",
      anio_mes: "2019-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3399,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "2/21/2019",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2019,
      fecha_notificacion: "2019-02-21",
      anio_mes: "2019-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2019,
      fila_archivo: 3400,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "CALERA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/28/2019",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2019,
      fecha_notificacion: "2019-06-28",
      anio_mes: "2019-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 6,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/10/2020",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-10",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 7,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "PABELLON DE ARTEAGA",
      fecha_texto: "1/15/2020",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-15",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 8,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/27/2020",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-27",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 9,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/27/2020",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-27",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 11,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/7/2020",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-07",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "30/12/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 14,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "2/12/2020",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-12",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 17,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "2/21/2020",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-21",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 30,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TECATE",
      fecha_texto: "2/5/2020",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-05",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "20/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 35,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "3/2/2020",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-02",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "19/02/2020",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 36,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "2/27/2020",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-27",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "30/01/2020",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 37,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "5/16/2020",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2020,
      fecha_notificacion: "2020-05-16",
      anio_mes: "2020-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 38,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "2/21/2020",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-21",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "17/02/2019",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 42,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "4/4/2020",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-04",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 47,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "2/19/2020",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-19",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 52,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "PLAYAS DE ROSARITO",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "PLAYAS DE ROSARITO",
      fecha_texto: "1/21/2020",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-21",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 54,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "4/27/2020",
      mes_fecha: 4,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-27",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 55,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "1/23/2020",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-23",
      anio_mes: "2020-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 56,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "PLAYAS DE ROSARITO",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "PLAYAS DE ROSARITO",
      fecha_texto: "2/24/2020",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-24",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 57,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "PLAYAS DE ROSARITO",
      fecha_texto: "2/12/2020",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-12",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 59,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "3/12/2020",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-12",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 64,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "4/13/2020",
      mes_fecha: 4,
      dia_fecha: 13,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-13",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 66,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOZOCOAUTLA DE ESPINOSA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/18/2020",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-18",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 67,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SIMOJOVEL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/25/2020",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-25",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 69,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/5/2020",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-05",
      anio_mes: "2020-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 70,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/9/2020",
      mes_fecha: 2,
      dia_fecha: 9,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-09",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 71,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TAPACHULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "5/4/2020",
      mes_fecha: 5,
      dia_fecha: 4,
      anio_fecha: 2020,
      fecha_notificacion: "2020-05-04",
      anio_mes: "2020-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 72,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TAPACHULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "6/9/2020",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2020,
      fecha_notificacion: "2020-06-09",
      anio_mes: "2020-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 75,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "1/9/2020",
      mes_fecha: 1,
      dia_fecha: 9,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-09",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 77,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SIMOJOVEL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/7/2020",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-07",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 79,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CHAMULA",
      fecha_texto: "5/5/2020",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2020,
      fecha_notificacion: "2020-05-05",
      anio_mes: "2020-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 81,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/5/2020",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-05",
      anio_mes: "2020-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 84,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SIMOJOVEL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/5/2020",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-05",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 85,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN FERNANDO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/29/2020",
      mes_fecha: 2,
      dia_fecha: 29,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-29",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 86,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN FERNANDO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/29/2020",
      mes_fecha: 2,
      dia_fecha: 29,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-29",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 87,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "PALENQUE",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "PALENQUE",
      fecha_texto: "2/22/2020",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-22",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 88,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MOTOZINTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "MOTOZINTLA",
      fecha_texto: "8/19/2020",
      mes_fecha: 8,
      dia_fecha: 19,
      anio_fecha: 2020,
      fecha_notificacion: "2020-08-19",
      anio_mes: "2020-08",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 90,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CHAMULA",
      fecha_texto: "5/5/2020",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2020,
      fecha_notificacion: "2020-05-05",
      anio_mes: "2020-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 94,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TAPACHULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "3/20/2020",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-20",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 97,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "1/26/2020",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-26",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 98,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MOTOZINTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "1/14/2020",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-14",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 100,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BERRIOZABAL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/28/2020",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-28",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 101,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/24/2020",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-24",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 108,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SUCHIAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/27/2020",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-27",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 109,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BERRIOZABAL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/18/2020",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-18",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 115,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/5/2020",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-05",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 125,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/18/2020",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-18",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 126,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/30/2020",
      mes_fecha: 3,
      dia_fecha: 30,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-30",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 129,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CU8AUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/16/2020",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-16",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 138,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NAMIQUIPA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/30/2020",
      mes_fecha: 3,
      dia_fecha: 30,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-30",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 147,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/26/2020",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-26",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 150,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUADALUPE Y CALVO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/19/2020",
      mes_fecha: 4,
      dia_fecha: 19,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-19",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 151,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "5/29/2020",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2020,
      fecha_notificacion: "2020-05-29",
      anio_mes: "2020-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 158,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/15/2020",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-15",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 161,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CARICHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "5/25/2020",
      mes_fecha: 5,
      dia_fecha: 25,
      anio_fecha: 2020,
      fecha_notificacion: "2020-05-25",
      anio_mes: "2020-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 166,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "2/28/2020",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-28",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 173,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/3/2020",
      mes_fecha: 2,
      dia_fecha: 3,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-03",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/01/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 177,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "2/13/2020",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-13",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 179,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLAHUAC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "6/1/2020",
      mes_fecha: 6,
      dia_fecha: 1,
      anio_fecha: 2020,
      fecha_notificacion: "2020-06-01",
      anio_mes: "2020-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 181,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "7/2/2020",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2020,
      fecha_notificacion: "2020-07-02",
      anio_mes: "2020-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "17/06/2020",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 186,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "3/17/2020",
      mes_fecha: 3,
      dia_fecha: 17,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-17",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 189,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "2/18/2020",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-18",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 191,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "2/10/2020",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-10",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 192,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "2/6/2020",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-06",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 193,
      edad: "71",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "5/18/2020",
      mes_fecha: 5,
      dia_fecha: 18,
      anio_fecha: 2020,
      fecha_notificacion: "2020-05-18",
      anio_mes: "2020-05",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 195,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "2/19/2020",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-19",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 197,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "1/24/2020",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-24",
      anio_mes: "2020-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "20/11/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 199,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "6/19/2020",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2020,
      fecha_notificacion: "2020-06-19",
      anio_mes: "2020-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 200,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/4/2020",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-04",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "29/10/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 201,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "2/26/2020",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-26",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 203,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "3/3/2020",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-03",
      anio_mes: "2020-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 206,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MAGDALENA CONTRERAS",
      fecha_texto: "2/14/2020",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-14",
      anio_mes: "2020-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 214,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "1/20/2020",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-20",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 221,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "11/10/2020",
      mes_fecha: 11,
      dia_fecha: 10,
      anio_fecha: 2020,
      fecha_notificacion: "2020-11-10",
      anio_mes: "2020-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 224,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/2/2020",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-02",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 227,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SAN PEDRO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SAN PEDRO",
      fecha_texto: "2/19/2020",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-19",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "23/01/2020",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 237,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COLIMA",
      municipio_residencia: "TECOMAN",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "VILLA DE ALVAREZ",
      fecha_texto: "1/13/2020",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-13",
      anio_mes: "2020-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 240,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "MEZQUITEL",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "3/8/2020",
      mes_fecha: 3,
      dia_fecha: 8,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-08",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "23/02/2020",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 241,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "SIMÓN BOLIVAR",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "CUENCAMÉ",
      fecha_texto: "3/20/2020",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-20",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 243,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/1/2020",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-01",
      anio_mes: "2020-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 245,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GÓMEZ PALACIO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "3/10/2020",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-10",
      anio_mes: "2020-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 248,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "2/12/2020",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-12",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 252,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "MANUEL DOBLADO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "MANUEL DOBLADO",
      fecha_texto: "2/12/2020",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-12",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "05/09/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 265,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/3/2020",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-03",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 271,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN MIGUEL DE ALLENDE",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN MIGUEL DE ALLENDE",
      fecha_texto: "1/20/2020",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-20",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 275,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "12/22/2020",
      mes_fecha: 12,
      dia_fecha: 22,
      anio_fecha: 2020,
      fecha_notificacion: "2020-12-22",
      anio_mes: "2020-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/11/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 291,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN LUIS DE LA PAZ",
      fecha_texto: "2/17/2020",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-17",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 300,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOCTOR MORA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN LUIS DE LA PAZ",
      fecha_texto: "3/17/2020",
      mes_fecha: 3,
      dia_fecha: 17,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-17",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 320,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "1/21/2020",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-21",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 359,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ZEMPOALA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA",
      fecha_texto: "3/23/2020",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-23",
      anio_mes: "2020-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "05/11/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 360,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ZEMPOALA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "ZEMPOALA",
      fecha_texto: "3/24/2020",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-24",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "29/07/2019",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 362,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "HUICHAPAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "HUICHAPAN",
      fecha_texto: "1/28/2020",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-28",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06/01/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 363,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TEPATITLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TEPATITLÁN DE MORELOS",
      fecha_texto: "1/30/2020",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-30",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 365,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ATOTONILCO EL ALTO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ATOTONILCO",
      fecha_texto: "3/21/2020",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-21",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 367,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/31/2020",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-31",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 370,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/29/2020",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-29",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 374,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "EL SALTO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/12/2020",
      mes_fecha: 4,
      dia_fecha: 12,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-12",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 378,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/8/2020",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-08",
      anio_mes: "2020-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/02/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 382,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/26/2020",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-26",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 392,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/27/2020",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-27",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 397,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "6/12/2020",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2020,
      fecha_notificacion: "2020-06-12",
      anio_mes: "2020-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "07/06/2019",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 398,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "1/30/2020",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-30",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 399,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "YAHUALICA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "2/7/2020",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-07",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 401,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "OCOTLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LA BARCA",
      fecha_texto: "2/5/2020",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-05",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 404,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/11/2020",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-11",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 405,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TALA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "1/7/2020",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-07",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2DA.",
      fecha_ultima_dosis: "14/10/2019",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 414,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "CHAPALA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/15/2020",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-15",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 417,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOTLAN EL REY",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/23/2020",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-23",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 418,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TALA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/13/2020",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-13",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 419,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZUMPANGO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA",
      fecha_texto: "2/21/2020",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-21",
      anio_mes: "2020-02",
      institucion_notificacion: 6,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 421,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHIMALHUACAN",
      fecha_texto: "3/6/2020",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-06",
      anio_mes: "2020-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 423,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEOLOYUCAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA",
      fecha_texto: "7/11/2020",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2020,
      fecha_notificacion: "2020-07-11",
      anio_mes: "2020-07",
      institucion_notificacion: 6,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/23/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 425,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "1/23/2020",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-23",
      anio_mes: "2020-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 426,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "VALLE DE CHALCO",
      fecha_texto: "3/6/2020",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-06",
      anio_mes: "2020-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/01/2019",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 427,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "4/8/2020",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-08",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 428,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "2/28/2020",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-28",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 430,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NAUCALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "5/20/2020",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2020,
      fecha_notificacion: "2020-05-20",
      anio_mes: "2020-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 431,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "LERMA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZITACUARO",
      fecha_texto: "2/20/2020",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-20",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 433,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/27/2020",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-27",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 436,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "LOS REYES LA PAZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "1/21/2020",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-21",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 442,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "2/21/2020",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-21",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 443,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "2/27/2020",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-27",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 444,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "2/4/2020",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-04",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 447,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "PARACUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "APATZINGAN",
      fecha_texto: "4/7/2020",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-07",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 450,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "1/20/2020",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-20",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 451,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "OCAMPO",
      fecha_texto: "2/10/2020",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-10",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 453,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZITACUARO",
      fecha_texto: "3/5/2020",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-05",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 455,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "TARETAN",
      estado_notificacion: "MICHOACACN",
      municipio_notificacion: "TARETAN",
      fecha_texto: "4/21/2020",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-21",
      anio_mes: "2020-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "31/03/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 456,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "TUZANTLA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZITACUARO",
      fecha_texto: "1/23/2020",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-23",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 458,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "HIDALGO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "HIDALGO",
      fecha_texto: "3/3/2020",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-03",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 459,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "COAHUAYANA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "TECOMAN",
      fecha_texto: "4/8/2020",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-08",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 460,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZITACUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZITACUARO",
      fecha_texto: "2/10/2020",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-10",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 461,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "PATZCUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "3/16/2020",
      mes_fecha: 3,
      dia_fecha: 16,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-16",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 462,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "CHURUMUCO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "2/13/2020",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-13",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 463,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "PATZCUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "2/13/2020",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-13",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 464,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "PICHATARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "3/3/2020",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-03",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 465,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "1/29/2020",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-29",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 466,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "PATZCUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "2/28/2020",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-28",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 472,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "AQUILA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "TECOMAN",
      fecha_texto: "3/9/2020",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-09",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 473,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "AQUILA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "TECOMAN",
      fecha_texto: "3/12/2020",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-12",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 478,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "YAUTEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "1/22/2020",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-22",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 479,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "AXOCHIAPN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "AXOCHIAPAN",
      fecha_texto: "4/27/2020",
      mes_fecha: 4,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-27",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "04/10/2019",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 480,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "AXOCHIAPN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "AXOCHIAPAN",
      fecha_texto: "4/27/2020",
      mes_fecha: 4,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-27",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "08/04/2020",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 484,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "1/29/2020",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-29",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 489,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "SANTIAGO IXCUINTLA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "1/23/2020",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-23",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 490,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "SAN BLAS",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "4/16/2020",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-16",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "18/03/2020",
      tipo_vacuna: "4",
      complicaciones: 4,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 491,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "JESUS MARIA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "DEL NAYAR",
      fecha_texto: "6/15/2020",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2020,
      fecha_notificacion: "2020-06-15",
      anio_mes: "2020-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 500,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/23/2020",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-23",
      anio_mes: "2020-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "18/02/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 502,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/8/2020",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-08",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "03/03/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 510,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GALEANA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GALEANA",
      fecha_texto: "3/27/2020",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-27",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "19/03/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 524,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/13/2020",
      mes_fecha: 4,
      dia_fecha: 13,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-13",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 557,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "9/2/2020",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2020,
      fecha_notificacion: "2020-09-02",
      anio_mes: "2020-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 559,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "2/5/2020",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-05",
      anio_mes: "2020-02",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 562,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/25/2020",
      mes_fecha: 5,
      dia_fecha: 25,
      anio_fecha: 2020,
      fecha_notificacion: "2020-05-25",
      anio_mes: "2020-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 572,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZARAGOZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/21/2020",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-21",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 573,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/14/2020",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-14",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 574,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/23/2020",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-23",
      anio_mes: "2020-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 583,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "2/4/2020",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-04",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 584,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CIENEGA DE FLORES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/18/2020",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-18",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 591,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTO DOMINGO ALBARRADAS",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "2/26/2020",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-26",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 594,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN MARTIN PERAS",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "3/24/2020",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-24",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 596,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "CUILAPAM DE GUERRERO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "4/3/2020",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-03",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 597,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PEDRO MIXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN PEDRO MIXTEPEC",
      fecha_texto: "2/10/2020",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-10",
      anio_mes: "2020-02",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "21/10/2014",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 600,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "ACATLAN DE PEREZ FIGUEROA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "CORDOBA",
      fecha_texto: "2/25/2020",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-25",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 601,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "YEHUALTEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "CDMX",
      fecha_texto: "2/10/2020",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-10",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 602,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "ESPERANZA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "CORDOVA",
      fecha_texto: "1/24/2020",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-24",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 604,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "SN.P. CHOLULA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "8/26/2020",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2020,
      fecha_notificacion: "2020-08-26",
      anio_mes: "2020-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 605,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADERYTA",
      fecha_texto: "2/13/2020",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-13",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "02/12/2019",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 606,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "AMEALCO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "4/1/2020",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-01",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 608,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "9/21/2020",
      mes_fecha: 9,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-09-21",
      anio_mes: "2020-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 609,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/24/2020",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-24",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 610,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "AMEALCO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "2/11/2020",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-11",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 612,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/10/2020",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-10",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 614,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/23/2020",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-23",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 617,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADERYTA",
      fecha_texto: "2/14/2020",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-14",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 618,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "3/30/2020",
      mes_fecha: 3,
      dia_fecha: 30,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-30",
      anio_mes: "2020-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 620,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "EL MARQUES",
      fecha_texto: "1/30/2020",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-30",
      anio_mes: "2020-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 621,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADERYTA",
      fecha_texto: "1/30/2020",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-30",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 622,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/2/2020",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-02",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 624,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/23/2020",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-23",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 626,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/26/2020",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-26",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 627,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CORREGIDORA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/12/2020",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-12",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 631,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "FELIPE CARRILLO PUERTO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "FELIPE CARRILLO PUERTO",
      fecha_texto: "1/30/2020",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-30",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 635,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/19/2020",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2020,
      fecha_notificacion: "2020-05-19",
      anio_mes: "2020-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 638,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "FELIPE CARRILLO PUERTO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "FELIPE CARRILLO PUERTO",
      fecha_texto: "4/20/2020",
      mes_fecha: 4,
      dia_fecha: 20,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-20",
      anio_mes: "2020-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 642,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSÍ",
      fecha_texto: "3/5/2020",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-05",
      anio_mes: "2020-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 653,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSÍ",
      fecha_texto: "1/29/2020",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-29",
      anio_mes: "2020-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 681,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSÍ",
      fecha_texto: "2/7/2020",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-07",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/11/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 685,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSÍ",
      fecha_texto: "1/28/2020",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-28",
      anio_mes: "2020-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 704,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "4/21/2020",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-21",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 727,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "SAN LUIS RIO COLORADO",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "2/21/2020",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-21",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 731,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "1/22/2020",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-22",
      anio_mes: "2020-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 733,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/6/2020",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-06",
      anio_mes: "2020-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 738,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/27/2020",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-27",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 739,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/27/2020",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-27",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 740,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "9/1/2020",
      mes_fecha: 9,
      dia_fecha: 1,
      anio_fecha: 2020,
      fecha_notificacion: "2020-09-01",
      anio_mes: "2020-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 742,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/29/2020",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-29",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 749,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/2/2020",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-02",
      anio_mes: "2020-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 756,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "1/7/2020",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-07",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 759,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "2/8/2020",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-08",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 760,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "1/23/2020",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-23",
      anio_mes: "2020-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 764,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "2/21/2020",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-21",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 768,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/9/2020",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-09",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "18/02/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 769,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/30/2020",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-30",
      anio_mes: "2020-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 774,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/9/2020",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-09",
      anio_mes: "2020-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 782,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/30/2020",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-30",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 784,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "JALPA DE MENDEZ",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "JALPA DE MENDEZ",
      fecha_texto: "2/5/2020",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-05",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "15/08/2010",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 785,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CENTLA",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "6/15/2020",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2020,
      fecha_notificacion: "2020-06-15",
      anio_mes: "2020-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 787,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CENTLA",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "8/24/2020",
      mes_fecha: 8,
      dia_fecha: 24,
      anio_fecha: 2020,
      fecha_notificacion: "2020-08-24",
      anio_mes: "2020-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 790,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MADERO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MADERO",
      fecha_texto: "3/30/2020",
      mes_fecha: 3,
      dia_fecha: 30,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-30",
      anio_mes: "2020-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 792,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "3/3/2020",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-03",
      anio_mes: "2020-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 799,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "2/25/2020",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-25",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 803,
      edad: "55",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SANTA CRUZ TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "4/1/2020",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-01",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 804,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TENANZINGO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "2/27/2020",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-27",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 805,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "YAUHQUEMECAN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "2/26/2020",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-26",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 807,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUEYOTLIPAN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "1/29/2020",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-29",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 809,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUEYOTLIPAN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "1/29/2020",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-29",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "01/01/2010",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 810,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SANTA CRUZ TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "4/1/2020",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-01",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 811,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SANTA CRUZ TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "4/1/2020",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-01",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "31/12/2019",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 812,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TEPETITLA DE LA ARDIZABAL",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "2/17/2020",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-17",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/01/2020",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 813,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TEPETITLA DE LA ARDIZABAL",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "2/17/2020",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-17",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 814,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COSOLEACAQUE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "MINATITLAN",
      fecha_texto: "1/17/2020",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-17",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 816,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "OTATITLAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA",
      fecha_texto: "2/17/2020",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-17",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "03/01/2020",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 819,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TEHUIPANGO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TLAQUILPA",
      fecha_texto: "3/2/2020",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-02",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 824,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MINATITLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "MINATITLAN",
      fecha_texto: "2/24/2020",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-24",
      anio_mes: "2020-02",
      institucion_notificacion: 7,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "31/01/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 825,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "IXTACZOQUITLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "2/11/2020",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-11",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 826,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ATZACAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "3/23/2020",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-23",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 828,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MOLOACAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COATZACOALCOS",
      fecha_texto: "2/24/2020",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-24",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 832,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "JUAN RODRIGUEZ CLARA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ISLA",
      fecha_texto: "5/7/2020",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2020,
      fecha_notificacion: "2020-05-07",
      anio_mes: "2020-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 834,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LAS VIGAS",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/9/2020",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-09",
      anio_mes: "2020-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 835,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZACOALCOS",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COATZACOALCOS",
      fecha_texto: "2/24/2020",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-24",
      anio_mes: "2020-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "15/08/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 836,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COTAXTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "BOCA DEL RIO",
      fecha_texto: "2/13/2020",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-13",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "20/01/2020",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 838,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LAS CHOAPAS",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "LAS CHOAPAS",
      fecha_texto: "1/22/2020",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-22",
      anio_mes: "2020-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 839,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "2/11/2020",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-11",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "07/01/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 841,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TEHUIPANGO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TLAQUILPA",
      fecha_texto: "4/28/2020",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-28",
      anio_mes: "2020-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 843,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZACOALCOS",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COATZACOALCOS",
      fecha_texto: "9/11/2020",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2020,
      fecha_notificacion: "2020-09-11",
      anio_mes: "2020-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "14/08/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 845,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/30/2020",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-30",
      anio_mes: "2020-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 846,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TECOH",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "2/7/2020",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-07",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 851,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TAHDZIU",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "7/29/2020",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2020,
      fecha_notificacion: "2020-07-29",
      anio_mes: "2020-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 853,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "2/10/2020",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-10",
      anio_mes: "2020-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "08/01/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 855,
      edad: "74",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/20/2020",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-20",
      anio_mes: "2020-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 857,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "2/12/2020",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-12",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 858,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "IZAMAL",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "2/12/2020",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-12",
      anio_mes: "2020-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 860,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "1/23/2020",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2020,
      fecha_notificacion: "2020-01-23",
      anio_mes: "2020-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 866,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/1/2020",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2020,
      fecha_notificacion: "2020-04-01",
      anio_mes: "2020-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 867,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "2/21/2020",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-21",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 876,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/26/2020",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-26",
      anio_mes: "2020-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 881,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA DE COS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "2/20/2020",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-20",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 882,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/11/2020",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2020,
      fecha_notificacion: "2020-03-11",
      anio_mes: "2020-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/02/2020",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 883,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "PINOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/5/2020",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-05",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "03/01/2020",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 886,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "2/21/2020",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-21",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2020,
      fila_archivo: 894,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "LORETO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "LORETO",
      fecha_texto: "2/26/2020",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2020,
      fecha_notificacion: "2020-02-26",
      anio_mes: "2020-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 7,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 8,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TECATE",
      fecha_texto: "7/21/2021",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2021,
      fecha_notificacion: "2021-07-21",
      anio_mes: "2021-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 49,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ZINACANTAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "3/7/2021",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2021,
      fecha_notificacion: "2021-03-07",
      anio_mes: "2021-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 56,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUADALUPE Y CALVO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "12/31/2021",
      mes_fecha: 12,
      dia_fecha: 31,
      anio_fecha: 2021,
      fecha_notificacion: "2021-12-31",
      anio_mes: "2021-12",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 57,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/4/2021",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2021,
      fecha_notificacion: "2021-02-04",
      anio_mes: "2021-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 62,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUADALUPE Y CALVO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "GUADALUPE Y CALVO",
      fecha_texto: "4/8/2021",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2021,
      fecha_notificacion: "2021-04-08",
      anio_mes: "2021-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 98,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "10/18/2021",
      mes_fecha: 10,
      dia_fecha: 18,
      anio_fecha: 2021,
      fecha_notificacion: "2021-10-18",
      anio_mes: "2021-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 101,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "8/24/2021",
      mes_fecha: 8,
      dia_fecha: 24,
      anio_fecha: 2021,
      fecha_notificacion: "2021-08-24",
      anio_mes: "2021-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 103,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "8/27/2021",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2021,
      fecha_notificacion: "2021-08-27",
      anio_mes: "2021-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/20/2021",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 278,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/30/2021",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2021,
      fecha_notificacion: "2021-07-30",
      anio_mes: "2021-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/22/2021",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 279,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/30/2021",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2021,
      fecha_notificacion: "2021-07-30",
      anio_mes: "2021-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 280,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JUVEMTINO ROSAS",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JUVENTINO ROSAS",
      fecha_texto: "10/18/2021",
      mes_fecha: 10,
      dia_fecha: 18,
      anio_fecha: 2021,
      fecha_notificacion: "2021-10-18",
      anio_mes: "2021-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/28/2014",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 455,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LAZARO CARDENAS",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "LAZARO CARDENAS",
      fecha_texto: "4/30/2021",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2021,
      fecha_notificacion: "2021-04-30",
      anio_mes: "2021-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 473,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "COMPOSTELA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "COMPOSTELA",
      fecha_texto: "11/8/2021",
      mes_fecha: 11,
      dia_fecha: 8,
      anio_fecha: 2021,
      fecha_notificacion: "2021-11-08",
      anio_mes: "2021-11",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 474,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "9/27/2021",
      mes_fecha: 9,
      dia_fecha: 27,
      anio_fecha: 2021,
      fecha_notificacion: "2021-09-27",
      anio_mes: "2021-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 476,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "6/28/2021",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2021,
      fecha_notificacion: "2021-06-28",
      anio_mes: "2021-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/21/2021",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 645,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "ETCHOJOA",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "5/6/2021",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2021,
      fecha_notificacion: "2021-05-06",
      anio_mes: "2021-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 647,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "12/9/2021",
      mes_fecha: 12,
      dia_fecha: 9,
      anio_fecha: 2021,
      fecha_notificacion: "2021-12-09",
      anio_mes: "2021-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 667,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/20/2021",
      mes_fecha: 4,
      dia_fecha: 20,
      anio_fecha: 2021,
      fecha_notificacion: "2021-04-20",
      anio_mes: "2021-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 670,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "12/14/2021",
      mes_fecha: 12,
      dia_fecha: 14,
      anio_fecha: 2021,
      fecha_notificacion: "2021-12-14",
      anio_mes: "2021-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/18/2021",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 686,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CENTRO",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "11/19/2021",
      mes_fecha: 11,
      dia_fecha: 19,
      anio_fecha: 2021,
      fecha_notificacion: "2021-11-19",
      anio_mes: "2021-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 714,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIXKOKOB",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "9/8/2021",
      mes_fecha: 9,
      dia_fecha: 8,
      anio_fecha: 2021,
      fecha_notificacion: "2021-09-08",
      anio_mes: "2021-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2021,
      fila_archivo: 729,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "7/29/2021",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2021,
      fecha_notificacion: "2021-07-29",
      anio_mes: "2021-07",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 8,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "JESUS MARIA",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "12/16/2022",
      mes_fecha: 12,
      dia_fecha: 16,
      anio_fecha: 2022,
      fecha_notificacion: "2022-12-16",
      anio_mes: "2022-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 11,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "12/16/2022",
      mes_fecha: 12,
      dia_fecha: 16,
      anio_fecha: 2022,
      fecha_notificacion: "2022-12-16",
      anio_mes: "2022-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 14,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "12/16/2022",
      mes_fecha: 12,
      dia_fecha: 16,
      anio_fecha: 2022,
      fecha_notificacion: "2022-12-16",
      anio_mes: "2022-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 41,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "5/3/2022",
      mes_fecha: 5,
      dia_fecha: 3,
      anio_fecha: 2022,
      fecha_notificacion: "2022-05-03",
      anio_mes: "2022-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 76,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "12/5/2022",
      mes_fecha: 12,
      dia_fecha: 5,
      anio_fecha: 2022,
      fecha_notificacion: "2022-12-05",
      anio_mes: "2022-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 79,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ZINACANTAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "8/26/2022",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2022,
      fecha_notificacion: "2022-08-26",
      anio_mes: "2022-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 83,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "7/27/2022",
      mes_fecha: 7,
      dia_fecha: 27,
      anio_fecha: 2022,
      fecha_notificacion: "2022-07-27",
      anio_mes: "2022-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 84,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "8/22/2022",
      mes_fecha: 8,
      dia_fecha: 22,
      anio_fecha: 2022,
      fecha_notificacion: "2022-08-22",
      anio_mes: "2022-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 85,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "IXTAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "12/23/2022",
      mes_fecha: 12,
      dia_fecha: 23,
      anio_fecha: 2022,
      fecha_notificacion: "2022-12-23",
      anio_mes: "2022-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 94,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHANAL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "5/24/2022",
      mes_fecha: 5,
      dia_fecha: 24,
      anio_fecha: 2022,
      fecha_notificacion: "2022-05-24",
      anio_mes: "2022-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 98,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "6/22/2022",
      mes_fecha: 6,
      dia_fecha: 22,
      anio_fecha: 2022,
      fecha_notificacion: "2022-06-22",
      anio_mes: "2022-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 99,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "AMATENANGO DEL VALLE",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "9/12/2022",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2022,
      fecha_notificacion: "2022-09-12",
      anio_mes: "2022-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 104,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LARRAINZAR",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "7/12/2022",
      mes_fecha: 7,
      dia_fecha: 12,
      anio_fecha: 2022,
      fecha_notificacion: "2022-07-12",
      anio_mes: "2022-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 105,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BERRIOZABAL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "11/14/2022",
      mes_fecha: 11,
      dia_fecha: 14,
      anio_fecha: 2022,
      fecha_notificacion: "2022-11-14",
      anio_mes: "2022-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 107,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ZINACANTAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "6/16/2022",
      mes_fecha: 6,
      dia_fecha: 16,
      anio_fecha: 2022,
      fecha_notificacion: "2022-06-16",
      anio_mes: "2022-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 111,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LARRAINZAR",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "3/29/2022",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2022,
      fecha_notificacion: "2022-03-29",
      anio_mes: "2022-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 112,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "IXTAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/27/2022",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2022,
      fecha_notificacion: "2022-06-27",
      anio_mes: "2022-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 113,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHENALHO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "8/29/2022",
      mes_fecha: 8,
      dia_fecha: 29,
      anio_fecha: 2022,
      fecha_notificacion: "2022-08-29",
      anio_mes: "2022-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 114,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TECPATAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "8/16/2022",
      mes_fecha: 8,
      dia_fecha: 16,
      anio_fecha: 2022,
      fecha_notificacion: "2022-08-16",
      anio_mes: "2022-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 118,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLAFLORES",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "9/1/2022",
      mes_fecha: 9,
      dia_fecha: 1,
      anio_fecha: 2022,
      fecha_notificacion: "2022-09-01",
      anio_mes: "2022-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/1/2021",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 119,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LARRAINZAR",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "10/14/2022",
      mes_fecha: 10,
      dia_fecha: 14,
      anio_fecha: 2022,
      fecha_notificacion: "2022-10-14",
      anio_mes: "2022-10",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 123,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TEOPISCA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "11/18/2022",
      mes_fecha: 11,
      dia_fecha: 18,
      anio_fecha: 2022,
      fecha_notificacion: "2022-11-18",
      anio_mes: "2022-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 126,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TENEJAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "11/17/2022",
      mes_fecha: 11,
      dia_fecha: 17,
      anio_fecha: 2022,
      fecha_notificacion: "2022-11-17",
      anio_mes: "2022-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 128,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHANAL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "7/7/2022",
      mes_fecha: 7,
      dia_fecha: 7,
      anio_fecha: 2022,
      fecha_notificacion: "2022-07-07",
      anio_mes: "2022-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 139,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TENEJAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "10/5/2022",
      mes_fecha: 10,
      dia_fecha: 5,
      anio_fecha: 2022,
      fecha_notificacion: "2022-10-05",
      anio_mes: "2022-10",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 140,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TEOPISCA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "11/7/2022",
      mes_fecha: 11,
      dia_fecha: 7,
      anio_fecha: 2022,
      fecha_notificacion: "2022-11-07",
      anio_mes: "2022-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 156,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "10/14/2022",
      mes_fecha: 10,
      dia_fecha: 14,
      anio_fecha: 2022,
      fecha_notificacion: "2022-10-14",
      anio_mes: "2022-10",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 157,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "12/1/2022",
      mes_fecha: 12,
      dia_fecha: 1,
      anio_fecha: 2022,
      fecha_notificacion: "2022-12-01",
      anio_mes: "2022-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 158,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHENALHO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "5/5/2022",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2022,
      fecha_notificacion: "2022-05-05",
      anio_mes: "2022-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 159,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LARRAINZAR",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "9/16/2022",
      mes_fecha: 9,
      dia_fecha: 16,
      anio_fecha: 2022,
      fecha_notificacion: "2022-09-16",
      anio_mes: "2022-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 166,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "7/27/2022",
      mes_fecha: 7,
      dia_fecha: 27,
      anio_fecha: 2022,
      fecha_notificacion: "2022-07-27",
      anio_mes: "2022-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 167,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "IXTAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "11/28/2022",
      mes_fecha: 11,
      dia_fecha: 28,
      anio_fecha: 2022,
      fecha_notificacion: "2022-11-28",
      anio_mes: "2022-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 172,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TEOPISCA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "11/29/2022",
      mes_fecha: 11,
      dia_fecha: 29,
      anio_fecha: 2022,
      fecha_notificacion: "2022-11-29",
      anio_mes: "2022-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 176,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHENALHO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CHAMULA",
      fecha_texto: "4/19/2022",
      mes_fecha: 4,
      dia_fecha: 19,
      anio_fecha: 2022,
      fecha_notificacion: "2022-04-19",
      anio_mes: "2022-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 177,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OXCHUC",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "10/25/2022",
      mes_fecha: 10,
      dia_fecha: 25,
      anio_fecha: 2022,
      fecha_notificacion: "2022-10-25",
      anio_mes: "2022-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 180,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHANAL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "5/20/2022",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2022,
      fecha_notificacion: "2022-05-20",
      anio_mes: "2022-05",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "NO APLICA",
      fecha_ultima_dosis: "NO APLICA",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 281,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "2/20/2023",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2023,
      fecha_notificacion: "2023-02-20",
      anio_mes: "2023-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 283,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "12/5/2022",
      mes_fecha: 12,
      dia_fecha: 5,
      anio_fecha: 2022,
      fecha_notificacion: "2022-12-05",
      anio_mes: "2022-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 286,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ARTEAGA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "9/20/2022",
      mes_fecha: 9,
      dia_fecha: 20,
      anio_fecha: 2022,
      fecha_notificacion: "2022-09-20",
      anio_mes: "2022-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "24/05/2017",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 305,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "10/11/2022",
      mes_fecha: 10,
      dia_fecha: 11,
      anio_fecha: 2022,
      fecha_notificacion: "2022-10-11",
      anio_mes: "2022-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "05/09/2022",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 306,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "5/23/2022",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2022,
      fecha_notificacion: "2022-05-23",
      anio_mes: "2022-05",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/30/2022",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 308,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "10/31/2022",
      mes_fecha: 10,
      dia_fecha: 31,
      anio_fecha: 2022,
      fecha_notificacion: "2022-10-31",
      anio_mes: "2022-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "13/04/2021",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 309,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "10/17/2022",
      mes_fecha: 10,
      dia_fecha: 17,
      anio_fecha: 2022,
      fecha_notificacion: "2022-10-17",
      anio_mes: "2022-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "14/09/2022",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 362,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ROMITA",
      fecha_texto: "5/23/2022",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2022,
      fecha_notificacion: "2022-05-23",
      anio_mes: "2022-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 5,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 457,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ROMITA",
      fecha_texto: "6/29/2022",
      mes_fecha: 6,
      dia_fecha: 29,
      anio_fecha: 2022,
      fecha_notificacion: "2022-06-29",
      anio_mes: "2022-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 619,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN GABRIEL",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOTLAN EL GRANDE",
      fecha_texto: "9/7/2022",
      mes_fecha: 9,
      dia_fecha: 7,
      anio_fecha: 2022,
      fecha_notificacion: "2022-09-07",
      anio_mes: "2022-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "SD",
      fecha_ultima_dosis: "SD",
      tipo_vacuna: "SD",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 620,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN GABRIEL",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOTLAN EL GRANDE",
      fecha_texto: "9/7/2022",
      mes_fecha: 9,
      dia_fecha: 7,
      anio_fecha: 2022,
      fecha_notificacion: "2022-09-07",
      anio_mes: "2022-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "SD",
      fecha_ultima_dosis: "SD",
      tipo_vacuna: "SD",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 621,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN GABRIEL",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOTLAN EL GRANDE",
      fecha_texto: "9/8/2022",
      mes_fecha: 9,
      dia_fecha: 8,
      anio_fecha: 2022,
      fecha_notificacion: "2022-09-08",
      anio_mes: "2022-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "SD",
      fecha_ultima_dosis: "SD",
      tipo_vacuna: "SD",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 622,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN GABRIEL",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOTLAN EL GRANDE",
      fecha_texto: "9/19/2022",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2022,
      fecha_notificacion: "2022-09-19",
      anio_mes: "2022-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "SD",
      fecha_ultima_dosis: "SD",
      tipo_vacuna: "SD",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 627,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN GABRIEL",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOTLAN EL GRANDE",
      fecha_texto: "9/7/2022",
      mes_fecha: 9,
      dia_fecha: 7,
      anio_fecha: 2022,
      fecha_notificacion: "2022-09-07",
      anio_mes: "2022-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "SD",
      fecha_ultima_dosis: "SD",
      tipo_vacuna: "SD",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 655,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN GABRIEL",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "8/4/2022",
      mes_fecha: 8,
      dia_fecha: 4,
      anio_fecha: 2022,
      fecha_notificacion: "2022-08-04",
      anio_mes: "2022-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "SD",
      fecha_ultima_dosis: "SD",
      tipo_vacuna: "SD",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 668,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "1/3/2023",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2023,
      fecha_notificacion: "2023-01-03",
      anio_mes: "2023-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "07/11/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 669,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "12/30/2022",
      mes_fecha: 12,
      dia_fecha: 30,
      anio_fecha: 2022,
      fecha_notificacion: "2022-12-30",
      anio_mes: "2022-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 671,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "XONACATLAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "12/9/2022",
      mes_fecha: 12,
      dia_fecha: 9,
      anio_fecha: 2022,
      fecha_notificacion: "2022-12-09",
      anio_mes: "2022-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 689,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TEOTIHUACAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA",
      fecha_texto: "12/27/2022",
      mes_fecha: 12,
      dia_fecha: 27,
      anio_fecha: 2022,
      fecha_notificacion: "2022-12-27",
      anio_mes: "2022-12",
      institucion_notificacion: 6,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/5/2022",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 700,
      edad: "63",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NEZAHUALCOYOTL",
      fecha_texto: "9/5/2022",
      mes_fecha: 9,
      dia_fecha: 5,
      anio_fecha: 2022,
      fecha_notificacion: "2022-09-05",
      anio_mes: "2022-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 711,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TENANGO DEL VALLE",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "11/1/2022",
      mes_fecha: 11,
      dia_fecha: 1,
      anio_fecha: 2022,
      fecha_notificacion: "2022-11-01",
      anio_mes: "2022-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 716,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "YURECUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "LA PIEDAD",
      fecha_texto: "9/22/2022",
      mes_fecha: 9,
      dia_fecha: 22,
      anio_fecha: 2022,
      fecha_notificacion: "2022-09-22",
      anio_mes: "2022-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 775,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "10/15/2022",
      mes_fecha: 10,
      dia_fecha: 15,
      anio_fecha: 2022,
      fecha_notificacion: "2022-10-15",
      anio_mes: "2022-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/11/2022",
      tipo_vacuna: "4 (hexavalente)",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 777,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "11/14/2022",
      mes_fecha: 11,
      dia_fecha: 14,
      anio_fecha: 2022,
      fecha_notificacion: "2022-11-14",
      anio_mes: "2022-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 1101,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CENTRO",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "10/28/2022",
      mes_fecha: 10,
      dia_fecha: 28,
      anio_fecha: 2022,
      fecha_notificacion: "2022-10-28",
      anio_mes: "2022-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/28/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 1103,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CENTRO",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "6/20/2022",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2022,
      fecha_notificacion: "2022-06-20",
      anio_mes: "2022-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 1113,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "11/25/2022",
      mes_fecha: 11,
      dia_fecha: 25,
      anio_fecha: 2022,
      fecha_notificacion: "2022-11-25",
      anio_mes: "2022-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/6/2022",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 1118,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "11/22/2022",
      mes_fecha: 11,
      dia_fecha: 22,
      anio_fecha: 2022,
      fecha_notificacion: "2022-11-22",
      anio_mes: "2022-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 1119,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/23/2022",
      mes_fecha: 6,
      dia_fecha: 23,
      anio_fecha: 2022,
      fecha_notificacion: "2022-06-23",
      anio_mes: "2022-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/02/2022",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 1121,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "RÍO BRAVO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "12/26/2022",
      mes_fecha: 12,
      dia_fecha: 26,
      anio_fecha: 2022,
      fecha_notificacion: "2022-12-26",
      anio_mes: "2022-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 1166,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "AKIL",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "10/30/2022",
      mes_fecha: 10,
      dia_fecha: 30,
      anio_fecha: 2022,
      fecha_notificacion: "2022-10-30",
      anio_mes: "2022-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 1185,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "11/7/2022",
      mes_fecha: 11,
      dia_fecha: 7,
      anio_fecha: 2022,
      fecha_notificacion: "2022-11-07",
      anio_mes: "2022-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2022,
      fila_archivo: 1192,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ENRIQUE ESTRADA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "1/11/2022",
      mes_fecha: 1,
      dia_fecha: 11,
      anio_fecha: 2022,
      fecha_notificacion: "2022-01-11",
      anio_mes: "2022-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "ASIENTOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "RINCON DE ROMOS",
      fecha_texto: "10/4/2023",
      mes_fecha: 10,
      dia_fecha: 4,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-04",
      anio_mes: "2023-10",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 2,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "11/13/2023",
      mes_fecha: 11,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-13",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "9",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 3,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "ASIENTOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "PABELLON DE ARTEAGA",
      fecha_texto: "8/18/2023",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-18",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 6,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "12/10/2023",
      mes_fecha: 12,
      dia_fecha: 10,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-10",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/22/2023",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 7,
      edad: "67",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "11/21/2023",
      mes_fecha: 11,
      dia_fecha: 21,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-21",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "9",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 11,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "12/1/2023",
      mes_fecha: 12,
      dia_fecha: 1,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-01",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "08/11/2021",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 18,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "12/8/2023",
      mes_fecha: 12,
      dia_fecha: 8,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-08",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 19,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "12/8/2023",
      mes_fecha: 12,
      dia_fecha: 8,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-08",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 23,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "SAN FCO DE LOS ROMO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "11/13/2023",
      mes_fecha: 11,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-13",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "1/8/1900",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 30,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "8/11/2023",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-11",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 46,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "TIJUANA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "9/14/2023",
      mes_fecha: 9,
      dia_fecha: 14,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-14",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 47,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "9/14/2023",
      mes_fecha: 9,
      dia_fecha: 14,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-14",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/31/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 48,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "SAN QUINTIN",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "11/5/2023",
      mes_fecha: 11,
      dia_fecha: 5,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-05",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 59,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "7/18/2023",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-18",
      anio_mes: "2023-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 63,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "12/22/2023",
      mes_fecha: 12,
      dia_fecha: 22,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-22",
      anio_mes: "2023-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 65,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "12/3/2023",
      mes_fecha: 12,
      dia_fecha: 3,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-03",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/19/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 71,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "TIJUANA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "5/30/2023",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2023,
      fecha_notificacion: "2023-05-30",
      anio_mes: "2023-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 79,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "TIJUANA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "2/14/2023",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2023,
      fecha_notificacion: "2023-02-14",
      anio_mes: "2023-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 93,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "11/6/2023",
      mes_fecha: 11,
      dia_fecha: 6,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-06",
      anio_mes: "2023-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 95,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "MEXICALI",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "11/29/2023",
      mes_fecha: 11,
      dia_fecha: 29,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-29",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/21/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 98,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "12/28/2023",
      mes_fecha: 12,
      dia_fecha: 28,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-28",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 121,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "12/13/2023",
      mes_fecha: 12,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-13",
      anio_mes: "2023-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/7/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 142,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "10/13/2023",
      mes_fecha: 10,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-13",
      anio_mes: "2023-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 147,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "9/9/2023",
      mes_fecha: 9,
      dia_fecha: 9,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-09",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 149,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ZINACANTAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "6/19/2023",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-19",
      anio_mes: "2023-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 150,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOZOCOAUTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "12/7/2023",
      mes_fecha: 12,
      dia_fecha: 7,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-07",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 152,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOZOCOAUTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "OCOZOCOAUTLA DE ESPINOSA",
      fecha_texto: "7/1/2023",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-01",
      anio_mes: "2023-07",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 153,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLAFLORES",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "9/11/2023",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-11",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 155,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "PALENQUE",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "PALENQUE",
      fecha_texto: "10/5/2023",
      mes_fecha: 10,
      dia_fecha: 5,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-05",
      anio_mes: "2023-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 156,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLACORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CHIAPAS",
      fecha_texto: "9/22/2023",
      mes_fecha: 9,
      dia_fecha: 22,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-22",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 159,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/19/2023",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2023,
      fecha_notificacion: "2023-02-19",
      anio_mes: "2023-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 161,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COMITAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN",
      fecha_texto: "12/7/2023",
      mes_fecha: 12,
      dia_fecha: 7,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-07",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 162,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOSINGO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "11/22/2023",
      mes_fecha: 11,
      dia_fecha: 22,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-22",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 163,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TENEJAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "3/19/2023",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2023,
      fecha_notificacion: "2023-03-19",
      anio_mes: "2023-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 165,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "1/25/2023",
      mes_fecha: 1,
      dia_fecha: 25,
      anio_fecha: 2023,
      fecha_notificacion: "2023-01-25",
      anio_mes: "2023-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 168,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "4/3/2023",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2023,
      fecha_notificacion: "2023-04-03",
      anio_mes: "2023-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 169,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "4/19/2023",
      mes_fecha: 4,
      dia_fecha: 19,
      anio_fecha: 2023,
      fecha_notificacion: "2023-04-19",
      anio_mes: "2023-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 181,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "10/13/2023",
      mes_fecha: 10,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-13",
      anio_mes: "2023-10",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 182,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "11/20/2023",
      mes_fecha: 11,
      dia_fecha: 20,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-20",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 185,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "2/20/2023",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2023,
      fecha_notificacion: "2023-02-20",
      anio_mes: "2023-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 186,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SIMOJOVEL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "1/31/2023",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2023,
      fecha_notificacion: "2023-01-31",
      anio_mes: "2023-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 189,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "JIQUIPILAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "4/24/2023",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2023,
      fecha_notificacion: "2023-04-24",
      anio_mes: "2023-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 190,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "5/5/2023",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2023,
      fecha_notificacion: "2023-05-05",
      anio_mes: "2023-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/28/2023",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 191,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHIAPA DE CORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "5/18/2023",
      mes_fecha: 5,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-05-18",
      anio_mes: "2023-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 205,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LAS MARGARITAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN",
      fecha_texto: "2/10/2023",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2023,
      fecha_notificacion: "2023-02-10",
      anio_mes: "2023-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 207,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLAFLORES",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "2/28/2023",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2023,
      fecha_notificacion: "2023-02-28",
      anio_mes: "2023-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 208,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "3/15/2023",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2023,
      fecha_notificacion: "2023-03-15",
      anio_mes: "2023-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 210,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CINTALAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "11/9/2023",
      mes_fecha: 11,
      dia_fecha: 9,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-09",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 211,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLAFLORES",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "1/18/2023",
      mes_fecha: 1,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-01-18",
      anio_mes: "2023-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 212,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BOCHIL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "1/30/2023",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2023,
      fecha_notificacion: "2023-01-30",
      anio_mes: "2023-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 214,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOSINGO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "OCOSINGO",
      fecha_texto: "5/9/2023",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2023,
      fecha_notificacion: "2023-05-09",
      anio_mes: "2023-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 215,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SIMOJOVEL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "5/25/2023",
      mes_fecha: 5,
      dia_fecha: 25,
      anio_fecha: 2023,
      fecha_notificacion: "2023-05-25",
      anio_mes: "2023-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 216,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COMITAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN",
      fecha_texto: "7/17/2023",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-17",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 219,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ZINACANTAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "10/9/2023",
      mes_fecha: 10,
      dia_fecha: 9,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-09",
      anio_mes: "2023-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 220,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BENEMERITO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "PALENQUE",
      fecha_texto: "10/31/2023",
      mes_fecha: 10,
      dia_fecha: 31,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-31",
      anio_mes: "2023-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 222,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "JITOTOL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "11/17/2023",
      mes_fecha: 11,
      dia_fecha: 17,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-17",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 224,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "PUEBLO NUEVO SOLISTAHUACAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "BOCHIL",
      fecha_texto: "3/1/2024",
      mes_fecha: 3,
      dia_fecha: 1,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-01",
      anio_mes: "2024-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 232,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "5/25/2023",
      mes_fecha: 5,
      dia_fecha: 25,
      anio_fecha: 2023,
      fecha_notificacion: "2023-05-25",
      anio_mes: "2023-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 234,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "7/4/2023",
      mes_fecha: 7,
      dia_fecha: 4,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-04",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 237,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MITONTIC",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "4/10/2023",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2023,
      fecha_notificacion: "2023-04-10",
      anio_mes: "2023-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 240,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN",
      fecha_texto: "7/26/2023",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-26",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 242,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLAFLORES",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "3/21/2023",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2023,
      fecha_notificacion: "2023-03-21",
      anio_mes: "2023-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 245,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLAFLORES",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "10/29/2023",
      mes_fecha: 10,
      dia_fecha: 29,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-29",
      anio_mes: "2023-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 250,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOZOCOAUTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/17/2023",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2023,
      fecha_notificacion: "2023-02-17",
      anio_mes: "2023-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 251,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "4/14/2023",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2023,
      fecha_notificacion: "2023-04-14",
      anio_mes: "2023-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 253,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SIMOJOVEL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "4/30/2023",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2023,
      fecha_notificacion: "2023-04-30",
      anio_mes: "2023-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 258,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TOTOLAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "12/14/2023",
      mes_fecha: 12,
      dia_fecha: 14,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-14",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 259,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TOTOLAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "12/11/2023",
      mes_fecha: 12,
      dia_fecha: 11,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-11",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 260,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TOTOLAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "12/28/2023",
      mes_fecha: 12,
      dia_fecha: 28,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-28",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 261,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "2/9/2023",
      mes_fecha: 2,
      dia_fecha: 9,
      anio_fecha: 2023,
      fecha_notificacion: "2023-02-09",
      anio_mes: "2023-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 262,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHENALHO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "7/22/2023",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-22",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 267,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LAS ROSAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "8/8/2023",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-08",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 268,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LAS ROSAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "8/8/2023",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-08",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 271,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OXCHUC",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/27/2023",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-27",
      anio_mes: "2023-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 273,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHENALHO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "1/13/2023",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-01-13",
      anio_mes: "2023-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 275,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TOTOLAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "1/7/2024",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-07",
      anio_mes: "2024-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 276,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "9/22/2023",
      mes_fecha: 9,
      dia_fecha: 22,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-22",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/18/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 280,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "5/20/2023",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2023,
      fecha_notificacion: "2023-05-20",
      anio_mes: "2023-05",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 281,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "5/30/2023",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2023,
      fecha_notificacion: "2023-05-30",
      anio_mes: "2023-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 286,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUERRERO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/24/2023",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2023,
      fecha_notificacion: "2023-03-24",
      anio_mes: "2023-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 292,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "8/15/2023",
      mes_fecha: 8,
      dia_fecha: 15,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-15",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/25/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 293,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "OJINAGA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "OJINAGA",
      fecha_texto: "11/27/2023",
      mes_fecha: 11,
      dia_fecha: 27,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-27",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 297,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "7/31/2023",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-31",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 299,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "OJINAGA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "OJINAGA",
      fecha_texto: "11/17/2023",
      mes_fecha: 11,
      dia_fecha: 17,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-17",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 300,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "OJINAGA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "OJINAGA",
      fecha_texto: "11/17/2023",
      mes_fecha: 11,
      dia_fecha: 17,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-17",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 302,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BUENAVENTURA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NCG",
      fecha_texto: "4/18/2023",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-04-18",
      anio_mes: "2023-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 307,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "7/11/2023",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-11",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 308,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "7/11/2023",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-11",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 309,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "7/11/2023",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-11",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 314,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "11/14/2023",
      mes_fecha: 11,
      dia_fecha: 14,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-14",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/24/2017",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 315,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BUENAVENTURA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NCG",
      fecha_texto: "7/28/2023",
      mes_fecha: 7,
      dia_fecha: 28,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-28",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 316,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/24/2023",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2023,
      fecha_notificacion: "2023-04-24",
      anio_mes: "2023-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 317,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "RIVA PALACIO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "11/3/2023",
      mes_fecha: 11,
      dia_fecha: 3,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-03",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 319,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BUENAVENTURA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BUENAVENTURA",
      fecha_texto: "8/7/2023",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-07",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 331,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "8/10/2023",
      mes_fecha: 8,
      dia_fecha: 10,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-10",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/7/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 332,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "8/18/2023",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-18",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "8/7/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 333,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "12/5/2023",
      mes_fecha: 12,
      dia_fecha: 5,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-05",
      anio_mes: "2023-12",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 336,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "OJINAGA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "11/9/2023",
      mes_fecha: 11,
      dia_fecha: 9,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-09",
      anio_mes: "2023-11",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 337,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "6/23/2023",
      mes_fecha: 6,
      dia_fecha: 23,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-23",
      anio_mes: "2023-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/30/2023",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 339,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "7/5/2023",
      mes_fecha: 7,
      dia_fecha: 5,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-05",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 340,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "7/5/2023",
      mes_fecha: 7,
      dia_fecha: 5,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-05",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 342,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "VILLA AHUMADA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/13/2023",
      mes_fecha: 7,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-13",
      anio_mes: "2023-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 343,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "VILLA AHUMADA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "7/18/2023",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-18",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 346,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "6/13/2023",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-13",
      anio_mes: "2023-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 347,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "6/13/2023",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-13",
      anio_mes: "2023-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 348,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "6/13/2023",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-13",
      anio_mes: "2023-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 349,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "6/18/2023",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-18",
      anio_mes: "2023-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 356,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "VILLA AHUMADA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/13/2023",
      mes_fecha: 7,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-13",
      anio_mes: "2023-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 357,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BUENAVENTURA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "6/8/2023",
      mes_fecha: 6,
      dia_fecha: 8,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-08",
      anio_mes: "2023-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 358,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "11/28/2023",
      mes_fecha: 11,
      dia_fecha: 28,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-28",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 367,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "10/25/2023",
      mes_fecha: 10,
      dia_fecha: 25,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-25",
      anio_mes: "2023-10",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 375,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "2/20/2023",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2023,
      fecha_notificacion: "2023-02-20",
      anio_mes: "2023-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 376,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "2/15/2023",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2023,
      fecha_notificacion: "2023-02-15",
      anio_mes: "2023-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 391,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "2/10/2023",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2023,
      fecha_notificacion: "2023-02-10",
      anio_mes: "2023-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 397,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA DE MORELOS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAJIMALPA",
      fecha_texto: "9/28/2023",
      mes_fecha: 9,
      dia_fecha: 28,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-28",
      anio_mes: "2023-09",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "00/00/0000",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 411,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "8/14/2023",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-14",
      anio_mes: "2023-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "7/12/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 419,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "2/20/2023",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2023,
      fecha_notificacion: "2023-02-20",
      anio_mes: "2023-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 443,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "MEZQUITAL",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "7/11/2023",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-11",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 445,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "MEZQUITAL",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "8/10/2023",
      mes_fecha: 8,
      dia_fecha: 10,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-10",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 450,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "MEZQUITAL",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "8/12/2023",
      mes_fecha: 8,
      dia_fecha: 12,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-12",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 451,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "MEZQUITAL",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "8/12/2023",
      mes_fecha: 8,
      dia_fecha: 12,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-12",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 452,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "MEZUQUITAL",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "8/29/2023",
      mes_fecha: 8,
      dia_fecha: 29,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-29",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 454,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "MEZQUITAL",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "9/8/2023",
      mes_fecha: 9,
      dia_fecha: 8,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-08",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 582,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ABASOLO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "11/7/2023",
      mes_fecha: 11,
      dia_fecha: 7,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-07",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 618,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "9/26/2023",
      mes_fecha: 9,
      dia_fecha: 26,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-26",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 679,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "APASEO EL GRANDE",
      fecha_texto: "11/13/2023",
      mes_fecha: 11,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-13",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/22/2022",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 698,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ALCOZAUCA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ALCOZAUCA",
      fecha_texto: "11/16/2023",
      mes_fecha: 11,
      dia_fecha: 16,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-16",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 729,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/15/2023",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2023,
      fecha_notificacion: "2023-03-15",
      anio_mes: "2023-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 755,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "11/16/2023",
      mes_fecha: 11,
      dia_fecha: 16,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-16",
      anio_mes: "2023-11",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 769,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ENCARNACIÓN DE DIAZ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "11/20/2023",
      mes_fecha: 11,
      dia_fecha: 20,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-20",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 776,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/15/2023",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2023,
      fecha_notificacion: "2023-03-15",
      anio_mes: "2023-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/9/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 800,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TOLIMAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOTLAN EL GRANDE",
      fecha_texto: "10/18/2023",
      mes_fecha: 10,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-18",
      anio_mes: "2023-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 829,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "OZUMBA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "10/13/2023",
      mes_fecha: 10,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-13",
      anio_mes: "2023-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 832,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE CHALCO SOLIDARIADA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "11/7/2023",
      mes_fecha: 11,
      dia_fecha: 7,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-07",
      anio_mes: "2023-11",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 851,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "11/3/2023",
      mes_fecha: 11,
      dia_fecha: 3,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-03",
      anio_mes: "2023-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 864,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "11/3/2023",
      mes_fecha: 11,
      dia_fecha: 3,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-03",
      anio_mes: "2023-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 895,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "SALVADOR ESCALANTE",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "10/25/2023",
      mes_fecha: 10,
      dia_fecha: 25,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-25",
      anio_mes: "2023-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 898,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "YURECUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "YURECUARO",
      fecha_texto: "9/8/2023",
      mes_fecha: 9,
      dia_fecha: 8,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-08",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 899,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "YURECUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "YURECUARO",
      fecha_texto: "9/8/2023",
      mes_fecha: 9,
      dia_fecha: 8,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-08",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 911,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "SALVADOR ESCALANTE",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "11/9/2023",
      mes_fecha: 11,
      dia_fecha: 9,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-09",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 921,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "GUERRERO",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "12/12/2023",
      mes_fecha: 12,
      dia_fecha: 12,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-12",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 926,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "HUIXILAC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "12/8/2023",
      mes_fecha: 12,
      dia_fecha: 8,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-08",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 935,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "EL NAYAR",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "23/5/2023",
      mes_fecha: 23,
      dia_fecha: 5,
      anio_fecha: 2023,
      fecha_notificacion: "2024-11-05",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 937,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "HUAJICORI",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "3/20/2023",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2023,
      fecha_notificacion: "2023-03-20",
      anio_mes: "2023-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 939,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "COMPOSTELA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "6/21/2023",
      mes_fecha: 6,
      dia_fecha: 21,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-21",
      anio_mes: "2023-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 943,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "EL NAYAR",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "7/24/2023",
      mes_fecha: 7,
      dia_fecha: 24,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-24",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 948,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "DEL NAYAR",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "DEL NAYAR",
      fecha_texto: "3/17/2023",
      mes_fecha: 3,
      dia_fecha: 17,
      anio_fecha: 2023,
      fecha_notificacion: "2023-03-17",
      anio_mes: "2023-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 951,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "SAN BLAS",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "6/20/2023",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-20",
      anio_mes: "2023-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 952,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "DEL NAYAR",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "DEL NAYAR",
      fecha_texto: "8/7/2023",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-07",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 955,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "3/29/2023",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2023,
      fecha_notificacion: "2023-03-29",
      anio_mes: "2023-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "2/15/2023",
      tipo_vacuna: "3 HEXAVALENTE",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 960,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "DEL NAYAR",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "DEL NAYAR",
      fecha_texto: "11/9/2023",
      mes_fecha: 11,
      dia_fecha: 9,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-09",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "3/18/2023",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 961,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "10/9/2023",
      mes_fecha: 10,
      dia_fecha: 9,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-09",
      anio_mes: "2023-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/11/2023",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 962,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "DEL NAYAR",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "DEL NAYAR",
      fecha_texto: "10/31/2023",
      mes_fecha: 10,
      dia_fecha: 31,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-31",
      anio_mes: "2023-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 965,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "10/9/2023",
      mes_fecha: 10,
      dia_fecha: 9,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-09",
      anio_mes: "2023-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 967,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "BAHIA DE BANDERAS",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "BAHIA DE BANDERAS",
      fecha_texto: "10/5/2023",
      mes_fecha: 10,
      dia_fecha: 5,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-05",
      anio_mes: "2023-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "09/07/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 968,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "DEL NAYAR",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "DEL NAYAR",
      fecha_texto: "9/7/2023",
      mes_fecha: 9,
      dia_fecha: 7,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-07",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 969,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "MEZQUITAL",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "DEL NAYAR",
      fecha_texto: "7/3/2023",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-03",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 971,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "DEL NAYAR",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "DEL NAYAR",
      fecha_texto: "10/20/2023",
      mes_fecha: 10,
      dia_fecha: 20,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-20",
      anio_mes: "2023-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1078,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "15/8/12023",
      mes_fecha: 15,
      dia_fecha: 8,
      anio_fecha: 12023,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/4/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1117,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "TULUM",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "SOLIDARIDAD",
      fecha_texto: "11/7/2023",
      mes_fecha: 11,
      dia_fecha: 7,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-07",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1149,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "12/12/2023",
      mes_fecha: 12,
      dia_fecha: 12,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-12",
      anio_mes: "2023-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "04/01/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1158,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "6/14/2023",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-14",
      anio_mes: "2023-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "04/05/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1241,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "ESCUINAPA",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "ESCUINAPA",
      fecha_texto: "5/26/2023",
      mes_fecha: 5,
      dia_fecha: 26,
      anio_fecha: 2023,
      fecha_notificacion: "2023-05-26",
      anio_mes: "2023-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1251,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "ETCHOJOA",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "1/8/2023",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2023,
      fecha_notificacion: "2023-01-08",
      anio_mes: "2023-01",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/22/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1257,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "11/29/2023",
      mes_fecha: 11,
      dia_fecha: 29,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-29",
      anio_mes: "2023-11",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1258,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "12/21/2023",
      mes_fecha: 12,
      dia_fecha: 21,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-21",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1277,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "12/13/2023",
      mes_fecha: 12,
      dia_fecha: 13,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-13",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1333,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "11/8/2023",
      mes_fecha: 11,
      dia_fecha: 8,
      anio_fecha: 2023,
      fecha_notificacion: "2023-11-08",
      anio_mes: "2023-11",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/7/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1335,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "1/3/2024",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-03",
      anio_mes: "2024-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1337,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "1/3/2024",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-03",
      anio_mes: "2024-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1375,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "UMAN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "10/18/2023",
      mes_fecha: 10,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-18",
      anio_mes: "2023-10",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1376,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MOTUL",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "10/24/2023",
      mes_fecha: 10,
      dia_fecha: 24,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-24",
      anio_mes: "2023-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1377,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "10/24/2023",
      mes_fecha: 10,
      dia_fecha: 24,
      anio_fecha: 2023,
      fecha_notificacion: "2023-10-24",
      anio_mes: "2023-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/28/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1380,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/8/2023",
      mes_fecha: 3,
      dia_fecha: 8,
      anio_fecha: 2023,
      fecha_notificacion: "2023-03-08",
      anio_mes: "2023-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1386,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VALPARAISO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "VALPARAISO",
      fecha_texto: "9/18/2023",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-18",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1387,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VALPARAISO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "VALPARAISO",
      fecha_texto: "9/18/2023",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-18",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1389,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "5/14/2023",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2023,
      fecha_notificacion: "2023-05-14",
      anio_mes: "2023-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1399,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VALPARAISO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "9/9/2023",
      mes_fecha: 9,
      dia_fecha: 9,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-09",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "9/29/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1401,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA DE COS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "8/11/2023",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-11",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1404,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "6/22/2023",
      mes_fecha: 6,
      dia_fecha: 22,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-22",
      anio_mes: "2023-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1405,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA DE COS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "6/20/2023",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-20",
      anio_mes: "2023-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1406,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "6/22/2023",
      mes_fecha: 6,
      dia_fecha: 22,
      anio_fecha: 2023,
      fecha_notificacion: "2023-06-22",
      anio_mes: "2023-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1408,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "7/23/2023",
      mes_fecha: 7,
      dia_fecha: 23,
      anio_fecha: 2023,
      fecha_notificacion: "2023-07-23",
      anio_mes: "2023-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1409,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "2/18/2023",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-02-18",
      anio_mes: "2023-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/7/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1410,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "LORETO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "12/12/2023",
      mes_fecha: 12,
      dia_fecha: 12,
      anio_fecha: 2023,
      fecha_notificacion: "2023-12-12",
      anio_mes: "2023-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1421,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "5/11/2023",
      mes_fecha: 5,
      dia_fecha: 11,
      anio_fecha: 2023,
      fecha_notificacion: "2023-05-11",
      anio_mes: "2023-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1435,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA DE COS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "8/16/2023",
      mes_fecha: 8,
      dia_fecha: 16,
      anio_fecha: 2023,
      fecha_notificacion: "2023-08-16",
      anio_mes: "2023-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2023,
      fila_archivo: 1440,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "CALERA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "9/18/2023",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2023,
      fecha_notificacion: "2023-09-18",
      anio_mes: "2023-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "10/4/2024",
      mes_fecha: 10,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-04",
      anio_mes: "2024-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 2,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "11/5/2024",
      mes_fecha: 11,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-05",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 4,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "10/24/2024",
      mes_fecha: 10,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-24",
      anio_mes: "2024-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 5,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "10/30/2024",
      mes_fecha: 10,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-30",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 7,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "11/8/2024",
      mes_fecha: 11,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-08",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 8,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "11/9/2024",
      mes_fecha: 11,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-09",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 9,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "11/13/2024",
      mes_fecha: 11,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-13",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 10,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "EL LLANO",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "3/4/2024",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-04",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 11,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "10/21/2024",
      mes_fecha: 10,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-21",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 12,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "10/21/2024",
      mes_fecha: 10,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-21",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 13,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "10/21/2024",
      mes_fecha: 10,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-21",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 15,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "7/29/2024",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-29",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 18,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "4/22/2024",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-22",
      anio_mes: "2024-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/26/2017",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 19,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "CALVILLO",
      estado_notificacion: "AGS",
      municipio_notificacion: "CALVILLO",
      fecha_texto: "6/24/2024",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-24",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 20,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "CALVILLO",
      estado_notificacion: "AGS",
      municipio_notificacion: "CALVILLO",
      fecha_texto: "6/25/2024",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-25",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 21,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "11/25/2024",
      mes_fecha: 11,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-25",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 22,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "11/27/2024",
      mes_fecha: 11,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-27",
      anio_mes: "2024-11",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 24,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMO",
      estado_notificacion: "AGS",
      municipio_notificacion: "RINCON DE ROMO",
      fecha_texto: "12/17/2024",
      mes_fecha: 12,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-17",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 25,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMO",
      estado_notificacion: "AGS",
      municipio_notificacion: "RINCON DE ROMO",
      fecha_texto: "12/20/2024",
      mes_fecha: 12,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-20",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 27,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "ASIENTOS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "12/18/2024",
      mes_fecha: 12,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-18",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 29,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "10/17/2024",
      mes_fecha: 10,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-17",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 30,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "10/17/2024",
      mes_fecha: 10,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-17",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 31,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "12/2/2024",
      mes_fecha: 12,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-02",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 32,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "12/2/2024",
      mes_fecha: 12,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-02",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 34,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "7/15/2024",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-15",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 36,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "SAN FRANCISCO DE LOS ROMO",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "12/11/2024",
      mes_fecha: 12,
      dia_fecha: 11,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-11",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 37,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "7/18/2024",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-18",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 38,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "10/17/2024",
      mes_fecha: 10,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-17",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 39,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "10/24/2024",
      mes_fecha: 10,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-24",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 40,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "10/24/2024",
      mes_fecha: 10,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-24",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 43,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "12/5/2024",
      mes_fecha: 12,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-05",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 44,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "11/26/2024",
      mes_fecha: 11,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-26",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 45,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "10/16/2024",
      mes_fecha: 10,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-16",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 46,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGS",
      estado_notificacion: "AGS",
      municipio_notificacion: "AGS",
      fecha_texto: "12/5/2024",
      mes_fecha: 12,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-05",
      anio_mes: "2024-12",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 47,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "5/16/2024",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-16",
      anio_mes: "2024-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 48,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "5/24/2024",
      mes_fecha: 5,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-24",
      anio_mes: "2024-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/26/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 51,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "12/9/2024",
      mes_fecha: 12,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-09",
      anio_mes: "2024-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 52,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "8/21/2024",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-21",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 55,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "10/31/2024",
      mes_fecha: 10,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-31",
      anio_mes: "2024-10",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 56,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "6/13/2024",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-13",
      anio_mes: "2024-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 57,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "7/31/2024",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-31",
      anio_mes: "2024-07",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 58,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "5/22/2024",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-22",
      anio_mes: "2024-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/2/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 59,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "5/22/2024",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-22",
      anio_mes: "2024-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/2/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 61,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "9/30/2024",
      mes_fecha: 9,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-30",
      anio_mes: "2024-09",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 62,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "4/17/2024",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-17",
      anio_mes: "2024-04",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 64,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "11/21/2024",
      mes_fecha: 11,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-21",
      anio_mes: "2024-11",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/24/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 69,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "6/6/2024",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-06",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 70,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "9/26/2024",
      mes_fecha: 9,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-26",
      anio_mes: "2024-09",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 71,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "6/17/2024",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-17",
      anio_mes: "2024-06",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 74,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "12/30/2024",
      mes_fecha: 12,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-30",
      anio_mes: "2024-12",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 77,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "11/19/2024",
      mes_fecha: 11,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-19",
      anio_mes: "2024-11",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/4/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 79,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "8/7/2024",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-07",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 80,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "SAN FELIPE",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "10/3/2024",
      mes_fecha: 10,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-03",
      anio_mes: "2024-10",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 84,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "7/25/2024",
      mes_fecha: 7,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-25",
      anio_mes: "2024-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/11/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 85,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "3/4/2024",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-04",
      anio_mes: "2024-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 86,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "8/6/2024",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-06",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 89,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "4/17/2024",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-17",
      anio_mes: "2024-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 91,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "5/7/2024",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-07",
      anio_mes: "2024-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 92,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "SAN QUINTIN",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "9/9/2024",
      mes_fecha: 9,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-09",
      anio_mes: "2024-09",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 93,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "8/5/2024",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-05",
      anio_mes: "2024-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 99,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "7/18/2024",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-18",
      anio_mes: "2024-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 100,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "5/2/2024",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-02",
      anio_mes: "2024-05",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 101,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "5/31/2024",
      mes_fecha: 5,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-31",
      anio_mes: "2024-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/11/1905",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 102,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TECATE",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "5/30/2024",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-30",
      anio_mes: "2024-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 103,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "5/22/2024",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-22",
      anio_mes: "2024-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/26/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 106,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "11/27/2024",
      mes_fecha: 11,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-27",
      anio_mes: "2024-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 110,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "8/5/2024",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-05",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/17/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 111,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "7/1/2024",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-01",
      anio_mes: "2024-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 112,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "3/29/2024",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-29",
      anio_mes: "2024-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 115,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "PLAYAS DE ROSARITO",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "PLAYAS DE ROSARITO",
      fecha_texto: "5/22/2024",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-22",
      anio_mes: "2024-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 119,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "2/19/2024",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-19",
      anio_mes: "2024-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 120,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "7/23/2024",
      mes_fecha: 7,
      dia_fecha: 23,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-23",
      anio_mes: "2024-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/24/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 122,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "5/28/2024",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-28",
      anio_mes: "2024-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 124,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "8/1/2024",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-01",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/21/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 125,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "8/6/2024",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-06",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/4/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 129,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "8/2/2024",
      mes_fecha: 8,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-02",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 130,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "3/28/2024",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-28",
      anio_mes: "2024-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 137,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "12/13/2024",
      mes_fecha: 12,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-13",
      anio_mes: "2024-12",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 142,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "7/2/2024",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-02",
      anio_mes: "2024-07",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 144,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "8/18/2024",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-18",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 150,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TECATE",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TECATE",
      fecha_texto: "8/5/2024",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-05",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 151,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "7/17/2024",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-17",
      anio_mes: "2024-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 153,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "7/26/2024",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-26",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 155,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "4/8/2024",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-08",
      anio_mes: "2024-04",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 160,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "PLAYAS DE ROSARITO",
      fecha_texto: "9/18/2024",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-18",
      anio_mes: "2024-09",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/15/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 162,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "5/17/2024",
      mes_fecha: 5,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-17",
      anio_mes: "2024-05",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 163,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "8/22/2024",
      mes_fecha: 8,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-22",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/22/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 166,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "7/15/2024",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-15",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "9/17/2021",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 169,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "3/11/2024",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-11",
      anio_mes: "2024-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/23/2024",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 171,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "6/11/2024",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-11",
      anio_mes: "2024-06",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 172,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "8/17/2024",
      mes_fecha: 8,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-17",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 176,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "3/22/2024",
      mes_fecha: 3,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-22",
      anio_mes: "2024-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/7/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 180,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "10/28/2024",
      mes_fecha: 10,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-28",
      anio_mes: "2024-10",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/25/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 182,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "8/28/2024",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-28",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 183,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "9/18/2024",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-18",
      anio_mes: "2024-09",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 186,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "8/21/2024",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-21",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 187,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "7/21/2024",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-21",
      anio_mes: "2024-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 188,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "7/31/2024",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-31",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 190,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "10/6/2024",
      mes_fecha: 10,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-06",
      anio_mes: "2024-10",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/16/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 191,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "4/2/2024",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-02",
      anio_mes: "2024-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/1/2023",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 192,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "8/19/2024",
      mes_fecha: 8,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-19",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/31/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 193,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "8/20/2024",
      mes_fecha: 8,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-20",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/20/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 196,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "6/13/2024",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-13",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 204,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "12/8/2024",
      mes_fecha: 12,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-08",
      anio_mes: "2024-12",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 209,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "8/16/2024",
      mes_fecha: 8,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-16",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 211,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "7/19/2024",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-19",
      anio_mes: "2024-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 212,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "6/7/2024",
      mes_fecha: 6,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-07",
      anio_mes: "2024-06",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 218,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/2/2024",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-02",
      anio_mes: "2024-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 226,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "9/10/2024",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-10",
      anio_mes: "2024-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/2/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 229,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "9/19/2024",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-19",
      anio_mes: "2024-09",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 237,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "5/7/2024",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-07",
      anio_mes: "2024-05",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 239,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "9/12/2024",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-12",
      anio_mes: "2024-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 240,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "8/1/2024",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-01",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/1/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 242,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "4/2/2024",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-02",
      anio_mes: "2024-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/25/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 246,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "7/12/2024",
      mes_fecha: 7,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-12",
      anio_mes: "2024-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 249,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "3/21/2024",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-21",
      anio_mes: "2024-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 255,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CARMEN",
      fecha_texto: "9/10/2024",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-10",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 256,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CARMEN",
      fecha_texto: "9/10/2024",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-10",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "9/10/2020",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 264,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "12/6/2024",
      mes_fecha: 12,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-06",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 266,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "HOPELCHEN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/5/2024",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-05",
      anio_mes: "2024-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 269,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "7/26/2024",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-26",
      anio_mes: "2024-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 270,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "8/1/2024",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-01",
      anio_mes: "2024-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 271,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "ESCARCEGA",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "8/23/2024",
      mes_fecha: 8,
      dia_fecha: 23,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-23",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 273,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CARMEN",
      fecha_texto: "8/27/2024",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-27",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 274,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "ESCARCEGA",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "8/21/2024",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-21",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 289,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLA CORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "7/3/2024",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-03",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/22/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 292,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOSINGO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "OCOSINGO",
      fecha_texto: "7/10/2024",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-10",
      anio_mes: "2024-07",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 293,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "8/8/2024",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-08",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/11/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 295,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/8/2024",
      mes_fecha: 3,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-08",
      anio_mes: "2024-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 297,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BOCHIL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "10/6/2024",
      mes_fecha: 10,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-06",
      anio_mes: "2024-10",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 301,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BERRIOZABAL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "BERRIOZABAL",
      fecha_texto: "4/26/2024",
      mes_fecha: 4,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-26",
      anio_mes: "2024-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 302,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/21/2024",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-21",
      anio_mes: "2024-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 303,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VESNUSTIANO CARRANZA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "10/7/2024",
      mes_fecha: 10,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-07",
      anio_mes: "2024-10",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 305,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/28/2024",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-28",
      anio_mes: "2024-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 309,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/6/2024",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-06",
      anio_mes: "2024-06",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 311,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MEZCALAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "7/26/2024",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-26",
      anio_mes: "2024-07",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 312,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SILTEPEC",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "MOTOZINTLA",
      fecha_texto: "9/19/2024",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-19",
      anio_mes: "2024-09",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 315,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "4/9/2024",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-09",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "02/02/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 316,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "5/9/2024",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-09",
      anio_mes: "2024-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 317,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLA CORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "8/27/2024",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-27",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/11/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 318,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOZOCOAUTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CINTALAPA",
      fecha_texto: "9/5/2024",
      mes_fecha: 9,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-05",
      anio_mes: "2024-09",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 319,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CINTALAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CINTALAPA",
      fecha_texto: "10/16/2024",
      mes_fecha: 10,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-16",
      anio_mes: "2024-10",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 320,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "8/14/2024",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-14",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 321,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "REFORMA",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "6/23/2024",
      mes_fecha: 6,
      dia_fecha: 23,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-23",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 322,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "11/12/2024",
      mes_fecha: 11,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-12",
      anio_mes: "2024-11",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 324,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ANGEL ALBINO CORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "5/7/2024",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-07",
      anio_mes: "2024-05",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 325,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "4/9/2024",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-09",
      anio_mes: "2024-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 326,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "PUEBLO NUEVO SOLISTAHUACAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "BOCHIL",
      fecha_texto: "1/3/2024",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-03",
      anio_mes: "2024-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 329,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "HUITIUPAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "HUITIUPAN",
      fecha_texto: "6/13/2024",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-13",
      anio_mes: "2024-06",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 330,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MONTECRISTO DE GUERRERO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "7/9/2024",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-09",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/23/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 331,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LA INDEPENDENCIA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN DE DOMINGUEZ",
      fecha_texto: "8/25/2024",
      mes_fecha: 8,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-25",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 332,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LAS MARGARITAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN DE DOMINGUEZ",
      fecha_texto: "10/2/2024",
      mes_fecha: 10,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-02",
      anio_mes: "2024-10",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 334,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OXCHUC",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "11/15/2024",
      mes_fecha: 11,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-15",
      anio_mes: "2024-11",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 335,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "PALENQUE",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "11/26/2024",
      mes_fecha: 11,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-26",
      anio_mes: "2024-11",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 337,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "12/12/2024",
      mes_fecha: 12,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-12",
      anio_mes: "2024-12",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 339,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "4/30/2024",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-30",
      anio_mes: "2024-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 341,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TENEJAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "12/20/2024",
      mes_fecha: 12,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-20",
      anio_mes: "2024-12",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 342,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LA TRINITARIA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "4/15/2024",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-15",
      anio_mes: "2024-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/5/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 343,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLA CORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "1/15/2024",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-15",
      anio_mes: "2024-01",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 345,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "5/30/2024",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-30",
      anio_mes: "2024-05",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 346,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LA TRINITARIA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "LA TRINITARIA",
      fecha_texto: "11/8/2024",
      mes_fecha: 11,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-08",
      anio_mes: "2024-11",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 354,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "IXTAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "9/4/2024",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-04",
      anio_mes: "2024-09",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 357,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOZOCOAUTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "OCOZOCOAUTLA",
      fecha_texto: "12/3/2024",
      mes_fecha: 12,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-03",
      anio_mes: "2024-12",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 358,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SUCHIAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "8/18/2024",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-18",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 359,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BERRIOZABAL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "BERRIOZABAL",
      fecha_texto: "3/15/2024",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-15",
      anio_mes: "2024-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 360,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TOTOLAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "2/2/2024",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-02",
      anio_mes: "2024-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/1/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 364,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOZOCOAUTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "8/30/2024",
      mes_fecha: 8,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-30",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 371,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COMITAN DE DOMINGUEZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN DE DOMINGUEZ",
      fecha_texto: "12/18/2024",
      mes_fecha: 12,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-18",
      anio_mes: "2024-12",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 372,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MOTOZINTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "MOTOZINTLA",
      fecha_texto: "4/26/2024",
      mes_fecha: 4,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-26",
      anio_mes: "2024-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 374,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TILA",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "4/12/2024",
      mes_fecha: 4,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-12",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 376,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "9/19/2024",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-19",
      anio_mes: "2024-09",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/4/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 377,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHENALHO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "12/20/2024",
      mes_fecha: 12,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-20",
      anio_mes: "2024-12",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/10/2024",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 378,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TZIMOL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN DE DOMINGUEZ",
      fecha_texto: "7/25/2024",
      mes_fecha: 7,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-25",
      anio_mes: "2024-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 379,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TOTOLAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "1/7/2024",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-07",
      anio_mes: "2024-01",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 380,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TOTOLAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "1/18/2024",
      mes_fecha: 1,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-18",
      anio_mes: "2024-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 381,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ANGEL ALBINO CORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "12/10/2024",
      mes_fecha: 12,
      dia_fecha: 10,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-10",
      anio_mes: "2024-12",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 383,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOSINGO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "OCOSINGO",
      fecha_texto: "3/12/2024",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-12",
      anio_mes: "2024-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 385,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MOTOZINTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "2/13/2024",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-13",
      anio_mes: "2024-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 388,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "HUIXTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "HUIXTLA",
      fecha_texto: "5/17/2024",
      mes_fecha: 5,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-17",
      anio_mes: "2024-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 392,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "6/28/2024",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-28",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 394,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "5/20/2024",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-20",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/13/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 395,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "7/17/2024",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-17",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/7/2024",
      tipo_vacuna: "6",
      complicaciones: 3,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 397,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "8/9/2024",
      mes_fecha: 8,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-09",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/24/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 400,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "11/6/2024",
      mes_fecha: 11,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-06",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/5/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 401,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "11/5/2024",
      mes_fecha: 11,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-05",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/31/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 402,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "11/5/2024",
      mes_fecha: 11,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-05",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 405,
      edad: "60",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/18/2024",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-18",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 406,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/5/2024",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-05",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 407,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BOCOYNA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BOCOYNA",
      fecha_texto: "11/19/2024",
      mes_fecha: 11,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-19",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/4/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 415,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/9/2024",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-09",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 416,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "8/2/2024",
      mes_fecha: 8,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-02",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 417,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUACHOCHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "8/31/2024",
      mes_fecha: 8,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-31",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 422,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "3/21/2024",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-21",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 423,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "12/29/2024",
      mes_fecha: 12,
      dia_fecha: 29,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-29",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 424,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "12/30/2024",
      mes_fecha: 12,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-30",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 426,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUADALUPE Y CALVO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "10/16/2024",
      mes_fecha: 10,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-16",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 434,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/19/2024",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-19",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 436,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUADALUPE Y CALVO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "GUADALUPE Y CALVO",
      fecha_texto: "10/15/2024",
      mes_fecha: 10,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-15",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 437,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUADALUPE Y CALVO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "GUADALUPE Y CALVO",
      fecha_texto: "10/15/2024",
      mes_fecha: 10,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-15",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 439,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ROSALES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "3/5/2024",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-05",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 440,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "3/19/2024",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-19",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 442,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BACHINIVA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "6/20/2024",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-20",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 443,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BACHINIVA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/3/2024",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-03",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 445,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "VILLA LOPEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "11/24/2024",
      mes_fecha: 11,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-24",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 446,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "6/17/2024",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-17",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 447,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NUEVO CASAS GRANDES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "7/18/2024",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-18",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 448,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "8/9/2024",
      mes_fecha: 8,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-09",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 449,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BUENA AVENTURA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "7/8/2024",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-08",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 454,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/31/2024",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-31",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 455,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "VILLA AHUMADA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/19/2024",
      mes_fecha: 4,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-19",
      anio_mes: "2024-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 462,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/4/2024",
      mes_fecha: 1,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-04",
      anio_mes: "2024-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 463,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/19/2024",
      mes_fecha: 1,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-19",
      anio_mes: "2024-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 464,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BOCOYNA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BOCOYNA",
      fecha_texto: "12/3/2024",
      mes_fecha: 12,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-03",
      anio_mes: "2024-12",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 465,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/2/2025",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-02",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 472,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/16/2024",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-16",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 474,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "6/25/2024",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-25",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 478,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "5/6/2024",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-06",
      anio_mes: "2024-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/16/2024",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 480,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BUENA AVENTURA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/2/2024",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-02",
      anio_mes: "2024-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 487,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/21/2024",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 488,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 490,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/29/2024",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-29",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 491,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/29/2024",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-29",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 494,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "URIQUE",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "GUAZAPARES",
      fecha_texto: "2/19/2024",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-19",
      anio_mes: "2024-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/11/2017",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 495,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "9/3/2024",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-03",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 499,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/21/2024",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-21",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 503,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/3/2024",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-03",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 504,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "8/5/2024",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-05",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 505,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "5/15/2024",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-15",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 510,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "12/9/2024",
      mes_fecha: 12,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-09",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 513,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/22/2024",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-22",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 514,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUADALUPE Y CALVO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "PARRAL",
      fecha_texto: "8/6/2024",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-06",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 516,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NUEVO CASAS GRANDES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "3/20/2024",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-20",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/26/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 517,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "URIQUE",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BOCOYNA",
      fecha_texto: "2/8/2024",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-08",
      anio_mes: "2024-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/29/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 519,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/9/2024",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-09",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 520,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/9/2024",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-09",
      anio_mes: "2024-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 521,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/8/2024",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-08",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/20/2024",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 523,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BOCOYNA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "5/2/2024",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-02",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 525,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "12/31/2024",
      mes_fecha: 12,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-31",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 526,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "10/28/2024",
      mes_fecha: 10,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-28",
      anio_mes: "2024-10",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/10/2021",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 527,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "9/30/2024",
      mes_fecha: 9,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-30",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "8/5/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 529,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUACHOCHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BOCOYNA",
      fecha_texto: "12/13/2024",
      mes_fecha: 12,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-13",
      anio_mes: "2024-12",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 532,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/22/2024",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-22",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/15/2024",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 533,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NAMIQUIPA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "5/27/2024",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-27",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/15/2024",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 538,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "9/23/2024",
      mes_fecha: 9,
      dia_fecha: 23,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-23",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 540,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUACHOCHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "6/3/2024",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-03",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 542,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/6/2024",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-06",
      anio_mes: "2024-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 544,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/22/2024",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-22",
      anio_mes: "2024-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 545,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/11/2024",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-11",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 547,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ROSALES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "10/6/2024",
      mes_fecha: 10,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-06",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 548,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NUEVO CASAS GRANDES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "3/20/2024",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-20",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 550,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "11/5/2024",
      mes_fecha: 11,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-05",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 553,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "12/31/2024",
      mes_fecha: 12,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-31",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 558,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GALEANA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "6/20/2024",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-20",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 561,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "5/9/2024",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-09",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/6/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 562,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/23/2024",
      mes_fecha: 7,
      dia_fecha: 23,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-23",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/19/2024",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 566,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "11/27/2024",
      mes_fecha: 11,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-27",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/12/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 567,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CARICHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "8/12/2024",
      mes_fecha: 8,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-12",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 569,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NUEVO CASAS GRANDES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "4/30/2024",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-30",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 570,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/10/2024",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-10",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/9/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 571,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/6/2024",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-06",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 572,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/24/2024",
      mes_fecha: 7,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-24",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 573,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "8/6/2024",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-06",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 575,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "5/24/2024",
      mes_fecha: 5,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-24",
      anio_mes: "2024-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 576,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/26/2024",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-26",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 578,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/30/2024",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-30",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 579,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/30/2024",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-30",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 581,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 585,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "6/25/2024",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-25",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 586,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "6/28/2024",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-28",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 587,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "URUACHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "10/9/2024",
      mes_fecha: 10,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-09",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 588,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "9/13/2024",
      mes_fecha: 9,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-13",
      anio_mes: "2024-09",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 4,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 590,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/26/2024",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-26",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 591,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/31/2024",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-31",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 594,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "5/16/2024",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-16",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/10/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 596,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "9/2/2024",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-02",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 597,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "9/2/2024",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-02",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 601,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "SAN FRANCISCO DE CONCHOS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "7/2/2024",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-02",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 602,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "10/24/2024",
      mes_fecha: 10,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-24",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 606,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MÉXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 614,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "11/29/2024",
      mes_fecha: 11,
      dia_fecha: 29,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-29",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 616,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTÉMOC",
      fecha_texto: "9/6/2024",
      mes_fecha: 9,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-06",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 619,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "2/23/2024",
      mes_fecha: 2,
      dia_fecha: 23,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-23",
      anio_mes: "2024-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 621,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLAHUAC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLAHUAC",
      fecha_texto: "12/18/2024",
      mes_fecha: 12,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-18",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 623,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "7/26/2024",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-26",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/8/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 636,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "12/10/2024",
      mes_fecha: 12,
      dia_fecha: 10,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-10",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 641,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA",
      estado_notificacion: "CIUDAD DE MÉXICO",
      municipio_notificacion: "BENITO JUÁREZ",
      fecha_texto: "1/8/2025",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-08",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/4/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 648,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTÉMOC",
      fecha_texto: "9/3/2024",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-03",
      anio_mes: "2024-09",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 649,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MÉXICO",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/15/2012",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 654,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTÉMOC",
      fecha_texto: "10/28/2024",
      mes_fecha: 10,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-28",
      anio_mes: "2024-10",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 656,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "12/5/2024",
      mes_fecha: 12,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-05",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 666,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MÉXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "1/12/2025",
      mes_fecha: 1,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-12",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 673,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "8/28/2024",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-28",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 684,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTÉMOC",
      fecha_texto: "9/14/2024",
      mes_fecha: 9,
      dia_fecha: 14,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-14",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "8/12/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 687,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "9/26/2024",
      mes_fecha: 9,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-26",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 690,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "11/20/2024",
      mes_fecha: 11,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-20",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 692,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "12/16/2024",
      mes_fecha: 12,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-16",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 693,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "9/12/0204",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-12",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 697,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "9/12/2024",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-12",
      anio_mes: "2024-09",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 702,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "6/24/2024",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-24",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 703,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MÉXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "12/30/2024",
      mes_fecha: 12,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-30",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 705,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "12/9/2024",
      mes_fecha: 12,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-09",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/26/2016",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 707,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MÉXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 712,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MÉXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "1/13/2024",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-13",
      anio_mes: "2024-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 715,
      edad: "74",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "11/13/2024",
      mes_fecha: 11,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-13",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 719,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MÉXICO",
      municipio_notificacion: "XOCHIMILCO",
      fecha_texto: "1/9/2025",
      mes_fecha: 1,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-09",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/15/2023",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 725,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "11/26/2024",
      mes_fecha: 11,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-26",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/11/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 726,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "12/17/2024",
      mes_fecha: 12,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-17",
      anio_mes: "2024-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 729,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "XOCHIMILCO",
      fecha_texto: "10/25/2024",
      mes_fecha: 10,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-25",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/7/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 730,
      edad: "60",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTÉMOC",
      fecha_texto: "10/27/2024",
      mes_fecha: 10,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-27",
      anio_mes: "2024-10",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 736,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MÉXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "28/10/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 740,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "8/14/2024",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-14",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 744,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "GALEANA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "1/21/2024",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-21",
      anio_mes: "2024-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 747,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "10/7/2024",
      mes_fecha: 10,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-07",
      anio_mes: "2024-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 751,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "1/23/2024",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-23",
      anio_mes: "2024-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 754,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "8/12/2024",
      mes_fecha: 8,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-12",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/5/2024",
      tipo_vacuna: "1",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 762,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "9/2/2024",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-02",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 764,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "10/8/2024",
      mes_fecha: 10,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-08",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 767,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "10/25/2024",
      mes_fecha: 10,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-25",
      anio_mes: "2024-10",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 772,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "7/29/2024",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-29",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/3/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 778,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "8/9/2024",
      mes_fecha: 8,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-09",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 779,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "8/9/2024",
      mes_fecha: 8,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-09",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 794,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "MEZQUITAL",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/27/2024",
      mes_fecha: 4,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-27",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 816,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN LUIS DE LA PAZ",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN LUIS DE LA PAZ",
      fecha_texto: "4/17/2024",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-17",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 849,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "11/4/2024",
      mes_fecha: 11,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-04",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 864,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "11/4/2024",
      mes_fecha: 11,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-04",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 886,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "3/27/2024",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-27",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/1/2012",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 887,
      edad: "77",
      grupo_edad: "75 - 79",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "3/27/2024",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-27",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 894,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "6/28/2024",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-28",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 912,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ROMITA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "11/15/2024",
      mes_fecha: 11,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-15",
      anio_mes: "2024-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 978,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "9/23/2024",
      mes_fecha: 9,
      dia_fecha: 23,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-23",
      anio_mes: "2024-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 981,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "7/3/2024",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-03",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/16/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 988,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "AJUCHITLAN DEL PROGRESO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "8/21/2024",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-21",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 995,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "12/6/2024",
      mes_fecha: 12,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-06",
      anio_mes: "2024-12",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 996,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ARCELIA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTÉMOC",
      fecha_texto: "11/26/2024",
      mes_fecha: 11,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-26",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 998,
      edad: "69",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "MINERAL DE LA REFORMA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "12/20/2024",
      mes_fecha: 12,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-20",
      anio_mes: "2024-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1000,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ATITALAQUIA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "1/6/2025",
      mes_fecha: 1,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-06",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/5/2024",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1013,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "FRANCISCO I MADERO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "1/1/2025",
      mes_fecha: 1,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-01",
      anio_mes: "2025-01",
      institucion_notificacion: 6,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "11/13/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1015,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "AGUA BLANCA DE ITURBIDE",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "11/4/2024",
      mes_fecha: 11,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-04",
      anio_mes: "2024-11",
      institucion_notificacion: 6,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1024,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "11/20/2024",
      mes_fecha: 11,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-20",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1026,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "12/2/2024",
      mes_fecha: 12,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-02",
      anio_mes: "2024-12",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/20/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1032,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "6/13/2024",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-13",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/11/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1033,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "6/13/2024",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-13",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "6/11/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1040,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "9/6/2024",
      mes_fecha: 9,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-06",
      anio_mes: "2024-09",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/26/1979",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1045,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "9/5/2024",
      mes_fecha: 9,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-05",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1049,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "MEZQUITIC",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "2/5/2024",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-05",
      anio_mes: "2024-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1050,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "6/12/2024",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-12",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/23/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1051,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "6/21/2024",
      mes_fecha: 6,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-21",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/27/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1054,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/31/2024",
      mes_fecha: 5,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-31",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1061,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "6/25/2024",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-25",
      anio_mes: "2024-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1065,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "10/16/2024",
      mes_fecha: 10,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-16",
      anio_mes: "2024-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1069,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "7/9/2024",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-09",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1074,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "6/20/2024",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-20",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1077,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "6/21/2024",
      mes_fecha: 6,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-21",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1078,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1081,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "1/21/2025",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-21",
      anio_mes: "2025-01",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/13/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1085,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "12/20/2024",
      mes_fecha: 12,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-20",
      anio_mes: "2024-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1087,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/15/2024",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-15",
      anio_mes: "2024-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1100,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/24/2024",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-24",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1101,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/30/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1102,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LAGOS DE MORENO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LAGOS DE MORENO",
      fecha_texto: "11/21/2024",
      mes_fecha: 11,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-21",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1106,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "12/26/2024",
      mes_fecha: 12,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-26",
      anio_mes: "2024-12",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/12/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1114,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/26/1970",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1116,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TOLIMAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOTLAN EL GRANDE",
      fecha_texto: "5/21/2024",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-21",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1133,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/29/2024",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-29",
      anio_mes: "2024-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1136,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "11/29/2024",
      mes_fecha: 11,
      dia_fecha: 29,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-29",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/30/2024",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1139,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "IXTLAHUACAN DE LOS MEMBRILLOS",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "6/9/2024",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-09",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1147,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "7/1/2024",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-01",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/22/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1154,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "12/30/2024",
      mes_fecha: 12,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-30",
      anio_mes: "2024-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1159,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "9/12/2024",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-12",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1161,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/1/2024",
      mes_fecha: 3,
      dia_fecha: 1,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-01",
      anio_mes: "2024-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1166,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/14/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1167,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/14/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1169,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "9/15/2024",
      mes_fecha: 9,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-15",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1177,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "6/11/2024",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-11",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1178,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "10/16/2024",
      mes_fecha: 10,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-16",
      anio_mes: "2024-10",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1180,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TALA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "AMECA",
      fecha_texto: "10/9/2024",
      mes_fecha: 10,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-09",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1181,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "8/27/2024",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-27",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1186,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "7/7/2024",
      mes_fecha: 7,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-07",
      anio_mes: "2024-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1196,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "COLOTLAN",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "5/1/2024",
      mes_fecha: 5,
      dia_fecha: 1,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-01",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/5/2024",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1200,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "12/12/2024",
      mes_fecha: 12,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-12",
      anio_mes: "2024-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1208,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "AMECAMECA",
      fecha_texto: "11/15/2024",
      mes_fecha: 11,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-15",
      anio_mes: "2024-11",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1209,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "LOS REYES LA PAZ",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "IXTAPALUCA",
      fecha_texto: "9/18/2024",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-18",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/22/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1223,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SANTA MARIA RAYON",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "12/11/2024",
      mes_fecha: 12,
      dia_fecha: 11,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-11",
      anio_mes: "2024-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "28/11/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1226,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TECAMAC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TECAMAC",
      fecha_texto: "12/9/2024",
      mes_fecha: 12,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-09",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "31/10/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1230,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "COACALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "COACALCO",
      fecha_texto: "1/3/2025",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-03",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1235,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SANTA MARIA RAYON",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "12/27/2024",
      mes_fecha: 12,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-27",
      anio_mes: "2024-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "05/10/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1239,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NAUCALPAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NAUCALPAN",
      fecha_texto: "6/21/2024",
      mes_fecha: 6,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-21",
      anio_mes: "2024-06",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1240,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "9/24/2024",
      mes_fecha: 9,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-24",
      anio_mes: "2024-09",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/22/2023",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1246,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZUMPANGO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ZUMPANGO",
      fecha_texto: "6/10/2024",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-10",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1249,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZUMPANGO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TECAMAC",
      fecha_texto: "11/21/2024",
      mes_fecha: 11,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-21",
      anio_mes: "2024-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1252,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "11/6/2024",
      mes_fecha: 11,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-06",
      anio_mes: "2024-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1253,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "IXTAPALUCA",
      fecha_texto: "11/26/2024",
      mes_fecha: 11,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-26",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1255,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CUAUTITLAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "",
      fecha_texto: "10/17/2024",
      mes_fecha: 10,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-17",
      anio_mes: "2024-10",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1256,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "IXTAPALUCA",
      fecha_texto: "11/6/2024",
      mes_fecha: 11,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-06",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1257,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "NUEVO SAN JUAN PARANGARICUTIRO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "2/15/2024",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-15",
      anio_mes: "2024-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "8/26/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1258,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "NUEVO SAN JUAN PARANGARICUTIRO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "2/15/2024",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-15",
      anio_mes: "2024-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/16/2023",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1265,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "TARIMBARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "11/26/2024",
      mes_fecha: 11,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-26",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1266,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "11/8/2024",
      mes_fecha: 11,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-08",
      anio_mes: "2024-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1271,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LA PIEDAD",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "LA PIEDAD",
      fecha_texto: "12/13/2024",
      mes_fecha: 12,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-13",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/31/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1277,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "SAHUAYO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "SAHUAYO",
      fecha_texto: "11/15/2024",
      mes_fecha: 11,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-15",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1280,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "12/2/2024",
      mes_fecha: 12,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-02",
      anio_mes: "2024-12",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1283,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "NUEVO SAN JUAN PARANGARICUTIRO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "2/15/2024",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-15",
      anio_mes: "2024-02",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "1/8/1900",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1284,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "SAN JUAN TLALPUJAHUILLA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/22/2024",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-22",
      anio_mes: "2024-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1300,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TEPOZTLAN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "9/17/2024",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-17",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1301,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TEPOZTLAN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "10/2/2024",
      mes_fecha: 10,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-02",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1308,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TEMOAC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "9/8/2024",
      mes_fecha: 9,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-08",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1309,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TOTOLOAPAN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "9/9/2024",
      mes_fecha: 9,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-09",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1315,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "5/28/2024",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-28",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/24/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1318,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "EL NAYAR",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "DEL NAYAR",
      fecha_texto: "7/17/2024",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-17",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1319,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "LA YESCA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "1/15/2024",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-15",
      anio_mes: "2024-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1320,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEUALA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "5/7/2024",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-07",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1321,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "BAHIA DE BANDERAS",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "BAHIA DE BANDERAS",
      fecha_texto: "3/7/2024",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-07",
      anio_mes: "2024-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1324,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "8/20/2024",
      mes_fecha: 8,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-20",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1325,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "10/28/2024",
      mes_fecha: 10,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-28",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1326,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "SAN BLAS",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/12/2024",
      mes_fecha: 4,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-12",
      anio_mes: "2024-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1328,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "JALA",
      estado_notificacion: "NYARIT",
      municipio_notificacion: "IXTLAN DEL RIO",
      fecha_texto: "4/2/2024",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-02",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/27/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1335,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "JALA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "IXTLAN DEL RIO",
      fecha_texto: "1/24/2024",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-24",
      anio_mes: "2024-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1339,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GENERAL ESCOBEDO",
      fecha_texto: "10/28/2024",
      mes_fecha: 10,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-28",
      anio_mes: "2024-10",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1344,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "10/2/2024",
      mes_fecha: 10,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-02",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1347,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "9/11/2024",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-11",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1350,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "10/24/2024",
      mes_fecha: 10,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-24",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1351,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/28/2024",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-28",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/22/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1352,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/12/2024",
      mes_fecha: 4,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-12",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1356,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "9/9/2024",
      mes_fecha: 9,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-09",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1359,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/26/2024",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-26",
      anio_mes: "2024-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1366,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "10/28/2024",
      mes_fecha: 10,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-28",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1367,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/21/2024",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-21",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1371,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CIENEGA DE FLORES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "10/4/2024",
      mes_fecha: 10,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-04",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1374,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/15/2024",
      mes_fecha: 8,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-15",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1376,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "9/2/2024",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-02",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1377,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "9/19/2024",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-19",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/2/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1383,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "1/26/2024",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-26",
      anio_mes: "2024-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/4/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1386,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/17/2024",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-17",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/28/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1387,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "10/7/2024",
      mes_fecha: 10,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-07",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1393,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/18/2024",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-18",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/24/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1397,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "8/30/2024",
      mes_fecha: 8,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-30",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1403,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "ZIMATLAN DE ALVAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "12/3/2024",
      mes_fecha: 12,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-03",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/29/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1406,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO JUXTLAHUACA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO JUXTLAHUACA",
      fecha_texto: "9/6/2024",
      mes_fecha: 9,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-06",
      anio_mes: "2024-09",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "19/08/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1407,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "CORRAL DE PIEDRA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO JUXTLAHUACA",
      fecha_texto: "11/27/2024",
      mes_fecha: 11,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-27",
      anio_mes: "2024-11",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/26/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1410,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN JUAN BAUTISTA TUXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN JUAN BAUTISTA TUXTEPEC",
      fecha_texto: "7/8/2024",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-08",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/8/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1411,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN ANTONINO CASTILLO VELASCO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "10/31/2024",
      mes_fecha: 10,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-31",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/16/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1412,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "CUILAPAM DE GUERRERO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "12/2/2024",
      mes_fecha: 12,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-02",
      anio_mes: "2024-12",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/28/2024",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1413,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "CANDELARIA LOXICHA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "MIAHUATLAN",
      fecha_texto: "12/14/2024",
      mes_fecha: 12,
      dia_fecha: 14,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-14",
      anio_mes: "2024-12",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1414,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "CANDELARIA LOXICHA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "MIAHUATLAN",
      fecha_texto: "12/14/2024",
      mes_fecha: 12,
      dia_fecha: 14,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-14",
      anio_mes: "2024-12",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1415,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "CANDELARIA LOXICHA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "MIAHUATLAN",
      fecha_texto: "12/14/2024",
      mes_fecha: 12,
      dia_fecha: 14,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-14",
      anio_mes: "2024-12",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1416,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "CANDELARIA LOXICHA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "MIAHUATLAN",
      fecha_texto: "12/14/2024",
      mes_fecha: 12,
      dia_fecha: 14,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-14",
      anio_mes: "2024-12",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1417,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN MATEO RIO HONDO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "7/26/2024",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-26",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1422,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN ANTONIO HUITEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "11/13/2024",
      mes_fecha: 11,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-13",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1424,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN PEDRO MIXTEPEC",
      fecha_texto: "8/5/2024",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-05",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1425,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "CHICHIQUILA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "HUATUSCO",
      fecha_texto: "12/15/2024",
      mes_fecha: 12,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-15",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1426,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "QUIMIXTLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "7/10/2024",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-10",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1430,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA DE HGO",
      fecha_texto: "1/8/2025",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-08",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/17/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1435,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "HUIMILPAN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "HUIMILPAN",
      fecha_texto: "8/25/2024",
      mes_fecha: 8,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-25",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/14/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1437,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/22/2024",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-22",
      anio_mes: "2024-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/26/2023",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1444,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/20/1900",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 1900,
      fecha_notificacion: "1900-01-20",
      anio_mes: "1900-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/2/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1448,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "12/26/2024",
      mes_fecha: 12,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-26",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1453,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "AMEALCO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "11/6/2024",
      mes_fecha: 11,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-06",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1457,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "PEDRO ESCOBEDO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/2/2025",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-02",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/11/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1459,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "8/19/2024",
      mes_fecha: 8,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-19",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1460,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "7/22/2024",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-22",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/10/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1463,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "12/9/2025",
      mes_fecha: 12,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-12-09",
      anio_mes: "2025-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1468,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "8/30/2024",
      mes_fecha: 8,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-30",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/21/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1495,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "FELIPE CARRILLO PUERTO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "FELIPE CARRILLO PUERTO",
      fecha_texto: "8/17/2024",
      mes_fecha: 8,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-17",
      anio_mes: "2024-08",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/25/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1496,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "FELIPE CARRILLO PUERTO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "FELIPE CARRILLO PUERTO",
      fecha_texto: "8/30/2024",
      mes_fecha: 8,
      dia_fecha: 30,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-30",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1507,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "11/28/2024",
      mes_fecha: 11,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-28",
      anio_mes: "2024-11",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "11/10/2022",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1512,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "SOLIDARIDAD",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "SOLIDARIDAD",
      fecha_texto: "6/24/2024",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-24",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/21/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1513,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "SOLIDARIDAD",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "SOLIDARIDAD",
      fecha_texto: "7/4/2024",
      mes_fecha: 7,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-04",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/10/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1516,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "7/6/2024",
      mes_fecha: 7,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-06",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1517,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "7/10/2024",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-10",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1522,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "7/11/2024",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-11",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/14/1993",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1532,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "SOLIDARIDAD",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "SOLIDARIDAD",
      fecha_texto: "7/26/2024",
      mes_fecha: 7,
      dia_fecha: 26,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-26",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1539,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "8/15/2024",
      mes_fecha: 8,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-15",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/12/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1544,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "9/13/2024",
      mes_fecha: 9,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-13",
      anio_mes: "2024-09",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1546,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "8/27/2024",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-27",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1548,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "SOLIDARIDAD",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "SOLIDARIDAD",
      fecha_texto: "7/24/2024",
      mes_fecha: 7,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-24",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1552,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "7/25/2024",
      mes_fecha: 7,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-25",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "1/23/2018",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1553,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "8/5/2024",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-05",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/6/2015",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1558,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "SOLIDARIDAD",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "SOLIDARIDAD",
      fecha_texto: "7/19/2024",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-19",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1559,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "11/28/2024",
      mes_fecha: 11,
      dia_fecha: 28,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-28",
      anio_mes: "2024-11",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1561,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "11/1/2024",
      mes_fecha: 11,
      dia_fecha: 1,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-01",
      anio_mes: "2024-11",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1562,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "11/7/2024",
      mes_fecha: 11,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-07",
      anio_mes: "2024-11",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/25/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1563,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "SOLIDARIDAD",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "SOLIDARIDAD",
      fecha_texto: "7/24/2024",
      mes_fecha: 7,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-24",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/21/2021",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1577,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SALINAS",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "1/17/2024",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-17",
      anio_mes: "2024-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1602,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "RAYON",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "10/3/2024",
      mes_fecha: 10,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-03",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1604,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "TIERRA NUEVA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSÍ",
      fecha_texto: "8/20/2024",
      mes_fecha: 8,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-20",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1620,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SDGS",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSÍ",
      fecha_texto: "8/25/2024",
      mes_fecha: 8,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-25",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1628,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULICAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "7/10/2024",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-10",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1648,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "8/21/2024",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-21",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/20/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1656,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "8/22/2024",
      mes_fecha: 8,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-22",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "20/012/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1671,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "MOCORITO",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "7/4/2024",
      mes_fecha: 7,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-04",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/20/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1679,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "NAVOLATO",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "NAVOLATO",
      fecha_texto: "8/7/2024",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-07",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/30/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1682,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "9/15/2024",
      mes_fecha: 9,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-15",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/22/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1688,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "8/1/2024",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-01",
      anio_mes: "2024-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1698,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "5/19/2024",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-19",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/17/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1701,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "7/29/2024",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-29",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1705,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "AHOME",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "AHOME",
      fecha_texto: "11/12/2024",
      mes_fecha: 11,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-12",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1717,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "4/12/2024",
      mes_fecha: 4,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-12",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1719,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "12/17/2024",
      mes_fecha: 12,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-17",
      anio_mes: "2024-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1734,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "GUAYMAS",
      estado_notificacion: "SONORA",
      municipio_notificacion: "GUAYMAS",
      fecha_texto: "7/9/2024",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-09",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1735,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "7/5/2024",
      mes_fecha: 7,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-05",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1736,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "11/11/2024",
      mes_fecha: 11,
      dia_fecha: 11,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-11",
      anio_mes: "2024-11",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "24/06/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1747,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "AGUA PRIETA",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "10/23/2024",
      mes_fecha: 10,
      dia_fecha: 23,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-23",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1749,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/15/2024",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-15",
      anio_mes: "2024-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1750,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "6/20/2024",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-20",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1761,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "5/7/2024",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-07",
      anio_mes: "2024-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "07/04/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1765,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "7/16/2024",
      mes_fecha: 7,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-16",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1767,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "5/15/2024",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-15",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1774,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "URES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "URES",
      fecha_texto: "7/31/2024",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-31",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1777,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "5/16/2024",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-16",
      anio_mes: "2024-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "14/05/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1779,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "7/5/2024",
      mes_fecha: 7,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-05",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1785,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "5/2/2024",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-02",
      anio_mes: "2024-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 7,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1790,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "GUAYMAS",
      estado_notificacion: "sonora",
      municipio_notificacion: "Guaymas",
      fecha_texto: "9/9/2024",
      mes_fecha: 9,
      dia_fecha: 9,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-09",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1795,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "6/20/2024",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-20",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1796,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "URES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "7/6/2024",
      mes_fecha: 7,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-06",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/5/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1797,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "URES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "URES",
      fecha_texto: "7/31/2024",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-31",
      anio_mes: "2024-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "16/02/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1800,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "4/29/2024",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-29",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1801,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "5/16/2024",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-16",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/16/2000",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1811,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CENTRO",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "9/7/2024",
      mes_fecha: 9,
      dia_fecha: 7,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-07",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/8/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1813,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CÁRDENAS",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "4/2/2024",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-02",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1814,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "JALPA DE MENDEZ",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "4/23/2024",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-23",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1815,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "JALPA DE MENDEZ",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "4/23/2024",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-23",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1822,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CÁRDENAS",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CÁRDENAS",
      fecha_texto: "6/3/2024",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-03",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1827,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "1/5/2024",
      mes_fecha: 1,
      dia_fecha: 5,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-05",
      anio_mes: "2024-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1840,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "2/2/2024",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-02",
      anio_mes: "2024-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1841,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "EL MANTE",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "EL MANTE",
      fecha_texto: "1/24/2024",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-24",
      anio_mes: "2024-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/9/2024",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1859,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUAMANTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "HUAMANTLA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1860,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUAMANTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "HUAMANTLA",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1861,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LA PERLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "6/12/2024",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-12",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1863,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MISANTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "10/12/2024",
      mes_fecha: 10,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-10-12",
      anio_mes: "2024-10",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "9/3/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1869,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "HUAYACOCOTLA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "2/6/2024",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-06",
      anio_mes: "2024-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/21/2023",
      tipo_vacuna: "1",
      complicaciones: 7,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1871,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SOLEDAD DE DOBLADO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SOLEDAD DE DOBLADO",
      fecha_texto: "11/22/2024",
      mes_fecha: 11,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-22",
      anio_mes: "2024-11",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1879,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "12/4/2024",
      mes_fecha: 12,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-04",
      anio_mes: "2024-12",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1890,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "12/4/2024",
      mes_fecha: 12,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-04",
      anio_mes: "2024-12",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1893,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "EMILIANO ZAPATA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "12/13/2024",
      mes_fecha: 12,
      dia_fecha: 13,
      anio_fecha: 2024,
      fecha_notificacion: "2024-12-13",
      anio_mes: "2024-12",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1894,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "9/25/2024",
      mes_fecha: 9,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-25",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1895,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TLAQUILPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "4/16/2024",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-16",
      anio_mes: "2024-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1899,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "AMATITLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "6/25/2024",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-25",
      anio_mes: "2024-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1910,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN ANDRES TUXTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SAN ANDRES TUXTLA",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1912,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "KANASIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "8/8/2024",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-08",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/14/2012",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1914,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/23/2024",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-23",
      anio_mes: "2024-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/9/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1921,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "9/17/2024",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-17",
      anio_mes: "2024-09",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1926,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/29/2024",
      mes_fecha: 6,
      dia_fecha: 29,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-29",
      anio_mes: "2024-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1929,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MAYAPAN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/16/2024",
      mes_fecha: 3,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-16",
      anio_mes: "2024-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1931,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "7/31/2024",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2024,
      fecha_notificacion: "2024-07-31",
      anio_mes: "2024-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/23/2016",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1932,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "9/11/2024",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2024,
      fecha_notificacion: "2024-09-11",
      anio_mes: "2024-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1943,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "11/8/2024",
      mes_fecha: 11,
      dia_fecha: 8,
      anio_fecha: 2024,
      fecha_notificacion: "2024-11-08",
      anio_mes: "2024-11",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1947,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "8/16/2024",
      mes_fecha: 8,
      dia_fecha: 16,
      anio_fecha: 2024,
      fecha_notificacion: "2024-08-16",
      anio_mes: "2024-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "7/26/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1951,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA DE COS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "5/22/2024",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-22",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1953,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/15/2024",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2024,
      fecha_notificacion: "2024-05-15",
      anio_mes: "2024-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2024,
      fila_archivo: 1967,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "3/11/2024",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2024,
      fecha_notificacion: "2024-03-11",
      anio_mes: "2024-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 4,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 5,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 6,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 11,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 12,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 13,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 14,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 18,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "JESUS MARIA",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 20,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 21,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "JESUS MARIA",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 22,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "JESUS MARIA",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 24,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/4/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 25,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/4/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 26,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 27,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 29,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 30,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "CALVILLO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "CALVILLO",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 34,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "RINCON DE ROMOS",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/15/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 35,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "RINCON DE ROMOS",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 36,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "RINCON DE ROMOS",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 40,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 41,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 42,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 47,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "JESUS MARIA",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/21/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 48,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "JESUS MARIA",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/30/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 49,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "ASIENTOS",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 50,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "ASIENTOS",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "9/28/2023",
      tipo_vacuna: "1, 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 51,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "ASIENTOS",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 52,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "RINCON DE ROMOS",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "ASIENTOS",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 53,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 54,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 55,
      edad: "67",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 56,
      edad: "86",
      grupo_edad: "85 - 89",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 57,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 58,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 61,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 62,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 64,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 71,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 72,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "JESUS MARIA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/28/1996",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 73,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "JESUS MARIA",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "JESUS MARIA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 74,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 75,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 76,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 81,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/8/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 82,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 83,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 84,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 85,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 86,
      edad: "65",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 91,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/24/2025",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 92,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 93,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 94,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 95,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 97,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "8/14/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 98,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 99,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 100,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/8/1900",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 103,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 104,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 105,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 119,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 120,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 125,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 134,
      edad: "63",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 135,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 141,
      edad: "69",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "JESUS MARIA",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "JESUS MARIA",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 142,
      edad: "66",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "JESUS MARIA",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "JESUS MARIA",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/1/2025",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 143,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 144,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 149,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 150,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 151,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 154,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 158,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/26/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 159,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 168,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/28/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 169,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 172,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/22/2015",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 173,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 182,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "CALVILLO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "CALVILLO",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 183,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "CALVILLO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "CALVILLO",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 184,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "CALVILLO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "CALVILLO",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 185,
      edad: "73",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "CALVILLO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "CALVILLO",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 186,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 187,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 188,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 191,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 192,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 193,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 195,
      edad: "60",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "EL LLANO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 196,
      edad: "62",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "EL LLANO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 197,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "CALVILLO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "CALVILLO",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/20/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 198,
      edad: "63",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "CALVILLO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "CALVILLO",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 208,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/12/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 217,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 219,
      edad: "55",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "JESUS MARIA",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 220,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "JESUS MARIA",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 229,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "8/8/2025",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-08",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 230,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "8/8/2025",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-08",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 231,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "AGUASCALIENTES",
      municipio_residencia: "AGUASCALIENTES",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "8/8/2025",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-08",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 235,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "1/11/2025",
      mes_fecha: 1,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-11",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/22/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 240,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 245,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "1/26/2025",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-26",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 251,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/20/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 257,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 264,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 266,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 287,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "2/23/2025",
      mes_fecha: 2,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-23",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 300,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "3/2/2025",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-02",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 322,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 327,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 345,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "ENSENADA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 352,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "4/5/2025",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-05",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 354,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TECATE",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TECATE",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 356,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 370,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 372,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/24/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 381,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 384,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 390,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 391,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "6/16/2025",
      mes_fecha: 6,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-16",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 394,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "6/25/2025",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-25",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/12/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 395,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "6/27/2025",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-27",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 400,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "ENSENADA",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "SAN QUINTIN",
      fecha_texto: "7/8/2025",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-08",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 401,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "MEXICALI",
      estado_notificacion: "BAJA CALIFORNIA",
      municipio_notificacion: "MEXICALI",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "TOS FERINA",
    },
    {
      anio: 2025,
      fila_archivo: 405,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA",
      municipio_residencia: "TIJUANA",
      estado_notificacion: "BAJA_CALIFORNIA",
      municipio_notificacion: "TIJUANA",
      fecha_texto: "7/20/2025",
      mes_fecha: 7,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-20",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/8/2025",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 407,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "11/12/2024",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 408,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 409,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "MULEGE",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "MULEGE",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "13/02/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 410,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "1/27/2025",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 411,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "MULEGE",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "MULEGE",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 412,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "COMONDU",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "COMONDU",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/21/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 413,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LORETO",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LORETO",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/01/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 414,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "04/05/2021",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 415,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 416,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "MULEGE",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "MULEGE",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "04/03/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 417,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 418,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "13/01/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 419,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "13/01/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 420,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "20/02/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 421,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 422,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "MULEGE",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "MULEGE",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/12/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 423,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "03/02/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 424,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/22/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 425,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "4/5/2025",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-05",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 426,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 427,
      edad: "70",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 428,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 429,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 430,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 431,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/8/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 432,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "01/04/2025",
      tipo_vacuna: "4 (HEXAVALENTE)",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 433,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "28/02/2019",
      tipo_vacuna: "1-2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 434,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 435,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "COMONDU",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "COMONDU",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "26/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 436,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "13/02/2025",
      tipo_vacuna: "4 (HEXAVALENTE)",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 437,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "MULEGE",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "MULEGE",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "08/12/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 438,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/03/2025",
      tipo_vacuna: "4 (HEXAVALENTE)",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 439,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "MULEGE",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "MULEGE",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "09/08/2004",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 440,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "30/06/2023",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 441,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "MULEGE",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "MULEGE",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 442,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "COMONDU",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "COMONDU",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 443,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "5/24/2025",
      mes_fecha: 5,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-24",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/2/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 444,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "5/24/2025",
      mes_fecha: 5,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-24",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/2/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 445,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "MULEGE",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "MULEGÉ",
      fecha_texto: "5/26/2025",
      mes_fecha: 5,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-26",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "31/03/2025",
      tipo_vacuna: "4 (HEXAVALENTE)",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 446,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 447,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "MULEGE",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "5/26/2025",
      mes_fecha: 5,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-26",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 448,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "01/04/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 449,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "01/04/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 450,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "MULEGE",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "MULEGE",
      fecha_texto: "7/8/2025",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-08",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 451,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "LOS CABOS",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LOS CABOS",
      fecha_texto: "7/18/2025",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-18",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 452,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "MULEGE",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "MULEGÉ",
      fecha_texto: "8/5/2025",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-05",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "23-06-2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 453,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "BAJA CALIFORNIA SUR",
      municipio_residencia: "MULEGE",
      estado_notificacion: "BAJA CALIFORNIA SUR",
      municipio_notificacion: "LA PAZ",
      fecha_texto: "5/26/2025",
      mes_fecha: 5,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-26",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 454,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "1/10/2025",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-10",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 455,
      edad: "86",
      grupo_edad: "85 - 89",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CARMEN",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 456,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/9/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 457,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 458,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/2/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 459,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/2/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 460,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 461,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "2/3/2025",
      mes_fecha: 2,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-03",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/26/2018",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 462,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "2/3/2025",
      mes_fecha: 2,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-03",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 463,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "2/3/2025",
      mes_fecha: 2,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-03",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/13/2022",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 464,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/19/2024",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 465,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "1/9/2023",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 466,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/2/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 467,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CHAMPOTON",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 468,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 469,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CALAKMUL",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/8/2024",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 5,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 470,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/7/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 471,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/26/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 472,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "3/2/2025",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-02",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 473,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "DZITBALCHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 474,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CARMEN",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/9/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 475,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 476,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 477,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 478,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "ESCARCEGA",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 479,
      edad: "64",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 480,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/13/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 481,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALAKMUL",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/23/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 482,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/8/1900",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 483,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/8/2012",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 484,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/4/1905",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 485,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/11/2023",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 486,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "ESCARCEGA",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1994",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 487,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "23/11/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 488,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALKINI",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "HECELCHAKAN",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/29/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 489,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CHAMPOTON",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "3/29/2025",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-29",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 490,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "3/29/2025",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-29",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "22/11/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 491,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CARMEN",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/5/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 492,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "4/6/2025",
      mes_fecha: 4,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-06",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/30/2021",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 493,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/25/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 494,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "HECELCHAKAN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "HECELCHAKAN",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/26/2016",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 495,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "4/17/2025",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-17",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/18/2023",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 496,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "4/17/2025",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-17",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/18/2023",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 497,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "13/04/2023",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 498,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "18/03/2022",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 499,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "4/26/2025",
      mes_fecha: 4,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-26",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 500,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "HECELCHAKAN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "HECELCHAKAN",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "7/7/1905",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 501,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "23/05/2014",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 502,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CANDELARIA",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "2/20/2016",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 503,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CANDELARIA",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/1/2017",
      tipo_vacuna: "7",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 504,
      edad: "57",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 505,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CARMEN",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 506,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CARMEN",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 507,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/09/2022",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 508,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "14/03/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 509,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/4/2022",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 510,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 511,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "8/27/2020",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 512,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/25/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 513,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "DZITBALCHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/12/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 514,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CALKINI",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "05/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 515,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/22/2011",
      tipo_vacuna: "7",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 516,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/1/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 517,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CD DEL CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CARMEN",
      fecha_texto: "6/15/2025",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-15",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/28/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 518,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "6/20/2025",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-20",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/1/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 519,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CARMEN",
      fecha_texto: "7/4/2025",
      mes_fecha: 7,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-04",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "30/2/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 520,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CARMEN",
      fecha_texto: "7/4/2025",
      mes_fecha: 7,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-04",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "17/08/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 521,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CARMEN",
      fecha_texto: "7/9/2025",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-09",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/7/2020",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 522,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "HOPELCHEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 523,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "HOPELCHEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "HOPELCHÉN",
      fecha_texto: "7/18/2025",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-18",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 524,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "HOPELCHEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "HOPELCHÉN",
      fecha_texto: "7/18/2025",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-18",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 525,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "7/18/2025",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-18",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 526,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "7/22/2025",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-22",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 527,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "7/25/2025",
      mes_fecha: 7,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-25",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 528,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "7/25/2025",
      mes_fecha: 7,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-25",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 529,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "ESCARCEGA",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "7/25/2025",
      mes_fecha: 7,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-25",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 530,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "ESCARCEGA",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "7/25/2025",
      mes_fecha: 7,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-25",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 531,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CAMPECHE",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CAMPECHE",
      fecha_texto: "7/30/2025",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-30",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 532,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "8/1/2025",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-01",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 533,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "ESCARCEGA",
      fecha_texto: "8/21/2025",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-21",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/7/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 534,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CAMPECHE",
      municipio_residencia: "CARMEN",
      estado_notificacion: "CAMPECHE",
      municipio_notificacion: "CARMEN",
      fecha_texto: "8/27/2025",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-27",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/22/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 535,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "HUITIUPAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "1/3/2025",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-03",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 536,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "HUITIUPAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "1/3/2025",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-03",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 537,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "HUITIUPAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "1/3/2025",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-03",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 538,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "HUITIUPAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SIMOJOVEL",
      fecha_texto: "1/10/2025",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-10",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/8/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 539,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LA TRINITARIA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "LA TRINITARIA",
      fecha_texto: "1/3/2025",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-03",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "11/6/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 540,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CHAMULA",
      fecha_texto: "1/6/2025",
      mes_fecha: 1,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-06",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 541,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SALTO DE AGUA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SALTO DE AGUA",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 542,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "JIQUIPILAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CINTALAPA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 543,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "JIQUIPILAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CINTALAPA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 544,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "JIQUIPILAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CINTALAPA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 545,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "JIQUIPILAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CINTALAPA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 546,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TAPACHULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/3/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 547,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TENEJAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 548,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "AMATAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "PICHUCALCO",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 549,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MITONTIC",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CHAMULA",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 550,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COMITAN DE DOMINGUEZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN DE DOMINGUEZ",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 551,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LARRAINZAR",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 552,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MOTOZINTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 553,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CHAMULA",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 554,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 555,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 556,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHENALHO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "1/26/2025",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-26",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 557,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLAFLORES",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 558,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLAFLORES",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 559,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 560,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 561,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 562,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LARRAINZAR",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "LARRAINZAR",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 563,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LARRAINZAR",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "LARRAINZAR",
      fecha_texto: "3/2/2025",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-02",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 564,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/5/2023",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 565,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOSINGO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 566,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/8/2025",
      mes_fecha: 3,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-08",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 567,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOZOCOAUTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "OCOZOCOAUTLA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 568,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/13/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 569,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ACALA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/17/2025",
      mes_fecha: 3,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-17",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 570,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ACALA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/17/2025",
      mes_fecha: 3,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-17",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 571,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CINTALAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CINTALAPA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 572,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CINTALAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 573,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CINTALAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CINTALAPA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 574,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CINTALAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CINTALAPA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 575,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CINTALAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 576,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CACAHOATAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/10/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 577,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MARAVILLA TENAJAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "MARAVILLA TENEJAPA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 578,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COMITAN DE DOMINGUEZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN DE DOMINGUEZ",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "12/21/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 579,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LA TRINITARIA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN DE DOMINGUEZ",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/22/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 580,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ZINACANTAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 581,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN JUAN CHAMULA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 582,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ARRIAGA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "ARRIAGA",
      fecha_texto: "3/30/2025",
      mes_fecha: 3,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-30",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/15/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 583,
      edad: "73",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 584,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LA TRINITARIA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "LA TRINITARIA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/22/2023",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 585,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "IXTACOMITAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "PICHUCALCO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 586,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "3/29/2025",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-29",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 587,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHIAPILLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/27/2024",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 588,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 589,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OXCHUC",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "OXCHUC",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/18/2016",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 590,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN JUAN CHAMULA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 591,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LARRAINZAR",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "LARRAINZAR",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/6/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 592,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "4/12/2025",
      mes_fecha: 4,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-12",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/10/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 593,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 594,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "MOTOZINTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "MOTOZINTLA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 595,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLACORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLACORZO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/14/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 596,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLACORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLACORZO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/10/2015",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 597,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLACORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLACORZO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 598,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLACORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLACORZO",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/26/2017",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 599,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLACORZO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLACORZO",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/15/2024",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 600,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ARRIAGA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "ARRIAGA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 601,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ARRIAGA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "ARRIAGA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/10/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 602,
      edad: "71",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TONALA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TONALA",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 603,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "PALENQUE",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "PALENQUE",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 604,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 605,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "2/9/2021",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 606,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OXCHUC",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/9/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 607,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "5/4/2025",
      mes_fecha: 5,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-04",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/6/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 608,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TAPACHULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 609,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TAPACHULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/27/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 610,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN JUAN CANCUC",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN JUAN CANCUC",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "9/9/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 611,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "VILLAFLORES",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/22/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 612,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 613,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/11/2025",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 614,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "5/18/2025",
      mes_fecha: 5,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-18",
      anio_mes: "2025-05",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 615,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 616,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CACAHOATAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 617,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TONALA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TONALA",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 618,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 619,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 620,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/5/2025",
      mes_fecha: 6,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-05",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 621,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "HUIXTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "HUIXTLA",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 622,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "HUIXTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 623,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "HUIXTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "HUIXTLA",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/12/2012",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 624,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHILON",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "YAJALON",
      fecha_texto: "6/10/2025",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-10",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 625,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHILON",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CHILON",
      fecha_texto: "6/25/2025",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-25",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 626,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHILON",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "CHILON",
      fecha_texto: "6/25/2025",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-25",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 627,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "6/10/2025",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-10",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 628,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CHAMULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/14/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 629,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN LUCAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 630,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COMITAN DE DOMINGUEZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN DE DOMINGUEZ",
      fecha_texto: "6/25/2025",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-25",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 631,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COMITAN DE DOMINGUEZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL DE LAS CASAS",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 632,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BELLA VISTA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN DE DOMINGUEZ",
      fecha_texto: "6/26/2025",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-26",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 633,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/14/2025",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-14",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 634,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/14/2025",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-14",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 635,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/14/2025",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-14",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 636,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/14/2025",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-14",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 637,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SUCHIATE",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 638,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SUCHIATE",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 639,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/21/2025",
      mes_fecha: 6,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-21",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 640,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/21/2025",
      mes_fecha: 6,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-21",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 641,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 642,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 643,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/28/2025",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-28",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 644,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "6/28/2025",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-28",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 645,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LA TRINITARIA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN DE DOMINGUEZ",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 646,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LA TRINITARIA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN DE DOMINGUEZ",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 647,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BELLA VISTA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "FRONTERA COMALAPA",
      fecha_texto: "7/10/2025",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-10",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 648,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BELLA VISTA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "",
      fecha_texto: "7/10/2025",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-10",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 649,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "BELLA VISTA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "",
      fecha_texto: "7/10/2025",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-10",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 650,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CINTALAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "7/5/2025",
      mes_fecha: 7,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-05",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 651,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SOYALO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "7/7/2025",
      mes_fecha: 7,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-07",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 652,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 653,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "HUEHUETAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "HUIXTLA",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/5/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 654,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SAN CRISTOBAL DE LAS CASAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SAN CRISTOBAL",
      fecha_texto: "7/18/2025",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-18",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/30/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 655,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "YAJALON",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "YAJALON",
      fecha_texto: "7/22/2026",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2026,
      fecha_notificacion: "2026-07-22",
      anio_mes: "2026-07",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 656,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TILA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "YAJALON",
      fecha_texto: "8/1/2025",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-01",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/7/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 657,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "OCOSINGO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "PALENQUE",
      fecha_texto: "8/1/2025",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-01",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 658,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CAPITAN LUIS A. VIDAL",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/15/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 659,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TONALA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TONALA",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 660,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COMITAN DE DOMINGUEZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN DE DOMINGUEZ",
      fecha_texto: "8/8/2025",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-08",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/27/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 661,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "COMITAN DE DOMINGUEZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "COMITAN DE DOMINGUEZ",
      fecha_texto: "8/8/2025",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-08",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 662,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CACAHOATAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "8/5/2025",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-05",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 663,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LAS MARGARITAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "LAS MARGARITAS",
      fecha_texto: "8/13/2025",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-13",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 664,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LAS MARGARITAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "LAS MARGARITAS",
      fecha_texto: "8/13/2025",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-13",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 665,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LAS MARGARITAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "LAS MARGARITAS",
      fecha_texto: "8/13/2025",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-13",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 666,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LAS MARGARITAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "LAS MARGARITAS",
      fecha_texto: "8/13/2025",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-13",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 667,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LAS MARGARITAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "LAS MARGARITAS",
      fecha_texto: "8/13/2025",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-13",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 668,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LAS MARGARITAS",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "LAS MARGARITAS",
      fecha_texto: "8/13/2025",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-13",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 669,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "LA TRINITARIA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "LA TRINITARIA",
      fecha_texto: "8/14/2025",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-14",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/7/2025",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 670,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ALTAMIRANO",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "ALTAMIRANO",
      fecha_texto: "8/11/2025",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-11",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 671,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SALTO DE AGUA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SALTO DE AGUA",
      fecha_texto: "8/22/2025",
      mes_fecha: 8,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-22",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/5/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 672,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SALTO DE AGUA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "SALTO DE AGUA",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 673,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "FRONTERA COMALAPA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "FRONTERA COMALAPA",
      fecha_texto: "8/28/2025",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-28",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 674,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CONCORDIA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "8/19/2025",
      mes_fecha: 8,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-19",
      anio_mes: "2025-08",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/20/2023",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 675,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CONCORDIA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "VILLAFLORES",
      fecha_texto: "8/19/2025",
      mes_fecha: 8,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-19",
      anio_mes: "2025-08",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/12/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 676,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TAPACHULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 677,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TAPACHULA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 678,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "TUXTLA GUTIERREZ",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TUXTLA GUTIERREZ",
      fecha_texto: "8/23/2025",
      mes_fecha: 8,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-23",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 679,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "CACAHOATAN",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "TAPACHULA",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 680,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "SALTO DE AGUA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "PALENQUE",
      fecha_texto: "9/19/2025",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-19",
      anio_mes: "2025-09",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 681,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIAPAS",
      municipio_residencia: "ESCUINTLA",
      estado_notificacion: "CHIAPAS",
      municipio_notificacion: "HUIXTLA",
      fecha_texto: "9/18/2025",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-18",
      anio_mes: "2025-09",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 682,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/6/2025",
      mes_fecha: 1,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-06",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 683,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/6/2025",
      mes_fecha: 1,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-06",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 684,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/7/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 685,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/19/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 686,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 687,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "PARRAL",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/10/2025",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-10",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 688,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 689,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 690,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 691,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "MEOQUI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 692,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 693,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUADALUPE Y CALVO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "PARRAL",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 694,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 695,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NUEVO CASAS GRANDES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 696,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/12/2025",
      mes_fecha: 1,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-12",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/5/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 697,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 698,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 699,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUACHOCHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BOCOYNA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 700,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 701,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 702,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "1/21/2025",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-21",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 703,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 704,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 705,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 706,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/20/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 707,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/21/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 708,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/28/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 709,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 710,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 711,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CARICHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 712,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 713,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUACHOCHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 714,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/3/2025",
      mes_fecha: 2,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-03",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 715,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 716,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/16/2024",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 717,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 718,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 719,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 720,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 721,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 722,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 723,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 724,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/21/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 725,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NAMIQUIPA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 726,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUERRERO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 727,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 728,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 729,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 730,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 731,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/19/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 732,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 733,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 734,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 735,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 736,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 737,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BOCOYNA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BOCOYNA",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/7/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 738,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 739,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 740,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 741,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 742,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 743,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 744,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 745,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 746,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "MEOQUI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/16/2025",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 747,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/26/2010",
      tipo_vacuna: "1",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 748,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/26/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 749,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/15/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 750,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/23/2024",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 751,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CARICHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 752,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 753,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 754,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/8/2025",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-08",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 755,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NAMIQUIPA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "9/23/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 756,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 757,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 758,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 759,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/24/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 760,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "30/02/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 761,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/16/2025",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-16",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 762,
      edad: "62",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/16/2025",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-16",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 763,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/16/2025",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-16",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 764,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/16/2025",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-16",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 765,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/16/2025",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-16",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 766,
      edad: "61",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/16/2025",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-16",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 767,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/16/2025",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-16",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/21/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 768,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 769,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 770,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/21/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 771,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/28/2024",
      tipo_vacuna: "4",
      complicaciones: 5,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 772,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 773,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/7/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 774,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 775,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 776,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/4/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 777,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 778,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "1/14/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 779,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 780,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "OJINAGA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 781,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "1/29/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 782,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NONOAVA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 783,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NONOAVA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 784,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 785,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 786,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/15/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 787,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 788,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 789,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/24/2025",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 790,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 791,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 792,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 793,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 794,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 795,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/2/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 796,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 797,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 798,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 799,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 800,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 801,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "2/16/2025",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-16",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/1/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 802,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 803,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 804,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "MAGUARICHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "MAGUARICHI",
      fecha_texto: "1/3/2025",
      mes_fecha: 1,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-03",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/2/2014",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 805,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "AHUMADA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 806,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 807,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CARICHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 808,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CARICHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 809,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ASCENSION",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 810,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JANOS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 811,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 812,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 813,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/3/2014",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 814,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 815,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 816,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "5/24/2018",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 817,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 818,
      edad: "55",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 819,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 820,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ASCENSION",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 821,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 822,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALLENDE",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALLENDE",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 823,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALLENDE",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALLENDE",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 824,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 825,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 826,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 827,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 828,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 829,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 830,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 831,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 832,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 833,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ASCENSION",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/16/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 834,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 835,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 836,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/12/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 837,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 838,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/19/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 839,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/3/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 840,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 841,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "PARRAL",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALLENDE",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 842,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/17/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 843,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 844,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 845,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUACHOCHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 846,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 847,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/6/2013",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 848,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 849,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 850,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUERRERO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/15/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 851,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 852,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 853,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "LA CRUZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 854,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 855,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "SAN FRANCISCO DE BORJA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/3/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 856,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 857,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 858,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/19/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 859,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BOCOYNA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 860,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 861,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 862,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALLENDE",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALLENDE",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 863,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "11/11/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 864,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 865,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/15/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 866,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "PARRAL",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "PARRAL",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "7/29/2023",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 867,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/7/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 868,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 869,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 870,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 871,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 872,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/9/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 873,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/17/2025",
      mes_fecha: 3,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-17",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 874,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 875,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 876,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 877,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 878,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 879,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/12/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 880,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/18/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 881,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 882,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "OJINAGA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/19/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 883,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 884,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALLENDE",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "11/26/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 885,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 886,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "PARRAL",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "PARRAL",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 887,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 888,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/25/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 889,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 890,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/5/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 891,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 892,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 893,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/14/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 894,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 895,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 896,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/16/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 897,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 898,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 899,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 900,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 901,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 902,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/7/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 903,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 904,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "SAUCILLO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 905,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/6/2025",
      mes_fecha: 4,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-06",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 906,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 907,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NUEVO CASAS GRANDES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/6/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 908,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ASCENSION",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 909,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 910,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/25/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 911,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/18/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 912,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/21/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 913,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 914,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 915,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALLENDE",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALLENDE",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 916,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 917,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "RIVA PALACIO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 5,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 918,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 919,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 920,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 921,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/20/2025",
      mes_fecha: 4,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-20",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 922,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/8/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 923,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 924,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NUEVO CASAS GRANDES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/17/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 925,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUACHOCHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BOCOYNA",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 926,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 927,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "4/12/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 928,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "PARRAL",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 929,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 930,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 931,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 932,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 933,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 934,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 935,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUERRERO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BOCOYNA",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 936,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUERRERO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BOCOYNA",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 937,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/14/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 938,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 939,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/13/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 940,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUACHOCHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 941,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUACHOCHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BOCOYNA",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/9/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 942,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 943,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 944,
      edad: "55",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 945,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/19/2025",
      mes_fecha: 4,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-19",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 946,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUADALUPE Y CALVO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "GUADALUPE Y CALVO",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 947,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 948,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 949,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 950,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 951,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 952,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUAZAPARES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "GUAZAPARES",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/1/2017",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 953,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUAZAPARES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "GUAZAPARES",
      fecha_texto: "5/26/2025",
      mes_fecha: 5,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-26",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 954,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUAZAPARES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "GUAZAPARES",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/18/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 955,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 956,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/7/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 957,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/26/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 958,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUAZAPARES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "GUAZAPARES",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/21/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 959,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "GUACHOCHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BOCOYNA",
      fecha_texto: "5/18/2025",
      mes_fecha: 5,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-18",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 960,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 961,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BATOPILAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "GUACHOCHI",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 962,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 963,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 964,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 965,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 966,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 967,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 968,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/1/2023",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 969,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BATOPILAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 970,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BUENAVENTURA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "6/13/2025",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-13",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 971,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 972,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 973,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/16/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 974,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "6/19/2025",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-19",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/6/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 975,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/30/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 976,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "6/2/2024",
      tipo_vacuna: "1,6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 977,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "6/19/2025",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-19",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 978,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "6/20/2025",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-20",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 979,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "4/26/2025",
      mes_fecha: 4,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-26",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/3/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 980,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 981,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 982,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "6/20/2025",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-20",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 983,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "7/3/2025",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-03",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 984,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/3/2025",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-03",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 985,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/8/2025",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-08",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 986,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "OJINAGA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 987,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "7/15/2025",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-15",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 988,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "MADERA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/17/2025",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-17",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 989,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "7/21/2025",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-21",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/27/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 990,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/22/2025",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-22",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 991,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CAMARGO",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CAMARGO",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/21/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 992,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 993,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "7/28/2025",
      mes_fecha: 7,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-28",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 994,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "8/7/2025",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-07",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 995,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "NUEVO CASAS GRANDES",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "NUEVO CASAS GRANDES",
      fecha_texto: "8/5/2025",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-05",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/29/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 996,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "URIQUE",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BOCOYNA",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/14/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 997,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "BOCOYNA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "BOCOYNA",
      fecha_texto: "7/8/2025",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-08",
      anio_mes: "2025-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 998,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 999,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1000,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/7/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1001,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "8/11/2025",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-11",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/7/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1002,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "8/11/2025",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-11",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1003,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/15/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1004,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/1/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1005,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/13/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1006,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1007,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/8/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1008,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1009,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "JUAREZ",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "8/17/2015",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1010,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "1/6/2025",
      mes_fecha: 1,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-06",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1011,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "1/8/1900",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1012,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1013,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ASCENSION",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/13/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1014,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "1/8/1900",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1015,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "8/15/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1016,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1017,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1018,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "8/22/2025",
      mes_fecha: 8,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-22",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "7/23/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1019,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "8/18/2025",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-18",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1020,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1021,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "8/27/2025",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-27",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1022,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "DELICIAS",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "DELICIAS",
      fecha_texto: "9/2/2025",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-02",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1023,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1024,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1025,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CUSIHUIRIACHI",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "9/9/2025",
      mes_fecha: 9,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-09",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 5,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1026,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "9/17/2025",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-17",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1027,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "PARRAL",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "PARRAL",
      fecha_texto: "9/17/2025",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-17",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1028,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "9/17/2025",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-17",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/11/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1029,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "9/17/2025",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-17",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1030,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "9/17/2025",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-17",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1031,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "CHIHUAHUA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "CHIHUAHUA",
      fecha_texto: "9/25/2025",
      mes_fecha: 9,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-25",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1032,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JIMENEZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JIMENEZ",
      fecha_texto: "9/25/2025",
      mes_fecha: 9,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-25",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1033,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "ALDAMA",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "ALDAMA",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1034,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CHIHUAHUA",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "CHIHUAHUA",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "9/22/2025",
      mes_fecha: 9,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-22",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1035,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "1/9/2025",
      mes_fecha: 1,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-09",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1036,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1037,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/10/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1038,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/16/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1039,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1040,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/5/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1041,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/22/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1042,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1043,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/26/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1044,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/2/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1045,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/6/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1046,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/8/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1047,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "12/4/2024",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1048,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1049,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/20/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1050,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "1/21/2025",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-21",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1051,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1052,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1053,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1054,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1055,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1056,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1057,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1058,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/4/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1059,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1060,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/10/2006",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1061,
      edad: "73",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1062,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "2/2/2025",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-02",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/9/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1063,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1064,
      edad: "80",
      grupo_edad: "80 - 84",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1065,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1066,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1067,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1068,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1069,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/8/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1070,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1071,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1072,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/16/2011",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1073,
      edad: "61",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1074,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "LA MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1075,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/8/2025",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-08",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1076,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1077,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1078,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1079,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1080,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1081,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/13/2024",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1082,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1083,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1084,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1085,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1086,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/8/2025",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-08",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1087,
      edad: "65",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1088,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1089,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/26/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1090,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/7/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1091,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/9/2025",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1092,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1093,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1094,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1095,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1096,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1097,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1098,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUCUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1099,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/13/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1100,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/4/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1101,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/25/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1102,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1103,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1104,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1105,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1106,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/30/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1107,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1108,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/15/2025",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-15",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/22/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1109,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1110,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1111,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1112,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1113,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1114,
      edad: "74",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1115,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "LA MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1116,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1117,
      edad: "74",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1118,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/31/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1119,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1120,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1121,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1122,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1123,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/1/2021",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1124,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1125,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1126,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1127,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLAHUAC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1128,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/15/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1129,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "LA MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1130,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1131,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/1/2015",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1132,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/9/2023",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1133,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1134,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/19/2023",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1135,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/19/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1136,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1137,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1138,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/22/2025",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-22",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1139,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1140,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1141,
      edad: "68",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1142,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "2/22/2025",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-22",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/29/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1143,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1144,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/3/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1145,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1146,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/5/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1147,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "8/16/2017",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1148,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1149,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA DE MORELOS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/6/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1150,
      edad: "61",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1151,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/8/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1152,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1153,
      edad: "56",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1154,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1155,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1156,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1157,
      edad: "68",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1158,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1159,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALNEPANTLA DE BAZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1160,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1161,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/1/2025",
      mes_fecha: 3,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-01",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1162,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/24/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1163,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1164,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/2/2025",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1165,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1166,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1167,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1168,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1169,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1170,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1171,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1172,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1173,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/14/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1174,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1175,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA DE MORELOS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/10/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1176,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA DE MORELOS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1177,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/8/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1178,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/22/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1179,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1180,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/14/2023",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1181,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1182,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/7/2017",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1183,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1184,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1185,
      edad: "90",
      grupo_edad: "90 - 94",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1186,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/4/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1187,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1188,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1189,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/28/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1190,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1191,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "XOCHIMILCO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "9/4/2021",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1192,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/7/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1193,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1194,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1195,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1196,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUÁREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/19/1988",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1197,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/4/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1198,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1199,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1200,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1201,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1202,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1203,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1204,
      edad: "76",
      grupo_edad: "75 - 79",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1205,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/25/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1206,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1207,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUÁREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1208,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/19/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1209,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1210,
      edad: "66",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1211,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1212,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/27/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1213,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/15/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1214,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/20/2016",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1215,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1216,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1217,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1218,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/29/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1219,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1220,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1221,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1222,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/3/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1223,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1224,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1225,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1226,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1227,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1228,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1229,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1230,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1231,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1/1/1900",
      fecha_ultima_dosis: "5/13/2010",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1232,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLAHUAC",
      fecha_texto: "3/23/2025",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-23",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1233,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/12/2015",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1234,
      edad: "63",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1235,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/1/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1236,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/14/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1237,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1238,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1239,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/13/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1240,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/27/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1241,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/9/2019",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1242,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1243,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1244,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1245,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1246,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1247,
      edad: "71",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1248,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1249,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/29/2025",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-29",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1250,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1251,
      edad: "55",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1252,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1253,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1254,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1255,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1256,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1257,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1258,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 8,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1259,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1260,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1261,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1262,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1263,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "6/26/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1264,
      edad: "60",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "LA MAGDALENA CONTRERAS",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1265,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/15/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1266,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1267,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1268,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/27/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1269,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/3/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1270,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ÁLVARO OBREGÓN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1271,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "1/1/2006",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1272,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1273,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1274,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/7/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1275,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1276,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1277,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/31/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1278,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1279,
      edad: "60",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1280,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/6/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1281,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1282,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ÁLVARO OBREGÓN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1283,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/11/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1284,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/19/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1285,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/4/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1286,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/29/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1287,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "LA MAGDALENA CONTRERAS",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/27/2014",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1288,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "LA MAGDALENA CONTRERAS",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1289,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "XOCHIMILCO",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1290,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1291,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1292,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "1/18/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1293,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1294,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1295,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/27/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1296,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1297,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "LA MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "1/1/2020",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1298,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "4/17/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1299,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAHUTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1300,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1301,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1302,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1303,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/8/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1304,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/12/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1305,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "LA MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1306,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1307,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ÁLVARO OBREGÓN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1308,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/27/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1309,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1310,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1311,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAHUTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/10/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1312,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1313,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1314,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1315,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1316,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/5/2021",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1317,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1318,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/20/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1319,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "4/17/2025",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-17",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1320,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/14/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1321,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/27/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1322,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1323,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/23/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1324,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/29/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1325,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 7,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/1/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1326,
      edad: "102",
      grupo_edad: "100 - 104",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1327,
      edad: "69",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1328,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1329,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/7/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1330,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 8,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1331,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/26/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1332,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1333,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/8/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1334,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "LA MAGDALENA CONTRERAS",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1335,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/26/2025",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1336,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1337,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "8/9/2017",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1338,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1339,
      edad: "81",
      grupo_edad: "80 - 84",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1340,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1341,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/6/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1342,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A AMDERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/19/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1343,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLAHUAC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "XOCHIMILCO",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1344,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/3/2024",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1345,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1346,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/27/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1347,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1348,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1349,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1350,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1351,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/1/2025",
      mes_fecha: 5,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-01",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1352,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "5/4/2025",
      mes_fecha: 5,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-04",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1353,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/22/2016",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1354,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1355,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/23/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1356,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1357,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUAHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1358,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/9/2021",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1359,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1360,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1361,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1362,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1363,
      edad: "62",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1364,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/3/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1365,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1366,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "9/5/2016",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1367,
      edad: "66",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1368,
      edad: "56",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1369,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "LA MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/18/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1370,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1371,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/13/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1372,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "XOCHIMILCO",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1373,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1374,
      edad: "69",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1375,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1376,
      edad: "88",
      grupo_edad: "85 - 89",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1377,
      edad: "73",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1378,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1379,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/12/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1380,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/19/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1381,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/25/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1382,
      edad: "93",
      grupo_edad: "90 - 94",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1383,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1384,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/29/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1385,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1386,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1387,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1388,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/25/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1389,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1390,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1391,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1392,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/27/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1393,
      edad: "95",
      grupo_edad: "95 - 99",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1394,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1395,
      edad: "80",
      grupo_edad: "80 - 84",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1396,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1397,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1398,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1399,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/6/2025",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1400,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "LA MAGDALENA CONTRERAS",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "11/8/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1401,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1402,
      edad: "64",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1403,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/15/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1404,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "LA MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/16/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1405,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/27/2023",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1406,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUÁREZ",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/2/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1407,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MAGDALENA CONTRERAS",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/17/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1408,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUÁREZ",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "15/04/2024",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1409,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1410,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/16/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1411,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/26/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1412,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1413,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1414,
      edad: "67",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HIDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "6/13/2025",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-13",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1415,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "6/13/2025",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-13",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1416,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "6/20/2025",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-20",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1417,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "6/14/2025",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-14",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/11/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1418,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "6/15/2025",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-15",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1419,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/17/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1420,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ÁLVARO OBREGÓN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "17/6/2025",
      mes_fecha: 17,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2026-05-06",
      anio_mes: "2026-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/17/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1421,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAHUTEMOC",
      estado_notificacion: "CIUDAD DE MÉXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/13/2022",
      tipo_vacuna: "1",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1422,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/31/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1423,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAJIMALPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTÉMOC",
      fecha_texto: "6/23/2025",
      mes_fecha: 6,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-23",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "00/01/1900",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1424,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAHUTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/25/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1425,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAHUTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "9/10/2013",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1426,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1427,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "6/25/2025",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-25",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/6/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1428,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "XOCHIMILCO",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/5/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1429,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "6/25/2025",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-25",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/27/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1430,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "6/27/2025",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-27",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "6/15/2022",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1431,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/6/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1432,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/3/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1433,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1434,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/6/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1435,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "6/29/2025",
      mes_fecha: 6,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-29",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/30/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1436,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1437,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "7/3/2025",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-03",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/21/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1438,
      edad: "68",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "7/3/2025",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-03",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1439,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1440,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUÁREZ",
      fecha_texto: "7/9/2025",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-09",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1441,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "7/9/2025",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-09",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "16/12/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1442,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "TLAHUAC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLAHUAC",
      fecha_texto: "7/3/2025",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-03",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/25/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1443,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "7/9/2025",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-09",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1444,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "XOCHIMILCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/17/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1445,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1446,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "7/16/2025",
      mes_fecha: 7,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-16",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/13/2023",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1447,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "7/18/2025",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-18",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1448,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "7/16/2025",
      mes_fecha: 7,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-16",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1449,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "7/23/2025",
      mes_fecha: 7,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-23",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/12/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1450,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "7/24/2025",
      mes_fecha: 7,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-24",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1451,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "7/24/2025",
      mes_fecha: 7,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-24",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1452,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "7/25/2025",
      mes_fecha: 7,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-25",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1453,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "7/28/2025",
      mes_fecha: 7,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-28",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1454,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "VENUZTIANO CARRANZA",
      fecha_texto: "7/30/2025",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-30",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1455,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "7/30/2025",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-30",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/5/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1456,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/8/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1457,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MIGUEL HDALGO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "8/1/2025",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-01",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1458,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "8/1/2025",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-01",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1459,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "8/4/2025",
      mes_fecha: 8,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-04",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1460,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "GUSTAVO A MADERO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "8/12/2025",
      mes_fecha: 8,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-12",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/17/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1461,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "8/12/2025",
      mes_fecha: 8,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-12",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/24/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1462,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A.MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "8/14/2025",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-14",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1463,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "12/8/2025",
      mes_fecha: 12,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-12-08",
      anio_mes: "2025-12",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1464,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MÉXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "8/13/2025",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-13",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1465,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "8/13/2025",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-13",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1466,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "8/14/2025",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-14",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1467,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "8/15/2025",
      mes_fecha: 8,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-15",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/13/2024",
      tipo_vacuna: "1,2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1468,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "8/21/2025",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-21",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/9/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1469,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "8/21/2025",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-21",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1470,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "ALVARO OBREGON",
      fecha_texto: "8/22/2025",
      mes_fecha: 8,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-22",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/27/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1471,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "8/25/2025",
      mes_fecha: 8,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-25",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1472,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "8/25/2025",
      mes_fecha: 8,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-25",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/1/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1473,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "BENITO JUÁREZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUÁREZ",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/7/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1474,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1475,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "8/27/2025",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-27",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1476,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "MAGDALENA CONTRERAS",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MAGDALENA CONTRERAS",
      fecha_texto: "8/29/2025",
      mes_fecha: 8,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-29",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/9/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1477,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTÉMOC",
      fecha_texto: "9/1/2025",
      mes_fecha: 9,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-01",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/31/2019",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1478,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "9/1/2025",
      mes_fecha: 9,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-01",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1479,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "ALVARO OBREGON",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUÁREZ",
      fecha_texto: "9/2/2025",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-02",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/23/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1480,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "9/2/2025",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-02",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1481,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTACALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "9/2/2025",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-02",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1482,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "XOCHIMILCO",
      fecha_texto: "9/3/2025",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-03",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/12/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1483,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "COYOACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "9/3/2025",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-03",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/18/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1484,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "9/4/2025",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-04",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1485,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "AZCAPOTZALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "9/5/2025",
      mes_fecha: 9,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-05",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1486,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "8/27/2025",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-27",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1487,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A.MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "9/10/2025",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-10",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/1/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1488,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "9/11/2025",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-11",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1489,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A. MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "9/12/2025",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-12",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1490,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "GUSTAVO A MADERO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "12/9/2025",
      mes_fecha: 12,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-12-09",
      anio_mes: "2025-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "9/9/2020",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1491,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "CIUDAD DE MEXICO",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "9/19/2025",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-19",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1492,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/03/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1493,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SABINAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "COAHUILA",
      fecha_texto: "12/30/1899",
      mes_fecha: 12,
      dia_fecha: 30,
      anio_fecha: 1899,
      fecha_notificacion: "3799-12-30",
      anio_mes: "3799-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1494,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "15/07/2022",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1495,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1496,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "16/05/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1497,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "RAMOS ARIZPE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "RAMOS ARIZPE",
      fecha_texto: "4/4/2024",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-04",
      anio_mes: "2024-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "15 11 2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1498,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "12/30/1899",
      mes_fecha: 12,
      dia_fecha: 30,
      anio_fecha: 1899,
      fecha_notificacion: "3799-12-30",
      anio_mes: "3799-12",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1499,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/14/1905",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1500,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "1/8/2025",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-08",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/12/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1501,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1502,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1503,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/20/2024",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1504,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MORELOS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1505,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MORELOS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MORELOS",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1506,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/4/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1507,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1508,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1509,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SAN PEDRO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "FCO. I MADERO",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1510,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/1/2024",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1511,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1512,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1513,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1514,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/6/2024",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-06",
      anio_mes: "2024-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1515,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/6/2024",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2024,
      fecha_notificacion: "2024-02-06",
      anio_mes: "2024-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1516,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ARTEAGA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/3/2025",
      mes_fecha: 2,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-03",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1517,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SAN PEDRO COAHUILA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "24/01/2025",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1518,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1519,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1520,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/8/2025",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-08",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1521,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "RAMOS ARIZPE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "RAMOS ARIZPE",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1522,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1523,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "19/09/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1524,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1525,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1526,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1527,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO, COAHUILA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1528,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1529,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1530,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MUZQUIZ",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MUZQUIZ",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "31/01/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1531,
      edad: "80",
      grupo_edad: "80 - 84",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SABINAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SAN JUAN DE SABINAS",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1532,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "21/08/2023",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1533,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1534,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1535,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "15/10/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1536,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "06/10/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1537,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1538,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "03/07/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1539,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MUZQUIZ",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MUZQUIZ",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1540,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "14/01/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1541,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "01/09/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1542,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1543,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "16/12/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1544,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1545,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "09/10/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1546,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "09/01/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1547,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1548,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "30/05/2014",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1549,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1550,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "RAMOS ARIZPE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1551,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SAN PEDRO DE LAS COLONIAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1552,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SAN PEDRO DE LAS COLONIAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "07/10/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1553,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1554,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1555,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SAN PEDRO DE LAS COLONIAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "07/10/2024",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1556,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "2/22/2025",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-22",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1557,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1558,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SAN PEDRO DE LAS COLONIAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1559,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SAN PEDRO DE LAS COLONIAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1560,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1561,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1562,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1563,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1564,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1565,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "RAMOS ARIZPE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "01/03/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1566,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1567,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1568,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1569,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SABINAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SAN JUAN DE SABINAS",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "07/01/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1570,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "20/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1571,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "26/07/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1572,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1573,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1574,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1575,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/5/2025",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1576,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1577,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "CONSTITUCION",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1578,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1579,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "05/08/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1580,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1581,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "13/03/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1582,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "01/01/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1583,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1584,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1585,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1586,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "09/10/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1587,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "VIESCAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1588,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1589,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1590,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1591,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1592,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "15/06/2022",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1593,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/17/2021",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1594,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "CASTAÑOS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1595,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/2/2025",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-02",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1596,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1597,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ALLENDE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/17/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1598,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "28/03/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1599,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1600,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1601,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "RAMOS ARIZPE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "04/03/2025",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1602,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ARTEAGA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1603,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ARTEAGA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1604,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ALLENDE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1605,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "26/02/2025",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1606,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1607,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "13/09/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1608,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "CUATROCIENEGAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "CUATROCIENEGAS",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/20/2017",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1609,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1610,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/10/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1611,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/09/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1612,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/24/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1613,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "02/12/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1614,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "01/04/2013",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1615,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/6/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1616,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1617,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/24/2027",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1618,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1619,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1620,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "FRONTERA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/9/2025",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-09",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1621,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "FRONTERA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1622,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "01/01/2020",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1623,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "27/02/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1624,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "17/02/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1625,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "VIESCA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1626,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "05/05/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1627,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06 / 02 / 2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1628,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "15/01/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1629,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "21/02/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1630,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "16/01/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1631,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1632,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/11/2024",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1633,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "04/09/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1634,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1635,
      edad: "73",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1636,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1637,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1638,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1639,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1640,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2020",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1641,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "18/12/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1642,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "26/02/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1643,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "22/11/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1644,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MUZQUIZ",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MUZQUIZ",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1645,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "12/30/1899",
      mes_fecha: 12,
      dia_fecha: 30,
      anio_fecha: 1899,
      fecha_notificacion: "3799-12-30",
      anio_mes: "3799-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "07/09/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1646,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MUZQUIZ",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MUZQUIZ",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1647,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "FRONTERA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "27/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1648,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "03/01/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1649,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/15/1905",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1650,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "19/09/2022",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1651,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "30 / may / 2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1652,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1653,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "16/07/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1654,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1655,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/08/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1656,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ALLENDE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "#REF!",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1657,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "12/30/1899",
      mes_fecha: 12,
      dia_fecha: 30,
      anio_fecha: 1899,
      fecha_notificacion: "3799-12-30",
      anio_mes: "3799-12",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "17/08/2020",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1658,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1659,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "26/02/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1660,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "08/02/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1661,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "RAMOS ARIZPE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1662,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "CUATROCEINEGAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MOCNLOVA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1663,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "08/06/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1664,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "08/06/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1665,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "22/11/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1666,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "FRONTERA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SAN BUENAVENTURA",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1667,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1668,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "27/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1669,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "26/04/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1670,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1671,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "21/03/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1672,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1673,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1674,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MUZQUIZ",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MUZQUIZ",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/02/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1675,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "0",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1676,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "02/07/2003",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1677,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "06/05/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1678,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SAN JUAN DE SABINAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SAN JUAN DE SABINAS",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "09/07/2024",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1679,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/02/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1680,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1681,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SAN PEDRO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/29/2025",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-29",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1682,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SAN PEDRO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "3/29/2025",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-29",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1683,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1684,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "Muzquiz",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "Muzquiz",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1685,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1686,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1687,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "05/03/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1688,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "21/02/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1689,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1690,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1691,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1692,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1693,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "Torreón",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "Torreón",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1694,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1695,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "01/09/2017",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1696,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "15/05/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1697,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "01/08/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1698,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1699,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1700,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "16/01/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1701,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1702,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1703,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "27/05/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1704,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "RAMOS ARIZPE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "RAMOS ARIZPE",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1705,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1706,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ALLENDE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "08/12/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1707,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "01/11/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1708,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1709,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1710,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1711,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "08/04/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1712,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "RAMOS ARIZPE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1713,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MONCLOVA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MONCLOVA",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1714,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1715,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1716,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1717,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "5/1/2025",
      mes_fecha: 5,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-01",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "01/03/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1718,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1719,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1720,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1721,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1722,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "03/08/2012",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1723,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "28/04/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1724,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ALLENDE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "#REF!",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "17/04/2023",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1725,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1726,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1727,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "29/08/2016",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1728,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ALLEDNE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGARS",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1729,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "CIUDAD ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1730,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "CIUDAD ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1731,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "CIUDAD ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1732,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "CIUDAD ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1733,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "CIUDAD ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1734,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "saltilo",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1735,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO, COAHUILA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "18/02/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1736,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SAN JUAN DE SABINAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SAN JUAN DE SABINAS",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1737,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO, COAHUILA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "09/05/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1738,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1739,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SALTILLO",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1740,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SALTILLO",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1741,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "PIEDRAS NEGRAS",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "PIEDRAS NEGRAS",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1742,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "RAMOS ARIZPE",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "RAMOS ARIZPE",
      fecha_texto: "6/16/2025",
      mes_fecha: 6,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-16",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "00 00 0000",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1743,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "6/19/2025",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-19",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "27/09/2021",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1744,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1745,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1746,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1747,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "4/25/2025",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1748,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "4/25/2025",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1749,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "4/25/2025",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1750,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "25/04/2025",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1751,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "SALTILLO",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "6/27/2025",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-27",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1752,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1753,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "7/3/2025",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-03",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1754,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "7/3/2025",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-03",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1755,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "7/3/2025",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-03",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "02/08/2023",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1756,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "7/17/2025",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-17",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "25/04/2025",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1757,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "saltillo",
      estado_notificacion: "SALTILLO",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1758,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "7/15/2025",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-15",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "11/06/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1759,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "ACUÑA",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "ACUÑA",
      fecha_texto: "7/16/2025",
      mes_fecha: 7,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-16",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "14/10/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1760,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "7/19/2025",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-19",
      anio_mes: "2025-07",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "14/05/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1761,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "8/1/2025",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-01",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "04/03/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1762,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "8/4/2025",
      mes_fecha: 8,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-04",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "01/12/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1763,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "0",
      estado_notificacion: "SALTILLO",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "8/4/2025",
      mes_fecha: 8,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-04",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1764,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "TORREON",
      fecha_texto: "8/17/2025",
      mes_fecha: 8,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-17",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1765,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "SALTILLO",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "8/11/2025",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-11",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1766,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "0",
      estado_notificacion: "SALTILLO",
      municipio_notificacion: "SALTILLO",
      fecha_texto: "8/28/2025",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-28",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "09/07/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1767,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "TORREON",
      estado_notificacion: "TORREON",
      municipio_notificacion: "TORREON",
      fecha_texto: "8/18/2025",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-18",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1768,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COAHUILA",
      municipio_residencia: "MUZQUIZ",
      estado_notificacion: "COAHUILA",
      municipio_notificacion: "MUZQUIZ",
      fecha_texto: "21/8/2025",
      mes_fecha: 21,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-08",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1769,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COLIMA",
      municipio_residencia: "VILLA DE ALVAREZ",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/11/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1770,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "VILLA DE ALVAREZ",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "02/07/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1771,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "CUAUTEMOC",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "VILLA DE ALVAREZ",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/10/2024",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1772,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1773,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "VILLA DE ALVAREZ",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "VILLA DE ALVAREZ",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1774,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "VILLA DE ALVAREZ",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1775,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "TECOMAN",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "TECOMAN",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/5/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1776,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "TECOMAN",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "TECOMAN",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1777,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "TECOMAN",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "TECOMAN",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1778,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COQUIMATLAN",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1779,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "VILLA DE ALVAREZ",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "VILLA DE ALVAREZ",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1780,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1781,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1782,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1783,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1784,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1785,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COQUIMATLAN",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/20/2023",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1786,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1787,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1788,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "CUAUHTEMOC",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/28/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1789,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "VILLA DE ALVAREZ",
      fecha_texto: "6/29/2025",
      mes_fecha: 6,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-29",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/19/2023",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1790,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "7/16/2025",
      mes_fecha: 7,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-16",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/4/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1791,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "VILLA DE ALVAREZ",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "8/1/2025",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-01",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1792,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "8/14/2025",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-14",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "6/1/2021",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1793,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "COLIMA",
      municipio_residencia: "COLIMA",
      estado_notificacion: "COLIMA",
      municipio_notificacion: "COLIMA",
      fecha_texto: "9/7/2025",
      mes_fecha: 9,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-07",
      anio_mes: "2025-09",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1794,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "SANTIAGO PAPASQUIARO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1795,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "SANTIAGO PAPASQUIARO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/10/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1796,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "CUENCAME",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "1/21/2025",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-21",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1797,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "PUEBLO NUEVO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1798,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/10/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1799,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GÓMEZ PALACIO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/16/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1800,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GÓMEZ PALACIO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1801,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "TEPEHUANES",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1802,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1803,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "CUENCAME",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1804,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GÓMEZ PALACIO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/12/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1805,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GÓMEZ PALACIO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "8/12/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1806,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GÓMEZ PALACIO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1807,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/15/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1808,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "LERDO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1809,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1810,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GÓMEZ PALACIO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/19/2024",
      tipo_vacuna: "10",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1811,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "LERDO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1812,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "LERDO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1813,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "18/032025",
      mes_fecha: 18,
      dia_fecha: 32025,
      anio_fecha: null,
      fecha_notificacion: "1989-02-03",
      anio_mes: "1989-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1814,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "TEPEHUANES",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "SANTIAGO PAPASQUIARO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1815,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/9/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1816,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1817,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "GÓMEZ PALACIO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "GÓMEZ PALACIO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/16/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1818,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "PEÑON BLANCO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1819,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "MEZQUITAL",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1820,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/24/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1821,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/1/2024",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2024,
      fecha_notificacion: "2024-04-01",
      anio_mes: "2024-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/13/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1822,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/5/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1823,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/5/2025",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-05",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1824,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/12/2025",
      mes_fecha: 4,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-12",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/7/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1825,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/19/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1826,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/13/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1827,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/19/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1828,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1829,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "PUEBLO NUEVO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/7/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1830,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "NUEVO IDEAL",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1831,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1832,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "DURANGO",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/16/2024",
      tipo_vacuna: "1, 10",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1833,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "DURANGO",
      municipio_residencia: "CUENCAME",
      estado_notificacion: "DURANGO",
      municipio_notificacion: "DURANGO",
      fecha_texto: "7/23/2025",
      mes_fecha: 7,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-23",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/24/2022",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1834,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/23/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1835,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "2/3/2025",
      mes_fecha: 2,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-03",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1836,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/10/2025",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-10",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1837,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1838,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FELIPE",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1839,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1840,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN DIEGO DE LA UNION",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN DIEGO DE LA UNION",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/24/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1841,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/13/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1842,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN FELIPE",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FELIPE",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1843,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/4/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1844,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "OCAMPO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/19/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1845,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "OCAMPO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/26/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1846,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN MIGUEL DE ALLENDE",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN MIGUEL DE ALLENDE",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "NA",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1847,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/1/2001",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1848,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1849,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "1/26/2025",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-26",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1850,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1851,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "COMONFORT",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1852,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "COMONFORT",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "COMONFORT",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "17/122024",
      tipo_vacuna: "4 HEXAVALENTE",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1853,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARIMORO",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/29/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1854,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARIMORO",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1855,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1856,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CCOMONFORT",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1857,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JUVENTINO ROSAS",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JUVENTINO ROSAS",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/15/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1858,
      edad: "67",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARIMORO",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1859,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "TARIMORO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "1/1/2015",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1860,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1861,
      edad: "60",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CORTAZAR",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARIMORO",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1862,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "APASEO EL ALTO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "APASEO EL ALTO",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1863,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "TARIMORO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARIMORO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/23/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1864,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1865,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "VILLAGRAN",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "VILLAGRAN",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1866,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CORTAZAR",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CORTAZAR",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1867,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "TARIMORO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARIMORO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "11/10/2015",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1868,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/15/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1869,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/31/2017",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1870,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JUVENTINO ROSAS",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/28/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1871,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "TARIMORO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARIMORO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/27/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1872,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1873,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "TARIMORO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARIMORO",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/3/2021",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1874,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "TARIMORO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARIMORO",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1875,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1876,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JUVENTINO ROSAS",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SANTA CRUZ DE JUVENTINO ROSAS",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1877,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1878,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "TARIMORO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARIMORO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/17/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1879,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SALVATIERRA",
      fecha_texto: "1/19/2025",
      mes_fecha: 1,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-19",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1880,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JERECUARO",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1881,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/4/2015",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1882,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JERECUARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JERECUARO",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/3/2020",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1883,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JERECUARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JERECUARO",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1884,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JERECUARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JERECUARO",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1885,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JERECUARO",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1886,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SANTIAGO MARAVATIO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SANTIAGO MARAVATIO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/6/2023",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1887,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SANTIAGO MARAVATIO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SANTIAGO MARAVATIO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/10/2010",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1888,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CAISES SALVATIERRSA",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1889,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CAISES SALVATIERRSA",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1890,
      edad: "67",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CAISES SALVATIERRSA",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1891,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/20/2023",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1892,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/19/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1893,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CORONEO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CORONEO",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "9/10/2012",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1894,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1895,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SALVATIERRA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1896,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SALVATIERRA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/10/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1897,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CAISES SALVATIERRSA",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/14/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1898,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CAISES SALVATIERRSA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/18/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1899,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/2/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1900,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALAMANCA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SALAMANCA",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/7/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1901,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALAMANCA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SALAMANCA",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1902,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "URIANGATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "URIANGATO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/19/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1903,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "URIANGATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "URIANGATO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/29/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1904,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "VALLE DE SANTIAGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "VALLE DE SANTIAGO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/21/2025",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1905,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1906,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1907,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1908,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1909,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1910,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1911,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/22/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1912,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1913,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1914,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1915,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1916,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1917,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1918,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN FRANCISCO DEL RINCON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/7/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1919,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1920,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/2/2021",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1921,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/23/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1922,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1923,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1924,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1925,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1926,
      edad: "66",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1927,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "11/21/2024",
      tipo_vacuna: "3",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1928,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "PENJAMO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/14/2022",
      tipo_vacuna: "3",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1929,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1930,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1931,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1932,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1933,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1934,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/15/2019",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1935,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/25/2022",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1936,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1937,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1938,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1939,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1940,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1941,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1942,
      edad: "80",
      grupo_edad: "80 - 84",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1943,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALAMANCA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1944,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1945,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/23/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1946,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1947,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/17/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1948,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "11/15/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1949,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/15/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1950,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/8/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1951,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1952,
      edad: "69",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1953,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1954,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1955,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/3/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1956,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1957,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1958,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/18/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1959,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/27/2018",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1960,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/3/2019",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1961,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1962,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/21/2021",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1963,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/25/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1964,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "1/16/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1965,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "5/19/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1966,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/7/2019",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1967,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/18/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1968,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1969,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1970,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1971,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1972,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1973,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1974,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/6/2023",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1975,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1976,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1977,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/3/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1978,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1979,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1980,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/24/2019",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1981,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/4/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1982,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/29/2021",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1983,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1984,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ROMITA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ROMITA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1985,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/30/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1986,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ROMITA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ROMITA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/9/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1987,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ROMITA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ROMITA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1988,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "PURISIMA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1989,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ROMITA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ROMITA",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 5,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1990,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "2/9/2025",
      mes_fecha: 2,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-09",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1991,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/15/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1992,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1993,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "PURISIMA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "PURISIMA",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/2/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1994,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1995,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/9/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1996,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ROMITA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1997,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "MANUEL DOBLADO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "MANUEL DOBLAO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/2/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1998,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 1999,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/20/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2000,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2001,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2002,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2003,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2004,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "MANUEL DOBLADO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "MANUEL DOBLAO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/27/2021",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2005,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2006,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/28/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2007,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/28/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2008,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/9/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2009,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2010,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2011,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2012,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JUVENTINO ROSAS",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SANTA CRUZ DE JUVENTINO ROSAS",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/6/2016",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2013,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "1/1/2020",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2014,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2015,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "TARANDACUAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARANDACUAO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/19/2015",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2016,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SALVATIERRA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2017,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2018,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/6/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2019,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/18/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2020,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/10/2021",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2021,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/2/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2022,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2023,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/19/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2024,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/3/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2025,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FELIPE",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/27/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2026,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/30/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2027,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2028,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/14/2025",
      tipo_vacuna: "6",
      complicaciones: 7,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2029,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DAN DIEGO DE LA UNION",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN DIEGO DE LA UNION",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/28/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2030,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FELIPE",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/14/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2031,
      edad: "83",
      grupo_edad: "80 - 84",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "TARIMORO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARIMORO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2032,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/30/2021",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2033,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "VILLAGRAN",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "VILLAGRAN",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/12/2011",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2034,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JUVENTINO ROSAS",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SANTA CRUZ DE JUVENTINO ROSAS",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2035,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "VILLAGRAN",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2036,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "13/08/20244",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2037,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JUVENTINO ROSAS",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SANTA CRUZ DE JUVENTINO ROSAS",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/3/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2038,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "VILLAGRÁN",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "VILLAGRAN",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/16/2022",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2039,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "TARANDACUAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARANDACUAO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2040,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JERECUARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JERECUARO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2041,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "3/30/2025",
      mes_fecha: 3,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-30",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/12/1981",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2042,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "TARANDACUAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARANDACUAO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "8/25/2017",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2043,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SALVATIERRA",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/21/2022",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2044,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SALVATIERRA",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/2/2016",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2045,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SANTIAGO MARAVATIO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/13/1998",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2046,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SANTIAGO MARAVATIO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SANTIAGO MARAVATIO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/21/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2047,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2048,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2049,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/18/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2050,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2051,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2052,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2053,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "1/1/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2054,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/25/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2055,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2056,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/29/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2057,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2058,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/21/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2059,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/6/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2060,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/23/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2061,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/20/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2062,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/2/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2063,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2064,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/1/2022",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2065,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/29/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2066,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CUERAMARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2067,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CUERAMARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2068,
      edad: "68",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2069,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "TARANDACUAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JERECUARO",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/5/2020",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2070,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/11/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2071,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SANTIAGO MARAVATIO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SANTIAGO MARAVATIO",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/5/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2072,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/15/1981",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2073,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JERECUARO",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/20/2023",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2074,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JERECUARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JERECUARO",
      fecha_texto: "4/13/2025",
      mes_fecha: 4,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-13",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/17/2022",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2075,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2076,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "TARIMORO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARIMORO",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/15/1976",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2077,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2078,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SANTA CRUZ DE JUVENTINO ROSAS",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SANTA CRUZ DE JUVENTINO ROSAS",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2079,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/2/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2080,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FRANCISCO",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/1/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2081,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/18/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2082,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "1/13/2014",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2083,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2084,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SALVATIERRA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2085,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/25/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2086,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/4/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2087,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2088,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2089,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/11/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2090,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2091,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2092,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2093,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2094,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ROMITA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ROMITA",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/16/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2095,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/12/2012",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2096,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN FELIPE",
      estado_notificacion: "SLP",
      municipio_notificacion: "SLP",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2097,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/6/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2098,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CORTAZAR",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2099,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2100,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/22/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2101,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/2/2020",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2102,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2103,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "MANUEL DOBLADO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "MANUEL DOBLAO",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/3/2023",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2104,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "COMONFORT",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "COMONFORT",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/25/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2105,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SANTIAGO MARAVATIO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SANTIAGO MARAVATIO",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2106,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CORONEO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CORONEO",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/6/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2107,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "DOLORES HIDALGO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "DOLORES HIDALGO",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/31/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2108,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2109,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2110,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2111,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2112,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2113,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/26/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2114,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/4/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2115,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN LUIS DE LA PAZ",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN LUIS DE LA PAZ",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/16/2014",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2116,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2117,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2118,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "9/3/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2119,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2120,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN FELIPE",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN FELIPE",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2121,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2122,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "APASEO EL GRANDE",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "APASEO EL GRANDE",
      fecha_texto: "5/26/2025",
      mes_fecha: 5,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-26",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/21/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2123,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CORONEO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CORONEO",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/21/2022",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2124,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JERECUARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "JERECUARO",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2125,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/1/2022",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2126,
      edad: "55",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/12/1971",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2127,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2128,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/1/2010",
      tipo_vacuna: "3",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2129,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2130,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SANTA CRUZ DE JUVENTINO ROSAS",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/1/2020",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2131,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CORONEO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CORONEO",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/4/2023",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2132,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN LUIS DE LA PAZ",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN LUIS DE LA PAZ",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "8/11/2014",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2133,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2134,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/20/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2135,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/12/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2136,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/26/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2137,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CORONEO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CORONEO",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2138,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2139,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2140,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "YURIRIA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "YURIRIA",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2141,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "6/16/2025",
      mes_fecha: 6,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-16",
      anio_mes: "2025-06",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2142,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "6/13/2025",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-13",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2143,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "6/19/2025",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-19",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2144,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SN FCO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SN FCO",
      fecha_texto: "5/25/2025",
      mes_fecha: 5,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-25",
      anio_mes: "2025-05",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2145,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2146,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "APASEO EL ALTO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "VILLAGRAN",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2147,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "VILLAGRAN",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "VILLAGRAN",
      fecha_texto: "6/19/2025",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-19",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2148,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "6/20/2025",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-20",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2149,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "6/23/2025",
      mes_fecha: 6,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-23",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2150,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "6/13/2025",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-13",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/11/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2151,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN LUIS DE LA PAZ",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN LUIS DE LA PAZ",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "NA",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2152,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ACAMBARO",
      fecha_texto: "6/26/2025",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-26",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/29/2017",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2153,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SALVATIERRA",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2154,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "YURIRIA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "YURIRIA",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/24/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2155,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "6/27/2025",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-27",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2156,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/4/2007",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2157,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "VILLAGRAN",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "VILLAGRAN",
      fecha_texto: "6/19/2025",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-19",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2158,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN FELIPE",
      estado_notificacion: "SLP",
      municipio_notificacion: "SLP",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2159,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2160,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CAISES SALVATIERRSA",
      fecha_texto: "7/8/2025",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-08",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/4/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2161,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SALVATIERRA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SALVATIERRA",
      fecha_texto: "7/8/2025",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-08",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2162,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "7/7/2025",
      mes_fecha: 7,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-07",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/12/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2163,
      edad: "55",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/4/2025",
      mes_fecha: 7,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-04",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2164,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/4/2025",
      mes_fecha: 7,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-04",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/24/2025",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2165,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/9/2025",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-09",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/8/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2166,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/10/2025",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-10",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2167,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN LUIS DE LA PAZ",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN LUIS DE LA PAZ",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "6/28/2010",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2168,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CELAYA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2169,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ACAMBARO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "TARANDACUAO",
      fecha_texto: "7/15/2025",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-15",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/9/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2170,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "7/15/2025",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-15",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/2/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2171,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2172,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CELAYA",
      fecha_texto: "7/21/2025",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-21",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "7/6/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2173,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN MIGUEL DE ALLENDE",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN MIGUEL DE ALLENDE",
      fecha_texto: "7/22/2025",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-22",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "NA",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2174,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/18/2025",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-18",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2175,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/21/2025",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-21",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2176,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "CORONEO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "CORONEO",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/17/2023",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2177,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "7/8/2028",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2028,
      fecha_notificacion: "2028-07-08",
      anio_mes: "2028-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/21/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2178,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ROMITA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ROMITA",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/19/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2179,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/30/2025",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-30",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2180,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/30/2025",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-30",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2181,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/30/2025",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-30",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2182,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2183,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2184,
      edad: "60",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2185,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2186,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN MIGUEL DE ALLENDE",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SAN MIGUEL DE ALLENDE",
      fecha_texto: "8/11/2025",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-11",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/23/2017",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2187,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "VILLAGRAN",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2188,
      edad: "66",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2189,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "8/1/2025",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-01",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2190,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "8/1/2025",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-01",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2191,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "8/5/2025",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-05",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "4/11/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2192,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "8/5/2025",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-05",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2193,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "8/5/2025",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-05",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2194,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "8/8/2025",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-08",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2195,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "8/9/2025",
      mes_fecha: 8,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-09",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2196,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "8/11/2025",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-11",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2197,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "8/14/2025",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-14",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/9/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2198,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "MANUEL DOBLADO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "MANUEL DOBLAO",
      fecha_texto: "8/13/2025",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-13",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/9/2021",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2199,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "8/15/2025",
      mes_fecha: 8,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-15",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2200,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "8/15/2025",
      mes_fecha: 8,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-15",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/10/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2201,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "8/19/2025",
      mes_fecha: 8,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-19",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2202,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2203,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "JUVENTINO ROSAS",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SANTA CRUZ DE JUVENTINO ROSAS",
      fecha_texto: "8/25/2025",
      mes_fecha: 8,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-25",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/5/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2204,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "9/3/2025",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-03",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2205,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "9/2/2025",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-02",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2206,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "IRAPUATO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "IRAPUATO",
      fecha_texto: "9/3/2025",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-03",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2207,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SAN FELIPE",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "9/8/2025",
      mes_fecha: 9,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-08",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2208,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "9/9/2025",
      mes_fecha: 9,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-09",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2209,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "9/10/2025",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-10",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2210,
      edad: "64",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "9/10/2025",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-10",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2211,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "ROMITA",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "ROMITA",
      fecha_texto: "9/10/2025",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-10",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/23/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2212,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "SILAO",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "SILAO",
      fecha_texto: "9/11/2025",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-11",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/18/2013",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2213,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "9/12/2025",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-12",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2214,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUANAJUATO",
      municipio_residencia: "LEON",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "9/25/2025",
      mes_fecha: 9,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-25",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/12/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2215,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "1/10/2025",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-10",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2216,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "IGUALA DE LA INDEPENDENCIA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/20/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2217,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ZIHUATANEJO DE AZUETA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ZIHUATANEJO DE AZUETA",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/22/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2218,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2219,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "TAXCO DE ALARCON",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "TAXCO DE ALARCON",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/4/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2220,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2221,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "COYUCA DE CATALAN",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "COYUCA DE CATALAN",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/18/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2222,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "COYUCA DE CATALAN",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "COYUCA DE CATALAN",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2223,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2224,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "LA UNION DE ISIDORO MONTES DE OCA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "LA UNION DE ISIDORO MONTES DE OCA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2225,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2226,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2227,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/28/2018",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2228,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "CHILAPA DE ALVAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "CHILAPA DE ALVAREZ",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2229,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/27/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2230,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2231,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/29/2014",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2232,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2233,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2234,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2235,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "TAXCO DE ALARCON",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "TAXCO DE ALARCON",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2236,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/24/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2237,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "LA UNION DE ISIDORO MONTES DE OCA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "LA UNION DE ISIDORO MONTES DE OCA",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2238,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2239,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2240,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/12/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2241,
      edad: "80",
      grupo_edad: "80 - 84",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ZIHUATANEJO DE AZUETA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ZIHUATANEJO DE AZUETA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2242,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/4/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2243,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/9/2018",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2244,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2245,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "IGUALA DE LA INDEPENDENCIA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "IGUALA DE LA INDEPENDENCIA",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/31/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2246,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/22/2020",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2247,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2248,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/18/2018",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2249,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2250,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/25/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2251,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2252,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2253,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/5/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2254,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2255,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "TAXCO DE ALARCON",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "TAXCO DE ALARCON",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2256,
      edad: "67",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "TAXCO DE ALARCON",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "TAXCO DE ALARCON",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2257,
      edad: "81",
      grupo_edad: "80 - 84",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "TAXCO DE ALARCON",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "TAXCO DE ALARCON",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2258,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "IGUALA DE LA INDEPENDENCIA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "IGUALA DE LA INDEPENDENCIA",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2259,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "TELOLOAPAN",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "IGUALA DE LA INDEPENDENCIA",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2260,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/20/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2261,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2262,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "TAXCO DE ALARCON",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "TAXCO DE ALARCON",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2263,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ZIHUATANEJO DE AZUETA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ZIHUATANEJO DE AZUETA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/22/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2264,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "CHILPANCINGO DE LOS BRAVO",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "CHILPANCINGO DE LOS BRAVO",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2265,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2266,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "TAXCO DE ALARCON",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "TAXCO DE ALARCON",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2267,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/4/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2268,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "TIXTLA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "CHILAPA DE ALVAREZ",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/3/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2269,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2270,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ARCELIA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ARCELIA",
      fecha_texto: "4/18/2025",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-18",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 5,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2271,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ARCELIA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "MORELOS",
      fecha_texto: "4/19/2025",
      mes_fecha: 4,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-19",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2272,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2273,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "EDUARDO NERI",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "IGUALA DE LA INDEPENDENCIA",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2274,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ZIHUATANEJO DE AZUETA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ZIHUATANEJO DE AZUETA",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2275,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "TAXCO DE ALARCON",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "TAXCO DE ALARCON",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2276,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2277,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/29/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2278,
      edad: "65",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2279,
      edad: "65",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2280,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ZIHUATANEJO DE AZUETA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ZIHUATANEJO DE AZUETA",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/2/2018",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2281,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2282,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2283,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/24/1990",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2284,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2285,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2286,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2287,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "CHILPANCINGO DE LOS BRAVO",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "CHILPANCINGO DE LOS BRAVO",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2288,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/11/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2289,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2290,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "CHILPANCINGO DE LOS BRAVO",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "CHILPANCINGO DE LOS BRAVO",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2291,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2292,
      edad: "56",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2293,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "IGUALA DE LA INDEPENDENCIA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "IGUALA DE LA INDEPENDENCIA",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/13/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2294,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "6/10/2025",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-10",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2295,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "OMETEPEC",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "OMETEPEC",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2296,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "7/10/2025",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-10",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/15/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2297,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "JUAN R ESCUDERO",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "EDUARDO NERI",
      fecha_texto: "7/17/2025",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-17",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2298,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "7/28/2025",
      mes_fecha: 7,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-28",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/1/2021",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2299,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "IGUALA DE LA INDEPENDENCIA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "IGUALA DE LA INDEPENDENCIA",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/7/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2300,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2301,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "EDUARDO NERI",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "EDUARDO NERI",
      fecha_texto: "8/11/2025",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-11",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2302,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "8/4/2025",
      mes_fecha: 8,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-04",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2303,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "8/3/2025",
      mes_fecha: 8,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-03",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/18/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2304,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "8/7/2025",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-07",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2305,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "TAXCO DE ALARCON",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "TAXCO DE ALARCON",
      fecha_texto: "7/30/2025",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-30",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2306,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "COYUCA DE BENÍTEZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2307,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "9/5/2025",
      mes_fecha: 9,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-05",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "29/08/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2308,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ZIHUATANEJO DE AZUETA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ZIHUATANEJO DE AZUETA",
      fecha_texto: "9/5/2025",
      mes_fecha: 9,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-05",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "28/07/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2309,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ACAPULCO DE JUAREZ",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ACAPULCO DE JUAREZ",
      fecha_texto: "9/18/2025",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-18",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "9/2/2021",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2310,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "ZIHUATANEJO DE AZUETA",
      estado_notificacion: "GUERRERO",
      municipio_notificacion: "ZIHUATANEJO DE AZUETA",
      fecha_texto: "9/19/2025",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-19",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "8/1/2020",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2311,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "GUERRERO",
      municipio_residencia: "IGUALA",
      estado_notificacion: "CDMX SUR",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2312,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULANCINGO DE BRAVO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 6,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2313,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ATITALAQUIA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "ATITALAQUIA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2314,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ATITALAQUIA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "ATITALAQUIA",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2315,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ATITALAQUIA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "ATITALAQUIA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2316,
      edad: "67",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ATITALAQUIA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "ATITALAQUIA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2317,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ATITALAQUIA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "ATITALAQUIA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2318,
      edad: "56",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ATITALAQUIA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "ATITALAQUIA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2319,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "AJACUBA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "AJACUBA",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/8/2021",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2320,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TEZONTEPEC DE ALDAMA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TEZONTEPEC DE ALDAMA",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/7/2021",
      tipo_vacuna: "1 y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2321,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULA DE ALLENDE",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TEPEJI DEL RIO",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2322,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ACAXOCHITLAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/16/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2323,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ACAXOCHITLAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "2/3/2025",
      mes_fecha: 2,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-03",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2324,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ACAXOCHITLAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/9/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2325,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2326,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2327,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TIZAYUCA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2328,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TIZAYUCA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/27/2011",
      tipo_vacuna: "1 y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2329,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TIZAYUCA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/26/2016",
      tipo_vacuna: "1 y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2330,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TIZAYUCA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/26/2016",
      tipo_vacuna: "1 y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2331,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TIZAYUCA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2332,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TIZAYUCA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2333,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "MINERAL DE LA REFORMA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2334,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULA DE ALLENDE",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TULA DE ALLENDE",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/9/2022",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2335,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/1/2000",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2336,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "MINERAL DE LA REFORMA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2337,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TIZAYUCA",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2338,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "MINERAL DE LA REFORMA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "MINERAL DE LA REFORMA",
      fecha_texto: "2/16/2025",
      mes_fecha: 2,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-16",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/14/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2339,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TECOZAUTLA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TECOZAUTLA",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/10/2020",
      tipo_vacuna: "1 y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2340,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/25/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2341,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TEPEJI DEL RIO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TEPEJI DEL RIO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/17/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2342,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULANCINGO DE BRAVO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2343,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "MINERAL DE LA REFORMA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/14/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2344,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ZAPOTLAN DE JUAREZ",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2345,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULANCINGO DE BRAVO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TULANCINGO DE BRAVO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "9/3/2021",
      tipo_vacuna: "1 y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2346,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "CHAPANTONGO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "CHAPANTONGO",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/26/2020",
      tipo_vacuna: "1 y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2347,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "METEPEC",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/10/2016",
      tipo_vacuna: "1 y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2348,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "MIXQUIAHUALA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "MIXQUIAHUALA",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "6/2/2020",
      tipo_vacuna: "1 y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2349,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULA DE ALLENDE",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TULA DE ALLENDE",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2350,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "IXMIQUILPAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "IXMIQUILPAN",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/20/2023",
      tipo_vacuna: "1 y 6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2351,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "IXMIQUILPAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "IXMIQUILPAN",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/24/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2352,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "MINERAL DE LA REFORMA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/6/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2353,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "3/8/2025",
      mes_fecha: 3,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-08",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2354,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ACTOPAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "ACTOPAN",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/8/2022",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2355,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2356,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2357,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TIZAYUCA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2358,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ZIMAPAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "ZIMAPAN",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2359,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "MINERAL DE LA REFORMA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/7/2018",
      tipo_vacuna: "1 y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2360,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TEPEJI DEL RIO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TEPEJI DEL RIO",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/30/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2361,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ZAPOTLAN DE JUAREZ",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "MINERAL DE LA REFORMA",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2362,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TEZONTEPEC DE ALDAMA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TEZONTEPEC DE ALDAMA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/2/2013",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2363,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "CARDONAL",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "IXMIQUILPAN",
      fecha_texto: "3/15/2025",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-15",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/27/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2364,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "CARDONAL",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "IXMIQUILPAN",
      fecha_texto: "3/15/2025",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-15",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2365,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "LA MISION",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "JACALA DE LEDEZMA",
      fecha_texto: "3/15/2025",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-15",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2366,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "3/15/2025",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-15",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2367,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ATOTONILCO DE TULA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "ATOTONILCO DE TULA",
      fecha_texto: "3/16/2025",
      mes_fecha: 3,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-16",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/28/2014",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2368,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TLAHUELILPAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "3/17/2025",
      mes_fecha: 3,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-17",
      anio_mes: "2025-03",
      institucion_notificacion: 6,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2369,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TLAXCOAPAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/31/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2370,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/20/2018",
      tipo_vacuna: "1 Y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2371,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULA DE ALLENDE",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TLAXCOAPAN",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "8/5/2019",
      tipo_vacuna: "1 Y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2372,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "AJACUBA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "AJACUBA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "1/23/2020",
      tipo_vacuna: "1 Y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2373,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULA DE ALLENDE",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TLAXCOAPAN",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "5/27/2011",
      tipo_vacuna: "1 Y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2374,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULA DE ALLENDE",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TULA DE ALLENDE",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 7,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/18/2016",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2375,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULA DE ALLENDE",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TULA DE ALLENDE",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 7,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2376,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "MINERAL DE LA REFORMA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "9/15/1991",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2377,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ATITALAQUIA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TULA DE ALLENDE",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 7,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/16/2014",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2378,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULA DE ALLENDE",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TULA DE ALLENDE",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 7,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/30/2016",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2379,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULA DE ALLENDE",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TLAXCOAPAN",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/1/2021",
      tipo_vacuna: "1 Y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2380,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/15/1985",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2381,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "CHILCUAUTLA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "CHILCUAUTLA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/14/2023",
      tipo_vacuna: "1 Y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2382,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULA DE ALLENDE",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TEPEJI DEL RIO",
      fecha_texto: "3/29/2025",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-29",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/29/2024",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2383,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ZAPOTLAN DE JUAREZ",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "MINERAL DE LA REFORMA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2384,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "CARDONAL",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "CARDONAL",
      fecha_texto: "3/30/2025",
      mes_fecha: 3,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-30",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2385,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ELOXOCHITLAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "METZTITLAN",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "4/26/2012",
      tipo_vacuna: "1 Y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2386,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULA DE ALLENDE",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TULA DE ALLENDE",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 7,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/27/2013",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2387,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "IXMIQUILPAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "IXMIQUILPAN",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/1/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2388,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "CUAUTEPEC DE HINOJOSA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "CUAUTEPEC DE HINOJOSA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/18/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2389,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULA DE ALLENDE",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TLAXCOAPAN",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "4/18/2018",
      tipo_vacuna: "1 Y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2390,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULANCINGO DE BRAVO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TULANCINGO DE BRAVO",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2391,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2392,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "SAN SALVADOR",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2393,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULANCINGO DE BRAVO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2394,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "CARDONAL",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "IXMIQUILPAN",
      fecha_texto: "4/18/2025",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-18",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/18/2024",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2395,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "IXMIQUILPAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "MIXQUIAHUALA",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2396,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ACAXOCHITLAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/27/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2397,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "METZTITLAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "METZTITLAN",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "1/7/2016",
      tipo_vacuna: "1 Y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2398,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ACAXOCHITLAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2399,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TASQUILLO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "IXMIQUILPAN",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2400,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "5/11/2025",
      mes_fecha: 5,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-11",
      anio_mes: "2025-05",
      institucion_notificacion: 6,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2401,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TIZAYUCA",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2402,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ACAXOCHITLAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/13/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2403,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "ACAXOCHITLAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/2/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2404,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "SAN BARTOLO TUTOTEPEC",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/21/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2405,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TEPEJI DEL RIO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TULA DE ALLENDE",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2406,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TLANCHINOL",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 6,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/26/2023",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2407,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "SAN BARTOLO TUTOTEPEC",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "HUEHUETLA",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2408,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "6/21/2025",
      mes_fecha: 6,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-21",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2409,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "CUAUTEPEC DE HINOJOSA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC DE LUGO GUERRERO",
      fecha_texto: "6/22/2025",
      mes_fecha: 6,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-22",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2410,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TULANCINGO DE BRAVO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "7/4/2025",
      mes_fecha: 7,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-04",
      anio_mes: "2025-07",
      institucion_notificacion: 6,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/7/2024",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2411,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "7/8/2025",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-08",
      anio_mes: "2025-07",
      institucion_notificacion: 6,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/24/2015",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2412,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TIZAYUCA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "7/17/2025",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-17",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2413,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2414,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "PACHUCA DE SOTO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "8/15/2025",
      mes_fecha: 8,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-15",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/8/2014",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2415,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "HUEHUETLA",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "PACHUCA DE SOTO",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 6,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/6/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2416,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "HIDALGO",
      municipio_residencia: "TEPEJI DEL RIO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TEPEJI DEL RIO",
      fecha_texto: "9/9/2025",
      mes_fecha: 9,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-09",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/9/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2417,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/5/2025",
      mes_fecha: 1,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-05",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2418,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2419,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2420,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/26/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2421,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2422,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/19/2025",
      mes_fecha: 1,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-19",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/13/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2423,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/18/2025",
      mes_fecha: 1,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-18",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2424,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/21/2025",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-21",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2425,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2426,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/26/2025",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-26",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2427,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "MEZQUITIC",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/15/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2428,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "IXTLAHUACAN DE LOS MEMBRILLOS",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2429,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2430,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2431,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2432,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2433,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2434,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAJOMULCO",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2435,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "11/19/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2436,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2437,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2438,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2439,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/30/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2440,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/22/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2441,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2442,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2443,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2444,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "AMECA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "AMECA",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2445,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2446,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2447,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "OJUELOS XALISCO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LAGOS DE MORENO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/29/2024",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2448,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ATOTONILCO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/2/2025",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-02",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2449,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/2/2025",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-02",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2450,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/2/2025",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-02",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/15/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2451,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2452,
      edad: "55",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2453,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/5/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2454,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2455,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2456,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAJOMULCO",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2457,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2458,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/15/2025",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-15",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2459,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/15/2025",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-15",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2460,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2461,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAJOMULCO",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2462,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2463,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2464,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2465,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2466,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2467,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2468,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2469,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "OCOTLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "OCOTLAN",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/1/2020",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2470,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/20/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2471,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2472,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2473,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2474,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2475,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/16/2024",
      tipo_vacuna: "3",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2476,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/5/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2477,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2478,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2479,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2480,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/7/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2481,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOTLÁN DEL REY",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/22/2025",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-22",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2482,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/24/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2483,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2484,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2485,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LAGOS DE MORENO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LAGOS DE MORENO",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2486,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "VILLA GUERRERO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "COLOTLAN",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/7/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 5,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2487,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2488,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN JUAN DE LOS LAGOS",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "SAN JUAN DE LOS LAGOS",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2489,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "AMECA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "AMECA",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2490,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/2/2025",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-02",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2491,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2492,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOTLANEJO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2493,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "IXTLAHUACAN DE LOS MEMBRILLOS",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAJOMULCO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2494,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2495,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2496,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TEPATITLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TEPATITALN DE MORELOS JALISCO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2497,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2498,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2499,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2500,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2501,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TEPATITLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TEPATITALN DE MORELOS JALISCO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/24/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2502,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2503,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2504,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "9/9/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2505,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2506,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2507,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TEPATITLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TEPATITALN DE MORELOS JALISCO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/19/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2508,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/3/1997",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2509,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2510,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2511,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "2/23/2025",
      mes_fecha: 2,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-23",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/23/2024",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2512,
      edad: "61",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2513,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2514,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2515,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TONALA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/21/2016",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2516,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "AMECA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "AMECA",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2517,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/22/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2518,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAJOMULCO",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2519,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2520,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/4/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2521,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN MARTIN DE HIDALGO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAJOMULCO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/28/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2522,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2523,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "OCOTLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "OCOTLAN",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/20/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2524,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/4/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2525,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/9/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2526,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2527,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "1/28/2025",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2528,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "EL SALTO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2529,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2530,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "COCULA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "COCULA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2531,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/8/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2532,
      edad: "61",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2533,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2534,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LAGOS DE MORENO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LAGOS DE MORENO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/27/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2535,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2536,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/28/2024",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2537,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2538,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/22/2025",
      mes_fecha: 3,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-22",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2539,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2540,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2541,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2542,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/14/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2543,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "EL SALTO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/3/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2544,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2545,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "EL SALTO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2546,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "AMECA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2547,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TONALA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/12/2021",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2548,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TONALA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2549,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2550,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/28/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2551,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2552,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2553,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/21/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2554,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/27/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2555,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/15/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2556,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/17/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2557,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2558,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN JULIAN",
      estado_notificacion: "GUANAJUATO",
      municipio_notificacion: "LEON",
      fecha_texto: "1/21/2025",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-21",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2559,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2560,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2561,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2562,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/11/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2563,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TEQUILA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2564,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2565,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "IXTLAHUACAN DE LOS MEMBRILLOS",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAJOMULCO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2566,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAJOMULCO",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/25/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2567,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/25/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2568,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/13/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2569,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/6/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2570,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2571,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2572,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/21/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2573,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "EL SALTO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "9/9/2024",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2574,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/7/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2575,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAJOMULCO",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/3/2025",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2576,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2577,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2578,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/18/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2579,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAJOMULCO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2580,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2581,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LAGOS DE MORENO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2582,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LAGOS DE MORENO",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2583,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LAGOS DE MORENO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LAGOS DE MORENO",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2584,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "EL SALTO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "4/4/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2585,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2586,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2587,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAQUEPAQUE",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2588,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/12/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2589,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TONALA",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2590,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TECOLOTLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "COCULA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2591,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "UNION DE SAN ANTONIO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LAGOS DE MORENO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2592,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PONCITLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2593,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ARANDAS",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TEPATITLAN",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2594,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ARANDAS",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TEPATITLAN",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2595,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN JUAN DE LOS LAGOS",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TEPATITLAN",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2596,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TEPATITLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TEPATITLAN",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/19/2022",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2597,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/18/2025",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-18",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2598,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TEOCALTICHE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2599,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LAGOS DE MORENO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LAGOS DE MORENO",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2600,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/3/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2601,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2602,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2603,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2604,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2605,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2606,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/21/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2607,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "AMACUECA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOTLAN EL GRANDE",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/27/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2608,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TEPATITLAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TEPATITLAN DE MORELOS",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/5/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2609,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "MEZQUITIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2610,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2611,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2612,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2613,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "CUAUTITLÁN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LA HUERTA",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2614,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LA HUERTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LA HUERTA",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/10/2023",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2615,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "IXTLAHUACAN DEL RIO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2616,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/2/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2617,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/1/2025",
      mes_fecha: 5,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-01",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2618,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2619,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/27/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2620,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2621,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2622,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ACATLÁN DE JUÁREZ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2623,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2624,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2625,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "EL SALTO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2626,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "IXTLAHUACAN DEL RIO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2627,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "27/11/23",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2628,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2629,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2630,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2631,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LAGOS DE MORENO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LAGOS DE MORENO",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2632,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/24/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2633,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "JOCOTEPEC",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2634,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/15/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2635,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2636,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2637,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LAGOS DE MORENO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LAGOS DE MORENO",
      fecha_texto: "6/5/2025",
      mes_fecha: 6,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-05",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2638,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2639,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "6/8/2025",
      mes_fecha: 6,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-08",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "22/10/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2640,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TLAJOMULCO DE ZUÑIGA",
      fecha_texto: "6/10/2025",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-10",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2641,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "6/10/2025",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-10",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "21/01/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2642,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2643,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "MEZQUITE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "6/10/2025",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-10",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2644,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LAGOS DE MORENO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LAGOS DE MORENO",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/11/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2645,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "6/14/2025",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-14",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2646,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2647,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "6/19/2025",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-19",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "01/04/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2648,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2649,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOTLAN EL GRANDE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOTLAN EL GRANDE",
      fecha_texto: "6/20/2025",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-20",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2650,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "7/3/2025",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-03",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2651,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "CUAUTITLÁN DE GARCÍA BARRAGÁN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LA HUERTA",
      fecha_texto: "7/6/2025",
      mes_fecha: 7,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-06",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2652,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "7/9/2025",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-09",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2653,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "7/10/2025",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-10",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2654,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "7/10/2025",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-10",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "08/01/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2655,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "7/10/2025",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-10",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2656,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2657,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "5/27/2025",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2658,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOTLAN EL GRANDE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOTLAN EL GRANDE",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "08/05/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2659,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "7/18/2025",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-18",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2660,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TEPATITLAN DE MORELOS",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TEPATITLAN DE MORELOS",
      fecha_texto: "7/18/2025",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-18",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2661,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "8/2/2025",
      mes_fecha: 8,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-02",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2662,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "8/2/2025",
      mes_fecha: 8,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-02",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2663,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "MEZQUITIC",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "8/7/2025",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-07",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2664,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ARANDAS",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ARANDAS",
      fecha_texto: "8/8/2025",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-08",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "05/12/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2665,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "8/18/2025",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-18",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2019",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2666,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "8/20/2025",
      mes_fecha: 8,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-20",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2667,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "JAMAY",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "8/23/2025",
      mes_fecha: 8,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-23",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2668,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "SAN PEDRO TLAQUEPAQUE",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "9/2/2025",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-02",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2669,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "GUADALAJARA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "9/2/2025",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-02",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2670,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TONALÁ",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "9/5/2025",
      mes_fecha: 9,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-05",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2671,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "TLAJOMULCO DE ZUÑIGA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "GUADALAJARA",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2672,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "EL SALTO",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "9/10/2025",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-10",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2673,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ARANDAS",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "TEPATITLAN",
      fecha_texto: "9/12/2025",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-12",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2674,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "JALISCO",
      municipio_residencia: "ZAPOPAN",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "ZAPOPAN",
      fecha_texto: "9/12/2025",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-12",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/4/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2675,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "PUERTO VALLARTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "PUERTO VALLARTA",
      fecha_texto: "9/19/2025",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-19",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2676,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LA HUERTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LA HUERTA",
      fecha_texto: "9/15/2025",
      mes_fecha: 9,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-15",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2677,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "JALISCO",
      municipio_residencia: "LA HUERTA",
      estado_notificacion: "JALISCO",
      municipio_notificacion: "LA HUERTA",
      fecha_texto: "9/15/2025",
      mes_fecha: 9,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-15",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2678,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ATIZAPAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CUAUTITLAN",
      fecha_texto: "1/8/2025",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-08",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2679,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "1/10/2025",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-10",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "20/09/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2680,
      edad: "57",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "1/10/2025",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-10",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2681,
      edad: "57",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "1/10/2025",
      mes_fecha: 1,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-10",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2682,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/27/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2683,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "METEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2684,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2685,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTVO A. MADERO",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2686,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2687,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "HUIXQUILUCAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NAUCALPAN",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2688,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2689,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2690,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2691,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZUMPANGO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ZUMPANGO",
      fecha_texto: "1/26/2025",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-26",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2692,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLEDE CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/24/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2693,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHICOLOAPAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "2/1/2025",
      mes_fecha: 2,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-01",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/16/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2694,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZUMPAHUCAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TENANCINGO",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2695,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/9/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2696,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2697,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2698,
      edad: "72",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "2/2/2025",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-02",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2699,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "9/30/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2700,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2701,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NAUCALPAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NAUCAPAN",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2702,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VILLA VICTORIA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "VILLA VICTORIA",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2703,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "LOS REYES",
      estado_notificacion: "CDMX",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2704,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/24/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2705,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/4/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2706,
      edad: "71",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2707,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TULTITLAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "BENITO JUÁREZ",
      fecha_texto: "8/14/2025",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-14",
      anio_mes: "2025-08",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2708,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/15/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2709,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2710,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEZOYUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ACOLMAN",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/15/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2711,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2712,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "17-06-2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2713,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2714,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NAUCALPAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2715,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/6/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2716,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "REYES LA PAZ",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/21/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2717,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NAUCALPAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/19/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2718,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "01/04/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2719,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTLAHUACA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ATLACOMULCO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2720,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2721,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEXCOCO",
      estado_notificacion: "CDMX",
      municipio_notificacion: "BENITO JUÁREZ",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2722,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ATIZAPAN",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2723,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NAUCALPAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2724,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/18/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2725,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE CHALCO",
      estado_notificacion: "CDMX",
      municipio_notificacion: "XOCHIMILCO",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/4/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2726,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/28/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2727,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "OZUMBA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2728,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEJUPILCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "28/01/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2729,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALMANALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/8/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2730,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NEZAHUALCOYOTL",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2731,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "OTUMBA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "AXAPUSCO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/6/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2732,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "IXTAPALUCA",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/30/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2733,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2734,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "08/03/2023",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2735,
      edad: "81",
      grupo_edad: "80 - 84",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2736,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2737,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NAUCALPAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2738,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TULTEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "08/11/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2739,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "JILOTZINGO",
      estado_notificacion: "CDMX",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2740,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/08/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2741,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2742,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2743,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTLAHUACA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ATLACOMULCO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2744,
      edad: "79",
      grupo_edad: "75 - 79",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2745,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2746,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLANEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2747,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2748,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NICOLAS ROMERO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ATIZAPAN",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2749,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "03/10/2022",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2750,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NEZAHUALCOYOTL",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2751,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TULTEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CUAUTITLAN IZCALLI",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "17/10/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2752,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NEZAHUALCOYOTL",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "10/23/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2753,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "21/10/2022",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2754,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHICOLOAPAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2755,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2756,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TULTITLAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TULTEPEC",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2757,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2758,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHICOLOAPAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NEZAHUALCOYOTL",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/4/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2759,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/1/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2760,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ATIZAPAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NAUCALPAN",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2761,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TECAMAC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TECAMAC",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "04/12/2012",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2762,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "15/01/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2763,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "LOS REYES",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2764,
      edad: "60",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2765,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CUAUTITLAN IZCALLI",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CUAUTITLAN IZCALLI",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2766,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHIMALHAUCAN",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2767,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEXCOCO",
      estado_notificacion: "CDMX",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2768,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "LOS REYES, LA PAZ",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2769,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TIANGUISTENCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2770,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "JOCOTITLAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ATLACOMULCO",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2771,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TECAMAC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2772,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/22/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2773,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2774,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2775,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2776,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2777,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "COACALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/25/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2778,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2779,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NAUCALPAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NAUCALPAN",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "23/02/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2780,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2781,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CUATITLAN IZCALLI",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CUAUTITLAN",
      fecha_texto: "13/3/2025",
      mes_fecha: 13,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2026-01-03",
      anio_mes: "2026-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2782,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2783,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "16/05/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2784,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TENANGO DEL VALLE",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/15/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2785,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TENANGO DEL VALLE",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/15/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2786,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TECAMAC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "3/15/2025",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-15",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2787,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ATIZAPAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "1/012/2018",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2788,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLANEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "13/10/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2789,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CUAUTITLAN IZCALLI",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CUAUTITLAN IZCALLI",
      fecha_texto: "3/16/2025",
      mes_fecha: 3,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-16",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2790,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TECAMAC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2791,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEXCOCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TEXCOCO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2792,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "CUAUHTÉMOC",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/4/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2793,
      edad: "56",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2794,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZINACANTEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2795,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VILLA VICTORIA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2796,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZINACANTEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/05/2021",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2797,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TECAMAC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2798,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "OTUMBA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "AXAPUSCO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/19/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2799,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHIMALHUACAN",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2800,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SAN MATEO ATENCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2801,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLANEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2802,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2803,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2804,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CUAUTITLAN IZCALLI",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CUAUTITLAN IZCALLI",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/7/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2805,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "METEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "02/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2806,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLANEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2807,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "LERMA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2808,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLANEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2809,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "COACALCO",
      estado_notificacion: "CDMX",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/4/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2810,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ACOLMAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "OTUMBA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2811,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2812,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ACOLMAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/25/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2813,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TECAMAC",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TIZAYUCA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2814,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLANEPANTLA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2815,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2816,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TECAMAC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TECAMAC",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2817,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "HUIXQUILUCAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TULTITLÁN",
      fecha_texto: "26/3/2025",
      mes_fecha: 26,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2027-02-03",
      anio_mes: "2027-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "18/05/1996",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2818,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "LERMA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/3/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2819,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "31/10/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2820,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2821,
      edad: "62",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ACOLMAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2822,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TECAMAC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2823,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/11/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2824,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NICOLAS ROMERO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TLALNEPANTLA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2825,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "HUIXQUILUCAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "MIGUEL HIDALGO",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/10/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2826,
      edad: "66",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2827,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TIANQUISTENCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "27/ 02/ 2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2828,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TULTITLAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CUAUTITLAN",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "23/10/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2829,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHIMALHUACAN",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2830,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SAN FELIPE DE PROGRESO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "SAN FELIPE DEL PROGRRESO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2831,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "METEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "24/05/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2832,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "IXTAPALUCA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2833,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "HUIXQUILUCAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NAUCALPAN DE JUAREZ",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2834,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "IXTAPALUCA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2835,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEJUPILCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TEJUPILCO",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2836,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2837,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "LOS REYES",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "LOS REYES LA PAZ",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2838,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CUAUTITLAN IZCALLI",
      estado_notificacion: "CDMX",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2839,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "CDMX",
      municipio_notificacion: "IZTACALCO",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2840,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "LOS REYES LA PAZ",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2841,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZINACANTEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2842,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "METEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/11/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2843,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2844,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEOTIHUACAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "OTUMBA",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/6/2013",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2845,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHINCONCOAC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2846,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEXCOCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TEXCOCO",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "5/28/2015",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2847,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SANTA MARIA RAYON",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2848,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZUMPANGO",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/1/2021",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2849,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/4/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2850,
      edad: "55",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2851,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLANEPANTLA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2852,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ZUMPANGO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CUCUTITLAN",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2853,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ACOLMAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TEOTIHUACAN",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/27/2021",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2854,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IZTAPALAPA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NEZAHUALCOYOTL",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2855,
      edad: "78",
      grupo_edad: "75 - 79",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "HUIXQUILUCAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2856,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLANEPANTLA DE BAZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 7,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2857,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2858,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "DEL. CUAUHTEMOC",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2859,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2860,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "LOS REYES, LA PAZ",
      fecha_texto: "18/4/2025",
      mes_fecha: 18,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2026-06-04",
      anio_mes: "2026-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/10/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2861,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/4/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2862,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SAN FELIPE DEL PROGRESO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "SAN FELIPE DEL PROGRESO",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/17/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2863,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CUAUTITLAN IZCALLI",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2864,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "IXTAPALUCA",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2865,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2866,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLATLAYA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TLATLAYA",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/3/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2867,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SAN FELIPE DEL PROGRESO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "SAN FELIPE DE PROGRESO",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/1/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2868,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SAN JOSE DEL RINCON",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "SAN JOSE DEL RINCON",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2869,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/6/2017",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2870,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA DE BAZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "COYOACAN",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/31/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2871,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2872,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "HUIXQUILUCAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2873,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/10/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2874,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SAN ANDRES TIMILPAN",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ATLACOMULCO",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "22/10/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2875,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "NEZAHUALCOYOTL",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/12/2017",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2876,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TECAMAC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "18/02/2002",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2877,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SAN FELIPE DEL PROGRESO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "SAN FELIPE DEL PROGRESO",
      fecha_texto: "5/4/2025",
      mes_fecha: 5,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-04",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2878,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "LOS REYES, LA PAZ",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2879,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "JILOTEPEC",
      estado_notificacion: "CDMX",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/6/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2880,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2881,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPAN DE LA SAL",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "15/04/2016",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2882,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2883,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TENANGO DEL VALLE",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "11/16/2017",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2884,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE BRAVO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2885,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2886,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SAN MATEO ATENCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "03/04/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2887,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ALMOLOYA DEL RIO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "04/11/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2888,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "05/03/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2889,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SAN JOSE DEL RINCON",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "SAN JOSE DEL RINCON",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/24/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2890,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEMASCALAPA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2891,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ALMOLOYA DE JUÁREZ",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "05/05/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2892,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TENANCINGO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TENANCINGO",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2893,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TENANCINGO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TENANCINGO",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2894,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ATIZAPAN DE ZARAGOZA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2895,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "LA PAZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/6/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2896,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "COATEPEC DE HARINAS",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TENANCINGO",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2897,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHULCOYOTL",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2898,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/29/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2899,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SAN MATEO ATENCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "9/6/20205",
      mes_fecha: 9,
      dia_fecha: 6,
      anio_fecha: 20205,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2900,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CUAUTITLAN IZCALLE",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CUAUTITLAN",
      fecha_texto: "6/16/2025",
      mes_fecha: 6,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-16",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2901,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTEMOC",
      fecha_texto: "6/16/2025",
      mes_fecha: 6,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-16",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/1/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2902,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TEOLOYUCAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUÁREZ",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2903,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLALNEPANTLA DE BAZ",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A. MADERO",
      fecha_texto: "6/13/2025",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-13",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2904,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "6/15/2025",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-15",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "29/04/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2905,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "6/15/2025",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-15",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2906,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/7/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2907,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TECAMAC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/1/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2908,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "6/20/2025",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-20",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "23/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2909,
      edad: "60",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "SAN MATEO ATENCO",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "TLALPAN",
      fecha_texto: "6/21/2025",
      mes_fecha: 6,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-21",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2910,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ECATEPEC",
      fecha_texto: "6/23/2025",
      mes_fecha: 6,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-23",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/0672025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2911,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ECATEPEC",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/21/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2912,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "METEPEC",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "08/04/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2913,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "ALMOLOYA DE JUAREZ",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "6/27/2025",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-27",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2914,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2915,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TLANEPANTLA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "7/3/2025",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-03",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/10/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2916,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACÁN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "CUAUHTÉMOC",
      fecha_texto: "7/9/2025",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-09",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2917,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "BENITO JUÁREZ",
      fecha_texto: "7/28/2025",
      mes_fecha: 7,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-28",
      anio_mes: "2025-07",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2918,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE BRAVO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "VALLE DE BRAVO",
      fecha_texto: "7/23/2025",
      mes_fecha: 7,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-23",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 5,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2919,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHIMALHUACAN",
      estado_notificacion: "CIUDAD DE MEXICO",
      municipio_notificacion: "IZTAPALAPA",
      fecha_texto: "7/21/2025",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-21",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2920,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "VALLE DE CHALCO SOLIDARIDAD",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "8/1/2025",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-01",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/8/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2921,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "7/30/2025",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-30",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "24/03/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2922,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NICOLAS ROMERO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "ATIZAPAN",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/21/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2923,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "8/5/2025",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-05",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2924,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "CHALCO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "CHALCO",
      fecha_texto: "8/14/2025",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-14",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/7/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2925,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TENANCINGO",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TENANCINGO",
      fecha_texto: "8/8/2025",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-08",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2926,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "LOS REYES, LA PAZ",
      fecha_texto: "8/25/2025",
      mes_fecha: 8,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-25",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "05/06/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2927,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/27/2025",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2928,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "NEZAHUALCOYOTL",
      estado_notificacion: "CDMX",
      municipio_notificacion: "GUSTAVO A MADERO",
      fecha_texto: "9/10/2025",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-10",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2929,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TOLUCA",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "TOLUCA",
      fecha_texto: "9/11/2025",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-11",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "06/08/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2930,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "TENANGO DEL VALLE",
      estado_notificacion: "MEXICO",
      municipio_notificacion: "METEPEC",
      fecha_texto: "9/17/2025",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-17",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "19/08/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2931,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ESTADO DE MEXICO",
      municipio_residencia: "IXTAPALUCA",
      estado_notificacion: "CDMX",
      municipio_notificacion: "AZCAPOTZALCO",
      fecha_texto: "9/18/2025",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-18",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2932,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "1/2/2025",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-02",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "05/11/ 2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2933,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "1/6/2025",
      mes_fecha: 1,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-06",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/11/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2934,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "PÁTZCUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2935,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "PÁTZCUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2936,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/25/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2937,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2938,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2939,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2940,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "CHILCHOTA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2941,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "CHILCHOTA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2942,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "CHILCHOTA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2943,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "NAHUATZEN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2944,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "NAHUATZEN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2945,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "PÁTZCUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/18/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2946,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "PÁTZCUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2947,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "28/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2948,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "NAHUATZEN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/6/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2949,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "NAHUATZEN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2950,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LA PIEDAD",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "LA PIEDAD",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2951,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2952,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2953,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "BUENA VISTA",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "BUENAVISTA",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2954,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2955,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "TURICATO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "TURICATO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2956,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "05/01/2025",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2957,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZACAPU",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZACAPU",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2958,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "CHERAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2959,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ARTEAGA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ARTEAGA",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/21/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2960,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LA HUACANA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2961,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LA HUACANA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2962,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LA HUACANA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2963,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/27/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2964,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "3/8/2025",
      mes_fecha: 3,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-08",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2965,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "PÁTZCUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "PATZCUARO",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2966,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "NUMARAN",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "LA PIEDAD",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2967,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2968,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2969,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LA PIEDAD",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "LA PIEDAD",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2970,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LA PIEDAD",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "LA PIEDAD",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2971,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LAZARO CARDENAS",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "LAZARO CARDENAS",
      fecha_texto: "3/15/2025",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-15",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2972,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ANGAMACUTIRO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ANGAMACUTIRO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/20/2017",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2973,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/4/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2974,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "YURECUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "YURECUARO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2975,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "OCAMPO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZITÁCUARO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "24/01/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2976,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "NUMARAN",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "LA PIEDAD",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2977,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "YURECUARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "YURECUARO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2978,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZAMORA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/7/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2979,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "HUETAMO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/28/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2980,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ZIRACUARETIRO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/30/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2981,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "MORELIA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "4/5/2025",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-05",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2982,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2983,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "TANGAMANDAPIO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2984,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "SAHUAYO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "SAHUAYO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2985,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "JACONA",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "ZAMORA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2986,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LAZARO CARDENAS",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "LAZARO CARDENAS",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/31/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2987,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LAZARO CARDENAS",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "LAZARO CARDENAS",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/03/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2988,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LA PIEDAD",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "LA PIEDAD",
      fecha_texto: "4/17/2025",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-17",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/8/1900",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2989,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "ARTEAGA",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "LAZARO CARDENAS",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2990,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/31/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2991,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "COPANDARO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "5/1/2025",
      mes_fecha: 5,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-01",
      anio_mes: "2025-05",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2992,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "SAHUAYO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "SAHUAYO",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/22/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2993,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "HUANDACAREO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "9/9/2022",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2994,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "JUNGAPEO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "MORELIA",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/30/2024",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2995,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/13/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2996,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LAZARO CARDENAS",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "LAZARO CARDENAS",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2997,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LAZARO CARDENAS",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "LAZARO CARDENAS",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2998,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "URUAPAN",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "URUAPAN",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "01/02/2009",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 2999,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "LA PIEDAD",
      estado_notificacion: "MICHOACÁN",
      municipio_notificacion: "",
      fecha_texto: "6/5/2025",
      mes_fecha: 6,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-05",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3000,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MICHOACAN",
      municipio_residencia: "HIDALGO",
      estado_notificacion: "MICHOACAN",
      municipio_notificacion: "HIDALGO",
      fecha_texto: "6/10/2025",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-10",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/20/73200",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3001,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "JIUTEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3002,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "JIUTEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3003,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "YECAPIXTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3004,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TLAQUITENANGO",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "TLATIZAPAN",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/22/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3005,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "AMAYUCA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3006,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TEMIXCO",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "TEMIXCO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/21/2023",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3007,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3008,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3009,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "EMILIANO ZAPATA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/24/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3010,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "EMILIANO ZAPATA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3011,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3012,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/1/2017",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3013,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3014,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "ZACUALPA DE AMILPA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3015,
      edad: "56",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "YECAPIXTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3016,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TEMOAC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "6/26/2025",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-26",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3017,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TLAQUITENANGO",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "TLAQUITENANGO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3018,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/1/2014",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3019,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3020,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "AYALA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/9/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3021,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "AYALA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3022,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/1/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3023,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "EMILIANO ZAPATA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/09/20254",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3024,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3025,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TEMIXCO",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3026,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TETELA DEL VOLCAN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3027,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3028,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "AMAYUCA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3029,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TEMIXCO",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3030,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TEMIXCO",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3031,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "ZACUALPA DE AMILPA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3032,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "AYALA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/2/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3033,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "EMILIANO ZAPATA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3034,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/12/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3035,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "AYALA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "AYALA",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3036,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "YECAPIXTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3037,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "YECAPIXTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3038,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TLAYACAPAN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "2/8/2025",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-08",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3039,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "ZACATEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "ZACATEPEC",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/23/2024",
      tipo_vacuna: "HEXA",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3040,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "JIUTEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/17/2025",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3041,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "HUITZILAC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/3/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3042,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "HUITZILAC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3043,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "XOXOCOTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "JOJUTLA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3044,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3045,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TLQUITENANGO",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "3/2/2025",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-02",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3046,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "YECAPIXTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "YECAPIXTLA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3047,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "JIUTEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "25/05/20219",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3048,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3049,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3050,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "JOJUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "JOJUTTLA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "4/28/2010",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3051,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "YAUTEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/5/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3052,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "YECAPIXTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3053,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/4/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3054,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "JIUTEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/22/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3055,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "HUITZILAC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/8/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3056,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/13/2022",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3057,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TETECALA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "TETECALA",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3058,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "ZACATEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "JOJUTLA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/22/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3059,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3060,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TLAYACAPAN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "5/1/2025",
      mes_fecha: 5,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-01",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/27/2022",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3061,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TLAYACAPAN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "5/1/2025",
      mes_fecha: 5,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-01",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/27/2022",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3062,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3063,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "HUITZILAC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3064,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "EMILIANO ZAPATA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3065,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3066,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "AXOCHIAPAN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "AXOCHIAPAN",
      fecha_texto: "2/8/2025",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-08",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3067,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3068,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3069,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "AYALA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/1/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3070,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/20/2019",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3071,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "MIACATLAN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "JOJUTLA",
      fecha_texto: "1/2/2025",
      mes_fecha: 1,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-02",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/23/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3072,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "JIUTEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "JIUTEPEC",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3073,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/21/2016",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3074,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TLQUITENANGO",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "3/1/2025",
      mes_fecha: 3,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-01",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3075,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "AXOCHIAPAN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "AXOCHIAPAN",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3076,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TLAYACAPAN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "5/1/2025",
      mes_fecha: 5,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-01",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/27/2022",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3077,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TEMIXCO",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3078,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "TLAYACAPAN",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3079,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "YAUTEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3080,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3081,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3082,
      edad: "70",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3083,
      edad: "63",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3084,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "COATLAN DEL RIO",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "COATLAN DEL RIO",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3085,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3086,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3087,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "ZACATEPEC",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "ZACATEPEC",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/7/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3088,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUAUTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/19/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3089,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/012/2020",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3090,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/9/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3091,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUERNAVACA",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3092,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "CUERNAVACA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "EMILIANO ZAPATA",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/1/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3093,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "MORELOS",
      municipio_residencia: "YECAPIXTLA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "YECAPIXTLA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3094,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "MORELOS",
      municipio_residencia: "AMAYUCA",
      estado_notificacion: "MORELOS",
      municipio_notificacion: "CUAUTLA",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3095,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "COMPOSTELA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3096,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3097,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "HUAJICORI",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3098,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "DEL NAYAR",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "DEL NAYAR",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3099,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "SANTA MARIA DEL ORO",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "3/1/2025",
      mes_fecha: 3,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-01",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3100,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "SANTA MARIA DEL ORO",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3101,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "SANTA MARIA DEL ORO",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3102,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "SANTA MARIA DEL ORO",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3103,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "ACAPONETA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "DEL NAYAR",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/9/2025",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3104,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "DEL NAYAR",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3105,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "03/07/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3106,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "SANTIAGO IXCUINTLA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "SANTIAGO IXCUINTLA",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/17/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3107,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "BAHIA DE BANDERAS",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "BAHIA DE BANDERAS",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/16/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3108,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "LA YESCA",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3109,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "TEPIC",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "7/22/2025",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-22",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/31/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3110,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "DEL NAYAR",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "29/7/2025",
      mes_fecha: 29,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2027-05-07",
      anio_mes: "2027-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3111,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NAYARIT",
      municipio_residencia: "XALISCO",
      estado_notificacion: "NAYARIT",
      municipio_notificacion: "TEPIC",
      fecha_texto: "8/17/2025",
      mes_fecha: 8,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-17",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/29/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3112,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/6/2025",
      mes_fecha: 1,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-06",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3113,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3114,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3115,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/6/2025",
      mes_fecha: 1,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-06",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3116,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTIAGO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/9/2025",
      mes_fecha: 1,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-09",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3117,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/9/2025",
      mes_fecha: 1,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-09",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3118,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3119,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3120,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZUAZUA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3121,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3122,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/7/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3123,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/15/2025",
      mes_fecha: 1,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-15",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3124,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3125,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/7/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3126,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "ALLENDE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTEMORELOS",
      fecha_texto: "1/21/2025",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-21",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3127,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/13/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3128,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/21/2025",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-21",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3129,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3130,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3131,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3132,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3133,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3134,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3135,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3136,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3137,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3138,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3139,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3140,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3141,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/16/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3142,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN PEDRO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3143,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CIENEGA DE FLORES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3144,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3145,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3146,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3147,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "DR. ARROYO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3148,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3149,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3150,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3151,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZUAZUA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3152,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3153,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3154,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3155,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3156,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3157,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3158,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3159,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3160,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3161,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3162,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3163,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CIENEGA DE FLORES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3164,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "LINARES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3165,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CIENEGA DE FLORES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3166,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/27/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3167,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/26/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3168,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3169,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3170,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3171,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/24/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3172,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3173,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/12/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3174,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTEMORELOS",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3175,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3176,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/7/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3177,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3178,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3179,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3180,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/27/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3181,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3182,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3183,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/16/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3184,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3185,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3186,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3187,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3188,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3189,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/2/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3190,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/1/2018",
      tipo_vacuna: "1 Y 2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3191,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3192,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/20/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3193,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "7/4/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3194,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3195,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/10/2016",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3196,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3197,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3198,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3199,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3200,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/24/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3201,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/22/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3202,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3203,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3204,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3205,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3206,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CIENEGA DE FLORES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3207,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "ABASOLO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/25/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3208,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3209,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3210,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3211,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3212,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3213,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3214,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3215,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 7,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/24/2020",
      tipo_vacuna: "1,2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3216,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GENERAL ESCOBEDO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3217,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3218,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3219,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3220,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3221,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3222,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/29/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3223,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN PEDRO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/1/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3224,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3225,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3226,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3227,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3228,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/2/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3229,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/25/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3230,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3231,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/17/2024",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3232,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3233,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/2/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3234,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3235,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "LINARES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3236,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GENERAL ESCOBEDO",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3237,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3238,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3239,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/10/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3240,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZUAZUA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3241,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/7/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3242,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/6/2019",
      tipo_vacuna: "1 Y 2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3243,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/8/2022",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3244,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GENERAL ESCOBEDO",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3245,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/15/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3246,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3247,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3248,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "9/20/2022",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3249,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3250,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "7/10/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3251,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/4/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3252,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3253,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GENERAL ESCOBEDO",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/20/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3254,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/15/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3255,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3256,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/26/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3257,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/1/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3258,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3259,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/6/2022",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3260,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/29/2025",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3261,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3262,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3263,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3264,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SANTA CATARINA",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/16/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3265,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3266,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTIAGO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/29/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3267,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/19/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3268,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3269,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3270,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/22/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3271,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GENERAL ESCOBEDO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/30/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3272,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/2/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3273,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3274,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/3/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3275,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/15/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3276,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/19/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3277,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN PEDRO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3278,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/12/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3279,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3280,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/10/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3281,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3282,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZUAZUA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3283,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/5/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3284,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3285,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3286,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 7,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/18/2022",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3287,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3288,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3289,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/23/2021",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3290,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/6/2021",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3291,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3292,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3293,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/27/2021",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3294,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3295,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/10/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3296,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3297,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3298,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/12/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3299,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GENERAL ESCOBEDO",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3300,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3301,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/31/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3302,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GENERAL ESCOBEDO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3303,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3304,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3305,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GENERAL ESCOBEDO",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3306,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3307,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3308,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZUAZUA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3309,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/25/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3310,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/7/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3311,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/16/2022",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3312,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3313,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3314,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3315,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GENERAL ESCOBEDO",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3316,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "DR. ARROYO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "DR. ARROYO",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/3/2023",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3317,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3318,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SABINAS HIDALGO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SABINAS HIDALGO",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3319,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3320,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/23/2011",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3321,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GARCIA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3322,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/10/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3323,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/12/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3324,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/25/2019",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3325,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3326,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3327,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3328,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3329,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3330,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/31/2016",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3331,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN PEDRO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/18/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3332,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3333,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3334,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/21/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3335,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3336,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CIENEGA DE FLORES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3337,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/19/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3338,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/2/2000",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3339,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/30/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3340,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 7,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "8/16/2018",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3341,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CHINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "4/17/2025",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-17",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3342,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3343,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3344,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3345,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/17/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3346,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/9/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3347,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3348,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GENERAL ESCOBEDO",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "4/16/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3349,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/3/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3350,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3351,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CERRALVO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "CERRALVO",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3352,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3353,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3354,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3355,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/5/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3356,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/21/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3357,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/28/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3358,
      edad: "69",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3359,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3360,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 7,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3361,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3362,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CIENEGA DE FLORES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/10/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3363,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTIAGO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTEMORELOS",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3364,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/7/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3365,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3366,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3367,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "DR. ARROYO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "DR. ARROYO",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/8/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3368,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/4/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3369,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTIAGO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/15/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3370,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/2/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3371,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3372,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/11/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3373,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "3/4/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3374,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN PEDRO",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/10/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3375,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN PEDRO",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/10/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3376,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/7/2025",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3377,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/24/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3378,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3379,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3380,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3381,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/21/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3382,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/19/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3383,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/2/2025",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3384,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3385,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/22/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3386,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/7/2016",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3387,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GENERAL ESCOBEDO",
      fecha_texto: "5/26/2025",
      mes_fecha: 5,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-26",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3388,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/26/2025",
      mes_fecha: 5,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-26",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3389,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/18/2005",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3390,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3391,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3392,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "8/27/2025",
      mes_fecha: 8,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-27",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3393,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3394,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3395,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3396,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/7/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3397,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3398,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3399,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3400,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3401,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/5/2025",
      mes_fecha: 6,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-05",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3402,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/5/2025",
      mes_fecha: 6,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-05",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3403,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "6/5/2025",
      mes_fecha: 6,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-05",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3404,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/26/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3405,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/31/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3406,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/29/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3407,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTIAGO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTEMORELOS",
      fecha_texto: "6/5/2025",
      mes_fecha: 6,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-05",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3408,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3409,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/26/2022",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3410,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/14/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3411,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/21/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3412,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3413,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3414,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/11/2025",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3415,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3416,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CIENEGA DE FLORES",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3417,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/13/2025",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-13",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3418,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/15/2025",
      mes_fecha: 6,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-15",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3419,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3420,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3421,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/13/2025",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-13",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3422,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3423,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3424,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3425,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3426,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "3/6/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3427,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/11/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3428,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/19/2025",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-19",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3429,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/19/2025",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-19",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3430,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/19/2025",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-19",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/24/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3431,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "6/23/2025",
      mes_fecha: 6,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-23",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/4/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3432,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/20/2025",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-20",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3433,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3434,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3435,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3436,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/26/2025",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-26",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/21/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3437,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/26/2025",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-26",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/13/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3438,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "6/26/2025",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-26",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3439,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3440,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3441,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3442,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/3/2025",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-03",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3443,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/7/2025",
      mes_fecha: 7,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-07",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3444,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/7/2025",
      mes_fecha: 7,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-07",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3445,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/7/2025",
      mes_fecha: 7,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-07",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/5/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3446,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/4/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3447,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/8/2025",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-08",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3448,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/8/2025",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-08",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/14/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3449,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "7/7/2025",
      mes_fecha: 7,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-07",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/22/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3450,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTEMORELOS",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTEMORELOS",
      fecha_texto: "7/8/2025",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-08",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3451,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL BRAVO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3452,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3453,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZUAZUA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3454,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SABINAS HIDALGO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SABINAS HIDALGO",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/5/2023",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3455,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3456,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3457,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SABINAS HIDALGO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SABINAS HIDALGO",
      fecha_texto: "7/17/2025",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-17",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3458,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZUAZUA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/15/2025",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-15",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/6/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3459,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "7/15/2025",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-15",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3460,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "7/17/2025",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-17",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3461,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/18/2025",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-18",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3462,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/21/2025",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-21",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3463,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/21/2025",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-21",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3464,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/23/2025",
      mes_fecha: 7,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-23",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3465,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/22/2025",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-22",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3466,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GARCIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/14/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3467,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3468,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "7/30/2025",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-30",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3469,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTIAGO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/19/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3470,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "ANAHUAC",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SABINAS HIDALGO",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/20/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3471,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "8/1/2025",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-01",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3472,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SAN NICOLAS DE LOS GARZA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "8/1/2025",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-01",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3473,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "8/8/2025",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-08",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/28/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3474,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/11/2025",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-11",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3475,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZUAZUA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "8/11/2025",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-11",
      anio_mes: "2025-08",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3476,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "EL CARMEN",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/12/2025",
      mes_fecha: 8,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-12",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3477,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/13/2025",
      mes_fecha: 8,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-13",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3478,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SALINAS VICTORIA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/14/2025",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-14",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3479,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/14/2025",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-14",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3480,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "8/14/2025",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-14",
      anio_mes: "2025-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3481,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3482,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3483,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/19/2025",
      mes_fecha: 8,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-19",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3484,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ESCOBEDO",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3485,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/20/2023",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3486,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "PESQUERÍA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "APODACA",
      fecha_texto: "8/24/2025",
      mes_fecha: 8,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-24",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3487,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "8/28/2025",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-28",
      anio_mes: "2025-08",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "8/20/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3488,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "SANTA CATARINA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "9/2/2025",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-02",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/30/2022",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3489,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "9/3/2025",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-03",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/20/2022",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3490,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "9/5/2025",
      mes_fecha: 9,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-05",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/6/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3491,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "GENERAL ZUAZUA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "9/8/2025",
      mes_fecha: 9,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-08",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3492,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "MONTERREY",
      fecha_texto: "9/12/2025",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-12",
      anio_mes: "2025-09",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3493,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "JUAREZ",
      fecha_texto: "9/17/2025",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-17",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3494,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "9/17/2025",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-17",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3495,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "JUAREZ",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "9/17/2025",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-17",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3496,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "MONTERREY",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "SAN NICOLAS DE LOS GARZA",
      fecha_texto: "9/18/2025",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-18",
      anio_mes: "2025-09",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3497,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "NUEVO LEON",
      municipio_residencia: "APODACA",
      estado_notificacion: "NUEVO LEON",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "9/19/2025",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-19",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3498,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "CUILAPAM DE GUERRERO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3499,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO APOSTOL",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/11/2024",
      tipo_vacuna: "1",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3500,
      edad: "70",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA CRUZ XOXOCOTLAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3501,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "LOMA BONITA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN JUAN BAUTISTA TUXTEPEC",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3502,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN JUAN BAUTISTA TUXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN JUAN BAUTISTA TUXTEPEC",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/15/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3503,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/09/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3504,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO APOSTOL",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO APOSTOL",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3505,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO APOSTOL",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO APOSTOL",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3506,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO APOSTOL",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO APOSTOL",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3507,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO APOSTOL",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO APOSTOL",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3508,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO APOSTOL",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO APOSTOL",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3509,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO APOSTOL",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO APOSTOL",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3510,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO APOSTOL",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO APOSTOL",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3511,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA CRUZ XOXOCOTLAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "1/22/2025",
      mes_fecha: 1,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-22",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3512,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN ANTONIO DE LA CAL",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3513,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN FELIPE USILA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN JUAN BAUTISTA TUXTEPEC",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3514,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN JUAN BAUTISTA TUXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN JUAN BAUTISTA TUXTEPEC",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/20/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3515,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3516,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA MARIA HUATULCO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTA MARIA HUATULCO",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "09/02/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3517,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN JOSE DEL PROGRESO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "30/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3518,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN JOSE DEL PROGRESO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "15/12/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3519,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "05/09/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3520,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3521,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "4/3/2019",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3522,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN MIGUEL SOYALTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN JUAN BAUTISTA TUXTEPEC",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "21/03/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3523,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN FELIPE JALAPA DE DIAZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN FELIPE JALAPA DE DIAZ",
      fecha_texto: "3/1/2025",
      mes_fecha: 3,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-01",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3524,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/2/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3525,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN JUAN BAUTISTA TUXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN JUAN BAUTISTA TUXTEPEC",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "20/12/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3526,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA MARIA HUATULCO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTA MARIA HUATULCO",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "00/00/2004",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3527,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN JUAN BAUTISTA TUXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN JUAN BAUTISTA TUXTEPEC",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "24/07/2019",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3528,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN JUAN BAUTISTA TUXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN JUAN BAUTISTA TUXTEPEC",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "07/02/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3529,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN ANTONINO MONTE VERDE",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "H. CIUDAD DE TLAXIACO",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/15/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3530,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN RAYMUNDO JALPAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "REFURZO",
      fecha_ultima_dosis: "7/4/1905",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3531,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA CRUZ XOXOCOTLAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3532,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3533,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3534,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA CRUZ XOXOCOTLAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3535,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "ACATLAN DE PEREZ FIGUEROA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "ACATLAN DE PEREZ FIGUEROA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3536,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "CUILAPAM DE GUERRERO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3537,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "MIAHUATLAN DE PORFIRIO DIAZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "MIAHUATLAN DE PORFIRIO DIAZ",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3538,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "MIAHUATLAN DE PORFIRIO DIAZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "MIAHUATLAN DE PORFIRIO DIAZ",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3539,
      edad: "91",
      grupo_edad: "90 - 94",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3540,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "ZIMATLAN DE ALVAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "ZIMATLAN DE ALVAREZ",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3541,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "ZIMATLAN DE ALVAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "ZIMATLAN DE ALVAREZ",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3542,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA CRUZ XOXOCOTLAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3543,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO SUCHILQUITONGO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3544,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PEDRO IXCATLAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN JUAN BAUTISTA TUXTEPEC",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/24/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3545,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "TLACOLULA DE MATAMOROS",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3546,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "4/6/2025",
      mes_fecha: 4,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-06",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3547,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA MARIA ATZOMPA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "25/02/2016",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3548,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "ASUNCIÓN NOCHIXTLAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "ASUNCION NOCHIXTLAN",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3549,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3550,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "IXTLAN DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3551,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN JUAN ATEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "09/06/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3552,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PEDRO POCHUTLA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTA MARIA COLOTEPEC",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "26/01/2023",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3553,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PEDRO IXTLAHUACA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3554,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN JOSE CHILTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN JUAN BAUTISTA TUXTEPEC",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3555,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3556,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "4/19/2025",
      mes_fecha: 4,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-19",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3557,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PABLO HUIXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3558,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN BARTOLO COYOTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3559,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN LUCAS OJITLAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN JUAN BAUTISTA TUXTEPEC",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/10/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3560,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA CRUZ MIXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/9/2024",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3561,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PABLO HUIXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN PABLO HUIXTEPEC",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3562,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA CRUZ XOXOCOTLAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3563,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PEDRO MIXTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN PEDRO MIXTEPEC",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/12/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3564,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTO DOMINGO TEHUANTEPEC",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3565,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PEDRO MARTIR YUCUXACO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "H. CIUDAD DE TLAXIACO",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3566,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN PEDRO MARTIR YUCUXACO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "H. CIUDAD DE TLAXIACO",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "05/11/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3567,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN AGUSTIN ETLA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3568,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN ANTONIO DE LA CAL",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/21/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3569,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA MARIA EL TULE",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3570,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA CRUZ XOXOCOTLAN",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTA CRUZ XOXOCOTLAN",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3571,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "6/25/2025",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-25",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3572,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "6/28/2025",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-28",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3573,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "6/26/2025",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-26",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3574,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN FRANCISCO TELIXTLAHUACA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN FRANCISCO TELIXTLAHUACA",
      fecha_texto: "26/6/20258",
      mes_fecha: 26,
      dia_fecha: 6,
      anio_fecha: 20258,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3575,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA CRUZ AMILPAS",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "7/4/2025",
      mes_fecha: 7,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-04",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/21/2018",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3576,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "COICOYAN DE LAS FLORES",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO JUXTLAHUACA",
      fecha_texto: "7/3/2025",
      mes_fecha: 7,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-03",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3577,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTA MARIA HUATULCO",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTA MARIA HUATULCO",
      fecha_texto: "7/17/2025",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-17",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3578,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SAN BARTOLO COYOTEPEC",
      fecha_texto: "7/22/2025",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-22",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/6/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3579,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "COICOYAN DE LAS FLORES",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "SANTIAGO JUXTLAHUACA",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/13/2020",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3580,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "7/17/2025",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-17",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/9/2017",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3581,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SAN JOSE AYUQUILLA",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "HUAJUAPAN DE LEON",
      fecha_texto: "7/28/2025",
      mes_fecha: 7,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-28",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3582,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "OAXACA",
      municipio_residencia: "OAXACA DE JUAREZ",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "OAXACA DE JUAREZ",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3583,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "OAXACA",
      municipio_residencia: "SANTIAGO YOLOMECATL",
      estado_notificacion: "OAXACA",
      municipio_notificacion: "TLAXIACO",
      fecha_texto: "9/18/2025",
      mes_fecha: 9,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-18",
      anio_mes: "2025-09",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "14/10/2011",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3584,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "ZACATLÁN",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "ZACATLÁN",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3585,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "CHALCHICOMULA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "CHALCHICOMULA DE SESMA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3586,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "TEPEYAHUALCO",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "LIBRES",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3587,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3588,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3589,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/24/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3590,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/19/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3591,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "3/8/2025",
      mes_fecha: 3,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-08",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/1/2024",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3592,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PALMAR DE BRAVO",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "TECAMACHALCO",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3593,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "AJALPAN",
      estado_notificacion: "TEHUACAN",
      municipio_notificacion: "TEHUACAN",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3594,
      edad: "60",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3595,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "AMOZOC",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/25/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3596,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "TEPANCO DE LOPEZ",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "TEHUACAN",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/27/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3597,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "3/30/2025",
      mes_fecha: 3,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-30",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3598,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/15/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3599,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/14/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3600,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "TEHUACAN",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "TEHUACAN",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/21/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3601,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "ATIZTZINTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "18/03/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3602,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "V. CARRANZA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "3/16/2025",
      mes_fecha: 3,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-16",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/6/2020",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3603,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3604,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3605,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/26/2025",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3606,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "VENUSTIANO CARRANZA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "VENUSTIANO CARRANZA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3607,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "ATLIXCO",
      estado_notificacion: "METEPEC",
      municipio_notificacion: "METEPEC",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/15/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3608,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "NAUPAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "SANTIAGO TULANTEPEC",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3609,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3610,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "4/18/2025",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-18",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3611,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/9/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3612,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "TECAMACHALCO",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "TECAMACHALCO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3613,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3614,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "SAN MARTIN TEXMELUCAN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3615,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "HUAUCHINANGO",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "HUAUCHINANGO",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/19/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3616,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/5/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3617,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "NAUPAN",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TULANCINGO DE BRAVO",
      fecha_texto: "22705/2025",
      mes_fecha: 22705,
      dia_fecha: 2025,
      anio_fecha: null,
      fecha_notificacion: "3797-07-17",
      anio_mes: "3797-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3618,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/31/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3619,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3620,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "PUEBLA",
      municipio_notificacion: "PUEBLA",
      fecha_texto: "7/8/2025",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-08",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/4/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3621,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3622,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "SAN FELIPE TEOTLALCINGO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/14/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3623,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "PUEBLA",
      municipio_residencia: "PUEBLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "SAN PABLO DEL MONTE",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3624,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/6/2025",
      mes_fecha: 1,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-06",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3625,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "TOLIMAN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3626,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JOAQUIN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "1/12/2025",
      mes_fecha: 1,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-12",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3627,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "HUIMILPAN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3628,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CORREGIDORA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/21/2025",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-21",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3629,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "EL MARQUES",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3630,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/21/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3631,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "HUIMILPAN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "HUIMILPAN",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3632,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CORREGIDORA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3633,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "AMEALCO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3634,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EZEQUIEL MONTES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3635,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "AMEALCO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3636,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "AMEALCO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "AMEALCO",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3637,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "30/872024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3638,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3639,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3640,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/8/2025",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-08",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3641,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3642,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "AMEALCO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/29/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3643,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "PEDRO ESCOBEDO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "PEDRO ESCOBEDO",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/6/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3644,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3645,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/1/2015",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3646,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3647,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/6/2018",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3648,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3649,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3650,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "HUIMILPAN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "HUIMILPAN",
      fecha_texto: "2/23/2025",
      mes_fecha: 2,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-23",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3651,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "HUIMILPAN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "HUIMILPAN",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/19/2020",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3652,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3653,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "4/19/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3654,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "EL MARQUES",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/21/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3655,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/1/2017",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3656,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3657,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "EL MARQUES",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3658,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/3/2025",
      mes_fecha: 2,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-03",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3659,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "HUIMILPAN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "HUIMILPAN",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3660,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "HUIMILPAN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "HUIMILPAN",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3661,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "EL MARQUES",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/16/2015",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3662,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3663,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/8/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3664,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/8/2025",
      mes_fecha: 3,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-08",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3665,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3666,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3667,
      edad: "77",
      grupo_edad: "75 - 79",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "EL MARQUES",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3668,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3669,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/5/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3670,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3671,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/19/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3672,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "11/14/2024",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3673,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "EL MARQUES",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3674,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/19/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3675,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3676,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3677,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CORREGIDORA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3678,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "EL MARQUES",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3679,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/2/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3680,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/27/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3681,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/16/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3682,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/10/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3683,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3684,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3685,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "EL MARQUES",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3686,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/9/2013",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3687,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/4/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3688,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3689,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3690,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "PEDRO ESCOBEDO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/23/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3691,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3692,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3693,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3694,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3695,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3696,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "EL MARQUES",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/4/2025",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3697,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3698,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/30/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3699,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/29/2025",
      mes_fecha: 3,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-29",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3700,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "TEQUISQUIAPAN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/22/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3701,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/18/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3702,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "9/3/2012",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3703,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "EL MARQUES",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3704,
      edad: "68",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3705,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/5/2025",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-05",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/29/2015",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3706,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/5/2025",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-05",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3707,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CORREGIDORA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CORREGIDORA",
      fecha_texto: "4/6/2025",
      mes_fecha: 4,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-06",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/8/2015",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3708,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "ESEQUIEL MONTES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3709,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3710,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3711,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3712,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SANTIAGO DE QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3713,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/27/2015",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3714,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EZEQUIEL MONTES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/22/2022",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3715,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3716,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "COLON",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3717,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3718,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "EL MARQUES",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3719,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "HUIMILPAN",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "5/10/2025",
      mes_fecha: 5,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-10",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/31/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3720,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3721,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3722,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3723,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/13/2025",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3724,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "SAN JUAN DEL RIO",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/7/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3725,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUEREATO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "5/26/2025",
      mes_fecha: 5,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-26",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/26/2027",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3726,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3727,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "PEDRO ESCOBEDO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "PEDRO ESCOBEDO",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/21/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3728,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "PEDRO ESCOBEDO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "PEDRO ESCOBEDO",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/21/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3729,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/24/2017",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3730,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/18/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3731,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "PEDRO ESCOBEDO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "PEDRO ESCOBEDO",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/21/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3732,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "7/9/2025",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-09",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3733,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "COLON",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "7/21/2025",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-21",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3734,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "7/24/2025",
      mes_fecha: 7,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-24",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3735,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3736,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CORREGIDORA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "8/3/2025",
      mes_fecha: 8,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-03",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3737,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "CADEREYTA",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "CADEREYTA",
      fecha_texto: "8/6/2025",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-06",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3738,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "8/6/2025",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-06",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3739,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "HIDALGO",
      municipio_notificacion: "TEPEJI DEL RIO",
      fecha_texto: "7/25/2025",
      mes_fecha: 7,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-25",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3740,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "EL MARQUES",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "8/11/2025",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-11",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3741,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "SAN JUAN DEL RIO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "8/14/2025",
      mes_fecha: 8,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-14",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3742,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "8/21/2025",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-21",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3743,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "8/28/2025",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-28",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/18/2017",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3744,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUERETARO",
      municipio_residencia: "QUERETARO",
      estado_notificacion: "QUERETARO",
      municipio_notificacion: "QUERETARO",
      fecha_texto: "9/3/2025",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-03",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3745,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3746,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "FELIPE CARRILLO PUERTO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "FELIPE CARRILLO PUERTO",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/10/2015",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3747,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3748,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3749,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3750,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/28/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3751,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "6/23/2020",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3752,
      edad: "55",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3753,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "SOLIDARIDAD",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "SOLIDARIDAD",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/15/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3754,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3755,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3756,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3757,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3758,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3759,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3760,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "COZUMEL",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "COZUMEL",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/5/2024",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3761,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "FELIPE CARRILLO PUERTO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "FELIPE CARRILLO PUERTO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3762,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/18/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3763,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/7/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3764,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3765,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/23/2022",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3766,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3767,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3768,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/13/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3769,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3770,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3771,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/29/2024",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3772,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/12/2014",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3773,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/14/2025",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3774,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/31/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3775,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3776,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "SOLIDARIDAD",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "SOLIDARIDAD",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1 Y 2",
      fecha_ultima_dosis: "3/26/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3777,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "4/23/2021",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3778,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "SOLIDARIDAD",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "SOLIDARIDAD",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3779,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "JOSE MARIA MORELOS",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "JOSE MARIA MORELOS",
      fecha_texto: "4/13/2025",
      mes_fecha: 4,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-13",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/26/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3780,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3781,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3782,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3783,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3784,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3785,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "JOSE MARIA MORELOS",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "JOSE MARIA MORELOS",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/17/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3786,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "JOSE MARIA MORELOS",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "JOSE MARIA MORELOS",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/17/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3787,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "JOSE MARIA MORELOS",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "FELIPE CARRILLO PUERTO",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3788,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "JOSE MARIA MORELOS",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "JOSE MARIA MORELOS",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3789,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/1/2022",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3790,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3791,
      edad: "62",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3792,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "JOSE MARIA MORELOS",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "FELIPE CARRILLO PUERTO",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3793,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "JOSE MARIA MORELOS",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "JOSE MARIA MORELOS",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/17/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3794,
      edad: "57",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BACALAR",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/21/2010",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3795,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3796,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3797,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3798,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/25/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3799,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/11/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3800,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3801,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3802,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3803,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "FELIPE CARRILLO PUERTO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "FELIPE CARRILLO PUERTO",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3804,
      edad: "57",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3805,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/26/2025",
      mes_fecha: 5,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-26",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3806,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3807,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3808,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3809,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "JOSE MARIA MORELOS",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "JOSE MARIA MORELOS",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/24/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3810,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BACALAR",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/2/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3811,
      edad: "57",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "6/19/2025",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-19",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3812,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "6/19/2025",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-19",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3813,
      edad: "63",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "6/26/2025",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-26",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3814,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3815,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3816,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "7/8/2025",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-08",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3817,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "7/8/2025",
      mes_fecha: 7,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-08",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3818,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "7/22/2025",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-22",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3819,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "7/25/2025",
      mes_fecha: 7,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-25",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3820,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "TULUM",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "SOLIDARIDAD",
      fecha_texto: "7/28/2025",
      mes_fecha: 7,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-28",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3821,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3822,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "OTHON P. BLANCO",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "OTHON P. BLANCO",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "5/14/2024",
      tipo_vacuna: "DPT Y HEXAVALENTE",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3823,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "TULUM",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "TULUM",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3824,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "TULUM",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "TULUM",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/28/2022",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3825,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "8/28/2025",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-28",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3826,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "9/4/2025",
      mes_fecha: 9,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-04",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3827,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "QUINTANA ROO",
      municipio_residencia: "BENITO JUAREZ",
      estado_notificacion: "QUINTANA ROO",
      municipio_notificacion: "BENITO JUAREZ",
      fecha_texto: "9/25/2025",
      mes_fecha: 9,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-25",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "1/22/2004",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3828,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CIUDAD FERNANDEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "1/5/2025",
      mes_fecha: 1,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-05",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3829,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3830,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN NICOLAS TOLENTINO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3831,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MATEHUALA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "MATEHUALA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3832,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "AHUALULCO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "AHUALULCO",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/29/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3833,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN VICENTE TANCUAYALAB",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3834,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CIUDAD VALLES",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/24/2024",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3835,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "1/21/2025",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-21",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3836,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CIUDAD VALLES",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3837,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/29/2015",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3838,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SALINAS DE HIDALGO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/2/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3839,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/14/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3840,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MATEHUALA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "MATEHUALA",
      fecha_texto: "2/2/2025",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-02",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "20/05/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3841,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SALINAS DE HIDALGO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SALINAS DE HIDALGO",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/27/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3842,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE REYES",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "VILLA DE REYES",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "3/18/2022",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3843,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/25/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3844,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SANTA MARIA DEL RIO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3845,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/27/2013",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3846,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3847,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3848,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "2/24/2025",
      mes_fecha: 2,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-24",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/19/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3849,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3850,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "17-04-2019",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3851,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MATEHUALA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "MATEHUALA",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3852,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3853,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VANEGAS",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "MATEHUALA",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3854,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3855,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MATEHUALA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "MATEHUALA",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3856,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "1/1/1980",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3857,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SALINAS DE HIDALGO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SALINAS DE HIDALGO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3858,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "AQUISMON",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3859,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CIUDAD VALLES",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/6/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3860,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3861,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA HIDALGO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3862,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MEXQUITIC DE CARMONA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3863,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3864,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA HIDALGO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3865,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE REYES",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "21-02-2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3866,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "AQUISMON",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3867,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3868,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3869,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "TAMASOPO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3870,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "AQUISMON",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3871,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CATORCE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "ESTACIÓN CATORCE",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3872,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MATEHUALA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "MATEHUALA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "03/04/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3873,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3874,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3875,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "AHUALULCO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "AHUALULCO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3876,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VENADO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CHARCAS",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "24/10/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3877,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "TAMAZUNCHALE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "TAMAZUNCHALE",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3878,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CHARCAS",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CHARCAS",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3879,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CIUDAD FERNANDEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CD FERNANDEZ",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "01/06/2006",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3880,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MATEHUALA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "MATEHUALA",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3881,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "RIOVERDE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3882,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "RIOVERDE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/03/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3883,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "03-03-2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3884,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MEXQUITIC DE CARMONA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3885,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3886,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3887,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3888,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3889,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "AHUALULCO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3890,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3891,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CIUDAD VALLES",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3892,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE ARISTA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3893,
      edad: "56",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3894,
      edad: "57",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3895,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3896,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "RIOVERDE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3897,
      edad: "74",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN CIRO DE ACOSTA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN CIRO DE ACOSTA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3898,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MATEHUALA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "MATEHUALA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "19/11/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3899,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3900,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA ZARAGOZA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "VILLA ZARAGOZA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/9/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3901,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "VILLA ZARAGOZA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3902,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "VILLA ZARAGOZA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3903,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "RIOVERDE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3904,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE ZARAGOZA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3905,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "XILITLA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3906,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3907,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3908,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3909,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MEXQUITIC DE CARMONA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "MEXQUITIC",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3910,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "TAMAZUNCHALE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "TAMAZUNCHALE",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "01/04//2025",
      tipo_vacuna: "1, 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3911,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "TAMAZUNCHALE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "TAMAZUNCHALE",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "27/02/2018",
      tipo_vacuna: "1, 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3912,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3913,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CIUDAD VALLES",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3914,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CARDENAS",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CARDENAS",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3915,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "24/11/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3916,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "17/02/2023",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3917,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "RIOVERDE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "21/10/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3918,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "RIOVERDE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3919,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA ZARAGOZA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "VILLA ZARAGOZA",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "04/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3920,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA ZARAGOZA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "VILLA ZARAGOZA",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "20/02/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3921,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3922,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3923,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA ZARAGOZA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "VILLA ZARAGOZA",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "20/03/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3924,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CARDENAS",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3925,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MATLAPA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "RIOVERDE",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3926,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN VICENTE TANCUAYALAB",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/2/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3927,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "EBANO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3928,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3929,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SALINAS DE HIDALGO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SALINAS DE HIDALGO",
      fecha_texto: "4/18/2025",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-18",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3930,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3931,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3932,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3933,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MATEHUALA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "MATEHUALA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "07/04/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3934,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3935,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3936,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3937,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3938,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CIUDAD VALLES",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3939,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3940,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3941,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "VILLA HIDALGO",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3942,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SANTA MARIA DEL RIO",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "31/03/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3943,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CIUDAD VALLES",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "06/06/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3944,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3945,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3946,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MOCTEZUMA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "VILLA DE ARISTA",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "13/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3947,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE ARISTA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "VILLA DE ARISTA",
      fecha_texto: "5/16/2025",
      mes_fecha: 5,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-16",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/10/20224",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3948,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3949,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3950,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3951,
      edad: "69",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3952,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/7/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3953,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "1/1/1980",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3954,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3955,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3956,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "07/01/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3957,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "TAMAZUNCHALE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3958,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "6/13/2025",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-13",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3959,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "6/25/2025",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-25",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3960,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3961,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "6/27/2025",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-27",
      anio_mes: "2025-06",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3962,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SOLEDAD DE GRACIANO SANCHEZ",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3963,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3964,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE ARISTA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "VILLA DE ARISTA",
      fecha_texto: "7/19/2025",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-19",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "07/10/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3965,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE ARISTA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "VILLA DE ARISTA",
      fecha_texto: "7/19/2025",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-19",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3966,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "7/21/2025",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-21",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3967,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "7/22/2025",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-22",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3968,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "7/24/2025",
      mes_fecha: 7,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-24",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/16/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3969,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "MATEHUALA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "MATEHUALA",
      fecha_texto: "8/4/2025",
      mes_fecha: 8,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-04",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3970,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "7/4/2025",
      mes_fecha: 7,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-04",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "16/06/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3971,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CIUDAD VALLES",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CIUDAD VALLES",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "22/10/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3972,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "CATORCE",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "CATORCE",
      fecha_texto: "8/10/2025",
      mes_fecha: 8,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-10",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3973,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE ARISTA",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "8/18/2025",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-18",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3974,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "8/29/2025",
      mes_fecha: 8,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-29",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3975,
      edad: "56",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "8/29/2025",
      mes_fecha: 8,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-29",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3976,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "8/29/2025",
      mes_fecha: 8,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-29",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3977,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "POZOS",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "9/1/2025",
      mes_fecha: 9,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-01",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3978,
      edad: "88",
      grupo_edad: "85 - 89",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "9/2/2025",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-02",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3979,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "9/8/2025",
      mes_fecha: 9,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-08",
      anio_mes: "2025-09",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3980,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "9/8/2025",
      mes_fecha: 9,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-08",
      anio_mes: "2025-09",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3981,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "9/12/2025",
      mes_fecha: 9,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-12",
      anio_mes: "2025-09",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/10/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3982,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE REYES",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "9/15/2025",
      mes_fecha: 9,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-15",
      anio_mes: "2025-09",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3983,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "SAN LUIS POTOSI",
      estado_notificacion: "SAN LUIS POTOSI",
      municipio_notificacion: "SAN LUIS POTOSI",
      fecha_texto: "9/17/2025",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-17",
      anio_mes: "2025-09",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3984,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SAN LUIS POTOSI",
      municipio_residencia: "VILLA DE RAMOS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "5/18/2025",
      mes_fecha: 5,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-18",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3985,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "AHOME",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "AHOME",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3986,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "EL FUERTE",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "AHOME",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3987,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "GUASAVE",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "GUASAVE",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3988,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3989,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3990,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "GUASAVE",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "GUASAVE",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/29/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3991,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3992,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "9/5/2024",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3993,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/17/2025",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3994,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3995,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "AHOME",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "AHOME",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3996,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3997,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "GUASAVE",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "AHOME",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3998,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "AHOME",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "AHOME",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 3999,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "AHOME",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "AHOME",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4000,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "GUASAVE",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "GUASAVE",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4001,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "ESCUINAPA",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "ESCUINAPA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4002,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "ESCUINAPA",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "ESCUINAPA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4003,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "ESCUINAPA",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "ESCUINAPA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/6/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4004,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4005,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/11/2119",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2119,
      fecha_notificacion: "2119-03-11",
      anio_mes: "2119-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4006,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/13/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4007,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4008,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/20/2024",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4009,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "NAVOLATO",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4010,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "MAZATLAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "MAZATLAN",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "1/26/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4011,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4012,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4013,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/29/2023",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4014,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4015,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "NAVOLATO",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/24/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4016,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "NAVOLATO",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/27/2023",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4017,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/6/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4018,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/23/2025",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-23",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4019,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/23/2024",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4020,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4021,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "NAVOLATO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/18/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4022,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/25/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4023,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "SALVADOR ALVARADO",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4024,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "EL DORADO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4025,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/12/2018",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4026,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "NAVOLATO",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/6/2017",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4027,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/23/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4028,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "MAZATLAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "MAZATLAN",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4029,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "GUASAVE",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "GUAMUCHIL",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/26/2016",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4030,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/23/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4031,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CRUZ DE ELOTA",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/15/2025",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4032,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "4/12/2025",
      mes_fecha: 4,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-12",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4033,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4034,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "EL FUERTE",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "EL FUERTE",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/5/2025",
      tipo_vacuna: "3",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4035,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/3/2025",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4036,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/25/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4037,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4038,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4039,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/13/2025",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4040,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "AHOME",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "AHOME",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4041,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "AHOME",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "AHOME",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4042,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/5/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4043,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "NAVOLATO",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "7/15/2025",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-15",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4044,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "7/23/2025",
      mes_fecha: 7,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-23",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/23/2025",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4045,
      edad: "60",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "AHOME",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "7/30/2025",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-30",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4046,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "MAZATLAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "",
      fecha_texto: "7/28/2025",
      mes_fecha: 7,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-28",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "7/17/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4047,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "8/8/2025",
      mes_fecha: 8,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-08",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4048,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "9/3/2025",
      mes_fecha: 9,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-03",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/19/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4049,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "9/11/2025",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-11",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/5/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4050,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "9/10/2025",
      mes_fecha: 9,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-10",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "9/7/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4051,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SINALOA",
      municipio_residencia: "CULIACAN",
      estado_notificacion: "SINALOA",
      municipio_notificacion: "CULIACAN",
      fecha_texto: "9/11/2025",
      mes_fecha: 9,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-11",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/7/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4052,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "03/12/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4053,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "1/11/2025",
      mes_fecha: 1,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-11",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "03/01/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4054,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "GUAYMAS",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "1/14/2025",
      mes_fecha: 1,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-14",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4055,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "1/18/2025",
      mes_fecha: 1,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-18",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4056,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4057,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "24/10/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4058,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "GUAYMAS",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4059,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "06/06/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4060,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "18/06/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4061,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "EMPALME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "GUAYMAS",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "21/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4062,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4063,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "15/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4064,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/7/2025",
      mes_fecha: 2,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-07",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4065,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/8/2025",
      mes_fecha: 2,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-08",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4066,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4067,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4068,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4069,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4070,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4071,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "AGUAPRIETA",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4072,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4073,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4074,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4075,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4076,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "27/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4077,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "14/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4078,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4079,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "PUERTO PEÑASCO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4080,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "CANANEA",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4081,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/01/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4082,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "07/02/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4083,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "MAGDALENA DE KINO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4084,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "24/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4085,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4086,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "17/01/2025",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4087,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "GUAYMAS",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4088,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4089,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4090,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "15/10/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4091,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "13/12/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4092,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4093,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/16/2025",
      mes_fecha: 3,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-16",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4094,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/15/2025",
      mes_fecha: 3,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-15",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/12/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4095,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/23/2019",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4096,
      edad: "76",
      grupo_edad: "75 - 79",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "EMPALME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "GUAYMAS",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4097,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NAVOJOA",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4098,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4099,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "19/11/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4100,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HUATABAMPO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NAVOJOA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4101,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "03/03/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4102,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "13/03/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4103,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4104,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4105,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "00/01/1900",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4106,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "3/30/2025",
      mes_fecha: 3,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-30",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4107,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "14/03/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4108,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4109,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "GUAYMAS",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "13/06/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4110,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4111,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "05/03/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4112,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NAVOJOA",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NAVOJOA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "18/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4113,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "NAVOJOA",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NAVOJOA",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4114,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4115,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HEMROSILLO",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4116,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "19/02/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4117,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/03/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4118,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/19/2025",
      mes_fecha: 4,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-19",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/03/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4119,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "BENJAMIN HILL",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4120,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "02/03/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4121,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4122,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4123,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NAVOJOA",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4124,
      edad: "74",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "CAJEME",
      estado_notificacion: "SONORA",
      municipio_notificacion: "CAJEME",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4125,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "21/04/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4126,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4127,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "18/03/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4128,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "NOGALES",
      estado_notificacion: "SONORA",
      municipio_notificacion: "NOGALES",
      fecha_texto: "5/3/2025",
      mes_fecha: 5,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-03",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4129,
      edad: "64",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4130,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "SAN MIGUEL DE HORCASITAS",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "5/1/2025",
      mes_fecha: 5,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-01",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4131,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "24/03/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4132,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4133,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "5/30/2025",
      mes_fecha: 5,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-30",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "17/07/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4134,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4135,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4136,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4137,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "7/7/2025",
      mes_fecha: 7,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-07",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "24/06/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4138,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "7/9/2025",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-09",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4139,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4140,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "8/5/2025",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-05",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4141,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "8/12/2025",
      mes_fecha: 8,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-12",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "04/06/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4142,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "8/21/2025",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-21",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "13/12/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4143,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "9/2/2025",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-02",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "06/01/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4144,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "SONORA",
      municipio_residencia: "HERMOSILLO",
      estado_notificacion: "SONORA",
      municipio_notificacion: "HERMOSILLO",
      fecha_texto: "9/19/2025",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-19",
      anio_mes: "2025-09",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4145,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CUNDUACÁN",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "2/28/2025",
      mes_fecha: 2,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-28",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4146,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CENTRO",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "REFURZO",
      fecha_ultima_dosis: "9/6/2022",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4147,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CENTRO",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/4/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4148,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CENTRO",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "6/24/2022",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4149,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CÁRDENAS",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CÁRDENAS",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4150,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TABASCO",
      municipio_residencia: "COMALCALCO",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "5/26/2025",
      mes_fecha: 5,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-26",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4151,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CENTLA",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "5/15/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4152,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CÁRDENAS",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4153,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CENTRO",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "7/10/2025",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-10",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "13/06/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4154,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TABASCO",
      municipio_residencia: "CENTRO",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "16/12/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4155,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TABASCO",
      municipio_residencia: "JONUTA",
      estado_notificacion: "TABASCO",
      municipio_notificacion: "CENTRO",
      fecha_texto: "8/3/2025",
      mes_fecha: 8,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-03",
      anio_mes: "2025-08",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4156,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "15/1/2025",
      mes_fecha: 15,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2026-03-01",
      anio_mes: "2026-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4157,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MANTE",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MANTE",
      fecha_texto: "1/11/2025",
      mes_fecha: 1,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-11",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/15/2024",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4158,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4159,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "1/17/2025",
      mes_fecha: 1,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-17",
      anio_mes: "2025-01",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/11/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4160,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "TAMPICO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "TAMPICO",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "07/01/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4161,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "1/31/2025",
      mes_fecha: 1,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-31",
      anio_mes: "2025-01",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/14/2025",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4162,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "TAMPICO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "TAMPICO",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4163,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "TAMPICO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MADERO",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4164,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "2/2/2025",
      mes_fecha: 2,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-02",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4165,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "VICTORIA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "VICTORIA",
      fecha_texto: "2/9/2025",
      mes_fecha: 2,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-09",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4166,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4167,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4168,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4169,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "VICTORIA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/29/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4170,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4171,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "NUEVO LAREDO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "NUEVO LAREDO",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4172,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4173,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "TAMPICO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MADERO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 7,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/6/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4174,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "TAMPICO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MADERO",
      fecha_texto: "2/19/2025",
      mes_fecha: 2,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-19",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "29/01/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4175,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "TAMPICO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MADERO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4176,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "TAMPICO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MADERO",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4177,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "NUEVO LAREDO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "NUEVO LAREDO",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4178,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MADERO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MADERO",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 6,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4179,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MADERO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MADERO",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/12/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4180,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "VICTORIA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "VICTORIA",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4181,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "3/9/2025",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-09",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/17/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4182,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "NUEVO LAREDO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "NUEVO LAREDO",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4183,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4184,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "VICTORIA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "VICTORIA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4185,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "VICTORIA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "VICTORIA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4186,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4187,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "1/25/2022",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4188,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4189,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "3/23/2025",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-23",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/5/2025",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4190,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "06/05/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4191,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "CUIDAD MADERO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "TAMPICO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/7/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4192,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4193,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4194,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "19/02/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4195,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "ALTAMIRA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MADERO",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/10/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4196,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "15/02/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4197,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "VICTORIA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "VICTORIA",
      fecha_texto: "4/6/2025",
      mes_fecha: 4,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-06",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/9/2015",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4198,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "05/02/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4199,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/16/2016",
      tipo_vacuna: "1,2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4200,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "4/5/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4201,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4202,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "4/18/2025",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-18",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4203,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4204,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4205,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4206,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "GONZÁLEZ",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "TAMPICO",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 4,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4207,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4208,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/15/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4209,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4210,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4211,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4212,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4213,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4214,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/5/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4215,
      edad: "69",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "NUEVO LAREDO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "NUEVO LAREDO",
      fecha_texto: "5/26/2025",
      mes_fecha: 5,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-26",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4216,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "H. MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/7/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4217,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "H. MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4218,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4219,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "SAN FERNANDO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "6/3/2025",
      mes_fecha: 6,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-03",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4220,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/19/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4221,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4222,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "5/4/2025",
      mes_fecha: 5,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-04",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/20/2021",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4223,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4224,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/10/2025",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-10",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/6/2020",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4225,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "6/10/2025",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-10",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4226,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4227,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4228,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/2/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4229,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/13/2025",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-13",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/28/2025",
      tipo_vacuna: "3",
      complicaciones: 4,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4230,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "NUEVO LAREDO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "NUEVO LAREDO",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4231,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4232,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "ALTAMIRA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "CD. MADERO",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4233,
      edad: "72",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4234,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4235,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/24/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4236,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "CD. MADERO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "CD. MADERO",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/8/2023",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4237,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "RIO BRAVO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "RIO BRAVO",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4238,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4239,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "NUEVO LAREDO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "NUEVO LAREDO",
      fecha_texto: "6/25/2025",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-25",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4240,
      edad: "69",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "H. MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/24/2025",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-24",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4241,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/25/2025",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-25",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4242,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "TAMPICO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "TAMPICO",
      fecha_texto: "6/25/2025",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-25",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/11/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4243,
      edad: "62",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "6/30/2025",
      mes_fecha: 6,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-30",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4244,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4245,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "NUEVO LAREDO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "NUEVO LAREDO",
      fecha_texto: "7/1/2025",
      mes_fecha: 7,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-01",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/25/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4246,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "RIO BRAVO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/23/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4247,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "NUEVO LAREDO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "NUEVO LAREDO",
      fecha_texto: "7/7/2025",
      mes_fecha: 7,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-07",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4248,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "RIO BRAVO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "RIO BRAVO",
      fecha_texto: "7/9/2025",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-09",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/9/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4249,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "RIO BRAVO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "RIO BRAVO",
      fecha_texto: "7/9/2025",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-09",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/6/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4250,
      edad: "73",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4251,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4252,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "ALTAMIRA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "TAMPICO",
      fecha_texto: "7/17/2025",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-17",
      anio_mes: "2025-07",
      institucion_notificacion: 4,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4253,
      edad: "66",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "7/19/2025",
      mes_fecha: 7,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-19",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4254,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "7/21/2025",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-21",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4255,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4256,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "7/22/2025",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-22",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4257,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "CD. VICTORIA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "CD. VICTORIA",
      fecha_texto: "7/22/2025",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-22",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "7/1/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4258,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "7/28/2025",
      mes_fecha: 7,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-28",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4259,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/11/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4260,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4261,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "NUEVO LAREDO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "NUEVO LAREDO",
      fecha_texto: "29/7/2025",
      mes_fecha: 29,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2027-05-07",
      anio_mes: "2027-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/9/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4262,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/15/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4263,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "CIUDAD MADERO",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/16/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4264,
      edad: "71",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4265,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "REYNOSA",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "REYNOSA",
      fecha_texto: "8/6/2025",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-06",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4266,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4267,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4268,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4269,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4270,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4271,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4272,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4273,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4274,
      edad: "64",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "MATAMOROS",
      fecha_texto: "8/11/2025",
      mes_fecha: 8,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-11",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4275,
      edad: "68",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MATAMOROS",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4276,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4277,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4278,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4279,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4280,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4281,
      edad: "56",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TAMAULIPAS",
      municipio_residencia: "MOAE681022MVZRGL08",
      estado_notificacion: "",
      municipio_notificacion: "",
      fecha_texto: "",
      mes_fecha: null,
      dia_fecha: null,
      anio_fecha: null,
      fecha_notificacion: "#NUM!",
      anio_mes: "#NUM!",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4282,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SAN PABLO DEL MONTE",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "SAN PABLO DEL MONTE",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4283,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "CHIAUTEMPAN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "3/2/2025",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-02",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4284,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUAMANTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "HUAMANTLA",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4285,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUAMANTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "HUAMANTLA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4286,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "CONTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "CONTLA",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4287,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "QUILEHTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4288,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "QUILEHTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4289,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "QUILEHTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4290,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "QUILEHTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4291,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TETLATLAHUCA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4292,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "CHIAUTEMPAN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "CHIAUTEMPAN",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4293,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "CHIAUTEMPAN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "CHIAUTEMPAN",
      fecha_texto: "3/16/2025",
      mes_fecha: 3,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-16",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4294,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "ZACATELCO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/17/2025",
      mes_fecha: 3,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-17",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4295,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TYAHUQUEMECAN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4296,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "APIZACO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "31/03/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4297,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "APETATITLAN DE ANTONIO CARVAJAL",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/15/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4298,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SAN PABLO DEL MONTE",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "SAN PABLO DEL MONTE",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4299,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "ZCATELCO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ZACATELCO",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4300,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SAN JUAN HUATZINGO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ZACATELCO",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/7/2020",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4301,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SAN JUAN HUATZINGO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ZACATELCO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/7/2020",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4302,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "APETATITLAN DE ANTONIO CARBAJAL",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4303,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "APIZACO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/5/1994",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4304,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "EL CARMEN AZTAMA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/3/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4305,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SANTA CATARINA AYOMETLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ZACATELCO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4306,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SAN JUAN HUATZINGO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ZACATELCO",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4307,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/19/2019",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4308,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "APIZACO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4309,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUAMANTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4310,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4311,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "LA MAGDALENA TLALTELULCO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/16/2025",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4312,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "ZACATELCO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ZACATELCO",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4313,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "NANACAMILPA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "CALPULALPAN",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/19/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4314,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4315,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "AMAXAC",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4316,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "AMAXAC",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4317,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "APIZACO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4318,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SAN MARTIN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "5/9/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4319,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4320,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4321,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SAN DAMIAN TLACOCALPAN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4322,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "PAPALOTLA DE XICOHTENCATL",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/20/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4323,
      edad: "56",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "IXTACUIXTLA DE MARIANO MATAMOROS",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4324,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "ZACATELCO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ZACATELCO",
      fecha_texto: "3/22/2025",
      mes_fecha: 3,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-22",
      anio_mes: "2025-03",
      institucion_notificacion: 4,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4325,
      edad: "63",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4326,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "XALTOCAN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "6/13/2013",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4327,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4328,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4329,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "APIZACO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/1/1988",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4330,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "CHIAUTEMPAN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/30/1971",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4331,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "APIZACO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/24/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4332,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "ZACATELCO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ZACATELCO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4333,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUAMANTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4334,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SAN SEBASTIAN TLACOTEPEC",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "4/18/2025",
      mes_fecha: 4,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-18",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4335,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ANTONIO CARVAJA",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4336,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "HUAMANTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/26/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4337,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "ESPAÑITA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4338,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4339,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "EMILIANO ZAPATA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ANTONIO CARVAJA",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4340,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TETLA DE LA SOLIDARIDAD",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "5/5/2025",
      mes_fecha: 5,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-05",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4341,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/18/2020",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4342,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "APIZACO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4343,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "CHIAUTEMPAN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "6/16/2025",
      mes_fecha: 6,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-16",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4344,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "CONTLA DE JUAN CUAMTZI",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/14/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4345,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "CONTLA DE JUAN CUAMTZI",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APETATITLAN DE ANTONIO CARVAJAL",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4346,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "YAUHQUEHMECAN",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "7/30/2012",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4347,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TETLA DE LA SOLIDARIDAD",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4348,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "APIZACO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "APIZACO",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4349,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SANTA QUILETLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ANTONIO CARVAJA",
      fecha_texto: "6/28/2025",
      mes_fecha: 6,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-28",
      anio_mes: "2025-06",
      institucion_notificacion: 5,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4350,
      edad: "56",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TLAXCALA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ANTONIO CARVAJA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4351,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "XALOZTOC",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ANTONIO CARVAJA",
      fecha_texto: "7/6/2025",
      mes_fecha: 7,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-06",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4352,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "EMILIANO ZAPATA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ANTONIO CARVAJA",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/28/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4353,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "CUAPIAXTLA",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ANTONIO CARVAJA",
      fecha_texto: "7/11/2025",
      mes_fecha: 7,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-11",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/28/2024",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4354,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "TOTOLAC",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "TLAXCALA",
      fecha_texto: "7/16/2025",
      mes_fecha: 7,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-16",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/1/2021",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4355,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "SAN PABLO DEL MONTE",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "SAN PABLO DEL MONTE",
      fecha_texto: "8/5/2025",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-05",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4356,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "ZACATELCO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ANTONIO CARVAJA",
      fecha_texto: "7/23/2025",
      mes_fecha: 7,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-23",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4357,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "TLAXCALA",
      municipio_residencia: "APIZACO",
      estado_notificacion: "TLAXCALA",
      municipio_notificacion: "ANTONIO CARVAJA",
      fecha_texto: "8/25/2025",
      mes_fecha: 8,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-25",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/10/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4358,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/16/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4359,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4360,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN ANDRES TUXTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SAN ANDRES TUXTLA",
      fecha_texto: "1/20/2025",
      mes_fecha: 1,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-20",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4361,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ANGEL R. CABADA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ANGEL R. CABDA",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/7/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4362,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 5,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4363,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "URSULO GALVAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "LA ANTIGUA",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/27/2022",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4364,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4365,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "JILOTEPEC",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/14/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4366,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CHICONTEPEC",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4367,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4368,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "16/12/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4369,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "2/4/2025",
      mes_fecha: 2,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-04",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4370,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TEOCELO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/28/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4371,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4372,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4373,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4374,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/27/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4375,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "2/5/2025",
      mes_fecha: 2,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-05",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4376,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MARTINEZ DE LA TORRE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "MARTINEZ DE LA TORRE",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/10/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4377,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MANLIO F ALTAMIRANO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/25/2024",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4378,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/27/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4379,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LAS CHOAPAS",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COATZACOALCOS",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4380,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LA ANTIGUA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "LA ANTIGUA",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/21/2022",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4381,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/27/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4382,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "2/11/2025",
      mes_fecha: 2,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-11",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4383,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4384,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LERDO DE TEJADA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "LERDO DE TEJADA",
      fecha_texto: "2/14/2025",
      mes_fecha: 2,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-14",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/03/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4385,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN ANDRES TUXTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SAN ANDRES TUXTLA",
      fecha_texto: "2/15/2025",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-15",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/13/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4386,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN ANDRES TUXTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SAN ANDRES TUXTLA",
      fecha_texto: "2/17/2025",
      mes_fecha: 2,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-17",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4387,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "URSULO GALVAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "LA ANTIGUA",
      fecha_texto: "2/21/2025",
      mes_fecha: 2,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-21",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/15/2009",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4388,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PEROTE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "PEROTE",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4389,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PEROTE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "PEROTE",
      fecha_texto: "2/25/2025",
      mes_fecha: 2,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-25",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/17/2025",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4390,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4391,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4392,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TUXPAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TUXPAN",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "27/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4393,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TUXPAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TUXPAN",
      fecha_texto: "2/27/2025",
      mes_fecha: 2,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-27",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "31/01/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4394,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CHICONQUIACO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/1/2025",
      mes_fecha: 3,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-01",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4395,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "EMILIANO ZAPATA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/2/2025",
      mes_fecha: 3,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-02",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4396,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PANUCO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "CIUDAD MADERO",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4397,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PANUCO",
      estado_notificacion: "TAMAULIPAS",
      municipio_notificacion: "CIUDAD MADERO",
      fecha_texto: "1/29/2025",
      mes_fecha: 1,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-29",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "07/01/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4398,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ACAYUCAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4399,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CORDOBA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "CORDOBA",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4400,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "02/09/2011",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4401,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN ANDRES TUXTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/27/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4402,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "BOCA DEL RIO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/10/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4403,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TUXPAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TUXPAN",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "11/12/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4404,
      edad: "19",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "BOCA DEL RIO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/4/2025",
      mes_fecha: 3,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-04",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/12/2009",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4405,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "BOCA DEL RIO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4406,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZACOALCOS",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COATZACOALCOS",
      fecha_texto: "3/7/2025",
      mes_fecha: 3,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-07",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/23/2021",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4407,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ACAYUCAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ACAYUCAN",
      fecha_texto: "3/8/2025",
      mes_fecha: 3,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-08",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/27/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4408,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ACAYUCAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ACAYUCAN",
      fecha_texto: "3/8/2025",
      mes_fecha: 3,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-08",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/11/2024",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4409,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "2/15/2025",
      mes_fecha: 2,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-15",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/8/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4410,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "06/04/1999",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4411,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "BOCA DEL RIO",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/5/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4412,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN ANDRES TUXTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SAN ANDRES TUXTLA",
      fecha_texto: "2/22/2025",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-22",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "19/09/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4413,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/21/2005",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4414,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XICO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/27/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4415,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LAS VIGAS DE RAMIREZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "12/5/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4416,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4417,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MEDELLIN DE BRAVO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4418,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CAZONES DE HERRERA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "3/6/2025",
      mes_fecha: 3,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-06",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4419,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TUXPAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TUXPAN",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/24/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4420,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MARTINEZ DE LA TORRE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "MARTINEZ DE LA TORRE",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/19/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4421,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN JUAN EVANGELISTA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SAN JUAN EVANGELISTA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4422,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN JUAN EVANGELISTA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SAN ANDRES TUXTLA",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4423,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LAS VIGAS DE RAMIREZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/18/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4424,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4425,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "6/20/2023",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4426,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ZONGOLICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ZONGOLICA",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4427,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "31/07/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4428,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MEDELLIN DE BRAVO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/18/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4429,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MINATITLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "MINATITLAN",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/25/2024",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4430,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/21/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4431,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4432,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/28/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4433,
      edad: "69",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4434,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "10/10/2017",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4435,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4436,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "10/30/2024",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4437,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZINTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4438,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "3/19/2025",
      mes_fecha: 3,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-19",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4439,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ACAYUCAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SAN ANDRES TUXTLA",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/17/2020",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4440,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN ANDRES TUXTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SAN ANDRES TUXTLA",
      fecha_texto: "3/16/2025",
      mes_fecha: 3,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-16",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4441,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COYUTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4442,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PEROTE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/23/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4443,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TUXPAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TUXPAN",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4444,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CAMERINO Z. MENDOZA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "8/16/2013",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4445,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CAZONES DE HERRERA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "3/23/2025",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-23",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/4/2025",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4446,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "18/08/2016",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4447,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4448,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/8/2020",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4449,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4450,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4451,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4452,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4453,
      edad: "52",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4454,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4455,
      edad: "70",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LA ANTIGUA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "LA ANTIGUA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/26/2019",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4456,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "EMILIANO ZAPATA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "LA ANTIGUA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4457,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/1/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4458,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4459,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4460,
      edad: "61",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4461,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "AMATLAN DE LOS REYES",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "CORDOBA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4462,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "NOGALES",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "MALTRATA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/1/2022",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4463,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ATZALAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ATZALAN",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/1/2023",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4464,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4465,
      edad: "12",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATEPEC",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4466,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4467,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "BOCA DEL RIO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "20/11/1989",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4468,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "HUATUSCO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "3/6/2024",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4469,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/26/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4470,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ATZALAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "3/28/2025",
      mes_fecha: 3,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-28",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/19/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4471,
      edad: "58",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4472,
      edad: "61",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4473,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/7/2025",
      tipo_vacuna: "2",
      complicaciones: 6,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4474,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "IXHUATLAN DEL CAFÉ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COSCOMATEPEC",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4475,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COTAXTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4476,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CORDOBA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "CORDOBA",
      fecha_texto: "3/26/2025",
      mes_fecha: 3,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-26",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/03/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4477,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LERDO DE TEJADA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SAN ANDRES TUXTLA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "8/31/2021",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4478,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ACAJETE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "2/14/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4479,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4480,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COXQUIHUI",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4481,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "20/11/1989",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4482,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4483,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LERDO DE TEJADA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SAN ANDRES TUXTLA",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4484,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MARIANO ESCOBEDO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4485,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PLAYA VICENTE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/28/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4486,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4487,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COXQUIHUI",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4488,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZACOALCOS",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "MINATITLAN",
      fecha_texto: "4/13/2025",
      mes_fecha: 4,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-13",
      anio_mes: "2025-04",
      institucion_notificacion: 7,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/8/2022",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4489,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "BOCA DEL RIO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/28/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4490,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/26/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4491,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "IXHUATLAN DE MADERO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "10/14/2024",
      tipo_vacuna: "2, 4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4492,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PAPANTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4493,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06/02/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4494,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4495,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "IXHUATLAN DEL CAFÉ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "CORDOBA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/31/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4496,
      edad: "82",
      grupo_edad: "80 - 84",
      demografia_edad: "MAYOR",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COXQUIHUI",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4497,
      edad: "57",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COXQUIHUI",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "4/7/2025",
      mes_fecha: 4,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-07",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4498,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LA PERLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/11/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4499,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/18/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4500,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PAPANTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "PAPANTLA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/16/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4501,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PAPANTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "PAPANTLA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/16/2025",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4502,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PEROTE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4503,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/5/2019",
      tipo_vacuna: "1,2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4504,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/6/2025",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4505,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CHONTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TUXPAN",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/11/2020",
      tipo_vacuna: "1",
      complicaciones: 9,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4506,
      edad: "18",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "8/16/2010",
      tipo_vacuna: "45689",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4507,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "30/10/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4508,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PAPANTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 1,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4509,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4510,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COXQUIHUI",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "4/30/2025",
      mes_fecha: 4,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-30",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/5/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4511,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "21/04/2021",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4512,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZINTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "28/03/2023",
      tipo_vacuna: "6",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4513,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4514,
      edad: "60",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "5/2/2025",
      mes_fecha: 5,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-02",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4515,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZINTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "21/10/2020",
      tipo_vacuna: "1-2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4516,
      edad: "68",
      grupo_edad: "65 - 69",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TIHUATLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4517,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4518,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4519,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4520,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "FORTIN DE LAS FLORES",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "CORDOBA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "21/05/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4521,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/25/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4522,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TIHUATLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA DE HGO",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/19/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4523,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "IXCATEPEC",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "IXCATEPEC",
      fecha_texto: "5/12/2025",
      mes_fecha: 5,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-12",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/6/2014",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4524,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZINTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA DE HGO",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "1/27/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4525,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "26/04/2024",
      tipo_vacuna: "1-2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4526,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZINTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "21/01/2018",
      tipo_vacuna: "1-2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4527,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TIHUATLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/01/2021",
      tipo_vacuna: "1-2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4528,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "BANDERILLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/14/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4529,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TIHUATLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA DE HGO",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "3/27/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4530,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZINTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA DE HGO",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4531,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA DE HGO",
      fecha_texto: "5/15/2025",
      mes_fecha: 5,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-15",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "5/18/2023",
      tipo_vacuna: "1,4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4532,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "CORDOBA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "CORDOBA",
      fecha_texto: "1/7/2025",
      mes_fecha: 1,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-07",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4533,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4534,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4535,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "URSULO GALVAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "LA ANTIGUA",
      fecha_texto: "5/22/2025",
      mes_fecha: 5,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-22",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/16/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4536,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "IXHUATLAN DE MADERO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "5/26/2025",
      mes_fecha: 5,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-26",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4537,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4538,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN ANDRES TUXTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SAN ANDRES TUXTLA",
      fecha_texto: "5/24/2025",
      mes_fecha: 5,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-24",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/13/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4539,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATEPEC",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "8/20/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4540,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZACOALCOS",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COATZACOALCOS",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "19/01/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4541,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/17/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4542,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "BOCA DEL RIO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4543,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TUXPAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TUXPAN",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "19/10/2023",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4544,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ALTO LUCERO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ALTO LUCERO",
      fecha_texto: "6/5/2025",
      mes_fecha: 6,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-05",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/28/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4545,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LERDO DE TEJADA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "LERDO DE TEJADA",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/9/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4546,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SAN ANDRES TUXTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "SAN ANDRES TUXTLA",
      fecha_texto: "6/5/2025",
      mes_fecha: 6,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-05",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/24/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4547,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "0",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4548,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TUXPAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TUXPAN",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/04/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4549,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "SANTIAGO SOCHIAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "6/10/2025",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-10",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/21/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4550,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "6/10/2025",
      mes_fecha: 6,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-10",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/9/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4551,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/8/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4552,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COACOTZINTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "6/12/2025",
      mes_fecha: 6,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-12",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/16/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4553,
      edad: "64",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TIHUATLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "6/16/2025",
      mes_fecha: 6,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-16",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4554,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ALVARADO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "LERDO DE TEJADA",
      fecha_texto: "6/11/2025",
      mes_fecha: 6,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-11",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4555,
      edad: "35",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TIHUATLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "6/20/2025",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-20",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4556,
      edad: "61",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TIHUATLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "6/20/2025",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-20",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4557,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4558,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "PAPANTLA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/17/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4559,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MARTINEZ DE LA TORRE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "MARTINEZ DE LA TORRE",
      fecha_texto: "6/19/2025",
      mes_fecha: 6,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-19",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "5/15/2024",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4560,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "6/20/2025",
      mes_fecha: 6,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-20",
      anio_mes: "2025-06",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/27/2009",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4561,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "6/25/2025",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-25",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "06/05/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4562,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATEPEC",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COATEPEC",
      fecha_texto: "6/27/2025",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-27",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4563,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "6/22/2025",
      mes_fecha: 6,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-22",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "9/24/2024",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4564,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATZACOALCOS",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COATZACOALCOS",
      fecha_texto: "6/27/2025",
      mes_fecha: 6,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-27",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "06/11/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4565,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "LA ANTIGUA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "LA ANTIGUA",
      fecha_texto: "6/26/2025",
      mes_fecha: 6,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-26",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4566,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ACULTZINGO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "NOGALES",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/23/2021",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4567,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "IXTACZOQUITLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "7/2/2025",
      mes_fecha: 7,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-02",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "6",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4568,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "7/9/2025",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-09",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/7/2025",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4569,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ORIZABA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ORIZABA",
      fecha_texto: "7/9/2025",
      mes_fecha: 7,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-09",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "12/13/2023",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4570,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ZONTECOMATLAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA DE HGO",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "9/5/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4571,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "6/24/2024",
      mes_fecha: 6,
      dia_fecha: 24,
      anio_fecha: 2024,
      fecha_notificacion: "2024-06-24",
      anio_mes: "2024-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/28/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4572,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4573,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "JUAN RODRIGUEZ CLARA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ISLA",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/25/2020",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4574,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "7/15/2025",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-15",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/20/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4575,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "JILOTEPEC",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "7/15/2025",
      mes_fecha: 7,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-15",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/23/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4576,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TAMIAHUA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TAMIAHUA",
      fecha_texto: "7/17/2025",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-17",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/13/2025",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4577,
      edad: "83",
      grupo_edad: "80 - 84",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ALAMO TEMAPACHE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ALAMO",
      fecha_texto: "7/17/2025",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-17",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4578,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "7/18/2025",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-18",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4579,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "9/29/2022",
      tipo_vacuna: "3",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4580,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TEQUILA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "ZONGOLICA",
      fecha_texto: "7/17/2025",
      mes_fecha: 7,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-17",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4581,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "7/14/2025",
      mes_fecha: 7,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-14",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "7/11/2024",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4582,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "7/31/2025",
      mes_fecha: 7,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-31",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4583,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "MARTINEZ DE LA TORRE",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "MARTINEZ DE LA TORRE",
      fecha_texto: "8/5/2025",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-05",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/24/2025",
      tipo_vacuna: "HEXAVALENTE",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4584,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TEZONAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "CORDOBA",
      fecha_texto: "8/6/2025",
      mes_fecha: 8,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-06",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/17/2021",
      tipo_vacuna: "1Y2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4585,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TUXPAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "TUXPAN",
      fecha_texto: "8/7/2025",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-07",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "12/30/1899",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4586,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "POZA RICA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "POZA RICA",
      fecha_texto: "8/1/2025",
      mes_fecha: 8,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-01",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "4/23/2023",
      tipo_vacuna: "1, 2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4587,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "TLILAPAN",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "RIO BLANCO",
      fecha_texto: "8/7/2025",
      mes_fecha: 8,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-07",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/4/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4588,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATEPEC",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "8/21/2025",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-21",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/15/2025",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4589,
      edad: "26",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "8/20/2025",
      mes_fecha: 8,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-20",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4590,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "ALTO LUCERO",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "8/25/2025",
      mes_fecha: 8,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-25",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/14/2025",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4591,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "VERACRUZ",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "VERACRUZ",
      fecha_texto: "8/28/2025",
      mes_fecha: 8,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-28",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/3/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4592,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATEPEC",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "COATEPEC",
      fecha_texto: "8/21/2025",
      mes_fecha: 8,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-21",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/15/2025",
      tipo_vacuna: "5",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4593,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "XALAPA",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "8/29/2025",
      mes_fecha: 8,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-29",
      anio_mes: "2025-08",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/20/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4594,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "VERACRUZ",
      municipio_residencia: "COATEPEC",
      estado_notificacion: "VERACRUZ",
      municipio_notificacion: "XALAPA",
      fecha_texto: "9/2/2025",
      mes_fecha: 9,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-02",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "3/11/2025",
      tipo_vacuna: "4",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4595,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "1/16/2025",
      mes_fecha: 1,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-16",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "2/4/2024",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4596,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MARIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "1/21/2025",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-21",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "6/24/2024",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4597,
      edad: "55",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "1/23/2025",
      mes_fecha: 1,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-23",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4598,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "1/24/2025",
      mes_fecha: 1,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-24",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/24/2024",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4599,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "1/26/2025",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-26",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "10/21/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4600,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4601,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "UMAN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "UMAN",
      fecha_texto: "1/30/2025",
      mes_fecha: 1,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-30",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/3/2025",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4602,
      edad: "29",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "KANASIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "KANASIN",
      fecha_texto: "2/10/2025",
      mes_fecha: 2,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-10",
      anio_mes: "2025-02",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4603,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TAHDZIU",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "PETO",
      fecha_texto: "1/12/2024",
      mes_fecha: 1,
      dia_fecha: 12,
      anio_fecha: 2024,
      fecha_notificacion: "2024-01-12",
      anio_mes: "2024-01",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4604,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4605,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "VALLADOLID",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "VALLADOLID",
      fecha_texto: "2/12/2025",
      mes_fecha: 2,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-12",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4606,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "KANTUNIL",
      estado_notificacion: "YUCATÁN",
      municipio_notificacion: "MOTUL",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4607,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "ESPITA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "ESPITA",
      fecha_texto: "3/5/2025",
      mes_fecha: 3,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-05",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4608,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "ESPITA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "ESPITA",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/13/2012",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4609,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "3/13/2025",
      mes_fecha: 3,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-13",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "10/2/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4610,
      edad: "46",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4611,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/17/2025",
      mes_fecha: 3,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-17",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4612,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4613,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4614,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4615,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "VALLADOLID",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "3/10/2025",
      mes_fecha: 3,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-10",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4616,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "UAYMA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "UAYMA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4617,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/21/2025",
      mes_fecha: 3,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-21",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4618,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4619,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "1/31/2025",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4620,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4621,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MOTUL",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4622,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4623,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "CHEMAX",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "VALLADOLID",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4624,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4625,
      edad: "7",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "3/31/2025",
      mes_fecha: 3,
      dia_fecha: 31,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-31",
      anio_mes: "2025-03",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "9/25/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4626,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "9/26/2019",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4627,
      edad: "23",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "UMAN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "UMAN",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4628,
      edad: "51",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "3/25/2025",
      mes_fecha: 3,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-25",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4629,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "ABALA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/5/2025",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-05",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4630,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "ABALA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/5/2025",
      mes_fecha: 4,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-05",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4631,
      edad: "60",
      grupo_edad: "60 - 64",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4632,
      edad: "36",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "KANASIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4633,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/3/2025",
      mes_fecha: 4,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-03",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4634,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "KANASIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4635,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "KANASIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4636,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "4/8/2025",
      mes_fecha: 4,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-08",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/16/2025",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4637,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4638,
      edad: "8",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "CHEMAX",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "CHEMAX",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/24/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4639,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "PETO",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/14/2025",
      mes_fecha: 4,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-14",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4640,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "4/10/2025",
      mes_fecha: 4,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-10",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "3/22/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4641,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "KANASIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/9/1905",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4642,
      edad: "59",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4643,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/1/2025",
      mes_fecha: 4,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-01",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4644,
      edad: "20",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/11/2025",
      mes_fecha: 4,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-11",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4645,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "7/3/1905",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4646,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "CHICHIMILA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "VALLADOLID",
      fecha_texto: "4/17/2025",
      mes_fecha: 4,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-17",
      anio_mes: "2025-04",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/7/2025",
      tipo_vacuna: "4",
      complicaciones: 1,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4647,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/21/2025",
      mes_fecha: 4,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-21",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4648,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4649,
      edad: "49",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4650,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/28/2025",
      mes_fecha: 4,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-28",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/25/2012",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4651,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "4/29/2025",
      mes_fecha: 4,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-29",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4652,
      edad: "14",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/6/2025",
      mes_fecha: 5,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-06",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4653,
      edad: "44",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "UMAN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "UMAN",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4654,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "VALLADOLID",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "VALLADOLID",
      fecha_texto: "5/4/2025",
      mes_fecha: 5,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-04",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4655,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/9/2025",
      mes_fecha: 5,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-09",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4656,
      edad: "22",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/13/2025",
      mes_fecha: 5,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-13",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4657,
      edad: "34",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 3,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4658,
      edad: "53",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4659,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/14/2025",
      mes_fecha: 5,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-14",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4660,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "UMAN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4661,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/20/2025",
      mes_fecha: 5,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-20",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4662,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "PETO",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "PETO",
      fecha_texto: "5/23/2025",
      mes_fecha: 5,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-23",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4663,
      edad: "5",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "5/25/2025",
      mes_fecha: 5,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-25",
      anio_mes: "2025-05",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/8/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4664,
      edad: "54",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MÉRIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4665,
      edad: "45",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/21/2025",
      mes_fecha: 5,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-21",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "9",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4666,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/19/2025",
      mes_fecha: 5,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-19",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4667,
      edad: "32",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/27/2025",
      mes_fecha: 5,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-27",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4668,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/2/2025",
      mes_fecha: 6,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-02",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/14/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4669,
      edad: "37",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4670,
      edad: "30",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "5/27/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4671,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "VALLADOLID",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "VALLADOLID",
      fecha_texto: "2/6/2025",
      mes_fecha: 2,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-06",
      anio_mes: "2025-02",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/23/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4672,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "KANASIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/5/2025",
      mes_fecha: 6,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-05",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4673,
      edad: "43",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/9/2025",
      mes_fecha: 6,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-09",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4674,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4675,
      edad: "73",
      grupo_edad: "70 - 74",
      demografia_edad: "MAYOR",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4676,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4677,
      edad: "21",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4678,
      edad: "38",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/13/2025",
      mes_fecha: 6,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-13",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4679,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/16/2025",
      mes_fecha: 6,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-16",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/30/2022",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4680,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "VALLADOLID",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4681,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MOTUL",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/16/2025",
      mes_fecha: 6,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-16",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "6",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4682,
      edad: "42",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4683,
      edad: "13",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/25/2025",
      mes_fecha: 6,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-25",
      anio_mes: "2025-06",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "12/31/1899",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4684,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "PROGRESO",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/14/2025",
      mes_fecha: 6,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-14",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4685,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "VALLADOLID",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "VALLADOLID",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "12/7/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4686,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TEKIT",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "6/29/2025",
      mes_fecha: 6,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-29",
      anio_mes: "2025-06",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "4/25/2025",
      tipo_vacuna: "2",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4687,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "KANASIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "7/13/2025",
      mes_fecha: 7,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-13",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "6/24/2025",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4688,
      edad: "6",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "7/18/2025",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-18",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4689,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "7/18/2025",
      mes_fecha: 7,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-18",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "5/8/2008",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4690,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "11/28/2024",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4691,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "12/12/2014",
      tipo_vacuna: "1 y 2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4692,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4693,
      edad: "9",
      grupo_edad: "5 - 9",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "8/21/2018",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4694,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/21/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4695,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "7/20/2025",
      mes_fecha: 7,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-20",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "6/10/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4696,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "7/10/2025",
      mes_fecha: 7,
      dia_fecha: 10,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-10",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "4/10/2015",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4697,
      edad: "50",
      grupo_edad: "50 - 54",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "7/22/2025",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-22",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/5/1905",
      tipo_vacuna: "3",
      complicaciones: 2,
      evolucion: 1,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4698,
      edad: "10",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "7/21/2025",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-21",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4699,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "KANASIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "7/21/2025",
      mes_fecha: 7,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-21",
      anio_mes: "2025-07",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "6/14/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4700,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "TIZIMIN",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "TIZIMIN",
      fecha_texto: "8/2/2025",
      mes_fecha: 8,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-02",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "5",
      complicaciones: 1,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4701,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "PROGRESO",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "8/18/2025",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-18",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4702,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "8/25/2025",
      mes_fecha: 8,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-25",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "7/26/2025",
      tipo_vacuna: "4",
      complicaciones: 2,
      evolucion: 4,
      ev_etiqueta: "HOSPITALIZADO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4703,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "HUNUCMA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "8/18/2025",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-18",
      anio_mes: "2025-08",
      institucion_notificacion: 1,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4704,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "YUCATAN",
      municipio_residencia: "MERIDA",
      estado_notificacion: "YUCATAN",
      municipio_notificacion: "MERIDA",
      fecha_texto: "9/8/2025",
      mes_fecha: 9,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-08",
      anio_mes: "2025-09",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "9",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4705,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "NOCHISTLAN",
      estado_notificacion: "AGUASCALIENTES",
      municipio_notificacion: "AGUASCALIENTES",
      fecha_texto: "1/8/2025",
      mes_fecha: 1,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-08",
      anio_mes: "2025-01",
      institucion_notificacion: 1,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "4/2/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4706,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "LORETO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "LORETO",
      fecha_texto: "1/5/2025",
      mes_fecha: 1,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-05",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4707,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "JALPA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "JALPA",
      fecha_texto: "1/21/2025",
      mes_fecha: 1,
      dia_fecha: 21,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-21",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/3/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4708,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "1/26/2025",
      mes_fecha: 1,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-26",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4709,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "1/13/2025",
      mes_fecha: 1,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-13",
      anio_mes: "2025-01",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/25/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4710,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "SAIN ALTO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "1/27/2025",
      mes_fecha: 1,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-27",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/16/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4711,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "1/28/2025",
      mes_fecha: 1,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-01-28",
      anio_mes: "2025-01",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4712,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "2/3/2025",
      mes_fecha: 2,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-03",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4713,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "2/9/2025",
      mes_fecha: 2,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-09",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4714,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "2/9/2025",
      mes_fecha: 2,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-09",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4715,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "JEREZ",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "JEREZ",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/24/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4716,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "CALERA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/13/2025",
      mes_fecha: 2,
      dia_fecha: 13,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-13",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4717,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "LORETO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "2/18/2025",
      mes_fecha: 2,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-18",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4718,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "LORETO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "LORETO",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4719,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "SAIN ALTO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/29/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4720,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "LORETO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "LORETO",
      fecha_texto: "2/23/2025",
      mes_fecha: 2,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-23",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4721,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "MIGUEL AUZA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "2/22/2025",
      mes_fecha: 2,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-22",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4722,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "TRANCOSO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "2/26/2025",
      mes_fecha: 2,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-26",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4723,
      edad: "17",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "JEREZ",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "JEREZ",
      fecha_texto: "2/20/2025",
      mes_fecha: 2,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-02-20",
      anio_mes: "2025-02",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4724,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/1/2025",
      mes_fecha: 3,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-01",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4725,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "PANUCO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4726,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4727,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4728,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "3/3/2025",
      mes_fecha: 3,
      dia_fecha: 3,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-03",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4729,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "TEPETONGO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "JEREZ",
      fecha_texto: "3/11/2025",
      mes_fecha: 3,
      dia_fecha: 11,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-11",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4730,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/9/2025",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-09",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "1/20/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4731,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VALPARAISO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "3/9/2025",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-09",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4732,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "OJOCALIENTE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "OJOCALIENTE",
      fecha_texto: "3/12/2025",
      mes_fecha: 3,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-12",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4733,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA GONZALEZ ORTEGA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "LORETO",
      fecha_texto: "3/9/2025",
      mes_fecha: 3,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-09",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "8/12/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4734,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "OJOCALIENTE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/24/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4735,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/16/2025",
      mes_fecha: 3,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-16",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/16/2023",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4736,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GENARO CODINA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "0",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4737,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "",
      fecha_ultima_dosis: "4/4/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4738,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA DE RAMOS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "1",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4739,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "CALERA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4740,
      edad: "33",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4741,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "2/22/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4742,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/24/2025",
      mes_fecha: 3,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-24",
      anio_mes: "2025-03",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/10/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4743,
      edad: "11",
      grupo_edad: "10 - 14",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "3/20/2025",
      mes_fecha: 3,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-20",
      anio_mes: "2025-03",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "5/30/2018",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4744,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "PINOS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "PINOS",
      fecha_texto: "3/18/2025",
      mes_fecha: 3,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-18",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4745,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "3/23/2025",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-23",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4746,
      edad: "3",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "3/23/2025",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-23",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4747,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA DE COS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "3/23/2025",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-23",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4748,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA GARCIA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "LORETO",
      fecha_texto: "3/23/2025",
      mes_fecha: 3,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-23",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "2/17/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4749,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA NUEVA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "VILLA NUEVA",
      fecha_texto: "3/14/2025",
      mes_fecha: 3,
      dia_fecha: 14,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-14",
      anio_mes: "2025-03",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/18/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4750,
      edad: "40",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "3/27/2025",
      mes_fecha: 3,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-03-27",
      anio_mes: "2025-03",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "12/15/2022",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4751,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "OJOCALIENTE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "4/2/2025",
      mes_fecha: 4,
      dia_fecha: 2,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-02",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "11/19/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4752,
      edad: "31",
      grupo_edad: "30 - 34",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "4/4/2025",
      mes_fecha: 4,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-04",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4753,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "4/6/2025",
      mes_fecha: 4,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-06",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 3,
      ev_etiqueta: "DEFUNCION",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4754,
      edad: "4",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "4/6/2025",
      mes_fecha: 4,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-06",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "5",
      fecha_ultima_dosis: "11/28/2025",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4755,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "4/9/2025",
      mes_fecha: 4,
      dia_fecha: 9,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-09",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4756,
      edad: "39",
      grupo_edad: "35 - 39",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "4/15/2025",
      mes_fecha: 4,
      dia_fecha: 15,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-15",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4757,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "MIGUEL AUZA",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "2",
      fecha_ultima_dosis: "10/15/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4758,
      edad: "28",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "4/22/2025",
      mes_fecha: 4,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-22",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4759,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "4/23/2025",
      mes_fecha: 4,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-23",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 1,
      dosis_vacuna: "3",
      fecha_ultima_dosis: "5/14/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4760,
      edad: "27",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "4/24/2025",
      mes_fecha: 4,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-24",
      anio_mes: "2025-04",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4761,
      edad: "56",
      grupo_edad: "55 - 59",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "4/25/2025",
      mes_fecha: 4,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-25",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4762,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "RIO GRANDE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "RIO GRANDE",
      fecha_texto: "4/27/2025",
      mes_fecha: 4,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-27",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "4/18/2025",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4763,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "RIO GRANDE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "RIO GRANDE",
      fecha_texto: "4/27/2025",
      mes_fecha: 4,
      dia_fecha: 27,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-27",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4764,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA DE COS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "VILLA DE COS",
      fecha_texto: "5/7/2025",
      mes_fecha: 5,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-07",
      anio_mes: "2025-05",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/27/2025",
      tipo_vacuna: "2",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4765,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "SOMBRERETE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "SOMBRERETE",
      fecha_texto: "4/16/2025",
      mes_fecha: 4,
      dia_fecha: 16,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-16",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "2/23/2024",
      tipo_vacuna: "2",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4766,
      edad: "15",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "4/26/2025",
      mes_fecha: 4,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-04-26",
      anio_mes: "2025-04",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4767,
      edad: "41",
      grupo_edad: "40 - 44",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "5/8/2025",
      mes_fecha: 5,
      dia_fecha: 8,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-08",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4768,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "6/1/2025",
      mes_fecha: 6,
      dia_fecha: 1,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-01",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4769,
      edad: "48",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "5/29/2025",
      mes_fecha: 5,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-29",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4770,
      edad: "25",
      grupo_edad: "25 - 29",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "5/28/2025",
      mes_fecha: 5,
      dia_fecha: 28,
      anio_fecha: 2025,
      fecha_notificacion: "2025-05-28",
      anio_mes: "2025-05",
      institucion_notificacion: 2,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4771,
      edad: "24",
      grupo_edad: "20 - 24",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "6/4/2025",
      mes_fecha: 6,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-04",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4772,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "SAIN ALTO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "6/5/2025",
      mes_fecha: 6,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-05",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 9,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4773,
      edad: "1",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "ZACATECAS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "6/6/2025",
      mes_fecha: 6,
      dia_fecha: 6,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-06",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4774,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "GUADALUPE",
      fecha_texto: "6/18/2025",
      mes_fecha: 6,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-18",
      anio_mes: "2025-06",
      institucion_notificacion: 3,
      vacunado: 1,
      dosis_vacuna: "4",
      fecha_ultima_dosis: "1/1/2010",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4775,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "6/17/2025",
      mes_fecha: 6,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-06-17",
      anio_mes: "2025-06",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4776,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "7/7/2025",
      mes_fecha: 7,
      dia_fecha: 7,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-07",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4777,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "GUADALUPE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "7/4/2025",
      mes_fecha: 7,
      dia_fecha: 4,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-04",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4778,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "7/12/2025",
      mes_fecha: 7,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-12",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4779,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "RIO GRANDE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "RIO GRANDE",
      fecha_texto: "7/22/2025",
      mes_fecha: 7,
      dia_fecha: 22,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-22",
      anio_mes: "2025-07",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "1",
      fecha_ultima_dosis: "7/2/2025",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4780,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "TRANCOSO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "7/29/2025",
      mes_fecha: 7,
      dia_fecha: 29,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-29",
      anio_mes: "2025-07",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4781,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "8/5/2025",
      mes_fecha: 8,
      dia_fecha: 5,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-05",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4782,
      edad: "47",
      grupo_edad: "45 - 49",
      demografia_edad: "ADULTO",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "7/30/2025",
      mes_fecha: 7,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-07-30",
      anio_mes: "2025-07",
      institucion_notificacion: 2,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4783,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "8/12/2025",
      mes_fecha: 8,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-12",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 9,
      evolucion: 9,
      ev_etiqueta: "OTRO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4784,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "RIO GRANDE",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "RIO GRANDE",
      fecha_texto: "8/12/2025",
      mes_fecha: 8,
      dia_fecha: 12,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-12",
      anio_mes: "2025-08",
      institucion_notificacion: 5,
      vacunado: 1,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4785,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "8/18/2025",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-18",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4786,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "8/18/2025",
      mes_fecha: 8,
      dia_fecha: 18,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-18",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4787,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA DE COS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "8/23/2025",
      mes_fecha: 8,
      dia_fecha: 23,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-23",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4788,
      edad: "16",
      grupo_edad: "15 - 19",
      demografia_edad: "ADULTO",
      sexo: 1,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "VILLA DE COS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "8/24/2025",
      mes_fecha: 8,
      dia_fecha: 24,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-24",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4789,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "8/26/2025",
      mes_fecha: 8,
      dia_fecha: 26,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-26",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4790,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "8/30/2025",
      mes_fecha: 8,
      dia_fecha: 30,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-30",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4791,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "8/25/2025",
      mes_fecha: 8,
      dia_fecha: 25,
      anio_fecha: 2025,
      fecha_notificacion: "2025-08-25",
      anio_mes: "2025-08",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4792,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "9/17/2025",
      mes_fecha: 9,
      dia_fecha: 17,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-17",
      anio_mes: "2025-09",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4793,
      edad: "2",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "MORELOS",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "ZACATECAS",
      fecha_texto: "9/19/2025",
      mes_fecha: 9,
      dia_fecha: 19,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-19",
      anio_mes: "2025-09",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
    {
      anio: 2025,
      fila_archivo: 4794,
      edad: "0",
      grupo_edad: "< 5",
      demografia_edad: "JOVEN",
      sexo: 2,
      entidad_residencia: "ZACATECAS",
      municipio_residencia: "FRESNILLO",
      estado_notificacion: "ZACATECAS",
      municipio_notificacion: "FRESNILLO",
      fecha_texto: "9/20/2025",
      mes_fecha: 9,
      dia_fecha: 20,
      anio_fecha: 2025,
      fecha_notificacion: "2025-09-20",
      anio_mes: "2025-09",
      institucion_notificacion: 20,
      vacunado: 2,
      dosis_vacuna: "0",
      fecha_ultima_dosis: "",
      tipo_vacuna: "",
      complicaciones: 2,
      evolucion: 2,
      ev_etiqueta: "SANO",
      clasificacion: "EN ESTUDIO",
    },
  ];
  const arreglo2025 = [
 {
   "anio": 2018,
   "fila_archivo": 2,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/26/2018",
   "mes_fecha": 1,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-26",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 3,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/26/2018",
   "mes_fecha": 1,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-26",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 4,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/26/2018",
   "mes_fecha": 11,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-26",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 6,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "JESUS MARIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/9/2018",
   "mes_fecha": 2,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-09",
   "anio_mes": "2018-02",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 7,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/30/2018",
   "mes_fecha": 4,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-30",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 9,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/21/2018",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-21",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 11,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/3/2018",
   "mes_fecha": 4,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-03",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "15/03/2018",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 12,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/16/2018",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-16",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 15,
   "edad": "32",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/22/2018",
   "mes_fecha": 10,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-22",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 17,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/3/2018",
   "mes_fecha": 7,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-03",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "14/06/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 19,
   "edad": "39",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/29/2018",
   "mes_fecha": 8,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-29",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 20,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/2/2018",
   "mes_fecha": 2,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-02",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 21,
   "edad": "17",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/2/2018",
   "mes_fecha": 2,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-02",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "02/02/2005",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 22,
   "edad": "17",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/2/2018",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-02",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 23,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "PABERLLON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/21/2018",
   "mes_fecha": 5,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-21",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "23/04/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 25,
   "edad": "22",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/26/2018",
   "mes_fecha": 1,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-26",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 26,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/2/2018",
   "mes_fecha": 2,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-02",
   "anio_mes": "2018-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 27,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/2/2018",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-02",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "27/03/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 28,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/22/2018",
   "mes_fecha": 10,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-22",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "23/04/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 29,
   "edad": "8",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/22/2018",
   "mes_fecha": 10,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-22",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "01/04/2018",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 30,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/22/2018",
   "mes_fecha": 10,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-22",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "23/04/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 33,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "EL LLANO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/4/2018",
   "mes_fecha": 4,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-04",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 34,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/22/2018",
   "mes_fecha": 10,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-22",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 35,
   "edad": "53",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/22/2018",
   "mes_fecha": 10,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-22",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 36,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/7/2018",
   "mes_fecha": 12,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-07",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 37,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/17/2018",
   "mes_fecha": 5,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-17",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 38,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/17/2018",
   "mes_fecha": 5,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-17",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 39,
   "edad": "21",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/17/2018",
   "mes_fecha": 5,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-17",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 40,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/17/2018",
   "mes_fecha": 5,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-17",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 42,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/29/2018",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-29",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "01/01/2017",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 44,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/24/2018",
   "mes_fecha": 9,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-24",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 45,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/13/2018",
   "mes_fecha": 9,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-13",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 46,
   "edad": "19",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/12/2018",
   "mes_fecha": 11,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-12",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 48,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/29/2018",
   "mes_fecha": 8,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-29",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 50,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "SAN FRANSCO DE LOS ROMO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/14/2018",
   "mes_fecha": 2,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-14",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 51,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "SAN FRANSCO DE LOS ROMO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/4/2018",
   "mes_fecha": 9,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-04",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "31/08/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 54,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/27/2018",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-27",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 57,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/12/2018",
   "mes_fecha": 11,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-12",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 60,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/25/2018",
   "mes_fecha": 12,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-25",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 62,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/15/2018",
   "mes_fecha": 10,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-15",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 63,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "CALVILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/12/2018",
   "mes_fecha": 9,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-12",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 64,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/10/2018",
   "mes_fecha": 5,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-10",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "16/04/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 65,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "JESUS MARIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/17/2018",
   "mes_fecha": 5,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-17",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "06/04/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 66,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/2/2018",
   "mes_fecha": 10,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-02",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 70,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/21/2018",
   "mes_fecha": 8,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-21",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 74,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/19/2018",
   "mes_fecha": 4,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-19",
   "anio_mes": "2018-04",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "10/2/2016",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 75,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/16/2018",
   "mes_fecha": 2,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-16",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 77,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/2/2018",
   "mes_fecha": 2,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-02",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 78,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/12/2018",
   "mes_fecha": 2,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-12",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 79,
   "edad": "29",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/15/2018",
   "mes_fecha": 2,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-15",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 80,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TECATE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/17/2018",
   "mes_fecha": 9,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-17",
   "anio_mes": "2018-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 82,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/18/2018",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-18",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 83,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/8/2018",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-08",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 88,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/27/2018",
   "mes_fecha": 7,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-27",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 90,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/13/2018",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-13",
   "anio_mes": "2018-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "1/26/2012",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 93,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/9/2018",
   "mes_fecha": 4,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-09",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "1/13/2018",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 94,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/15/2018",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-15",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 95,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/2/2018",
   "mes_fecha": 10,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-02",
   "anio_mes": "2018-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 96,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/14/2018",
   "mes_fecha": 2,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-14",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 100,
   "edad": "18",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/27/2018",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-27",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 101,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/9/2018",
   "mes_fecha": 1,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-09",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 102,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/11/2018",
   "mes_fecha": 12,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-11",
   "anio_mes": "2018-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "6/12/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 103,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/28/2018",
   "mes_fecha": 3,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-28",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 105,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/13/2018",
   "mes_fecha": 12,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-13",
   "anio_mes": "2018-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/22/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 107,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/12/2018",
   "mes_fecha": 1,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-12",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 108,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/30/2018",
   "mes_fecha": 5,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-30",
   "anio_mes": "2018-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 109,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/17/2018",
   "mes_fecha": 9,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-17",
   "anio_mes": "2018-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 110,
   "edad": "55",
   "grupo_edad": "55 - 59",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/24/2018",
   "mes_fecha": 5,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-24",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 112,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/31/2018",
   "mes_fecha": 5,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-31",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 116,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/27/2018",
   "mes_fecha": 8,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-27",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 118,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/14/2018",
   "mes_fecha": 11,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-14",
   "anio_mes": "2018-11",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "8/14/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 121,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/11/2018",
   "mes_fecha": 6,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-11",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 124,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "PLAYAS DE ROSARITO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/7/2018",
   "mes_fecha": 6,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-07",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 6,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 126,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/26/2018",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-26",
   "anio_mes": "2018-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 127,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/20/2018",
   "mes_fecha": 12,
   "dia_fecha": 20,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-20",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/5/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 129,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/12/2018",
   "mes_fecha": 1,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-12",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 130,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/30/2018",
   "mes_fecha": 5,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-30",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 131,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/13/2018",
   "mes_fecha": 12,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-13",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "6/1/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 132,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/25/2018",
   "mes_fecha": 1,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-25",
   "anio_mes": "2018-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 133,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/18/2018",
   "mes_fecha": 4,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-18",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 134,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/10/2018",
   "mes_fecha": 10,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-10",
   "anio_mes": "2018-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 136,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/22/2018",
   "mes_fecha": 5,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-22",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 137,
   "edad": "27",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/6/2018",
   "mes_fecha": 6,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-06",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 138,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/14/2018",
   "mes_fecha": 6,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-14",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 139,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/21/2018",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-21",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 140,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "PLAYAS DE ROSARITO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/10/2019",
   "mes_fecha": 1,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-10",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 141,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/6/2018",
   "mes_fecha": 12,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-06",
   "anio_mes": "2018-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "8/21/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 143,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/26/2018",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-26",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 146,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LOS CABOS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/15/2018",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-15",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 147,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LOS CABOS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/22/2018",
   "mes_fecha": 5,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-22",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 148,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LOS CABOS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/19/2018",
   "mes_fecha": 11,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-19",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 149,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/1/2018",
   "mes_fecha": 2,
   "dia_fecha": 1,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-01",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 152,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/3/2018",
   "mes_fecha": 12,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-03",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 154,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/28/2018",
   "mes_fecha": 3,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-28",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 156,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LOS CABOS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/23/2018",
   "mes_fecha": 5,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-23",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 158,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LOS CABOS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/26/2018",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-26",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 159,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/11/2018",
   "mes_fecha": 7,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-11",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 160,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LOS CABOS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/29/2018",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-29",
   "anio_mes": "2018-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 162,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/7/2018",
   "mes_fecha": 6,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-07",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "5/24/2018",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 164,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CAMPECHE",
   "municipio_residencia": "CHAMPOTON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/22/2018",
   "mes_fecha": 5,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-22",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 166,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CAMPECHE",
   "municipio_residencia": "ESCARCEGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/9/2018",
   "mes_fecha": 1,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-09",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 173,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CAMPECHE",
   "municipio_residencia": "CARMEN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/10/2018",
   "mes_fecha": 7,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-10",
   "anio_mes": "2018-07",
   "institucion_notificacion": 7,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "03/08/2016",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 179,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/10/2018",
   "mes_fecha": 9,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-10",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 181,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VILLAFLORES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/23/2018",
   "mes_fecha": 11,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-23",
   "anio_mes": "2018-11",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/1/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 182,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "PIJIJIAPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/21/2018",
   "mes_fecha": 1,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-21",
   "anio_mes": "2018-01",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 183,
   "edad": "32",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SUCHIAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/24/2018",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-24",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 184,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SUCHIAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/24/2018",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-24",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 185,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "COMITAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/17/2018",
   "mes_fecha": 4,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-17",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 187,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CACAHOATAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/19/2018",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-19",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 188,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUZANTAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/5/2018",
   "mes_fecha": 6,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-05",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "10/26/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 190,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/12/2018",
   "mes_fecha": 9,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-12",
   "anio_mes": "2018-09",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 192,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/18/2018",
   "mes_fecha": 4,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-18",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 6,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 193,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TAPACHULA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/16/2018",
   "mes_fecha": 7,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-16",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 195,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OCOZOCUAUTLA DE ESPINOSA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/23/2018",
   "mes_fecha": 4,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-23",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 197,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "MARGARITAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/1/2018",
   "mes_fecha": 10,
   "dia_fecha": 1,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-01",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 200,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "COMITAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/2/2018",
   "mes_fecha": 9,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-02",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 201,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/19/2018",
   "mes_fecha": 6,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-19",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 202,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "LA CONCORDIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/5/2018",
   "mes_fecha": 9,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-05",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 203,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SAN CRISTOBAL DE LAS CASAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/19/2018",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-19",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 208,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "MARGARITAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/3/2018",
   "mes_fecha": 9,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-03",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 209,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/2/2018",
   "mes_fecha": 7,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-02",
   "anio_mes": "2018-07",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "6/11/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 213,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "COMITAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/14/2018",
   "mes_fecha": 6,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-14",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 215,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TAPACHULA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/27/2018",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-27",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 216,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/2/2018",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-02",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 218,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "ACAPETAHUA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/8/2018",
   "mes_fecha": 8,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-08",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 233,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/21/2018",
   "mes_fecha": 5,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-21",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 251,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/4/2018",
   "mes_fecha": 4,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-04",
   "anio_mes": "2018-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 252,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/15/2018",
   "mes_fecha": 5,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-15",
   "anio_mes": "2018-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 258,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/18/2018",
   "mes_fecha": 1,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-18",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 262,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CARICHI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/13/2018",
   "mes_fecha": 4,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-13",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 266,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/21/2018",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-21",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 274,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/20/2019",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-20",
   "anio_mes": "2019-01",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 296,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/17/2018",
   "mes_fecha": 4,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-17",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 304,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/14/2018",
   "mes_fecha": 5,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-14",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 306,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "TORREON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/24/2018",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-24",
   "anio_mes": "2018-02",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 311,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/16/2018",
   "mes_fecha": 1,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-16",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 315,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/23/2018",
   "mes_fecha": 3,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-23",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 316,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "ARTEAGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/11/2018",
   "mes_fecha": 12,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-11",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 320,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/8/2018",
   "mes_fecha": 8,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-08",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 321,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "TORREON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/6/2018",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-06",
   "anio_mes": "2018-02",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 325,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "TORREON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/30/2018",
   "mes_fecha": 3,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-30",
   "anio_mes": "2018-03",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 326,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/27/2018",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-27",
   "anio_mes": "2018-03",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "02/03/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 327,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/17/2018",
   "mes_fecha": 5,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-17",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 328,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/11/2018",
   "mes_fecha": 12,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-11",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 329,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "ARTEAGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/3/2019",
   "mes_fecha": 1,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-03",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 330,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "TORREON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/18/2018",
   "mes_fecha": 4,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-18",
   "anio_mes": "2018-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 332,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/7/2019",
   "mes_fecha": 1,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-07",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "04/09/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 336,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/12/2018",
   "mes_fecha": 1,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-12",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 338,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "ALLENDE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/20/2018",
   "mes_fecha": 2,
   "dia_fecha": 20,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-20",
   "anio_mes": "2018-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 344,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/31/2018",
   "mes_fecha": 5,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-31",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 345,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/6/2018",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-06",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 347,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/7/2018",
   "mes_fecha": 8,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-07",
   "anio_mes": "2018-08",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 349,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/7/2018",
   "mes_fecha": 3,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-07",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 353,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/5/2018",
   "mes_fecha": 1,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-05",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 357,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/1/2018",
   "mes_fecha": 2,
   "dia_fecha": 1,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-01",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 358,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/13/2018",
   "mes_fecha": 4,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-13",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 359,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/24/2019",
   "mes_fecha": 9,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-24",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 361,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "RAMOS ARIZPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/10/2018",
   "mes_fecha": 4,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-10",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 363,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/4/2018",
   "mes_fecha": 1,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-04",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 364,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "RAMOS ARIZPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/21/2018",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-21",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 365,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/8/2019",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-08",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 366,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "FRONTERA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/27/2018",
   "mes_fecha": 4,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-27",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 369,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SAN PEDRO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/8/2019",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-08",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 374,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COLIMA",
   "municipio_residencia": "VILLA DE ALVAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/22/2018",
   "mes_fecha": 5,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-22",
   "anio_mes": "2018-05",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 377,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COLIMA",
   "municipio_residencia": "COLIMA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/6/2018",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-06",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 379,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COLIMA",
   "municipio_residencia": "TECOMÁN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/19/2018",
   "mes_fecha": 4,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-19",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 382,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "COYOACAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/27/2018",
   "mes_fecha": 7,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-27",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "2/2/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 384,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MAGDALENA CONTRERAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/12/2018",
   "mes_fecha": 12,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-12",
   "anio_mes": "2018-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 388,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTACALCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/10/2018",
   "mes_fecha": 9,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-10",
   "anio_mes": "2018-09",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "11/17/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 389,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/4/2018",
   "mes_fecha": 7,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-04",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "5/14/2018",
   "tipo_vacuna": "2",
   "complicaciones": 6,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 390,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "COYOACAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/27/2018",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-27",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "3/16/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 392,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/13/2018",
   "mes_fecha": 9,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-13",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "IGN",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 395,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/7/2018",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-07",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1/19/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 396,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/13/2018",
   "mes_fecha": 6,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-13",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "NO RECUERDA FECHA",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 397,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/3/2018",
   "mes_fecha": 12,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-03",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 400,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/2/2018",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-02",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "3/6/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 402,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/22/2018",
   "mes_fecha": 2,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-22",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 404,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/24/2018",
   "mes_fecha": 8,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-24",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 405,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/30/2018",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-30",
   "anio_mes": "2018-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 406,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/15/2018",
   "mes_fecha": 6,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-15",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 407,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/4/2018",
   "mes_fecha": 9,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-04",
   "anio_mes": "2018-09",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "6/23/2018",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 408,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "COYOACAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/14/2018",
   "mes_fecha": 10,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-14",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 410,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/15/2018",
   "mes_fecha": 6,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-15",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/18/2018",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 413,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/19/2018",
   "mes_fecha": 7,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-19",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 414,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/2/2018",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-02",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 416,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/18/2018",
   "mes_fecha": 5,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-18",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 417,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/17/2018",
   "mes_fecha": 12,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-17",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 419,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MILPA ALTA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/4/2018",
   "mes_fecha": 9,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-04",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "6/26/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 420,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/20/2018",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-20",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "6",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 421,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/8/2018",
   "mes_fecha": 3,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-08",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 422,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/14/2018",
   "mes_fecha": 5,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-14",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 427,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/24/2018",
   "mes_fecha": 4,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-24",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/28/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 428,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MAGDALENA CONTRERAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/16/2018",
   "mes_fecha": 10,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-16",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 430,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/6/2018",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-06",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/7/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 433,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "COYOACAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/6/2018",
   "mes_fecha": 11,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-06",
   "anio_mes": "2018-11",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "9/4/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 434,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/4/2018",
   "mes_fecha": 5,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-04",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/16/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 436,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/11/2018",
   "mes_fecha": 12,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-11",
   "anio_mes": "2018-12",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/28/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 439,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/28/2018",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-28",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/26/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 440,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MIGUEL HIDALGO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/18/2018",
   "mes_fecha": 4,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-18",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/20/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 441,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/3/2018",
   "mes_fecha": 9,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-03",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 448,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MIGUEL HIDALGO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/12/2018",
   "mes_fecha": 3,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-12",
   "anio_mes": "2018-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "7/20/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 455,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "CUAJIMALPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/9/2018",
   "mes_fecha": 10,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-09",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 459,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/13/2018",
   "mes_fecha": 8,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-13",
   "anio_mes": "2018-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 462,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MAGDALENA CONTRERAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/15/2018",
   "mes_fecha": 8,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-15",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 464,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/18/2018",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-18",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "1/9/2018",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 467,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/15/2018",
   "mes_fecha": 3,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-15",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 471,
   "edad": "19",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/13/2018",
   "mes_fecha": 3,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-13",
   "anio_mes": "2018-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "3/13/2005",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 472,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/26/2018",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-26",
   "anio_mes": "2018-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 474,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/18/2018",
   "mes_fecha": 9,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-18",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 475,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLAHUAC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/18/2018",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-18",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "7/25/2016",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 477,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/13/2018",
   "mes_fecha": 7,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-13",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "IGN",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 479,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/24/2018",
   "mes_fecha": 12,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-24",
   "anio_mes": "2018-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "12/14/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 480,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/18/2018",
   "mes_fecha": 5,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-18",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 481,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/10/2018",
   "mes_fecha": 4,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-10",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "11/16/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 483,
   "edad": "48",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "XOCHIMILCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/13/2018",
   "mes_fecha": 12,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-13",
   "anio_mes": "2018-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "7/18/1970",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 485,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "XOCHIMILCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/11/2018",
   "mes_fecha": 9,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-11",
   "anio_mes": "2018-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 490,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/3/2018",
   "mes_fecha": 9,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-03",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 491,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTACALCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/19/2018",
   "mes_fecha": 1,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-19",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "12/31/2016",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 492,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLAHUAC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/12/2018",
   "mes_fecha": 6,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-12",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/14/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 493,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "VENUSTIANO CARRANZA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/10/2018",
   "mes_fecha": 8,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-10",
   "anio_mes": "2018-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 497,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/8/2018",
   "mes_fecha": 11,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-08",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 498,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/4/2018",
   "mes_fecha": 6,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-04",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 499,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/4/2018",
   "mes_fecha": 6,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-04",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 500,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "VENUSTIANO CARRANZA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/11/2018",
   "mes_fecha": 7,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-11",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 501,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "COYOACAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/23/2018",
   "mes_fecha": 11,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-23",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 502,
   "edad": "14",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2018",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-23",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 505,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2018",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-23",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 509,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "VICENTE GUERRERO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/30/2018",
   "mes_fecha": 10,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-30",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "6/1/2018",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 510,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/9/2018",
   "mes_fecha": 4,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-09",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "3/15/2018",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 511,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/6/2018",
   "mes_fecha": 8,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-06",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "3/15/2018",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 512,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/2/2018",
   "mes_fecha": 7,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-02",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "9",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 513,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/9/2018",
   "mes_fecha": 10,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-09",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/27/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 514,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "MEZQUITAL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/17/2018",
   "mes_fecha": 9,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-17",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "9",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 518,
   "edad": "9",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "SANTIAGO PAPASQUIARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/27/2018",
   "mes_fecha": 9,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-27",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "9",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 520,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "GOMEZ PALACIO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/14/2018",
   "mes_fecha": 5,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-14",
   "anio_mes": "2018-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 522,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "GOMEZ PALACIO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/22/2018",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-22",
   "anio_mes": "2018-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 524,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/5/2018",
   "mes_fecha": 11,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-05",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/9/2018",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 525,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/6/2018",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-06",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 526,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "PUEBLO NUEVO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/2/2018",
   "mes_fecha": 7,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-02",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "9",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 528,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/12/2018",
   "mes_fecha": 6,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-12",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/7/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 539,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/16/2018",
   "mes_fecha": 10,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-16",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 540,
   "edad": "11",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/18/2018",
   "mes_fecha": 10,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-18",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 545,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/9/2018",
   "mes_fecha": 4,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-09",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 546,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/27/2018",
   "mes_fecha": 4,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-27",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 549,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/31/2018",
   "mes_fecha": 10,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-31",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 551,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/17/2018",
   "mes_fecha": 4,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-17",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 555,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "COMONFORT",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/19/2018",
   "mes_fecha": 4,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-19",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 3,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 556,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "COMONFORT",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/3/2018",
   "mes_fecha": 8,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-03",
   "anio_mes": "2018-08",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 561,
   "edad": "47",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/13/2018",
   "mes_fecha": 12,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-13",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 562,
   "edad": "50",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/29/2018",
   "mes_fecha": 6,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-29",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 564,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "ROMITA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/11/2018",
   "mes_fecha": 3,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-11",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "19/01/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 566,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/8/2018",
   "mes_fecha": 12,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-08",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 568,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/7/2018",
   "mes_fecha": 3,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-07",
   "anio_mes": "2018-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/21/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 571,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/24/2018",
   "mes_fecha": 9,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-24",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "4/1/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 572,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/5/2018",
   "mes_fecha": 11,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-05",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 584,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "URIANGATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/29/2018",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-29",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 585,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SALAMANCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/15/2018",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-15",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 586,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/11/2018",
   "mes_fecha": 9,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-11",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 587,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/27/2018",
   "mes_fecha": 7,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-27",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 591,
   "edad": "50",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/24/2018",
   "mes_fecha": 8,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-24",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 592,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/9/2018",
   "mes_fecha": 8,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-09",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 598,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "CORTAZAR",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/12/2018",
   "mes_fecha": 4,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-12",
   "anio_mes": "2018-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 613,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/10/2019",
   "mes_fecha": 1,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-10",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "9/1/1982",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 620,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/1/2018",
   "mes_fecha": 10,
   "dia_fecha": 1,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-01",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 628,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/10/2018",
   "mes_fecha": 12,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-10",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 633,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "VALLE DE SANTIAGO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/2/2018",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-02",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 635,
   "edad": "30",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/16/2018",
   "mes_fecha": 10,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-16",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 648,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SALAMANCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/31/2018",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-31",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 655,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "JUVENTINO ROSAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/20/2018",
   "mes_fecha": 2,
   "dia_fecha": 20,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-20",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 674,
   "edad": "32",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/29/2018",
   "mes_fecha": 6,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-29",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "01/06/2009",
   "tipo_vacuna": "3",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 675,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/13/2018",
   "mes_fecha": 7,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-13",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 676,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/14/2018",
   "mes_fecha": 8,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-14",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/13/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 679,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/26/2018",
   "mes_fecha": 10,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-26",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 680,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SALAMANCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/21/2018",
   "mes_fecha": 11,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-21",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 682,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/22/2018",
   "mes_fecha": 11,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-22",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 684,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/21/2018",
   "mes_fecha": 12,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-21",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 691,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "JUVENTINO ROSAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/29/2018",
   "mes_fecha": 11,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-29",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 692,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/4/2018",
   "mes_fecha": 9,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-04",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 693,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/4/2018",
   "mes_fecha": 9,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-04",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 694,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/5/2018",
   "mes_fecha": 11,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-05",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 701,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/25/2018",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-25",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 702,
   "edad": "33",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/10/2018",
   "mes_fecha": 12,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-10",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 703,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/23/2018",
   "mes_fecha": 12,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-23",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 704,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/13/2018",
   "mes_fecha": 12,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-13",
   "anio_mes": "2018-12",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 712,
   "edad": "22",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/19/2018",
   "mes_fecha": 6,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-19",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 716,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/12/2018",
   "mes_fecha": 11,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-12",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 725,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/13/2018",
   "mes_fecha": 8,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-13",
   "anio_mes": "2018-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 729,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/10/2018",
   "mes_fecha": 5,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-10",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "30/04/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 731,
   "edad": "74",
   "grupo_edad": "70 - 74",
   "demografia_edad": "MAYOR",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/12/2018",
   "mes_fecha": 7,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-12",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 735,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/7/2018",
   "mes_fecha": 8,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-07",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "8/1/2018",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 744,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "ABASOLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/24/2018",
   "mes_fecha": 7,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-24",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 746,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/7/2018",
   "mes_fecha": 3,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-07",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 747,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/15/2018",
   "mes_fecha": 11,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-15",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 750,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/2/2018",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-02",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 751,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "ABASOLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/21/2018",
   "mes_fecha": 12,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-21",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 755,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/7/2018",
   "mes_fecha": 11,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-07",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 765,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/26/2018",
   "mes_fecha": 6,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-26",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 766,
   "edad": "27",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/7/2018",
   "mes_fecha": 8,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-07",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 768,
   "edad": "33",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "COMONFORT",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/15/2018",
   "mes_fecha": 8,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-15",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 772,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/24/2018",
   "mes_fecha": 8,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-24",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/10/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 775,
   "edad": "16",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/24/2018",
   "mes_fecha": 8,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-24",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 777,
   "edad": "49",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/23/2018",
   "mes_fecha": 10,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-23",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 784,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/4/2018",
   "mes_fecha": 12,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-04",
   "anio_mes": "2018-12",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 785,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/10/2019",
   "mes_fecha": 1,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-10",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 787,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SALAMANCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/20/2018",
   "mes_fecha": 8,
   "dia_fecha": 20,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-20",
   "anio_mes": "2018-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 791,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/15/2018",
   "mes_fecha": 11,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-15",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 794,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/26/2018",
   "mes_fecha": 10,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-26",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 6,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 799,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "CELAYA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/29/2018",
   "mes_fecha": 8,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-29",
   "anio_mes": "2018-08",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 803,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "JERECUARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/14/2018",
   "mes_fecha": 11,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-14",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 812,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/30/2018",
   "mes_fecha": 11,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-30",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 819,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/9/2018",
   "mes_fecha": 3,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-09",
   "anio_mes": "2018-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 820,
   "edad": "9",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/7/2018",
   "mes_fecha": 11,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-07",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 823,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/6/2018",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-06",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 824,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SALAMANCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/30/2018",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-30",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "28/12/2013",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 826,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "ABASOLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/30/2018",
   "mes_fecha": 3,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-30",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 833,
   "edad": "21",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/30/2018",
   "mes_fecha": 11,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-30",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 840,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SAN FRANCISCO DEL RINCON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/28/2018",
   "mes_fecha": 12,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-28",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 842,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SILAO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/3/2018",
   "mes_fecha": 7,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-03",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 846,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "CELAYA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/27/2018",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-27",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 847,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "JUVENTINO ROSAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/26/2018",
   "mes_fecha": 10,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-26",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 848,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/10/2018",
   "mes_fecha": 12,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-10",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 849,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/10/2018",
   "mes_fecha": 12,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-10",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 850,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/30/2018",
   "mes_fecha": 11,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-30",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 859,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/5/2018",
   "mes_fecha": 11,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-05",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 860,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/21/2018",
   "mes_fecha": 5,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-21",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 865,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SALAMANCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/1/2018",
   "mes_fecha": 8,
   "dia_fecha": 1,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-01",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 870,
   "edad": "23",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/29/2018",
   "mes_fecha": 10,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-29",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 876,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/30/2018",
   "mes_fecha": 11,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-30",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 885,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SALAMANCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/7/2018",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-07",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 892,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/6/2018",
   "mes_fecha": 12,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-06",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 898,
   "edad": "7",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "M DOBLADO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/27/2018",
   "mes_fecha": 11,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-27",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "23/07/2015",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 902,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SAN FRANCISCO DEL RINCON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/5/2018",
   "mes_fecha": 4,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-05",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 903,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "URIANGATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/29/2018",
   "mes_fecha": 9,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-29",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/09/2018",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 911,
   "edad": "38",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/9/2018",
   "mes_fecha": 3,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-09",
   "anio_mes": "2018-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 914,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/10/2019",
   "mes_fecha": 1,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-10",
   "anio_mes": "2019-01",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/20/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 920,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/14/2018",
   "mes_fecha": 11,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-14",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 921,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/23/2018",
   "mes_fecha": 12,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-23",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 956,
   "edad": "17",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "MINERAL DE LA REFORMA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/31/2018",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-31",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 960,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "TEPEHUACAN DE GUERRERO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/10/2018",
   "mes_fecha": 4,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-10",
   "anio_mes": "2018-04",
   "institucion_notificacion": 5,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/5/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 963,
   "edad": "23",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "CUAUTEPEC DE HINOJOSA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/30/2018",
   "mes_fecha": 9,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-30",
   "anio_mes": "2018-09",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 964,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "CUAUTEPEC DE HINOJOSA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/30/2018",
   "mes_fecha": 9,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-30",
   "anio_mes": "2018-09",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "9/24/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 966,
   "edad": "55",
   "grupo_edad": "55 - 59",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "MINERAL DE LA REFORMA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/31/2018",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-31",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 967,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "PACHUCA DE SOTO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/14/2018",
   "mes_fecha": 10,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-14",
   "anio_mes": "2018-10",
   "institucion_notificacion": 6,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 968,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "ZEMPOALA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/26/2018",
   "mes_fecha": 12,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-26",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 975,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "TECOZAUTLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/3/2018",
   "mes_fecha": 8,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-03",
   "anio_mes": "2018-08",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "2/20/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 979,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "PACHUCA DE SOTO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/31/2018",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-31",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1/22/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 980,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "PACHUCA DE SOTO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/18/2018",
   "mes_fecha": 3,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-18",
   "anio_mes": "2018-03",
   "institucion_notificacion": 6,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 987,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "PACHUCA DE SOTO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/7/2018",
   "mes_fecha": 12,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-07",
   "anio_mes": "2018-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/23/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1001,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1004,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/3/2018",
   "mes_fecha": 5,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-03",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1010,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "LA HUERTA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/12/2018",
   "mes_fecha": 4,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-12",
   "anio_mes": "2018-04",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "21/08/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1014,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TALA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/13/2018",
   "mes_fecha": 8,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-13",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1015,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TONALA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "27/01/2018",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1021,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "23/07/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1027,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/27/2018",
   "mes_fecha": 9,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-27",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1028,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/22/2018",
   "mes_fecha": 10,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-22",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1034,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "AMATITAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/12/2018",
   "mes_fecha": 9,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-12",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1042,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1044,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/8/2018",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-08",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1045,
   "edad": "17",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/18/2018",
   "mes_fecha": 9,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-18",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1047,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "26/02/2015",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1050,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TONALA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1MES",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1052,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2018",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-23",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1053,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN IGNACIO CERRO GORDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/8/2018",
   "mes_fecha": 5,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-08",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1059,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/20/2018",
   "mes_fecha": 8,
   "dia_fecha": 20,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-20",
   "anio_mes": "2018-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1061,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/16/2018",
   "mes_fecha": 2,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-16",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1070,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "OCOTLAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/12/2018",
   "mes_fecha": 9,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-12",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1095,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAQUEPAQUE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/15/2018",
   "mes_fecha": 12,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-15",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1104,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOTLANEJO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1105,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/21/2018",
   "mes_fecha": 6,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-21",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1122,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/28/2018",
   "mes_fecha": 8,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-28",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1135,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/30/2018",
   "mes_fecha": 5,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-30",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1146,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAQUEPAQUE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/4/2019",
   "mes_fecha": 1,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-04",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1149,
   "edad": "36",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/8/2019",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-08",
   "anio_mes": "2019-01",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1151,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TONALA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/26/2018",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-26",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "08/02/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1154,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAYULITA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/14/2018",
   "mes_fecha": 6,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-14",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1159,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/21/2018",
   "mes_fecha": 1,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-21",
   "anio_mes": "2018-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1160,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1163,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAQUEPAQUE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/25/2018",
   "mes_fecha": 1,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-25",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1171,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/24/2018",
   "mes_fecha": 11,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-24",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1173,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TALA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1175,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TALA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1176,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/21/2018",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-21",
   "anio_mes": "2018-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1180,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TONALA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1184,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/14/2018",
   "mes_fecha": 6,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-14",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1188,
   "edad": "18",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/28/2018",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-28",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1189,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/10/2018",
   "mes_fecha": 12,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-10",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1191,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "CIHUATLAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/28/2018",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-28",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1193,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAQUEPAQUE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/2/2018",
   "mes_fecha": 3,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-02",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1195,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ARANDAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/29/2018",
   "mes_fecha": 5,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-29",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1196,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TONALA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1205,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAQUEPAQUE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/4/2018",
   "mes_fecha": 12,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-04",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1206,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/5/2018",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-05",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1209,
   "edad": "64",
   "grupo_edad": "60 - 64",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/10/2018",
   "mes_fecha": 12,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-10",
   "anio_mes": "2018-12",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1210,
   "edad": "11",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAQUEPAQUE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/4/2019",
   "mes_fecha": 1,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-04",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1215,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAQUEPAQUE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/24/2018",
   "mes_fecha": 9,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-24",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1219,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TENANGO DEL AIRE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/17/2018",
   "mes_fecha": 12,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-17",
   "anio_mes": "2018-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "01/06/2017",
   "tipo_vacuna": "2",
   "complicaciones": 6,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1223,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/30/2018",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-30",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1224,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "VALLE DE CHALCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/5/2018",
   "mes_fecha": 1,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-05",
   "anio_mes": "2018-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1225,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TLALNEPANTLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/10/2018",
   "mes_fecha": 4,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-10",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "IGN",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1226,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/5/2018",
   "mes_fecha": 7,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-05",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1227,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TLALNEPANTLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/5/2018",
   "mes_fecha": 11,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-05",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "9/10/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1230,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/17/2018",
   "mes_fecha": 1,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-17",
   "anio_mes": "2018-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "22/11/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1231,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "SA SIMON DE GUERRERO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/11/2018",
   "mes_fecha": 6,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-11",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1232,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TLALNEPANTLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/5/2018",
   "mes_fecha": 12,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-05",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1233,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "SANTIAGO TIANGUISTENCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/1/2018",
   "mes_fecha": 8,
   "dia_fecha": 1,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-01",
   "anio_mes": "2018-08",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1234,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "COYOTEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/1/2018",
   "mes_fecha": 8,
   "dia_fecha": 1,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-01",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1242,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CUAUTITLAN IZCALLI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/6/2018",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-06",
   "anio_mes": "2018-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1244,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC DE MORELOS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/21/2018",
   "mes_fecha": 8,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-21",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1246,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NAUCALPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/4/2018",
   "mes_fecha": 7,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-04",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1247,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC DE MORELOS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/12/2018",
   "mes_fecha": 12,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-12",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1248,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TLALNEPANTLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/5/2018",
   "mes_fecha": 12,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-05",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1251,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TEXCOCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/22/2018",
   "mes_fecha": 11,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-22",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1252,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NAUCALPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/15/2018",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-15",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1254,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TEXCOCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/5/2018",
   "mes_fecha": 10,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-05",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1258,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TEZOYUCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/27/2018",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-27",
   "anio_mes": "2018-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1260,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TULTITLAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/16/2018",
   "mes_fecha": 1,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-16",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1261,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CD NEZAHUALCOYOTL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/2/2018",
   "mes_fecha": 1,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-02",
   "anio_mes": "2018-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "10/9/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1262,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC DE MORELOS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/11/2018",
   "mes_fecha": 9,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-11",
   "anio_mes": "2018-09",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/18/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1264,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC DE MORELOS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/30/2018",
   "mes_fecha": 7,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-30",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "IGN",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1265,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TLALNEPANTLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/26/2018",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-26",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1266,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TOLUCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/5/2018",
   "mes_fecha": 12,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-05",
   "anio_mes": "2018-12",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1267,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CHIMALHUACAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/17/2018",
   "mes_fecha": 12,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-17",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "20/09/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1270,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "LOS REYES LA PAZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/10/2018",
   "mes_fecha": 9,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-10",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1272,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "13/11/201/8",
   "mes_fecha": 13,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-11",
   "anio_mes": "2018-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "05/11/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1276,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TEMASCALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/27/2018",
   "mes_fecha": 6,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-27",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "27/05/2018",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1279,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NEZAHUALCOYOTL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/12/2018",
   "mes_fecha": 11,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-12",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1280,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "VILLA NICOLAS ROMERO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/31/2018",
   "mes_fecha": 1,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-31",
   "anio_mes": "2018-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1281,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "IXTAPALUCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/17/2018",
   "mes_fecha": 8,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-17",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "ABRIL",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1283,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "IXTAPALUCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/14/2018",
   "mes_fecha": 12,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-14",
   "anio_mes": "2018-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 6,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1290,
   "edad": "14",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NEZAHUALCOYOTL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/6/2018",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-06",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "8/3/2004",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1291,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "VALLE DE CHALCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/23/2018",
   "mes_fecha": 11,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-23",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1293,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CHIMALHUACAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/17/2018",
   "mes_fecha": 8,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-17",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1294,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CUAUTITLAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/9/2018",
   "mes_fecha": 4,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-09",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1295,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CHALCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/14/2018",
   "mes_fecha": 12,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-14",
   "anio_mes": "2018-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 6,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1296,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TOLUCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/14/2018",
   "mes_fecha": 11,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-14",
   "anio_mes": "2018-11",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1298,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "IXTAPALUCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/1/2018",
   "mes_fecha": 6,
   "dia_fecha": 1,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-01",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1300,
   "edad": "21",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ATIZAPAN DE ZARAGOZA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/10/2018",
   "mes_fecha": 7,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-10",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "IGN",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1301,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/5/2018",
   "mes_fecha": 8,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-05",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1303,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/2/2018",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-02",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1310,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CHALCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/25/2018",
   "mes_fecha": 4,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-25",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "14/10/2016",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1314,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "LOS REYES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/15/2018",
   "mes_fecha": 5,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-15",
   "anio_mes": "2018-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1315,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/3/2018",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-03",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1316,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/9/2018",
   "mes_fecha": 10,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-09",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1318,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "TACÁMBARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/5/2018",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-05",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "---",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1320,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "CHERAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/30/2018",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-30",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "---",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1323,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "QUIROGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/22/2018",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-22",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "--",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1325,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/31/2018",
   "mes_fecha": 12,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-31",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1326,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/23/2018",
   "mes_fecha": 3,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-23",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1328,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/15/2018",
   "mes_fecha": 2,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-15",
   "anio_mes": "2018-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1329,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/15/2018",
   "mes_fecha": 2,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-15",
   "anio_mes": "2018-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1331,
   "edad": "23",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "INDAPARAPEO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/14/2018",
   "mes_fecha": 12,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-14",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1333,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "ZAMORA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/7/2018",
   "mes_fecha": 3,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-07",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1334,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "LOS REYES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/12/2018",
   "mes_fecha": 6,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-12",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1336,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "ZAMORA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/14/2018",
   "mes_fecha": 3,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-14",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1339,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/12/2018",
   "mes_fecha": 6,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-12",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1341,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/24/2018",
   "mes_fecha": 4,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-24",
   "anio_mes": "2018-04",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1343,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "URUAPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/14/2018",
   "mes_fecha": 2,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-14",
   "anio_mes": "2018-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1345,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "ZAMORA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/31/2018",
   "mes_fecha": 8,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-31",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1346,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/28/2018",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-28",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "--",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1348,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/24/2018",
   "mes_fecha": 4,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-24",
   "anio_mes": "2018-04",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1351,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "ZITACUARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/20/2018",
   "mes_fecha": 9,
   "dia_fecha": 20,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-20",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1352,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "ZITACUARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/20/2018",
   "mes_fecha": 9,
   "dia_fecha": 20,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-20",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 6,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1353,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "NAHUATZEN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/7/2018",
   "mes_fecha": 10,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-07",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1354,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "QUIROGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/26/2018",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-26",
   "anio_mes": "2018-02",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1356,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "TANCITARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/17/2018",
   "mes_fecha": 7,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-17",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1358,
   "edad": "26",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "QUIROGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/26/2018",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-26",
   "anio_mes": "2018-02",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1365,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "TOTOLAPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/3/2018",
   "mes_fecha": 5,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-03",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1366,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "YAUTEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/16/2018",
   "mes_fecha": 1,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-16",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1368,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "TEMIXCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/27/2018",
   "mes_fecha": 12,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-27",
   "anio_mes": "2018-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/26/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1371,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "TEMIXCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/9/2018",
   "mes_fecha": 8,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-09",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/16/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1372,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "CUERNAVACA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/28/2018",
   "mes_fecha": 5,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-28",
   "anio_mes": "2018-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "5/24/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1373,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "CUERNAVACA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/1/2018",
   "mes_fecha": 8,
   "dia_fecha": 1,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-01",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/16/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1379,
   "edad": "19",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "CUERNAVACA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/7/2018",
   "mes_fecha": 6,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-07",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1386,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "EMILIANO ZAPATA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/8/2018",
   "mes_fecha": 8,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-08",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "6/20/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1388,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "MIACATLAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/8/2019",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-08",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 6,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1389,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "AXOCHIAPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/2/2018",
   "mes_fecha": 10,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-02",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1391,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "SANTA MARIA DEL ORO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/29/2018",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-29",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1394,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "COMPOSTELA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/13/2018",
   "mes_fecha": 6,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-13",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "9/9/2017",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1396,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "RUIZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/5/2018",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-05",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1398,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEPIC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/20/2018",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-20",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1402,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/19/2018",
   "mes_fecha": 7,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-19",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1408,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/13/2018",
   "mes_fecha": 7,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-13",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1412,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/30/2018",
   "mes_fecha": 5,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-30",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1413,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/9/2018",
   "mes_fecha": 3,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-09",
   "anio_mes": "2018-03",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/20/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1414,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/29/2018",
   "mes_fecha": 8,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-29",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1415,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/31/2018",
   "mes_fecha": 5,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-31",
   "anio_mes": "2018-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/1/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1417,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/27/2018",
   "mes_fecha": 7,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-27",
   "anio_mes": "2018-07",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1422,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/3/2018",
   "mes_fecha": 9,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-03",
   "anio_mes": "2018-09",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1424,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/7/2018",
   "mes_fecha": 6,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-07",
   "anio_mes": "2018-06",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1432,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SANTA CATARINA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/9/2018",
   "mes_fecha": 2,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-09",
   "anio_mes": "2018-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/30/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1434,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/2/2018",
   "mes_fecha": 11,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-02",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1443,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/28/2018",
   "mes_fecha": 6,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-28",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1446,
   "edad": "48",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SAN NICOLAS DE LOS GARZA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/22/2018",
   "mes_fecha": 6,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-22",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1447,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/2/2018",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-02",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1448,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/22/2018",
   "mes_fecha": 2,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-22",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1453,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/4/2018",
   "mes_fecha": 5,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-04",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1454,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MIER Y NORIEGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/11/2018",
   "mes_fecha": 9,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-11",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1460,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/17/2018",
   "mes_fecha": 9,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-17",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1463,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/15/2018",
   "mes_fecha": 8,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-15",
   "anio_mes": "2018-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1466,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "PESQUERIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/15/2018",
   "mes_fecha": 6,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-15",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1469,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/31/2018",
   "mes_fecha": 1,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-31",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1470,
   "edad": "61",
   "grupo_edad": "60 - 64",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SAN NICOLAS DE LOS GARZA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/5/2018",
   "mes_fecha": 9,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-05",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1472,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/15/2018",
   "mes_fecha": 3,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-15",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1476,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/9/2018",
   "mes_fecha": 8,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-09",
   "anio_mes": "2018-08",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1478,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/19/2018",
   "mes_fecha": 7,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-19",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1481,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/22/2018",
   "mes_fecha": 5,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-22",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "5/3/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1483,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/24/2018",
   "mes_fecha": 4,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-24",
   "anio_mes": "2018-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1485,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/19/2018",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-19",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1488,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SAN PEDRO GARZA GARCIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/4/2018",
   "mes_fecha": 12,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-04",
   "anio_mes": "2018-12",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1490,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/26/2018",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-26",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1492,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/25/2018",
   "mes_fecha": 5,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-25",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1497,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/27/2018",
   "mes_fecha": 7,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-27",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1498,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "PESQUERIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/21/2018",
   "mes_fecha": 8,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-21",
   "anio_mes": "2018-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/12/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1508,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/10/2018",
   "mes_fecha": 12,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-10",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1511,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/2/2018",
   "mes_fecha": 8,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-02",
   "anio_mes": "2018-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1516,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "EL CARMEN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/29/2018",
   "mes_fecha": 6,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-29",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1517,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/6/2018",
   "mes_fecha": 7,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-06",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/2/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1518,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/30/2018",
   "mes_fecha": 9,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-30",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1523,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/25/2018",
   "mes_fecha": 7,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-25",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1524,
   "edad": "47",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SANTIAGO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/12/2018",
   "mes_fecha": 12,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-12",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1525,
   "edad": "76",
   "grupo_edad": "75 - 79",
   "demografia_edad": "MAYOR",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SANTIAGO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/12/2018",
   "mes_fecha": 12,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-12",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1527,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/9/2018",
   "mes_fecha": 1,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-09",
   "anio_mes": "2018-01",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "11/1/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1529,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/28/2018",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-28",
   "anio_mes": "2018-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1531,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/5/2018",
   "mes_fecha": 4,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-05",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/3/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1535,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "ARAMBERRI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/28/2018",
   "mes_fecha": 10,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-28",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "12/13/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1538,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/30/2018",
   "mes_fecha": 7,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-30",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1541,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/15/2018",
   "mes_fecha": 6,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-15",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/22/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1546,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/14/2018",
   "mes_fecha": 8,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-14",
   "anio_mes": "2018-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1550,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "EL CARMEN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/15/2018",
   "mes_fecha": 6,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-15",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "6/11/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1555,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/2/2018",
   "mes_fecha": 11,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-02",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1557,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/6/2018",
   "mes_fecha": 8,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-06",
   "anio_mes": "2018-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/13/2018",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1561,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/30/2018",
   "mes_fecha": 3,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-30",
   "anio_mes": "2018-03",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1565,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SALINAS VICTORIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/26/2018",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-26",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1566,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SAN NICOLAS DE LOS GARZA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/2/2018",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-02",
   "anio_mes": "2018-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1569,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SAN NICOLAS DE LOS GARZA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/16/2018",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-16",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1/20/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1570,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/18/2018",
   "mes_fecha": 5,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-18",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/12/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1578,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SAN NICOLAS DE LOS GARZA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/2/2018",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-02",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1579,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/28/2018",
   "mes_fecha": 8,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-28",
   "anio_mes": "2018-08",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "2016",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1582,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "LINARES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/24/2018",
   "mes_fecha": 4,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-24",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1584,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/10/2018",
   "mes_fecha": 4,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-10",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/21/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1589,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SANTA CATARINA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/16/2018",
   "mes_fecha": 11,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-16",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1593,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/9/2019",
   "mes_fecha": 1,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-09",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1594,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/10/2018",
   "mes_fecha": 7,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-10",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1595,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/8/2018",
   "mes_fecha": 7,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-08",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1599,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/22/2018",
   "mes_fecha": 5,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-22",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1601,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/2/2018",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-02",
   "anio_mes": "2018-05",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1613,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "PESQUERIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/10/2018",
   "mes_fecha": 12,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-10",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1617,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SANTA CATARINA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/4/2018",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-04",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "7/23/2018",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1618,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/10/2018",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-10",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1619,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/31/2018",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-31",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1623,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SALINAS VICTORIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/19/2018",
   "mes_fecha": 4,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-19",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1624,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/1/2018",
   "mes_fecha": 5,
   "dia_fecha": 1,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-01",
   "anio_mes": "2018-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/16/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1626,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/12/2018",
   "mes_fecha": 11,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-12",
   "anio_mes": "2018-11",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1629,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/15/2018",
   "mes_fecha": 3,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-15",
   "anio_mes": "2018-03",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1634,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "PESQUERIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/25/2018",
   "mes_fecha": 11,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-25",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1636,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/1/2018",
   "mes_fecha": 6,
   "dia_fecha": 1,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-01",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1637,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/18/2018",
   "mes_fecha": 6,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-18",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1638,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/14/2018",
   "mes_fecha": 5,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-14",
   "anio_mes": "2018-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/18/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1639,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SAN NICOLAS DE LOS GARZA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/2/2018",
   "mes_fecha": 7,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-02",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1641,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ZUAZUA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/14/2018",
   "mes_fecha": 11,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-14",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1649,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/7/2018",
   "mes_fecha": 6,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-07",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "3/15/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1654,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "PESQUERIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/25/2018",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-25",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1657,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN LUCAS ZOOQUIAPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/30/2018",
   "mes_fecha": 10,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-30",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1659,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "VILLA DE TUTUTEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/18/2018",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-18",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1660,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "OAXACA DE JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/30/2018",
   "mes_fecha": 10,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-30",
   "anio_mes": "2018-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1661,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "ACATLAN DE PEREZ FIGUEROA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/16/2018",
   "mes_fecha": 7,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-16",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1663,
   "edad": "68",
   "grupo_edad": "65 - 69",
   "demografia_edad": "MAYOR",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTIAGO PINOTEPA NACIONAL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/19/2018",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-19",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1664,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTIAGO PINOTEPA NACIONAL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/19/2018",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-19",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "8/15/2014",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1666,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "OAXACA DE JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/10/2018",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-10",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1667,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTA CRUZ XOXOCOTLAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/28/2018",
   "mes_fecha": 6,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-28",
   "anio_mes": "2018-06",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1670,
   "edad": "22",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTIAGO PINOTEPA NACIONAL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/19/2018",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-19",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1671,
   "edad": "40",
   "grupo_edad": "40 - 44",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTIAGO PINOTEPA NACIONAL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/19/2018",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-19",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1672,
   "edad": "7",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTIAGO PINOTEPA NACIONAL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/19/2018",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-19",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "8/5/2015",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1675,
   "edad": "43",
   "grupo_edad": "40 - 44",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTIAGO PINOTEPA NACIONAL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/19/2018",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-19",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1676,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTIAGO PINOTEPA NACIONAL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/17/2018",
   "mes_fecha": 9,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-17",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1677,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTIAGO MATATLAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/17/2018",
   "mes_fecha": 12,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-17",
   "anio_mes": "2018-12",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1678,
   "edad": "62",
   "grupo_edad": "60 - 64",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTIAGO MATATLAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/11/2019",
   "mes_fecha": 1,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-11",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1679,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "OAXACA DE JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2018",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-23",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1680,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN SEBASTIAN TUTLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/7/2018",
   "mes_fecha": 9,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-07",
   "anio_mes": "2018-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1681,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTIAGO TLAZOYALTEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/16/2018",
   "mes_fecha": 7,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-16",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1682,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN ANDRES HUAYAPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/11/2018",
   "mes_fecha": 12,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-11",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1684,
   "edad": "31",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "VILLA DE TUTUTEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/19/2018",
   "mes_fecha": 7,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-19",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1686,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "REYES ETLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/24/2018",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-24",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1688,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "JUCHITAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/22/2018",
   "mes_fecha": 11,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-22",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1690,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN PABLO HUIXTEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/10/2018",
   "mes_fecha": 7,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-10",
   "anio_mes": "2018-07",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1691,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN PABLO HUIXTEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/18/2018",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-18",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "1/10/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1693,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "JUCHITAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/5/2018",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-05",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1694,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN PEDRO MIXTEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/11/2018",
   "mes_fecha": 9,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-11",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "8/16/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1695,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN PEDRO MIXTEPEC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/11/2018",
   "mes_fecha": 9,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-11",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1697,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "TEHUACAN PUEBLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/19/2018",
   "mes_fecha": 12,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-19",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1704,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "CHICHIQUILA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/21/2018",
   "mes_fecha": 11,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-21",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1707,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "ESPERANZA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/4/2019",
   "mes_fecha": 1,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-04",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1721,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/24/2018",
   "mes_fecha": 5,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-24",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/8/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1724,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "SAN JUAN DEL RIO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/3/2019",
   "mes_fecha": 1,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-03",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/30/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1727,
   "edad": "22",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/8/2019",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-08",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1728,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/2/2019",
   "mes_fecha": 1,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-02",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1730,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "CORREGIDORA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/27/2018",
   "mes_fecha": 8,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-27",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/23/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1736,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/4/2018",
   "mes_fecha": 9,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-04",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/6/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1739,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/22/2018",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-22",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1741,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "TEQUISQUIAPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/3/2018",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-03",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1744,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/16/2019",
   "mes_fecha": 1,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-16",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1745,
   "edad": "49",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/16/2019",
   "mes_fecha": 1,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-16",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1753,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "COLON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/5/2018",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-05",
   "anio_mes": "2018-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1755,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/26/2018",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-26",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/14/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1756,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "PEDRO ESCOBEDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/16/2018",
   "mes_fecha": 8,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-16",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1757,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "EL MAQUES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/4/2018",
   "mes_fecha": 4,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-04",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1758,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "EL MARQUES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/13/2018",
   "mes_fecha": 8,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-13",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1760,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/24/2018",
   "mes_fecha": 12,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-24",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "12/11/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1761,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/3/2019",
   "mes_fecha": 1,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-03",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/18/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1762,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/18/2018",
   "mes_fecha": 11,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-18",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1765,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/12/2018",
   "mes_fecha": 1,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-12",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1770,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "CORREGIDORA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/14/2018",
   "mes_fecha": 11,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-14",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1775,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/13/2018",
   "mes_fecha": 11,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-13",
   "anio_mes": "2018-11",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/10/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1776,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/8/2019",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-08",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "NO RECUERDA",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1778,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "CORREGIDORA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/26/2018",
   "mes_fecha": 10,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-26",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/10/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1788,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "OTHON P BLANCO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/25/2018",
   "mes_fecha": 4,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-25",
   "anio_mes": "2018-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1791,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "SOLIDARIDAD",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/22/2018",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-22",
   "anio_mes": "2018-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "1/9/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1801,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/4/2018",
   "mes_fecha": 10,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-04",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1/15/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1811,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/17/2018",
   "mes_fecha": 1,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-17",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1812,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/9/2018",
   "mes_fecha": 10,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-09",
   "anio_mes": "2018-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/21/2017",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1813,
   "edad": "31",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/20/2018",
   "mes_fecha": 2,
   "dia_fecha": 20,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-20",
   "anio_mes": "2018-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1822,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "TAMAZUNCHALE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/18/2018",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-18",
   "anio_mes": "2018-07",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1825,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SANTA MARIA DEL RIO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/7/2018",
   "mes_fecha": 12,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-07",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1828,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN MARTIN CHALCHICOAUTLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/24/2018",
   "mes_fecha": 4,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-24",
   "anio_mes": "2018-04",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1834,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/31/2018",
   "mes_fecha": 10,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-31",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1842,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/8/2018",
   "mes_fecha": 6,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-08",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "4/19/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1851,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/28/2018",
   "mes_fecha": 6,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-28",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "6",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1868,
   "edad": "8",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN NICOLAS TOLENTINO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/14/2018",
   "mes_fecha": 11,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-14",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "28/11/2014",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1875,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/11/2018",
   "mes_fecha": 10,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-11",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1878,
   "edad": "31",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/30/2018",
   "mes_fecha": 7,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-30",
   "anio_mes": "2018-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1882,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/12/2018",
   "mes_fecha": 7,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-12",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "6",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1885,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "GUADALCAZAR",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/8/2018",
   "mes_fecha": 6,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-08",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1890,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "CD VALLES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/3/2018",
   "mes_fecha": 4,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-03",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1894,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "RIOVERDE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/24/2018",
   "mes_fecha": 8,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-24",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "07/08/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1895,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/18/2018",
   "mes_fecha": 5,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-18",
   "anio_mes": "2018-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/14/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1898,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SOLEDAD DE GRACIANO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/9/2018",
   "mes_fecha": 2,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-09",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1901,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/23/2018",
   "mes_fecha": 5,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-23",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "10/10/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1903,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SOLEDAD DE GRACIANO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/29/2018",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-29",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/23/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1908,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "MATEHUALA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/16/2018",
   "mes_fecha": 2,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-16",
   "anio_mes": "2018-02",
   "institucion_notificacion": 5,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1/26/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1916,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "GUADALCAZAR",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/9/2018",
   "mes_fecha": 12,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-09",
   "anio_mes": "2018-12",
   "institucion_notificacion": 5,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "17/11/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1918,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "CATORCE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/7/2018",
   "mes_fecha": 8,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-07",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1921,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/28/2018",
   "mes_fecha": 8,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-28",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "07/08/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1923,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/9/2018",
   "mes_fecha": 4,
   "dia_fecha": 9,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-09",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1948,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "VILLA DE REYES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/7/2018",
   "mes_fecha": 12,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-07",
   "anio_mes": "2018-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1952,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SALINAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/13/2018",
   "mes_fecha": 9,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-13",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "6",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1954,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "AQUISMON",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/18/2018",
   "mes_fecha": 12,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-18",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "23/11/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1956,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/8/2018",
   "mes_fecha": 6,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-08",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "6",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1958,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/27/2018",
   "mes_fecha": 9,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-27",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "6",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1959,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/12/2018",
   "mes_fecha": 10,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-12",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "17/08/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1961,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/23/2018",
   "mes_fecha": 10,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-23",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1967,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "LOS MOCHIS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/27/2018",
   "mes_fecha": 8,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-27",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1984,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "AHOME",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/7/2018",
   "mes_fecha": 3,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-07",
   "anio_mes": "2018-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1985,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULIACÁN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/19/2018",
   "mes_fecha": 2,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-19",
   "anio_mes": "2018-02",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "08/02/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1986,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "NAVOLATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/10/2018",
   "mes_fecha": 10,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-10",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1987,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "NAVOLATO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/25/2018",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-25",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 1996,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULIACÁN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/5/2018",
   "mes_fecha": 4,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-05",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "20/03/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2003,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "GUASAVE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/6/2018",
   "mes_fecha": 9,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-06",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2035,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "GUAYMAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/22/2018",
   "mes_fecha": 2,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-22",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2036,
   "edad": "9",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "GUAYMAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/26/2018",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-26",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2052,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/11/2018",
   "mes_fecha": 5,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-11",
   "anio_mes": "2018-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2078,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/22/2018",
   "mes_fecha": 2,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-22",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "15/02/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2079,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/23/2018",
   "mes_fecha": 2,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-23",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "15/02/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2080,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/26/2018",
   "mes_fecha": 6,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-26",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2094,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/8/2018",
   "mes_fecha": 5,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-08",
   "anio_mes": "2018-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2096,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/23/2018",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-23",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2113,
   "edad": "35",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/24/2018",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-24",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2114,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/24/2018",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-24",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2127,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NAVOJOA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/23/2018",
   "mes_fecha": 4,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-23",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "02/03/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2142,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "PARAISO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/4/2018",
   "mes_fecha": 11,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-04",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2145,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "CENTRO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/25/2018",
   "mes_fecha": 10,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-25",
   "anio_mes": "2018-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2146,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "MACUSPANA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/5/2018",
   "mes_fecha": 4,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-05",
   "anio_mes": "2018-04",
   "institucion_notificacion": 7,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "10/11/2016",
   "tipo_vacuna": "2",
   "complicaciones": 6,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2149,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "HUIMANGUILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/18/2018",
   "mes_fecha": 1,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-18",
   "anio_mes": "2018-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "12/4/2017",
   "tipo_vacuna": "2",
   "complicaciones": 6,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2154,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "VICTORIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/10/2018",
   "mes_fecha": 8,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-10",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "19/06/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2157,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "ALTAMIRA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/27/2018",
   "mes_fecha": 4,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-27",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2161,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "NUEVO LAREDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/4/2018",
   "mes_fecha": 6,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-04",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "18/10/2017",
   "tipo_vacuna": "2",
   "complicaciones": 6,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2165,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "TULA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/10/2018",
   "mes_fecha": 8,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-10",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/07/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2170,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "MADERO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/29/2018",
   "mes_fecha": 4,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-29",
   "anio_mes": "2018-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2171,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/29/2018",
   "mes_fecha": 5,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-29",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "31/01/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2173,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/29/2018",
   "mes_fecha": 6,
   "dia_fecha": 29,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-29",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/06/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2174,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/26/2018",
   "mes_fecha": 4,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-26",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2175,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/27/2018",
   "mes_fecha": 7,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-27",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "13/04/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2176,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "VICTORIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/13/2018",
   "mes_fecha": 8,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-13",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2184,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "VICTORIA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/20/2018",
   "mes_fecha": 7,
   "dia_fecha": 20,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-20",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "25/06/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2186,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "ALTAMIRA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/18/2018",
   "mes_fecha": 4,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-18",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 3,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2189,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/6/2018",
   "mes_fecha": 6,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-06",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "04/06/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2197,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "NUEVO LAREDO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/13/2018",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-13",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2206,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/2/2018",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-02",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 6,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2210,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/31/2018",
   "mes_fecha": 10,
   "dia_fecha": 31,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-31",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2215,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "RIO BRAVO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/15/2018",
   "mes_fecha": 8,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-15",
   "anio_mes": "2018-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2219,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "VALLE HERMOSO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/8/2019",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-08",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2225,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "SAN CARLOS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/27/2018",
   "mes_fecha": 12,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-27",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2226,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "TAMPICO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/10/2019",
   "mes_fecha": 1,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-10",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2230,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "BUSTAMANTE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/24/2018",
   "mes_fecha": 9,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-24",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/17/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2232,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "TENANZINGO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/30/2018",
   "mes_fecha": 11,
   "dia_fecha": 30,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-30",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "-",
   "tipo_vacuna": "-",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2235,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/12/2018",
   "mes_fecha": 10,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-12",
   "anio_mes": "2018-10",
   "institucion_notificacion": 6,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/3/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2237,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "IGNACIO ZARAGOZA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/11/2018",
   "mes_fecha": 4,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-11",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 5,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2241,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "ACUAMANALA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/24/2018",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-24",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2242,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "HUAMANTLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/8/2018",
   "mes_fecha": 2,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-08",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2243,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "NANACAMILPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/22/2018",
   "mes_fecha": 2,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-22",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2247,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "HUAMANTLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/12/2018",
   "mes_fecha": 2,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-12",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "24/01/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2248,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "XALOZTOC",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/3/2018",
   "mes_fecha": 8,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-03",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/02/2016",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2249,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "PUEBLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/16/2018",
   "mes_fecha": 3,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-16",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "13/03/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2251,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "SANTIAGO SOCHIAPAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/5/2018",
   "mes_fecha": 11,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-05",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2252,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/27/2018",
   "mes_fecha": 7,
   "dia_fecha": 27,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-27",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2253,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "SOLEDAD ATZOMPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/22/2018",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-22",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2254,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "SOLEDAD ATZOMPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/26/2018",
   "mes_fecha": 6,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-26",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2261,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "XOXOCOTLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/3/2018",
   "mes_fecha": 7,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-03",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/2/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2264,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "IXTACZOQUITLÁN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/7/2018",
   "mes_fecha": 3,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-07",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2265,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "COATZACOALCOS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/12/2018",
   "mes_fecha": 6,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-12",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2266,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "CARRILLO PUERTO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/13/2018",
   "mes_fecha": 11,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-13",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2267,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "FORTIN DE LAS FLORES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/17/2018",
   "mes_fecha": 7,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-17",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2269,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "CIUDAD MENDOZA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/2/2019",
   "mes_fecha": 1,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-02",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2274,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "LA PERLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/4/2018",
   "mes_fecha": 4,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-04",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2278,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "CORDOBA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/12/2018",
   "mes_fecha": 11,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-12",
   "anio_mes": "2018-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2279,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "SAN ANDRES TUXTLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/14/2018",
   "mes_fecha": 3,
   "dia_fecha": 14,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-14",
   "anio_mes": "2018-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/3/2016",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2280,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "MINATITLAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/15/2018",
   "mes_fecha": 3,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-15",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2281,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "TIERRA BLANCA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/11/2018",
   "mes_fecha": 5,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-11",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/19/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2294,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "LAS CHOAPAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/6/2018",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-06",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2295,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "PEROTE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/3/2018",
   "mes_fecha": 8,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-03",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "6/20/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2301,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "COATZACOALCOS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/1/2018",
   "mes_fecha": 2,
   "dia_fecha": 1,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-01",
   "anio_mes": "2018-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "11/30/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2303,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "TEZONAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/24/2018",
   "mes_fecha": 5,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-24",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2304,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "ORIZABA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/12/2018",
   "mes_fecha": 7,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-12",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2306,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/22/2018",
   "mes_fecha": 2,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-22",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2309,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "CHINAMPA DE GOROSTIZA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/24/2018",
   "mes_fecha": 6,
   "dia_fecha": 24,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-24",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2317,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "XALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/6/2018",
   "mes_fecha": 11,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-06",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2318,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "XALAPA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/16/2018",
   "mes_fecha": 7,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-16",
   "anio_mes": "2018-07",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2319,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "SAN ANDRES TUXTLA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/6/2018",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-06",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2322,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "KANASIN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/11/2018",
   "mes_fecha": 7,
   "dia_fecha": 11,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-11",
   "anio_mes": "2018-07",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "16/05/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2325,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/22/2018",
   "mes_fecha": 6,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-22",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2326,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "TECOH",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/5/2018",
   "mes_fecha": 4,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-05",
   "anio_mes": "2018-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2330,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/5/2018",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-05",
   "anio_mes": "2018-03",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2331,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "TICUL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/26/2018",
   "mes_fecha": 10,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-26",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2332,
   "edad": "52",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/8/2018",
   "mes_fecha": 3,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-08",
   "anio_mes": "2018-03",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2335,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "IZAMAL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/25/2018",
   "mes_fecha": 1,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-25",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2337,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/3/2018",
   "mes_fecha": 6,
   "dia_fecha": 3,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-03",
   "anio_mes": "2018-06",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2339,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "TIZIMIN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/28/2018",
   "mes_fecha": 9,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-28",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2340,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "TIXPEHUAL",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/20/2018",
   "mes_fecha": 12,
   "dia_fecha": 20,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-20",
   "anio_mes": "2018-12",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "22/11/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2342,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/12/2018",
   "mes_fecha": 7,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-12",
   "anio_mes": "2018-07",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2345,
   "edad": "21",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/20/2018",
   "mes_fecha": 7,
   "dia_fecha": 20,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-20",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2348,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "CHEMAX",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/13/2018",
   "mes_fecha": 8,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-13",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "14/09/2016",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 5,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2349,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "CHICHIMILA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/21/2018",
   "mes_fecha": 11,
   "dia_fecha": 21,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-21",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2350,
   "edad": "48",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/25/2018",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-25",
   "anio_mes": "2018-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2352,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "CACALCHEN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/18/2018",
   "mes_fecha": 12,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-18",
   "anio_mes": "2018-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "20/11/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2354,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "CHEMAX",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/19/2018",
   "mes_fecha": 12,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-19",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2358,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/7/2018",
   "mes_fecha": 5,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-07",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "20/04/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2359,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "CUZAMA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/8/2018",
   "mes_fecha": 11,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-08",
   "anio_mes": "2018-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2360,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/23/2018",
   "mes_fecha": 4,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-23",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2361,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/17/2018",
   "mes_fecha": 10,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-17",
   "anio_mes": "2018-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2362,
   "edad": "36",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/7/2018",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-07",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2364,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "TIXKOKOB",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/13/2018",
   "mes_fecha": 3,
   "dia_fecha": 13,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-13",
   "anio_mes": "2018-03",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2366,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "HALACHO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/22/2018",
   "mes_fecha": 6,
   "dia_fecha": 22,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-22",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2367,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "PETO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/7/2018",
   "mes_fecha": 8,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-07",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2369,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "HOCTUN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/12/2018",
   "mes_fecha": 7,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-12",
   "anio_mes": "2018-07",
   "institucion_notificacion": 5,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "21/05/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2372,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "TECOH",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/19/2018",
   "mes_fecha": 6,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-19",
   "anio_mes": "2018-06",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2373,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/18/2018",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-18",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2378,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/26/2018",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-26",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2381,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "SAIN ALTO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/16/2018",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-16",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2383,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/8/2018",
   "mes_fecha": 7,
   "dia_fecha": 8,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-08",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2385,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/5/2018",
   "mes_fecha": 10,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-05",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2389,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "ZACATECAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/16/2018",
   "mes_fecha": 11,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-16",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2392,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/4/2018",
   "mes_fecha": 5,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-04",
   "anio_mes": "2018-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/26/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2396,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "TRANCOSO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "9/4/2018",
   "mes_fecha": 9,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-09-04",
   "anio_mes": "2018-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2398,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VETAGRANDE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/23/2018",
   "mes_fecha": 4,
   "dia_fecha": 23,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-23",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2399,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/5/2018",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-05",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2400,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "4/19/2018",
   "mes_fecha": 4,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-04-19",
   "anio_mes": "2018-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/7/2017",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2401,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/16/2018",
   "mes_fecha": 8,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-16",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2403,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "OJOCALIENTE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/17/2018",
   "mes_fecha": 1,
   "dia_fecha": 17,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-17",
   "anio_mes": "2018-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2404,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/15/2018",
   "mes_fecha": 2,
   "dia_fecha": 15,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-15",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2405,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "6/4/2018",
   "mes_fecha": 6,
   "dia_fecha": 4,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-06-04",
   "anio_mes": "2018-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2407,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VILLA GONZALEZ ORTEGA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/7/2018",
   "mes_fecha": 8,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-07",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/27/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2409,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "12/18/2018",
   "mes_fecha": 12,
   "dia_fecha": 18,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-12-18",
   "anio_mes": "2018-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2410,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "ZACATECAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "2/6/2018",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-02-06",
   "anio_mes": "2018-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2411,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "5/7/2018",
   "mes_fecha": 5,
   "dia_fecha": 7,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-05-07",
   "anio_mes": "2018-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2413,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "10/10/2018",
   "mes_fecha": 10,
   "dia_fecha": 10,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-10-10",
   "anio_mes": "2018-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2416,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "NOCHISTLAN",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/3/2019",
   "mes_fecha": 1,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-03",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2417,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "ZACATECAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/2/2018",
   "mes_fecha": 11,
   "dia_fecha": 2,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-02",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2418,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "ZACATECAS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/1/2018",
   "mes_fecha": 3,
   "dia_fecha": 1,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-01",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2419,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VILLA DE COS",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "3/19/2018",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-03-19",
   "anio_mes": "2018-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2424,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "JEREZ",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "8/28/2018",
   "mes_fecha": 8,
   "dia_fecha": 28,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-08-28",
   "anio_mes": "2018-08",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2430,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "CALERA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "11/12/2018",
   "mes_fecha": 11,
   "dia_fecha": 12,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-11-12",
   "anio_mes": "2018-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "SD",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2431,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "7/19/2018",
   "mes_fecha": 7,
   "dia_fecha": 19,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-07-19",
   "anio_mes": "2018-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "6/1/2018",
   "tipo_vacuna": "2",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2018,
   "fila_archivo": 2434,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "PANFILO NATERA",
   "estado_notificacion": "SIN DATO",
   "municipio_notificacion": "SIN DATO",
   "fecha_texto": "1/8/2019",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-08",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "0",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3,
   "edad": "59",
   "grupo_edad": "55 - 59",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/14/2019",
   "mes_fecha": 2,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-14",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 6,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/28/2019",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-28",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "25/11/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 7,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "PABELLON DE ARTEAGA",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/6/2019",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-06",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "21/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 10,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "7/5/2019",
   "mes_fecha": 7,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-05",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "09/11/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 12,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "PABELLON DE ARTEAGA",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "CALVILLO",
   "fecha_texto": "2/5/2019",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-05",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 20,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "5/7/2019",
   "mes_fecha": 5,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-07",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 22,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "PABELLON DE ARTEAGA",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "PABELLON DE ARTEAGA",
   "fecha_texto": "2/13/2019",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-13",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 23,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "5/3/2019",
   "mes_fecha": 5,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-03",
   "anio_mes": "2019-05",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "22/04/2019",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 24,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/4/2019",
   "mes_fecha": 3,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-04",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 25,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/4/2019",
   "mes_fecha": 3,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-04",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 32,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "SAN FRANCISCO DE LOS ROMO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "PABELLON DE ARTEAGA",
   "fecha_texto": "2/15/2019",
   "mes_fecha": 2,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-15",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 40,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/25/2019",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-25",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 41,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "TEPEZALA",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/8/2019",
   "mes_fecha": 3,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-08",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "12/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 45,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/14/2019",
   "mes_fecha": 2,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-14",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 46,
   "edad": "65",
   "grupo_edad": "65 - 69",
   "demografia_edad": "MAYOR",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/14/2019",
   "mes_fecha": 2,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-14",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 47,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "SAN FRANCISCO DE LOS ROMO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/5/2019",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-05",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 52,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "COSIO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "RINCON DE ROMOS",
   "fecha_texto": "2/7/2019",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-07",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "29/12/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 55,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/25/2019",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-25",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 56,
   "edad": "24",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/25/2019",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-25",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 63,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "JESUS MARIA",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/28/2019",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-28",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 67,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/4/2019",
   "mes_fecha": 3,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-04",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 71,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "RINCON DE ROMOS",
   "fecha_texto": "3/4/2019",
   "mes_fecha": 3,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-04",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "15/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 74,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "SAN FRANCISCO DE LOS ROMO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/5/2019",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-05",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 79,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/16/2019",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-16",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 82,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/4/2019",
   "mes_fecha": 3,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-04",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 84,
   "edad": "17",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/28/2019",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-28",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 88,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/21/2019",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-21",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 89,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "8/12/2019",
   "mes_fecha": 8,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-12",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 94,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "7/5/2019",
   "mes_fecha": 7,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-05",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 115,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "4/16/2019",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-16",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 125,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "5/7/2019",
   "mes_fecha": 5,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-07",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 128,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "PLAYAS DE ROSARITO",
   "fecha_texto": "6/4/2019",
   "mes_fecha": 6,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-04",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 129,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "12/17/2019",
   "mes_fecha": 12,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-17",
   "anio_mes": "2019-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "7/19/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 133,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "6/25/2019",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-25",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 140,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "5/29/2019",
   "mes_fecha": 5,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-29",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/15/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 144,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "4/5/2019",
   "mes_fecha": 4,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-05",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 145,
   "edad": "30",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "8/19/2019",
   "mes_fecha": 8,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-19",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 148,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "7/16/2019",
   "mes_fecha": 7,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-16",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 156,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "4/11/2019",
   "mes_fecha": 4,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-11",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/29/2019",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 158,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "PLAYAS DE ROSARITO",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "PLAYAS DE ROSARITO",
   "fecha_texto": "7/31/2019",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-31",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 159,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "8/26/2019",
   "mes_fecha": 8,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-26",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 161,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "7/3/2019",
   "mes_fecha": 7,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-03",
   "anio_mes": "2019-07",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 165,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "2/5/2019",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-05",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 179,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "10/25/2019",
   "mes_fecha": 10,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-25",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 180,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "1/6/2020",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-06",
   "anio_mes": "2020-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 183,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TECATE",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "4/8/2019",
   "mes_fecha": 4,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-08",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 196,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "11/4/2019",
   "mes_fecha": 11,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-04",
   "anio_mes": "2019-11",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "7/31/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 198,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "5/20/2019",
   "mes_fecha": 5,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-20",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/1/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 204,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "5/9/2019",
   "mes_fecha": 5,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-09",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 210,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "5/16/2019",
   "mes_fecha": 5,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-16",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 213,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ROSARITO",
   "fecha_texto": "7/26/2019",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-26",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 219,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "7/8/2019",
   "mes_fecha": 7,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-08",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 220,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "4/8/2019",
   "mes_fecha": 4,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-08",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 221,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "5/31/2019",
   "mes_fecha": 5,
   "dia_fecha": 31,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-31",
   "anio_mes": "2019-05",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 223,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "10/10/2019",
   "mes_fecha": 10,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-10",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 226,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "11/29/2019",
   "mes_fecha": 11,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-29",
   "anio_mes": "2019-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 231,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "1/15/2019",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-15",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 232,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "COMONDU",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "12/10/2019",
   "mes_fecha": 12,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-10",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "16/10/2019",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 234,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "12/11/2019",
   "mes_fecha": 12,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-11",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 237,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "11/11/2019",
   "mes_fecha": 11,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-11",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 241,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "1/8/2019",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-08",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "12/06/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 243,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "COMONDU",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "COMONDU",
   "fecha_texto": "1/31/2019",
   "mes_fecha": 1,
   "dia_fecha": 31,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-31",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 245,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "12/9/2019",
   "mes_fecha": 12,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-09",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 246,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LOS CABOS",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LOS CABOS",
   "fecha_texto": "6/28/2019",
   "mes_fecha": 6,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-28",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "05/06/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 248,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LOS CABOS",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "6/4/2019",
   "mes_fecha": 6,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-04",
   "anio_mes": "2019-06",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "06/06/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 258,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CAMPECHE",
   "municipio_residencia": "CD.CARMEN",
   "estado_notificacion": "CAMPECHE",
   "municipio_notificacion": "CD.CARMEN",
   "fecha_texto": "10/8/2019",
   "mes_fecha": 10,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-08",
   "anio_mes": "2019-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "11/09/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 260,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHIAPA DE CORZO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/1/2019",
   "mes_fecha": 2,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-01",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 261,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHIAPA DE CORZO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/1/2019",
   "mes_fecha": 2,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-01",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 265,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "6/10/2019",
   "mes_fecha": 6,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-10",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 269,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "BERRIOZABAL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "3/16/2019",
   "mes_fecha": 3,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-16",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 270,
   "edad": "18",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "BERRIOZABAL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "3/17/2019",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-17",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 271,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "8/10/2019",
   "mes_fecha": 8,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-10",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 275,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "1/11/2019",
   "mes_fecha": 1,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-11",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 278,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "COPAINALA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "4/6/2019",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-06",
   "anio_mes": "2019-04",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 279,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "HUEHUETAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TAPACHULA",
   "fecha_texto": "3/9/2019",
   "mes_fecha": 3,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-09",
   "anio_mes": "2019-03",
   "institucion_notificacion": 9,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 280,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "11/11/2019",
   "mes_fecha": 11,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-11",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 284,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VILLAFLORES",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "7/21/2019",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-21",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 286,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "8/2/2019",
   "mes_fecha": 8,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-02",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 288,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "9/25/2019",
   "mes_fecha": 9,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-25",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 290,
   "edad": "28",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "3/22/2019",
   "mes_fecha": 3,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-22",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 292,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "ESCUINTLA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TAPACHULA",
   "fecha_texto": "6/12/2019",
   "mes_fecha": 6,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-12",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 294,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "COPAINALA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "9/20/2019",
   "mes_fecha": 9,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-20",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 297,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "BERRIOZABAL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "OCOZOCOAUTLA DE ESPINOSA",
   "fecha_texto": "4/15/2019",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-15",
   "anio_mes": "2019-04",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 306,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "8/10/2019",
   "mes_fecha": 8,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-10",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "06/06/2019",
   "tipo_vacuna": "4",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 307,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHIAPA DE CORZO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "9/16/2019",
   "mes_fecha": 9,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-16",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 308,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "1/11/2019",
   "mes_fecha": 1,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-11",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 310,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OCOZOCOAUTLA DE ESPINOSA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "OCOZOCOAUTLA DE ESPINOSA",
   "fecha_texto": "4/15/2019",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-15",
   "anio_mes": "2019-04",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 314,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "5/5/2019",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-05",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 317,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "1/4/2019",
   "mes_fecha": 1,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-04",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 318,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CINTALAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "1/26/2019",
   "mes_fecha": 1,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-26",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 319,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "1/4/2019",
   "mes_fecha": 1,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-04",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 320,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "6/15/2019",
   "mes_fecha": 6,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-15",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 321,
   "edad": "33",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "6/15/2019",
   "mes_fecha": 6,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-15",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 323,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TAPACHULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TAPACHULA",
   "fecha_texto": "7/25/2019",
   "mes_fecha": 7,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-25",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 324,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VILLAFLORES",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "VILLAFLORES",
   "fecha_texto": "9/4/2019",
   "mes_fecha": 9,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-04",
   "anio_mes": "2019-09",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 325,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "COPAINALA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "9/20/2019",
   "mes_fecha": 9,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-20",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 327,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "HUEHUETAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "HUIXTLA",
   "fecha_texto": "9/6/2019",
   "mes_fecha": 9,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-06",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 330,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "10/1/2019",
   "mes_fecha": 10,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-01",
   "anio_mes": "2019-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/09/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 331,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "USUMACINTA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "1/9/2019",
   "mes_fecha": 1,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-09",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 333,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "3/22/2019",
   "mes_fecha": 3,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-22",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 336,
   "edad": "36",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "COPAINALA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "4/6/2019",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-06",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 338,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "8/6/2019",
   "mes_fecha": 8,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-06",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 339,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CACAHOATAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TAPACHULA",
   "fecha_texto": "9/20/2019",
   "mes_fecha": 9,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-20",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 340,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "8/8/2019",
   "mes_fecha": 8,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-08",
   "anio_mes": "2019-08",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 341,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "MEZCALAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "11/7/2019",
   "mes_fecha": 11,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-07",
   "anio_mes": "2019-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 342,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "10/18/2019",
   "mes_fecha": 10,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-18",
   "anio_mes": "2019-10",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 346,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "9/24/2019",
   "mes_fecha": 9,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-24",
   "anio_mes": "2019-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 362,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "BALLEZA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "PARRAL",
   "fecha_texto": "10/15/2019",
   "mes_fecha": 10,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-15",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 363,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GUACHOCHI",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "GUACHOCHI",
   "fecha_texto": "9/28/2019",
   "mes_fecha": 9,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-28",
   "anio_mes": "2019-09",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 373,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CARICHI",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "7/24/2019",
   "mes_fecha": 7,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-24",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 379,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "2/6/2019",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-06",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 381,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "NUEVO CASAS GRANDES",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "NUEVO CASAS GRANDES",
   "fecha_texto": "9/13/2019",
   "mes_fecha": 9,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-13",
   "anio_mes": "2019-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 386,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GALEANA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "NUEVO CASAS GRANDES",
   "fecha_texto": "8/2/2019",
   "mes_fecha": 8,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-02",
   "anio_mes": "2019-08",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 413,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "5/8/2019",
   "mes_fecha": 5,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-08",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 425,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "6/14/2019",
   "mes_fecha": 6,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-14",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 432,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "8/12/2019",
   "mes_fecha": 8,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-12",
   "anio_mes": "2019-08",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 433,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTACALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTACALCO",
   "fecha_texto": "1/30/2019",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-30",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 446,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "2/25/2019",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-25",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 448,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "3/26/2019",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-26",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 452,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MIGUEL HIDALGO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "ALVARO OBREGON",
   "fecha_texto": "3/27/2019",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-27",
   "anio_mes": "2019-03",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 453,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "8/14/2019",
   "mes_fecha": 8,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-14",
   "anio_mes": "2019-08",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "22/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 454,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "4/26/2019",
   "mes_fecha": 4,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-26",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "17/04/2019",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 456,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACCAN",
   "fecha_texto": "6/28/2019",
   "mes_fecha": 6,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-28",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 457,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTACALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "6/25/2019",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-25",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 465,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "VENUSTIANO CARRANZA",
   "fecha_texto": "2/28/2019",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-28",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 470,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MILPA ALTA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "MIGUEL HIDALGO",
   "fecha_texto": "11/7/2019",
   "mes_fecha": 11,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-07",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 471,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "2/27/2019",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-27",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 472,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "VENUSTIANO CARRANZA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "VENUSTIANO CARRANZA",
   "fecha_texto": "7/5/2019",
   "mes_fecha": 7,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-05",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 481,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "3/6/2019",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-06",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "23/05/2017",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 482,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "3/26/2019",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-26",
   "anio_mes": "2019-03",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 483,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "11/28/2019",
   "mes_fecha": 11,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-28",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 486,
   "edad": "50",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "MAGDALENA CONTRERAS",
   "fecha_texto": "3/7/2019",
   "mes_fecha": 3,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-07",
   "anio_mes": "2019-03",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 487,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "XOCHIMILCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "6/25/2019",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-25",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 491,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "1/26/2019",
   "mes_fecha": 1,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-26",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 493,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "VENUSTIANO CARRANZA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "8/29/2019",
   "mes_fecha": 8,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-29",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "06/08/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 495,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MIGUEL HIDALGO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "MIGUEL HIDALGO",
   "fecha_texto": "11/20/2019",
   "mes_fecha": 11,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-20",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 498,
   "edad": "51",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "COYOACAN",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "12/4/2019",
   "mes_fecha": 12,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-04",
   "anio_mes": "2019-12",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 500,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "2/13/2019",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-13",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 503,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "10/24/2019",
   "mes_fecha": 10,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-24",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 505,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MAGDALENA CONTRERAS",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "MAGDALENA CONTRERAS",
   "fecha_texto": "7/9/2019",
   "mes_fecha": 7,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-09",
   "anio_mes": "2019-07",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 507,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "5/6/2019",
   "mes_fecha": 5,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-06",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 511,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "9/10/2019",
   "mes_fecha": 9,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-10",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 519,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MILPA ALTA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTACALCO",
   "fecha_texto": "8/24/2019",
   "mes_fecha": 8,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-24",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 521,
   "edad": "73",
   "grupo_edad": "70 - 74",
   "demografia_edad": "MAYOR",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MAGDALENA CONTRERAS",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "MAGDALENA CONTRERAS",
   "fecha_texto": "2/28/2019",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-28",
   "anio_mes": "2019-02",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 524,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "6/3/2019",
   "mes_fecha": 6,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-03",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "01/09/2018",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 526,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "4/26/2019",
   "mes_fecha": 4,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-26",
   "anio_mes": "2019-04",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 530,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "11/29/2019",
   "mes_fecha": 11,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-29",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 531,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "3/19/2019",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-19",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 534,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "10/18/2019",
   "mes_fecha": 10,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-18",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 535,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "AZCAPOTZALCO",
   "fecha_texto": "11/1/2019",
   "mes_fecha": 11,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-01",
   "anio_mes": "2019-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 541,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "1/25/2019",
   "mes_fecha": 1,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-25",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 543,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "10/29/2019",
   "mes_fecha": 10,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-29",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 546,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "CUAJIMALPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "MIGUEL HIDALGO",
   "fecha_texto": "11/20/2019",
   "mes_fecha": 11,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-20",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 551,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "CUAJIMALPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "9/12/2019",
   "mes_fecha": 9,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-12",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 553,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "9/18/2019",
   "mes_fecha": 9,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-18",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 555,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "2/4/2019",
   "mes_fecha": 2,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-04",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 562,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "XOCHIMILCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "12/12/2019",
   "mes_fecha": 12,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-12",
   "anio_mes": "2019-12",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 565,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTACALCO",
   "fecha_texto": "2/25/2019",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-25",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 566,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLAHUAC",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "XOCHIMILCO",
   "fecha_texto": "3/20/2019",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-20",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 572,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "VENUSTIANO CARRANZA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "6/20/2019",
   "mes_fecha": 6,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-20",
   "anio_mes": "2019-06",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "24/05/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 573,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "ALVARO OBREGON",
   "fecha_texto": "1/6/2020",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-06",
   "anio_mes": "2020-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 575,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "2/25/2019",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-25",
   "anio_mes": "2019-02",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 578,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "1/28/2019",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-28",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 581,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTACALCO",
   "fecha_texto": "4/15/2019",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-15",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 585,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "XOCHIMILCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "7/31/2019",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-31",
   "anio_mes": "2019-07",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "18/07/2019",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 589,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTACALCO",
   "fecha_texto": "6/27/2019",
   "mes_fecha": 6,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-27",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 591,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "9/17/2019",
   "mes_fecha": 9,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-17",
   "anio_mes": "2019-09",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "02/09/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 594,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "11/22/2019",
   "mes_fecha": 11,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-22",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 598,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "3/7/2019",
   "mes_fecha": 3,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-07",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 599,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTACALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTACALCO",
   "fecha_texto": "1/7/2019",
   "mes_fecha": 1,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-07",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 600,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 605,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "11/15/2019",
   "mes_fecha": 11,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-15",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 606,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "1/14/2019",
   "mes_fecha": 1,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-14",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 609,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "VENUSTIANO CARRANZA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "VENUSTIANO CARRANZA",
   "fecha_texto": "11/11/2019",
   "mes_fecha": 11,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-11",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "9/3/2019",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 611,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "3/13/2019",
   "mes_fecha": 3,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-13",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 612,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTACALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "7/19/2019",
   "mes_fecha": 7,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-19",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 613,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "1/10/2019",
   "mes_fecha": 1,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-10",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 615,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "4/15/2019",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-15",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 620,
   "edad": "54",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "MAGDALENA CONTRERAS",
   "fecha_texto": "5/14/2019",
   "mes_fecha": 5,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-14",
   "anio_mes": "2019-05",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 624,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "10/22/2019",
   "mes_fecha": 10,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-22",
   "anio_mes": "2019-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 627,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "3/22/2019",
   "mes_fecha": 3,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-22",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 633,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "4/22/2019",
   "mes_fecha": 4,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-22",
   "anio_mes": "2019-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 634,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "2/28/2019",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-28",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 635,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "5/12/2019",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-12",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 640,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "5/13/2019",
   "mes_fecha": 5,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-13",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 644,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "10/7/2019",
   "mes_fecha": 10,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-07",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 648,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "RAMOS ARIZPE",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "6/2/2019",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-02",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 652,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "1/2/2020",
   "mes_fecha": 1,
   "dia_fecha": 2,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-02",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 653,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "2/27/2019",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-27",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "8",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 654,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "TORREÓN",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "TORREÓN",
   "fecha_texto": "3/15/2019",
   "mes_fecha": 3,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-15",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 655,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "ACUÑA",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "ACUÑA",
   "fecha_texto": "6/20/2019",
   "mes_fecha": 6,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-20",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 656,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "3/29/2019",
   "mes_fecha": 3,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-29",
   "anio_mes": "2019-03",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 665,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "5/14/2019",
   "mes_fecha": 5,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-14",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 668,
   "edad": "42",
   "grupo_edad": "40 - 44",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "OCAMPO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "CUATRO CIENEGAS",
   "fecha_texto": "8/5/2019",
   "mes_fecha": 8,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-05",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 670,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "TORREÓN",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "TORREON",
   "fecha_texto": "4/8/2019",
   "mes_fecha": 4,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-08",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 671,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "PIEDRAS NEGRAS",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "PIEDRAS NEGRAS",
   "fecha_texto": "7/9/2019",
   "mes_fecha": 7,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-09",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "30/06/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 672,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "1/2/2020",
   "mes_fecha": 1,
   "dia_fecha": 2,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-02",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 674,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "9/30/2019",
   "mes_fecha": 9,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-30",
   "anio_mes": "2019-09",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 675,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "MONCLOVA",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "MONCLOVA",
   "fecha_texto": "7/10/2019",
   "mes_fecha": 7,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-10",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 676,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "TORREÓN",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "TORREON",
   "fecha_texto": "4/1/2019",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-01",
   "anio_mes": "2019-04",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 678,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "3/27/2019",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-27",
   "anio_mes": "2019-03",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 682,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "MONCLOVA",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "MONCLOVA",
   "fecha_texto": "8/26/2019",
   "mes_fecha": 8,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-26",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 683,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "1/2/2020",
   "mes_fecha": 1,
   "dia_fecha": 2,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-02",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 686,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "5/13/2019",
   "mes_fecha": 5,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-13",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "24/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 688,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "1/2/2020",
   "mes_fecha": 1,
   "dia_fecha": 2,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-02",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 691,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "1/2/2020",
   "mes_fecha": 1,
   "dia_fecha": 2,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-02",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 694,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "1/2/2020",
   "mes_fecha": 1,
   "dia_fecha": 2,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-02",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 698,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "2/25/2019",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-25",
   "anio_mes": "2019-02",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 700,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "5/13/2019",
   "mes_fecha": 5,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-13",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 703,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "TORREÓN",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "TORREON",
   "fecha_texto": "3/29/2019",
   "mes_fecha": 3,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-29",
   "anio_mes": "2019-03",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 704,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "MONCLOVA",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "MONCLOVA",
   "fecha_texto": "6/13/2019",
   "mes_fecha": 6,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-13",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 707,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "TORREÓN",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "TORREON",
   "fecha_texto": "5/17/2019",
   "mes_fecha": 5,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-17",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "03/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 708,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "TORREÓN",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "TORREON",
   "fecha_texto": "5/17/2019",
   "mes_fecha": 5,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-17",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "03/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 710,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "COAHUILA",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "7/8/2019",
   "mes_fecha": 7,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-08",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 711,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "OCAMPO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "CUATRO CIENEGAS",
   "fecha_texto": "7/16/2019",
   "mes_fecha": 7,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-16",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 714,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "3/26/2019",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-26",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 717,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "MONCLOVA",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "MONCLOVA",
   "fecha_texto": "5/27/2019",
   "mes_fecha": 5,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-27",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 720,
   "edad": "7",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "MONCLOVA",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "MONCLOVA",
   "fecha_texto": "4/4/2019",
   "mes_fecha": 4,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-04",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "21/05/2013",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 721,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "5/6/2019",
   "mes_fecha": 5,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-06",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 723,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "7/23/2019",
   "mes_fecha": 7,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-23",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 724,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "GENERAL CEPEDA",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "3/26/2019",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-26",
   "anio_mes": "2019-03",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 727,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "TORREÓN",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "TORREON",
   "fecha_texto": "4/2/2019",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-02",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 729,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "RAMOS ARIZPE",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "7/26/2019",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-26",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 731,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "7/9/2019",
   "mes_fecha": 7,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-09",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 734,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "1/2/2019",
   "mes_fecha": 1,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-02",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 739,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "TORREÓN",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "TORREON",
   "fecha_texto": "4/2/2019",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-02",
   "anio_mes": "2019-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 757,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "MAPIMÍ",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "LERDO",
   "fecha_texto": "5/2/2019",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-02",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 758,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "LERDO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "GÓMEZ PALACIO",
   "fecha_texto": "4/23/2019",
   "mes_fecha": 4,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-23",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "25/03/2019",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 760,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "10/16/2019",
   "mes_fecha": 10,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-16",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 761,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "10/16/2019",
   "mes_fecha": 10,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-16",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 764,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "2/6/2019",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-06",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 765,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "GÓMEZ PALACIO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "GÓMEZ PALACIO",
   "fecha_texto": "6/11/2019",
   "mes_fecha": 6,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-11",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "05/06/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 767,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "4/23/2019",
   "mes_fecha": 4,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-23",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 768,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "1/15/2019",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-15",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 769,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "GÓMEZ PALACIO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "GÓMEZ PALACIO",
   "fecha_texto": "5/6/2019",
   "mes_fecha": 5,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-06",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "09/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 772,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "LERDO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "LERDO",
   "fecha_texto": "3/11/2019",
   "mes_fecha": 3,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-11",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 773,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "MAPIMÍ",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "GÓMEZ PALACIO",
   "fecha_texto": "2/20/2019",
   "mes_fecha": 2,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-20",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "28/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 774,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "SANTIAGO PAPASQUIARO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "12/3/2019",
   "mes_fecha": 12,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-03",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "05/10/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 775,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "GÓMEZ PALACIO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "GÓMEZ PALACIO",
   "fecha_texto": "2/13/2019",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-13",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 776,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "GÓMEZ PALACIO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "GÓMEZ PALACIO",
   "fecha_texto": "4/8/2019",
   "mes_fecha": 4,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-08",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "06/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 777,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "3/16/2019",
   "mes_fecha": 3,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-16",
   "anio_mes": "2019-03",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 778,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "SANTIAGO PAPASQUIARO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "SANTIAGO PAPASQUIARO",
   "fecha_texto": "9/27/2019",
   "mes_fecha": 9,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-27",
   "anio_mes": "2019-09",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "21/06/2019",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 779,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "IRAPUATO",
   "fecha_texto": "3/13/2019",
   "mes_fecha": 3,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-13",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 780,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "1/15/2019",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-15",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 782,
   "edad": "21",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "6/11/2019",
   "mes_fecha": 6,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-11",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 786,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "1/23/2019",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-23",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 791,
   "edad": "#REF!",
   "grupo_edad": "#REF!",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "CORTAZAR",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "CORTAZAR",
   "fecha_texto": "1/31/2019",
   "mes_fecha": 1,
   "dia_fecha": 31,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-31",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 793,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "CELAYA",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "CELAYA",
   "fecha_texto": "3/13/2019",
   "mes_fecha": 3,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-13",
   "anio_mes": "2019-03",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "04/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 801,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "2/6/2019",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-06",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 807,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "IRAPUATO",
   "fecha_texto": "5/10/2019",
   "mes_fecha": 5,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-10",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 808,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "1/30/2019",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-30",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 810,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "3/12/2019",
   "mes_fecha": 3,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-12",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 820,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "2/11/2019",
   "mes_fecha": 2,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-11",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "18/12/2018",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 824,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "2/17/2019",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-17",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "29/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 836,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "IRAPUATO",
   "fecha_texto": "5/31/2019",
   "mes_fecha": 5,
   "dia_fecha": 31,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-31",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "21/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 845,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SAN MIGUEL DE ALLENDE",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "SAN MIGUEL DE ALLENDE",
   "fecha_texto": "8/27/2019",
   "mes_fecha": 8,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-27",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "08/08/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 846,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SAN FELIPE",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "DOLORES HIDALGO",
   "fecha_texto": "6/4/2019",
   "mes_fecha": 6,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-04",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "13/04/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 851,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "PURISIMA",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "PURISIMA",
   "fecha_texto": "3/7/2019",
   "mes_fecha": 3,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-07",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "01/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 852,
   "edad": "39",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "PURISIMA",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "PURISIMA",
   "fecha_texto": "3/12/2019",
   "mes_fecha": 3,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-12",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 853,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "GUANAJUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "SILAO",
   "fecha_texto": "1/30/2019",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-30",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 856,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "4/15/2019",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-15",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "03/12/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 867,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SILAO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "SILAO",
   "fecha_texto": "2/25/2019",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-25",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 874,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "1/10/2019",
   "mes_fecha": 1,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-10",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 886,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SALAMANCA",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "SALAMANCA",
   "fecha_texto": "2/1/2019",
   "mes_fecha": 2,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-01",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 890,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "5/13/2019",
   "mes_fecha": 5,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-13",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "15/04/2019",
   "tipo_vacuna": "1",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 891,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "ROMITA",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "ROMITA",
   "fecha_texto": "2/1/2019",
   "mes_fecha": 2,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-01",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "10/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 899,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "1/25/2019",
   "mes_fecha": 1,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-25",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 900,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "2/6/2019",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-06",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 917,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "IRAPUATO",
   "fecha_texto": "2/7/2019",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-07",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 935,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "ABASOLO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "IRAPUATO",
   "fecha_texto": "5/24/2019",
   "mes_fecha": 5,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-24",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 937,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "2/1/2019",
   "mes_fecha": 2,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-01",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 943,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "IRAPUATO",
   "fecha_texto": "4/24/2019",
   "mes_fecha": 4,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-24",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 944,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "1/10/2019",
   "mes_fecha": 1,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-10",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 960,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SAN FELIPE",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "4/2/2019",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-02",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 965,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "OCAMPO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "5/8/2019",
   "mes_fecha": 5,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-08",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 966,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "3/11/2019",
   "mes_fecha": 3,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-11",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "01/06/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 972,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "IRAPUATO",
   "fecha_texto": "3/13/2019",
   "mes_fecha": 3,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-13",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 973,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "3/14/2019",
   "mes_fecha": 3,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-14",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 978,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "1/17/2019",
   "mes_fecha": 1,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-17",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 982,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "3/5/2019",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-05",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 991,
   "edad": "24",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "2/26/2019",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-26",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 992,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "6/22/2019",
   "mes_fecha": 6,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-22",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1002,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SILAO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "SILAO",
   "fecha_texto": "3/18/2019",
   "mes_fecha": 3,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-18",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1015,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SALAMANCA",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "SALAMANCA",
   "fecha_texto": "4/16/2019",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-16",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1022,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SILAO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "SILAO",
   "fecha_texto": "3/22/2019",
   "mes_fecha": 3,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-22",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1024,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "GUANAJUATO",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "10/11/2019",
   "mes_fecha": 10,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-11",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "12/21/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1027,
   "edad": "17",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "3/5/2019",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-05",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "01/01/1992",
   "tipo_vacuna": "1",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1029,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "3/19/2019",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-19",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "15/12/2017",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1047,
   "edad": "#REF!",
   "grupo_edad": "#REF!",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "JUVENTINO ROSAS",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "JUVENTINO ROSAS",
   "fecha_texto": "1/22/2019",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-22",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "28/12/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1048,
   "edad": "27",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "3/5/2019",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-05",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "01/01/1992",
   "tipo_vacuna": "1",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1050,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "11/22/2019",
   "mes_fecha": 11,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-22",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1051,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "IRAPUATO",
   "fecha_texto": "10/30/2019",
   "mes_fecha": 10,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-30",
   "anio_mes": "2019-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1062,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "3/11/2019",
   "mes_fecha": 3,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-11",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1065,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "2/16/2019",
   "mes_fecha": 2,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-16",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1067,
   "edad": "#REF!",
   "grupo_edad": "#REF!",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "VILLAGRAN",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "VILLAGRAN",
   "fecha_texto": "2/15/2019",
   "mes_fecha": 2,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-15",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "18/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1068,
   "edad": "27",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "1/14/2019",
   "mes_fecha": 1,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-14",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1073,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "ROMITA",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "ROMITA",
   "fecha_texto": "11/21/2019",
   "mes_fecha": 11,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-21",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "26/07/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1078,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "4/1/2019",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-01",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "09/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1080,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SAN FELIPE",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "9/20/2019",
   "mes_fecha": 9,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-20",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1094,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "2/18/2019",
   "mes_fecha": 2,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-18",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1106,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "1/28/2019",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-28",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1109,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "2/13/2019",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-13",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1118,
   "edad": "#REF!",
   "grupo_edad": "#REF!",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "COMONFORT",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "CELAYA",
   "fecha_texto": "7/18/2019",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-18",
   "anio_mes": "2019-07",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1119,
   "edad": "8",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "COMONFORT",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "CELAYA",
   "fecha_texto": "7/18/2019",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-18",
   "anio_mes": "2019-07",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "31/10/2014",
   "tipo_vacuna": "1",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1132,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "3/19/2019",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-19",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1140,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "2/18/2019",
   "mes_fecha": 2,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-18",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1147,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "GUANAJUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "GUANAJUATO",
   "fecha_texto": "1/16/2019",
   "mes_fecha": 1,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-16",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1160,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "IRAPUATO",
   "fecha_texto": "4/30/2019",
   "mes_fecha": 4,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-30",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1162,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "2/26/2019",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-26",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1164,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "1/22/2019",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-22",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/01/2019",
   "tipo_vacuna": "3",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1174,
   "edad": "13",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "3/5/2019",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-05",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "01/01/2004",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1185,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "DOLORES HIDALGO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "DOLORES HIDALGO",
   "fecha_texto": "7/1/2019",
   "mes_fecha": 7,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-01",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1186,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "IRAPUATO",
   "fecha_texto": "4/16/2019",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-16",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "23/03/2019",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1187,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "GUANAJUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "DOLORES HIDALGO",
   "fecha_texto": "4/1/2019",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-01",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1213,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "12/8/2019",
   "mes_fecha": 12,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-08",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1227,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "3/29/2019",
   "mes_fecha": 3,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-29",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1231,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUERRERO",
   "municipio_residencia": "TECPAN DE GALEANA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "10/24/2019",
   "mes_fecha": 10,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-24",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1297,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "TIZAYUCA",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "TIZAYUCA",
   "fecha_texto": "6/10/2019",
   "mes_fecha": 6,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-10",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1329,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "MINERAL DE LA REFORMA",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "PACHUCA",
   "fecha_texto": "7/17/2019",
   "mes_fecha": 7,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-17",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1339,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "PACHUCA DE SOTO",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "PACHUCA",
   "fecha_texto": "6/26/2019",
   "mes_fecha": 6,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-26",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1349,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "TULANCINGO",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "METEPEC",
   "fecha_texto": "5/2/2019",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-02",
   "anio_mes": "2019-05",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1354,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "12/13/2019",
   "mes_fecha": 12,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-13",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1356,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "4/22/2019",
   "mes_fecha": 4,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-22",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1370,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "10/28/2019",
   "mes_fecha": 10,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-28",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "22/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1376,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "11/13/2019",
   "mes_fecha": 11,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-13",
   "anio_mes": "2019-11",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "07/06/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1377,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "9/20/2019",
   "mes_fecha": 9,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-20",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "19/08/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1378,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "BOLAÑOS",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "COLOTLAN",
   "fecha_texto": "8/29/2019",
   "mes_fecha": 8,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-29",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "25/11/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1387,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "BOLAÑOS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "JEREZ",
   "fecha_texto": "8/19/2019",
   "mes_fecha": 8,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-19",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "25/06/2019",
   "tipo_vacuna": "1",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1391,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "10/22/2019",
   "mes_fecha": 10,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-22",
   "anio_mes": "2019-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1397,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "PONCITLAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "2/1/2019",
   "mes_fecha": 2,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-01",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1403,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "1/15/2019",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-15",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1411,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "10/25/2019",
   "mes_fecha": 10,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-25",
   "anio_mes": "2019-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1412,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "2/8/2019",
   "mes_fecha": 2,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-08",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1414,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "PONCITLAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "2/16/2019",
   "mes_fecha": 2,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-16",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1418,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "2/20/2019",
   "mes_fecha": 2,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-20",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1439,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "2/18/2019",
   "mes_fecha": 2,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-18",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1441,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "TLAJOMULCO DE ZÚÑIGA",
   "fecha_texto": "2/5/2019",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-05",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1445,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN PEDRO TLAQUEPAQUE",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "7/10/2019",
   "mes_fecha": 7,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-10",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1461,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN PEDRO TLAQUEPAQUE",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "4/17/2019",
   "mes_fecha": 4,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-17",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "20/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1464,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "AUTLAN DE NAVARRO",
   "estado_notificacion": "COLIMA",
   "municipio_notificacion": "COLIMA",
   "fecha_texto": "1/22/2019",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-22",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1465,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "2/13/2019",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-13",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1471,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "7/12/2019",
   "mes_fecha": 7,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-12",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "07/06/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1475,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TONALA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "2/27/2019",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-27",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "25/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1488,
   "edad": "11",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "3/5/2019",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-05",
   "anio_mes": "2019-03",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "30/06/1905",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1489,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "1/24/2019",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-24",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1492,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TONALA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "6/3/2019",
   "mes_fecha": 6,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-03",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1502,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "5/13/2019",
   "mes_fecha": 5,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-13",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1503,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "2/11/2019",
   "mes_fecha": 2,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-11",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1509,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TONALA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "3/5/2019",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-05",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1514,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "5/31/2019",
   "mes_fecha": 5,
   "dia_fecha": 31,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-31",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1521,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "TLAJOMULCO DE ZÚÑIGA",
   "fecha_texto": "3/6/2019",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-06",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1529,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "EL SALTO",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "3/19/2019",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-19",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1535,
   "edad": "19",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "3/19/2019",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-19",
   "anio_mes": "2019-03",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1537,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "6/18/2019",
   "mes_fecha": 6,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-18",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1540,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "JALOSTOTITLAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "JALOSTOTITLAN",
   "fecha_texto": "6/26/2019",
   "mes_fecha": 6,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-26",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1542,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TONALA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "3/26/2019",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-26",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1550,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "8/10/2019",
   "mes_fecha": 8,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-10",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1551,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "5/27/2019",
   "mes_fecha": 5,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-27",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1556,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "2/1/2019",
   "mes_fecha": 2,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-01",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1559,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "OJUELOS DE JALISCO",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "OJUELOS DE JALISCO",
   "fecha_texto": "4/24/2019",
   "mes_fecha": 4,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-24",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1565,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN PEDRO TLAQUEPAQUE",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "3/17/2019",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-17",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1569,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "PONCITLAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "1/29/2019",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-29",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1575,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "3/15/2019",
   "mes_fecha": 3,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-15",
   "anio_mes": "2019-03",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1576,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "1/7/2019",
   "mes_fecha": 1,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-07",
   "anio_mes": "2019-01",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1577,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN PEDRO TLAQUEPAQUE",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "1/28/2019",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-28",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1579,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TUXCUECA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "8/4/2019",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-04",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1588,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NEZAHUALCOYOTL",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "AZCAPOTZALCO",
   "fecha_texto": "4/2/2019",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-02",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1589,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ZUMPANGO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TECAMAC",
   "fecha_texto": "5/3/2019",
   "mes_fecha": 5,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-03",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1590,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ZUMPANGO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TECAMAC",
   "fecha_texto": "5/3/2019",
   "mes_fecha": 5,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-03",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1591,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CHIMALHUACAN",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "NEZAHUALCOYOTL",
   "fecha_texto": "3/13/2019",
   "mes_fecha": 3,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-13",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1592,
   "edad": "16",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NEZAHUALCOYOTL",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "NEZAHUALCOYOTL",
   "fecha_texto": "3/13/2019",
   "mes_fecha": 3,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-13",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1594,
   "edad": "69",
   "grupo_edad": "65 - 69",
   "demografia_edad": "MAYOR",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "ECATEPEC",
   "fecha_texto": "5/8/2019",
   "mes_fecha": 5,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-08",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1595,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TENANCINGO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TENANCINGO",
   "fecha_texto": "4/17/2019",
   "mes_fecha": 4,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-17",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1597,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NEZAHUALCOYOTL",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "NEZAHUALCOYOTL",
   "fecha_texto": "5/30/2019",
   "mes_fecha": 5,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-30",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1602,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ZUMPANGO",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "PACHUCA",
   "fecha_texto": "4/2/2019",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-02",
   "anio_mes": "2019-04",
   "institucion_notificacion": 6,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1604,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "ECATEPEC",
   "fecha_texto": "4/1/2019",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-01",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1605,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC DE MORELOS",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "1/8/2019",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-08",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1608,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TLALNEPANTLA",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "4/26/2019",
   "mes_fecha": 4,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-26",
   "anio_mes": "2019-04",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1609,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TECAMAC",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "6/24/2019",
   "mes_fecha": 6,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-24",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1612,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TLALNEPANTLA",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TLLNEPANTLA",
   "fecha_texto": "1/18/2019",
   "mes_fecha": 1,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-18",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1615,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "OZUMBA",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "CUAUTLA",
   "fecha_texto": "6/13/2019",
   "mes_fecha": 6,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-13",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1617,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "MELCHOR OCAMPO",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "1/25/2019",
   "mes_fecha": 1,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-25",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1619,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TLALNEPANTLA",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "6/20/2019",
   "mes_fecha": 6,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-20",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1620,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC DE MORELOS",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "7/3/2019",
   "mes_fecha": 7,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-03",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1625,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TLALNEPANTLA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "8/19/2019",
   "mes_fecha": 8,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-19",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1626,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ZINACANTEPEC",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "ZINACANTEPEC",
   "fecha_texto": "3/15/2019",
   "mes_fecha": 3,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-15",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "20/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1628,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "HUEHUETOCA",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "ZUMPANGO",
   "fecha_texto": "10/8/2019",
   "mes_fecha": 10,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-08",
   "anio_mes": "2019-10",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1629,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "JILOTZINGO",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "3/20/2019",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-20",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1630,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TLALNEPANTLA",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "1/6/2019",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-06",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "24/10/2018",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1631,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CUAUTITLAN IZCALLI",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "CUAUTITLAN I",
   "fecha_texto": "3/21/2019",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-21",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "31/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1633,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TULTITLAN",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "AZCAPOTZALCO",
   "fecha_texto": "9/12/2019",
   "mes_fecha": 9,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-12",
   "anio_mes": "2019-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1634,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TULTITLAN",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "AZCAPOTZALCO",
   "fecha_texto": "10/2/2019",
   "mes_fecha": 10,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-02",
   "anio_mes": "2019-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1636,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "COCOTITLAN",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "CHALCO",
   "fecha_texto": "9/19/2019",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-19",
   "anio_mes": "2019-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1638,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "LOS REYES LA PAZ",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "4/10/2019",
   "mes_fecha": 4,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-10",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1640,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "VALLE DE CHALCO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "VALLE DE CHALCO",
   "fecha_texto": "2/8/2019",
   "mes_fecha": 2,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-08",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1641,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CHALCO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "CHALCO",
   "fecha_texto": "3/22/2019",
   "mes_fecha": 3,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-22",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1642,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NEZAHUALCOYOTL",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GAM",
   "fecha_texto": "5/23/2019",
   "mes_fecha": 5,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-23",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "19/04/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1643,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "HUEHUETOCAN",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "CUAUTITLAN",
   "fecha_texto": "6/11/2019",
   "mes_fecha": 6,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-11",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1646,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "VALLE DE CHALCO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "CHALCO",
   "fecha_texto": "1/25/2019",
   "mes_fecha": 1,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-25",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1648,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TLALNEPANTLA",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "7/3/2019",
   "mes_fecha": 7,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-03",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1652,
   "edad": "18",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ZUMPANGO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TECAMAC",
   "fecha_texto": "5/3/2019",
   "mes_fecha": 5,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-03",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1653,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TEXCOCO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TEXCOCO",
   "fecha_texto": "2/28/2019",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-28",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1655,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CHALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "10/18/2019",
   "mes_fecha": 10,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-18",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1657,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CHALCO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "CHALCO",
   "fecha_texto": "3/5/2019",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-05",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1659,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "OTZOLOTEPEC",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "OTZOLOTEPEC",
   "fecha_texto": "3/21/2019",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-21",
   "anio_mes": "2019-03",
   "institucion_notificacion": 6,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1660,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NEZAHUALCOYOTL",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "1/8/2019",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-08",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1664,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NAUCALPAN",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "NAUCALPAN",
   "fecha_texto": "2/6/2019",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-06",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1675,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC DE MORELOS",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "7/1/2019",
   "mes_fecha": 7,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-01",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "27/05/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1677,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TOLUCA",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TOLUCA",
   "fecha_texto": "4/26/2019",
   "mes_fecha": 4,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-26",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1679,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CHALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "9/5/2019",
   "mes_fecha": 9,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-05",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1680,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "VILLA VICTORIA",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TOLUCA",
   "fecha_texto": "9/14/2019",
   "mes_fecha": 9,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-14",
   "anio_mes": "2019-09",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1685,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NEZAHUALCOYOTL",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "VENUSTIANO CARRANZA",
   "fecha_texto": "7/30/2019",
   "mes_fecha": 7,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-30",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1687,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "HUEHUETOCA",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "MIGUEL HIDALGO",
   "fecha_texto": "1/1/2019",
   "mes_fecha": 1,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-01",
   "anio_mes": "2019-01",
   "institucion_notificacion": 8,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1694,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TLALNEPANTLA",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "6/18/2019",
   "mes_fecha": 6,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-18",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1699,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC DE MORELOS",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "7/31/2019",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-31",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1701,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC DE MORELOS",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "3/5/2019",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-05",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1704,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "HUIXQUILUCAN",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "6/25/2019",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-25",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1707,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC DE MORELOS",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "3/19/2019",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-19",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1711,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NAUCALPAN",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "NAUCALPAN",
   "fecha_texto": "1/22/2019",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-22",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "07/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1712,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "XONACATLAN",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TOLUCA",
   "fecha_texto": "6/6/2019",
   "mes_fecha": 6,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-06",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1721,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TECAMAC",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TECAMAC",
   "fecha_texto": "4/24/2019",
   "mes_fecha": 4,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-24",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1722,
   "edad": "50",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NEZAHUALCOYOTL",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "LOS REYES LA PAZ",
   "fecha_texto": "6/4/2019",
   "mes_fecha": 6,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-04",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1723,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TEZOYUCA",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "8/6/2019",
   "mes_fecha": 8,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-06",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1731,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CHALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "9/19/2019",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-19",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1743,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "2/4/2019",
   "mes_fecha": 2,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-04",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "28/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1744,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "URUAPAN",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "URUAPAN",
   "fecha_texto": "10/4/2019",
   "mes_fecha": 10,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-04",
   "anio_mes": "2019-10",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1747,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "CARACUARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "3/28/2019",
   "mes_fecha": 3,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-28",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1748,
   "edad": "16",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "CARACUARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "3/28/2019",
   "mes_fecha": 3,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-28",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1757,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "1/15/2019",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-15",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "13/12/2018",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1761,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "2/4/2019",
   "mes_fecha": 2,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-04",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1762,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "TARIMBARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "3/27/2019",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-27",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1766,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "ZAMORA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "ZAMORA",
   "fecha_texto": "10/28/2019",
   "mes_fecha": 10,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-28",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1769,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "YURECUARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "YURECUARO",
   "fecha_texto": "10/15/2019",
   "mes_fecha": 10,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-15",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1773,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "OCAMPO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "4/26/2019",
   "mes_fecha": 4,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-26",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1774,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "3/26/2019",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-26",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "13/05/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1780,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "PATZCUARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "2/7/2019",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-07",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "02/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1781,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "JACONA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "JACONA",
   "fecha_texto": "10/6/2019",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-06",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1782,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "10/2/2019",
   "mes_fecha": 10,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-02",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1792,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "2/25/2019",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-25",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "28/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1795,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "TLALPUJAHUA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MARAVATIO",
   "fecha_texto": "9/6/2019",
   "mes_fecha": 9,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-06",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1798,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "URUAPAN",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "URUAPAN",
   "fecha_texto": "1/28/2019",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-28",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "08/01/1900",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1800,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "9/19/2019",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-19",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1805,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "HIDALGO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "10/20/2019",
   "mes_fecha": 10,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-20",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1807,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "URUAPAN",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "URUAPAN",
   "fecha_texto": "7/24/2019",
   "mes_fecha": 7,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-24",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1811,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "QUIROGA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "PATZCUARO",
   "fecha_texto": "12/16/2019",
   "mes_fecha": 12,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-16",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1815,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "COENEO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "COENEO",
   "fecha_texto": "3/21/2019",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-21",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "25/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1817,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "3/26/2019",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-26",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1821,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "TEMIXCO",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "TEMIXCO",
   "fecha_texto": "1/16/2019",
   "mes_fecha": 1,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-16",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "25/02/2014",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1828,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "CUERNAVACA",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "CUERNAVACA",
   "fecha_texto": "4/1/2019",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-01",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/03/2019",
   "tipo_vacuna": "4",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1833,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "JIUTEPEC",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "10/21/2019",
   "mes_fecha": 10,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-21",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1837,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "MAZATEPEC",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "TETECALA",
   "fecha_texto": "3/19/2019",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-19",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "14/03/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1838,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "CUERNAVACA",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "1/28/2019",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-28",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "30/10/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1840,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "YAUTEPEC",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "3/20/2019",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-20",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "31/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1845,
   "edad": "63",
   "grupo_edad": "60 - 64",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "CUERNAVACA",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "1/28/2019",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-28",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1846,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "MIACATLAN",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "6/5/2019",
   "mes_fecha": 6,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-05",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1847,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "AYALA",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "JONACATEPEC",
   "fecha_texto": "9/12/2019",
   "mes_fecha": 9,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-12",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1850,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "YAUTEPEC",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "4/10/2019",
   "mes_fecha": 4,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-10",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1852,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "ZACATEPEC",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "CUARNAVACA",
   "fecha_texto": "10/9/2019",
   "mes_fecha": 10,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-09",
   "anio_mes": "2019-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "06/10/2018",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1855,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "CUERNAVACA",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "CUERNAVACA",
   "fecha_texto": "3/4/2019",
   "mes_fecha": 3,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-04",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1856,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "JIUTEPEC",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "1/28/2019",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-28",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1857,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "CUAUTLA",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "CUAUTLA",
   "fecha_texto": "1/29/2019",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-29",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1858,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "COATETELCO",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "3/27/2019",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-27",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1866,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "CUERNAVACA",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "5/28/2019",
   "mes_fecha": 5,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-28",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1872,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "JALA",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "11/17/2019",
   "mes_fecha": 11,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-17",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1875,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "SAN BLAS",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "7/9/2019",
   "mes_fecha": 7,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-09",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1876,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEPIC",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "4/16/2019",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-16",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1877,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "COMPOSTELA",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "COMPOSTELA",
   "fecha_texto": "12/3/2019",
   "mes_fecha": 12,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-03",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "22/11/2019",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1879,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "SANTIAGO IXCUINTLA",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "SANTIAGO IXCUINTLA",
   "fecha_texto": "11/21/2019",
   "mes_fecha": 11,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-21",
   "anio_mes": "2019-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1886,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "APODACA",
   "fecha_texto": "7/3/2019",
   "mes_fecha": 7,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-03",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1888,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "6/6/2019",
   "mes_fecha": 6,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-06",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1892,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "EL CARMEN",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "6/3/2019",
   "mes_fecha": 6,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-03",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1894,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "6/24/2019",
   "mes_fecha": 6,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-24",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1895,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "6/19/2019",
   "mes_fecha": 6,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-19",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "15/05/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1897,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "HIDALGO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "6/22/2019",
   "mes_fecha": 6,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-22",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1900,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SANTA CATARINA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "2/6/2019",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-06",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1905,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "9/2/2019",
   "mes_fecha": 9,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-02",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1910,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "5/6/2019",
   "mes_fecha": 5,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-06",
   "anio_mes": "2019-05",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1911,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "6/27/2019",
   "mes_fecha": 6,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-27",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1912,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "1/16/2019",
   "mes_fecha": 1,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-16",
   "anio_mes": "2019-01",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1916,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "4/22/2019",
   "mes_fecha": 4,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-22",
   "anio_mes": "2019-04",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "20/12/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1921,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "2/6/2019",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-06",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1923,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "7/21/2019",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-21",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1924,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "4/18/2019",
   "mes_fecha": 4,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-18",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1926,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SAN NICOLAS DE LOS GARZA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "4/4/2019",
   "mes_fecha": 4,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-04",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "25/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1929,
   "edad": "23",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GENERAL ESCOBEDO",
   "fecha_texto": "1/16/2019",
   "mes_fecha": 1,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-16",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1930,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "4/15/2019",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-15",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "01/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1931,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "4/25/2019",
   "mes_fecha": 4,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-25",
   "anio_mes": "2019-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1932,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SANTA CATARINA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "6/3/2019",
   "mes_fecha": 6,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-03",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "05/11/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1933,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "PESQUERIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "APODACA",
   "fecha_texto": "3/12/2019",
   "mes_fecha": 3,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-12",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1940,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "2/7/2019",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-07",
   "anio_mes": "2019-02",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 6,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1941,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "8/28/2019",
   "mes_fecha": 8,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-28",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1944,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "2/6/2019",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-06",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1948,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ZUAZUA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "6/25/2019",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-25",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "04/06/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1949,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/21/2019",
   "mes_fecha": 5,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-21",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "25/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1950,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "APODACA",
   "fecha_texto": "4/16/2019",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-16",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1952,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "6/1/2019",
   "mes_fecha": 6,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-01",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1957,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/12/2019",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-12",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "26/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1963,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "4/26/2019",
   "mes_fecha": 4,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-26",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1965,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SANTA CATARINA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "4/4/2019",
   "mes_fecha": 4,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-04",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "06/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1966,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "5/13/2019",
   "mes_fecha": 5,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-13",
   "anio_mes": "2019-05",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "05/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1973,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "12/30/2019",
   "mes_fecha": 12,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-30",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1975,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ZUAZUA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "APODACA",
   "fecha_texto": "6/14/2019",
   "mes_fecha": 6,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-14",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1977,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "5/13/2019",
   "mes_fecha": 5,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-13",
   "anio_mes": "2019-05",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1978,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "EL CARMEN",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/20/2019",
   "mes_fecha": 5,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-20",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1979,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "CIENEGA DE FLORES",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "3/5/2019",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-05",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1980,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ZUAZUA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "11/21/2019",
   "mes_fecha": 11,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-21",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1983,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SAN NICOLAS DE LOS GARZA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "4/16/2019",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-16",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1984,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "HIDALGO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "6/18/2019",
   "mes_fecha": 6,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-18",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1985,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "6/3/2019",
   "mes_fecha": 6,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-03",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1990,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SAN PEDRO GARZA GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "11/25/2019",
   "mes_fecha": 11,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-25",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 1998,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "6/12/2019",
   "mes_fecha": 6,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-12",
   "anio_mes": "2019-06",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2007,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "1/27/2019",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-27",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2011,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "6/18/2019",
   "mes_fecha": 6,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-18",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "25/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2014,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "3/1/2019",
   "mes_fecha": 3,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-01",
   "anio_mes": "2019-03",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2015,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "6/24/2019",
   "mes_fecha": 6,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-24",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2022,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "3/29/2019",
   "mes_fecha": 3,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-29",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "13/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2025,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTEMORELOS",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTEMORELOS",
   "fecha_texto": "5/19/2019",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-19",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2026,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "6/3/2019",
   "mes_fecha": 6,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-03",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "22/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2028,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "6/10/2019",
   "mes_fecha": 6,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-10",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2029,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "7/8/2019",
   "mes_fecha": 7,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-08",
   "anio_mes": "2019-07",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2032,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/11/2019",
   "mes_fecha": 5,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-11",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2035,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "APODACA",
   "fecha_texto": "3/20/2019",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-20",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2037,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "CADEREYTA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "4/17/2019",
   "mes_fecha": 4,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-17",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2038,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SALINAS VICTORIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "10/18/2019",
   "mes_fecha": 10,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-18",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2040,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "LOS HERRERA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "CERRALVO",
   "fecha_texto": "7/15/2019",
   "mes_fecha": 7,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-15",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2041,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "8/19/2019",
   "mes_fecha": 8,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-19",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2046,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "2/4/2019",
   "mes_fecha": 2,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-04",
   "anio_mes": "2019-02",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2051,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "4/26/2019",
   "mes_fecha": 4,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-26",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2053,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "6/1/2019",
   "mes_fecha": 6,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-01",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2058,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "8/20/2019",
   "mes_fecha": 8,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-20",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2059,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SANTA CATARINA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "8/28/2019",
   "mes_fecha": 8,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-28",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2061,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "8/14/2019",
   "mes_fecha": 8,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-14",
   "anio_mes": "2019-08",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2067,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/2/2019",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-02",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "10/10/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2072,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "8/21/2019",
   "mes_fecha": 8,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-21",
   "anio_mes": "2019-08",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2073,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "EL CARMEN",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "4/17/2019",
   "mes_fecha": 4,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-17",
   "anio_mes": "2019-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2076,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "11/1/2019",
   "mes_fecha": 11,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-01",
   "anio_mes": "2019-11",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2078,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "5/20/2019",
   "mes_fecha": 5,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-20",
   "anio_mes": "2019-05",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2079,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "5/30/2019",
   "mes_fecha": 5,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-30",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "29/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2080,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "4/24/2019",
   "mes_fecha": 4,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-24",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2086,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SALINAS VICTORIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "4/22/2019",
   "mes_fecha": 4,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-22",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2087,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "CADEREYTA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/14/2019",
   "mes_fecha": 5,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-14",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2091,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "2/25/2019",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-25",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "14/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2094,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "4/29/2019",
   "mes_fecha": 4,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-29",
   "anio_mes": "2019-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2095,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "4/6/2019",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-06",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "15/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2105,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "CIENEGA DE FLORES",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "3/25/2019",
   "mes_fecha": 3,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-25",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2107,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "6/25/2019",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-25",
   "anio_mes": "2019-06",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2108,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "7/15/2019",
   "mes_fecha": 7,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-15",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "05/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2110,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "8/15/2019",
   "mes_fecha": 8,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-15",
   "anio_mes": "2019-08",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2111,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "CADEREYTA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "CERRALVO",
   "fecha_texto": "9/16/2019",
   "mes_fecha": 9,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-16",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2115,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "11/27/2019",
   "mes_fecha": 11,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-27",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2119,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/8/2019",
   "mes_fecha": 5,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-08",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "02/05/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2122,
   "edad": "46",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "6/14/2019",
   "mes_fecha": 6,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-14",
   "anio_mes": "2019-06",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2123,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "6/4/2019",
   "mes_fecha": 6,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-04",
   "anio_mes": "2019-06",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "06/05/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2128,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "6/6/2019",
   "mes_fecha": 6,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-06",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2133,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "4/3/2019",
   "mes_fecha": 4,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-03",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "04/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2137,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "4/29/2019",
   "mes_fecha": 4,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-29",
   "anio_mes": "2019-04",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "06/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2149,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "CADEREYTA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "9/17/2019",
   "mes_fecha": 9,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-17",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2151,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "PESQUERIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "APODACA",
   "fecha_texto": "7/8/2019",
   "mes_fecha": 7,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-08",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2152,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "APODACA",
   "fecha_texto": "8/18/2019",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-18",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2153,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "HIDALGO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "5/15/2019",
   "mes_fecha": 5,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-15",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2154,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/2/2019",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-02",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2157,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "1/21/2019",
   "mes_fecha": 1,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-21",
   "anio_mes": "2019-01",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2160,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "PESQUERIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/2/2019",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-02",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "15/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2163,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GALEANA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GALEANA",
   "fecha_texto": "6/25/2019",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-25",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2165,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL TERAN",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTEMORELOS",
   "fecha_texto": "2/26/2019",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-26",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "07/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2168,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "5/2/2019",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-02",
   "anio_mes": "2019-05",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2175,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "5/13/2019",
   "mes_fecha": 5,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-13",
   "anio_mes": "2019-05",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2182,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/6/2019",
   "mes_fecha": 5,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-06",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2183,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/6/2019",
   "mes_fecha": 5,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-06",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2185,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "CADEREYTA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "8/7/2019",
   "mes_fecha": 8,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-07",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2194,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SANTA CATARINA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "6/6/2019",
   "mes_fecha": 6,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-06",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "22/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2197,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "8/14/2019",
   "mes_fecha": 8,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-14",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2204,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/20/2019",
   "mes_fecha": 5,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-20",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2205,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "EL CARMEN",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "7/1/2019",
   "mes_fecha": 7,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-01",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2211,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "2/25/2019",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-25",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2212,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "3/18/2019",
   "mes_fecha": 3,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-18",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2213,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "7/10/2019",
   "mes_fecha": 7,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-10",
   "anio_mes": "2019-07",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2214,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "CIENEGA DE FLORES",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "1/27/2019",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-27",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2218,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "1/22/2019",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-22",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2220,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SALINAS VICTORIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "5/3/2019",
   "mes_fecha": 5,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-03",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "26/03/2019",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2225,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "4/9/2019",
   "mes_fecha": 4,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-09",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2227,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "12/11/2019",
   "mes_fecha": 12,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-11",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2233,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "DOCTOR ARROYO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "1/3/2020",
   "mes_fecha": 1,
   "dia_fecha": 3,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-03",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2234,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "10/13/2019",
   "mes_fecha": 10,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-13",
   "anio_mes": "2019-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "05/10/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2236,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "APODACA",
   "fecha_texto": "7/21/2019",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-21",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2237,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SAN NICOLAS DE LOS GARZA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "10/22/2019",
   "mes_fecha": 10,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-22",
   "anio_mes": "2019-10",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "10/09/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2241,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SANTA CATARINA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "2/27/2019",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-27",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2243,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTEMORELOS",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTEMORELOS",
   "fecha_texto": "5/28/2019",
   "mes_fecha": 5,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-28",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "03/07/2017",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2246,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "7/30/2019",
   "mes_fecha": 7,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-30",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "22/05/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2250,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "5/14/2019",
   "mes_fecha": 5,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-14",
   "anio_mes": "2019-05",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "15/04/2019",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2252,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "4/29/2019",
   "mes_fecha": 4,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-29",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "02/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2256,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "ALLENDE",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTEMORELOS",
   "fecha_texto": "10/30/2019",
   "mes_fecha": 10,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-30",
   "anio_mes": "2019-10",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2270,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/27/2019",
   "mes_fecha": 5,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-27",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "01/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2272,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "5/24/2019",
   "mes_fecha": 5,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-24",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2278,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "HUAJUAPAN DE LEON",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "HUAJUAPAN DE LEON",
   "fecha_texto": "2/11/2019",
   "mes_fecha": 2,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-11",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2279,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "ZAACHILA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "ZAACHILA",
   "fecha_texto": "2/18/2019",
   "mes_fecha": 2,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-18",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2280,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "OAXACA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "OAXACA",
   "fecha_texto": "1/18/2019",
   "mes_fecha": 1,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-18",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2282,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "PINOTEPA DE DON LUIS",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "PINOTEPA DE DON LUIS",
   "fecha_texto": "6/13/2019",
   "mes_fecha": 6,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-13",
   "anio_mes": "2019-06",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2283,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN JACINTO AMILPAS",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN BARTOLO COYOTEPEC",
   "fecha_texto": "7/15/2019",
   "mes_fecha": 7,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-15",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2287,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN ANTONIO SINICAHUA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "TLAXIACO",
   "fecha_texto": "11/25/2019",
   "mes_fecha": 11,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-25",
   "anio_mes": "2019-11",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2289,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "STA CRUZ XOXOCOTLAN",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "OAXACA",
   "fecha_texto": "6/6/2019",
   "mes_fecha": 6,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-06",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2290,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTA MARIA CHILCHOTLA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "HUAUTLA DE JIMENEZ",
   "fecha_texto": "7/23/2019",
   "mes_fecha": 7,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-23",
   "anio_mes": "2019-07",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2292,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN FELIPE TEJALAPAN",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN FELIPE TEJALAPAN",
   "fecha_texto": "7/17/2019",
   "mes_fecha": 7,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-17",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2294,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "JUXTLAHUACA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SANTIAGO JUXTLAHUACA",
   "fecha_texto": "9/18/2019",
   "mes_fecha": 9,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-18",
   "anio_mes": "2019-09",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2295,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "MIAHUATLAN DE PORFIRIO DIAZ",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN BARTOLO COYOTEPEC",
   "fecha_texto": "2/7/2019",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-07",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2297,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN PEDRO MIXTEPEC",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN PEDRO MIXTEPEC",
   "fecha_texto": "3/27/2019",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-27",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2298,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTIAGO JAMILTEPEC",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SANTIAGO JAMILTEPEC",
   "fecha_texto": "1/12/2019",
   "mes_fecha": 1,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-12",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2299,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN AGUSTIN YATARENI",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN BARTOLO COYOTEPEC",
   "fecha_texto": "2/19/2019",
   "mes_fecha": 2,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-19",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2300,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTA MARIA PEÑOLES",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SANTA MARIA PEÑOLES",
   "fecha_texto": "8/30/2019",
   "mes_fecha": 8,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-30",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2302,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN MIGUEL PERAS",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SANTIAGO JUXTLAHUACA",
   "fecha_texto": "11/26/2019",
   "mes_fecha": 11,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-26",
   "anio_mes": "2019-11",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2304,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTIAGO AYUQUILILLA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SANTIAGO AYUQULILLA",
   "fecha_texto": "2/15/2019",
   "mes_fecha": 2,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-15",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2308,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "JUXTLAHUACA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SANTIAGO JUXTLAHUACA",
   "fecha_texto": "8/30/2019",
   "mes_fecha": 8,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-30",
   "anio_mes": "2019-08",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2309,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "PINOTEPA DE DON LUIS",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "PINOTEPA DE DON LUIS",
   "fecha_texto": "11/25/2019",
   "mes_fecha": 11,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-25",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2310,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN NICOLAS HIDALGO",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN NICOLAS HIDALGO",
   "fecha_texto": "7/17/2019",
   "mes_fecha": 7,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-17",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2311,
   "edad": "36",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN PEDRO MIXTEPEC",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN PEDRO MIXTEPEC",
   "fecha_texto": "3/27/2019",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-27",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2312,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "STA MARIA TONAMECA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "OAXACA",
   "fecha_texto": "6/6/2019",
   "mes_fecha": 6,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-06",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2313,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTA MARIA PEÑOLES",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "OAXACA",
   "fecha_texto": "6/24/2019",
   "mes_fecha": 6,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-24",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2315,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTA CRUZ XOXOCOTLAN",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SANTA CRUZ XOXOCOTLAN",
   "fecha_texto": "7/14/2019",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-14",
   "anio_mes": "2019-07",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/8/2019",
   "tipo_vacuna": "4",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2316,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTA LUCIA DEL CAMINO",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "OAXACA",
   "fecha_texto": "8/3/2019",
   "mes_fecha": 8,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-03",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2317,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "STO DOMINGO TEOJOMULCO",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "VILLA SOLA DE VEGA",
   "fecha_texto": "6/10/2019",
   "mes_fecha": 6,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-10",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2321,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "CONSTANCIA ROSARIO",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "PUTLA DE GUERRERO",
   "fecha_texto": "11/28/2019",
   "mes_fecha": 11,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-28",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/5/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2323,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "TEZOATLAN DE SEGURA Y LUNA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "TEZOATLAN DE SEGURA Y LUNA",
   "fecha_texto": "2/26/2019",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-26",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2324,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTA CRUZ MIXTEPEC",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN PABLO HUIXTEPEC",
   "fecha_texto": "7/5/2019",
   "mes_fecha": 7,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-05",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2328,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "HUAUCHINANGO",
   "estado_notificacion": "PUEBLA",
   "municipio_notificacion": "HUAUCHINANGO",
   "fecha_texto": "2/20/2019",
   "mes_fecha": 2,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-20",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "06/02/2019",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2329,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "TEHUACAN",
   "estado_notificacion": "PUEBLA",
   "municipio_notificacion": "TEHUACAN",
   "fecha_texto": "1/15/2019",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-15",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2334,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "NAUPAN",
   "estado_notificacion": "PUEBLA",
   "municipio_notificacion": "NAUPAN",
   "fecha_texto": "1/10/2019",
   "mes_fecha": 1,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-10",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2345,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "CHIGNAHUAPAN",
   "estado_notificacion": "PUEBLA",
   "municipio_notificacion": "CHIGNAHUAPAN",
   "fecha_texto": "1/13/2019",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-13",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2346,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "CHILCHOTLA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "5/6/2019",
   "mes_fecha": 5,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-06",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2351,
   "edad": "26",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "5/27/2019",
   "mes_fecha": 5,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-27",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2352,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "9/30/2019",
   "mes_fecha": 9,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-30",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2355,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "EL MARQUES",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "8/20/2019",
   "mes_fecha": 8,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-20",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "27/05/2019",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2356,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "COLON",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "SAN JUAN DEL RIO",
   "fecha_texto": "9/9/2019",
   "mes_fecha": 9,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-09",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2357,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "AMEALCO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "SAN JUAN DEL RIO",
   "fecha_texto": "11/21/2019",
   "mes_fecha": 11,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-21",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2360,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "EL MARQUES",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "6/30/2019",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-30",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2362,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "PEDRO ESCOBEDO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "8/12/2019",
   "mes_fecha": 8,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-12",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2364,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "5/19/2019",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-19",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2366,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "6/3/2019",
   "mes_fecha": 6,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-03",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2374,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "SAN JUAN DEL RIO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "SAN JUAN DEL RIO",
   "fecha_texto": "3/20/2019",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-20",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2378,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "4/29/2019",
   "mes_fecha": 4,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-29",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2384,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "PEDRO ESCOBEDO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "10/14/2019",
   "mes_fecha": 10,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-14",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2385,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "SAN JUAN DEL RIO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "SAN JUAN DEL RIO",
   "fecha_texto": "3/20/2019",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-20",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2389,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "TEQUISQUIAPAN",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "SAN JUAN DEL RIO",
   "fecha_texto": "2/4/2019",
   "mes_fecha": 2,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-04",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "18/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2391,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "4/1/2019",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-01",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2392,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "7/19/2019",
   "mes_fecha": 7,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-19",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2395,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "SAN JOAQUIN",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "CADEREYTA",
   "fecha_texto": "2/22/2019",
   "mes_fecha": 2,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-22",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "03/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2397,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "CADEREYTA",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "CADEREYTA",
   "fecha_texto": "12/8/2019",
   "mes_fecha": 12,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-08",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2400,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "SAN JUAN DEL RIO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "SAN JUAN DEL RIO",
   "fecha_texto": "3/6/2019",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-06",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2403,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "10/25/2019",
   "mes_fecha": 10,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-25",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2406,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "2/26/2019",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-26",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2409,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "EZEQUIEL MONTES",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "CADEREYTA",
   "fecha_texto": "3/27/2019",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-27",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2412,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "8/17/2019",
   "mes_fecha": 8,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-17",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "24/07/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2413,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "7/25/2019",
   "mes_fecha": 7,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-25",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2417,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "COLON",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "11/7/2019",
   "mes_fecha": 11,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-07",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2420,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "9/3/2019",
   "mes_fecha": 9,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-03",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "01/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2423,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "1/18/2019",
   "mes_fecha": 1,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-18",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2426,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "2/6/2019",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-06",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2427,
   "edad": "30",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "1/24/2019",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-24",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2433,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "CADEREYTA",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "CADEREYTA",
   "fecha_texto": "7/5/2019",
   "mes_fecha": 7,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-05",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2436,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "1/16/2019",
   "mes_fecha": 1,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-16",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2438,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "1/6/2020",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-06",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2442,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "4/8/2019",
   "mes_fecha": 4,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-08",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2443,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "HUIMILPAN",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "1/24/2019",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-24",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "19/12/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2456,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "EL MARQUES",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "7/11/2019",
   "mes_fecha": 7,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-11",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2457,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "6/25/2019",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-25",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2464,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "1/24/2019",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-24",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2467,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "1/15/2019",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-15",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2470,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "EL MARQUES",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "1/16/2018",
   "mes_fecha": 1,
   "dia_fecha": 16,
   "anio_fecha": 2018,
   "fecha_notificacion": "2018-01-16",
   "anio_mes": "2018-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2473,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "EL MARQUES",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "9/5/2019",
   "mes_fecha": 9,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-05",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2478,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "COZUMEL",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "COZUMEL",
   "fecha_texto": "6/10/2019",
   "mes_fecha": 6,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-10",
   "anio_mes": "2019-06",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "03/06/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2479,
   "edad": "43",
   "grupo_edad": "40 - 44",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "COZUMEL",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "COZUMEL",
   "fecha_texto": "6/10/2019",
   "mes_fecha": 6,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-10",
   "anio_mes": "2019-06",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "XX/XX/1961",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2487,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "SOLIDARIDAD",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "SOLIDARIDAD",
   "fecha_texto": "10/1/2019",
   "mes_fecha": 10,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-01",
   "anio_mes": "2019-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "30/06/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2488,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "9/30/2019",
   "mes_fecha": 9,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-30",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2506,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "10/11/2019",
   "mes_fecha": 10,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-11",
   "anio_mes": "2019-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "28/08/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2529,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "TAMASOPO",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "RIOVERDE",
   "fecha_texto": "4/4/2019",
   "mes_fecha": 4,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-04",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/25/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2530,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SOLEDAD DE GRACIANO SANCHEZ",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "8/2/2019",
   "mes_fecha": 8,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-02",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2545,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "3/20/2019",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-20",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2553,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SOLEDAD DE GRACIANO SANCHEZ",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "2/7/2019",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-07",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2562,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "VILLA DE REYES",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "1/30/2019",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-30",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2567,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "CERRITOS",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "CERRITOS",
   "fecha_texto": "1/15/2019",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-15",
   "anio_mes": "2019-01",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2574,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "4/17/2019",
   "mes_fecha": 4,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-17",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/1/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2580,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SOLEDAD DE GRACIANO SANCHEZ",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "2/21/2019",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-21",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1/31/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2620,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "8/6/2019",
   "mes_fecha": 8,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-06",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2621,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "AHUALULCO",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "10/11/2019",
   "mes_fecha": 10,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-11",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2626,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "VILLA DE REYES",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "1/8/2019",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-08",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/23/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2628,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "MATLAPA",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "MATLAPA",
   "fecha_texto": "12/3/2019",
   "mes_fecha": 12,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-03",
   "anio_mes": "2019-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "11/26/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2637,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SALINAS",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SALINAS",
   "fecha_texto": "5/29/2019",
   "mes_fecha": 5,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-29",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2655,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "RIOVERDE",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "RIOVERDE",
   "fecha_texto": "3/28/2019",
   "mes_fecha": 3,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-28",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2680,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SOLEDAD DE GRACIANO SANCHEZ",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "1/7/2019",
   "mes_fecha": 1,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-07",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/21/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2681,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "2/22/2019",
   "mes_fecha": 2,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-22",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/21/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2682,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SOLEDAD DE GRACIANO SANCHEZ",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "1/18/2019",
   "mes_fecha": 1,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-18",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2695,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "CERRITOS",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "RIOVERDE",
   "fecha_texto": "2/7/2019",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-07",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2701,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "5/28/2019",
   "mes_fecha": 5,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-28",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2706,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "3/12/2019",
   "mes_fecha": 3,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-12",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2709,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "HUEHUETLA",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "CD VALLES",
   "fecha_texto": "3/7/2019",
   "mes_fecha": 3,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-07",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/12/2019",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2716,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "TAMUIN",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "CD VALLES",
   "fecha_texto": "5/16/2019",
   "mes_fecha": 5,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-16",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2731,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "VILLA DE ARISTA",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "1/8/2019",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-08",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/13/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2733,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "MATEHUALA",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "MATEHUALA",
   "fecha_texto": "9/13/2019",
   "mes_fecha": 9,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-13",
   "anio_mes": "2019-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2763,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "AHOME",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "AHOME",
   "fecha_texto": "11/25/2019",
   "mes_fecha": 11,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-25",
   "anio_mes": "2019-11",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "15/11/2019",
   "tipo_vacuna": "4",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2769,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULIACAN",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "CULIACAN",
   "fecha_texto": "11/25/2019",
   "mes_fecha": 11,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-25",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2770,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULIACAN",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "CULIACAN",
   "fecha_texto": "9/3/2019",
   "mes_fecha": 9,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-03",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "14/08/2019",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2801,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "ETCHOJOA",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "ETCHOJOA",
   "fecha_texto": "9/10/2019",
   "mes_fecha": 9,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-10",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2803,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "ALAMOS",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "ALAMOS",
   "fecha_texto": "1/22/2019",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-22",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2807,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "7/2/2019",
   "mes_fecha": 7,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-02",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2812,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "4/15/2019",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-15",
   "anio_mes": "2019-04",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "21/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2816,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "4/1/2019",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-01",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2817,
   "edad": "9",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "4/1/2019",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-01",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2819,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "12/30/2019",
   "mes_fecha": 12,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-30",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2829,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "11/4/2019",
   "mes_fecha": 11,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-04",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "28/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2837,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "8/22/2019",
   "mes_fecha": 8,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-22",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "19/05/2017",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2842,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NOGALES",
   "fecha_texto": "5/14/2019",
   "mes_fecha": 5,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-14",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "24/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2846,
   "edad": "9",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "8/22/2019",
   "mes_fecha": 8,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-22",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "07/09/2014",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2847,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "8/22/2019",
   "mes_fecha": 8,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-22",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "03/05/2016",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2848,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HUATABAMPO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NAVOJOA",
   "fecha_texto": "5/27/2019",
   "mes_fecha": 5,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-27",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2855,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "3/25/2019",
   "mes_fecha": 3,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-25",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "07/03/2019",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2858,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NAVOJOA",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NAVOJOA",
   "fecha_texto": "7/30/2019",
   "mes_fecha": 7,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-30",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "15/05/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2865,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "2/12/2019",
   "mes_fecha": 2,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-12",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2867,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NOGALES",
   "fecha_texto": "6/24/2019",
   "mes_fecha": 6,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-24",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2868,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "GUAYMAS",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "GUAYMAS",
   "fecha_texto": "12/16/2019",
   "mes_fecha": 12,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-16",
   "anio_mes": "2019-12",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2874,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "2/5/2019",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-05",
   "anio_mes": "2019-02",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "14/11/2017",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2877,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "12/4/2019",
   "mes_fecha": 12,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-04",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2878,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "4/13/2019",
   "mes_fecha": 4,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-13",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2884,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "3/11/2019",
   "mes_fecha": 3,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-11",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2887,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "12/27/2019",
   "mes_fecha": 12,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-27",
   "anio_mes": "2019-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2888,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "EMPALME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "GUAYMAS",
   "fecha_texto": "8/15/2019",
   "mes_fecha": 8,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-15",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2891,
   "edad": "27",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "12/27/2019",
   "mes_fecha": 12,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-27",
   "anio_mes": "2019-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2894,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "GUAYMAS",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "GUAYMAS",
   "fecha_texto": "6/27/2019",
   "mes_fecha": 6,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-27",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "11/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2901,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CUMPAS",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "12/9/2019",
   "mes_fecha": 12,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-09",
   "anio_mes": "2019-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2905,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HUATABAMPO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "4/10/2019",
   "mes_fecha": 4,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-10",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "20/03/2019",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2911,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "12/12/2019",
   "mes_fecha": 12,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-12",
   "anio_mes": "2019-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2913,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NOGALES",
   "fecha_texto": "8/5/2019",
   "mes_fecha": 8,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-05",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2917,
   "edad": "52",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HUATABAMPO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NAVOJOA",
   "fecha_texto": "4/24/2019",
   "mes_fecha": 4,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-24",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2918,
   "edad": "38",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "5/9/2019",
   "mes_fecha": 5,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-09",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2924,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "10/14/2019",
   "mes_fecha": 10,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-14",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2929,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NOGALES",
   "fecha_texto": "1/8/2020",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-08",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2934,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "8/20/2019",
   "mes_fecha": 8,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-20",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2935,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NOGALES",
   "fecha_texto": "4/29/2019",
   "mes_fecha": 4,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-29",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2936,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NOGALES",
   "fecha_texto": "8/5/2019",
   "mes_fecha": 8,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-05",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2940,
   "edad": "39",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NAVOJOA",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NAVOJOA",
   "fecha_texto": "8/30/2019",
   "mes_fecha": 8,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-30",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2942,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "12/30/2019",
   "mes_fecha": 12,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-30",
   "anio_mes": "2019-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2945,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "1/21/2019",
   "mes_fecha": 1,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-21",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2951,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "10/23/2019",
   "mes_fecha": 10,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-23",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2952,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "11/5/2019",
   "mes_fecha": 11,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-05",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "8",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2954,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NOGALES",
   "fecha_texto": "5/30/2019",
   "mes_fecha": 5,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-30",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2957,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "EMPALME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "GUAYMAS",
   "fecha_texto": "7/12/2019",
   "mes_fecha": 7,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-12",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "03/06/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2963,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NOGALES",
   "fecha_texto": "5/16/2019",
   "mes_fecha": 5,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-16",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "06/05/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2970,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CABORCA",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "4/22/2019",
   "mes_fecha": 4,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-22",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2974,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "6/29/2019",
   "mes_fecha": 6,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-29",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2979,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "7/8/2019",
   "mes_fecha": 7,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-08",
   "anio_mes": "2019-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "14/06/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 2982,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "HUIMANGUILLO",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CENTRO",
   "fecha_texto": "12/18/2019",
   "mes_fecha": 12,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-18",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3006,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "JIMENEZ",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "VICTORIA",
   "fecha_texto": "1/14/2020",
   "mes_fecha": 1,
   "dia_fecha": 14,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-14",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "20/12/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3011,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "4/3/2019",
   "mes_fecha": 4,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-03",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3013,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "4/8/2019",
   "mes_fecha": 4,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-08",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "30/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3030,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "ALTAMIRA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "TAMPICO",
   "fecha_texto": "5/29/2019",
   "mes_fecha": 5,
   "dia_fecha": 29,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-29",
   "anio_mes": "2019-05",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3032,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "PADILLA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "VICTORIA",
   "fecha_texto": "3/22/2019",
   "mes_fecha": 3,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-22",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3038,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "MATAMOROS",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "MATAMOROS",
   "fecha_texto": "3/20/2019",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-20",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3040,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "9/18/2019",
   "mes_fecha": 9,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-18",
   "anio_mes": "2019-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3045,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "VICTORIA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "VICTORIA",
   "fecha_texto": "7/22/2019",
   "mes_fecha": 7,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-22",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3048,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "3/31/2019",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-31",
   "anio_mes": "2019-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3053,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "MATAMOROS",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "MATAMOROS",
   "fecha_texto": "3/19/2019",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-19",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3056,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "2/14/2019",
   "mes_fecha": 2,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-14",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3062,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "MATAMOROS",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "MATAMOROS",
   "fecha_texto": "1/7/2019",
   "mes_fecha": 1,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-07",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3064,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "VICTORIA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "VICTORIA",
   "fecha_texto": "7/22/2019",
   "mes_fecha": 7,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-22",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3067,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "MATAMOROS",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "MATAMOROS",
   "fecha_texto": "1/31/2019",
   "mes_fecha": 1,
   "dia_fecha": 31,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-31",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3070,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "MATAMOROS",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "MATAMOROS",
   "fecha_texto": "4/25/2019",
   "mes_fecha": 4,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-25",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3074,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "ANTONIO CARVAJAL",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "TLAXCALA",
   "fecha_texto": "2/6/2019",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-06",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "10/09/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3075,
   "edad": "59",
   "grupo_edad": "55 - 59",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "ANTONIO CARVAJAL",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "TLAXCALA",
   "fecha_texto": "4/7/2019",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-07",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3076,
   "edad": "21",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "HUAMANTLA",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "HUAMANTLA",
   "fecha_texto": "10/18/2019",
   "mes_fecha": 10,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-18",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3078,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "APIZACO",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "TLAXCALA",
   "fecha_texto": "5/8/2019",
   "mes_fecha": 5,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-08",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3086,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "HUAMANTLA",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "APIZACO",
   "fecha_texto": "6/18/2019",
   "mes_fecha": 6,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-18",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3090,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "XICOTZINCO",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "ANTONIO CARBAJAL",
   "fecha_texto": "11/19/2019",
   "mes_fecha": 11,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-19",
   "anio_mes": "2019-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3094,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "TLAXCALA",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "TLAXCALA",
   "fecha_texto": "3/25/2019",
   "mes_fecha": 3,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-25",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "20/12/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3096,
   "edad": "29",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "APIZACO",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "TLAXCALA",
   "fecha_texto": "5/24/2019",
   "mes_fecha": 5,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-24",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3100,
   "edad": "8",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "ANTONIO CARVAJAL",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "TLAXCALA",
   "fecha_texto": "4/7/2019",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-07",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3103,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "TOTOLAC",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "TLAXCALA",
   "fecha_texto": "12/11/2019",
   "mes_fecha": 12,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-11",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "28/08/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3105,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "HUAMANTLA",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "HUAMANTLA",
   "fecha_texto": "10/3/2019",
   "mes_fecha": 10,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-03",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3113,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "HUAMANTLA",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "APIZACO",
   "fecha_texto": "6/19/2019",
   "mes_fecha": 6,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-19",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "14/07/2019",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3116,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "CORDOBA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "CORDOBA",
   "fecha_texto": "1/24/2019",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-24",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3118,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "TANTOYUCA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "8/2/2019",
   "mes_fecha": 8,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-02",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3126,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "TATAHUICAPAN DE JUAREZ",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "MECAYAPAN",
   "fecha_texto": "2/13/2019",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-13",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3130,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "TEXHUACAN",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "ORIZABA",
   "fecha_texto": "11/25/2019",
   "mes_fecha": 11,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-25",
   "anio_mes": "2019-11",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3133,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "LAS CHOAPAS",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "LAS CHOAPAS",
   "fecha_texto": "10/19/2019",
   "mes_fecha": 10,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-19",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3137,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "COATZACOALCOS",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "COATZACOALCOS",
   "fecha_texto": "5/10/2019",
   "mes_fecha": 5,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-10",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3142,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "CORDOBA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "RIO BLANCO",
   "fecha_texto": "6/26/2019",
   "mes_fecha": 6,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-26",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3147,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "EL HIGO",
   "estado_notificacion": "TAMPICO",
   "municipio_notificacion": "TAMPICO",
   "fecha_texto": "4/15/2019",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-15",
   "anio_mes": "2019-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3152,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "XALAPA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "5/27/2019",
   "mes_fecha": 5,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-27",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3153,
   "edad": "57",
   "grupo_edad": "55 - 59",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "ORIZABA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "ORIZABA",
   "fecha_texto": "8/26/2019",
   "mes_fecha": 8,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-26",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3154,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "TLACOLULAN",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "9/10/2019",
   "mes_fecha": 9,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-10",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "24/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3157,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "EMILIANO ZAPATA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "3/13/2019",
   "mes_fecha": 3,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-13",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3161,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "VERACRUZ",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "VERACRUZ",
   "fecha_texto": "7/22/2019",
   "mes_fecha": 7,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-22",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "06/07/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3164,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "MARTINEZ DE LA TORRE",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "8/20/2019",
   "mes_fecha": 8,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-20",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3165,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "OMEALCA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "CORDOBA",
   "fecha_texto": "9/4/2019",
   "mes_fecha": 9,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-04",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3170,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "PLAYA VICENTE",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "PLAYA VICENTE",
   "fecha_texto": "12/11/2019",
   "mes_fecha": 12,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-11",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3174,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "VERACRUZ",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "VERACRUZ",
   "fecha_texto": "5/23/2019",
   "mes_fecha": 5,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-23",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3180,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "VERACRUZ",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "VERACRUZ",
   "fecha_texto": "6/25/2019",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-25",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3181,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "ORIZABA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "RIO BLANCO",
   "fecha_texto": "8/6/2019",
   "mes_fecha": 8,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-06",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/07/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3185,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "MINATITLAN",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "MINATITLAN",
   "fecha_texto": "7/8/2019",
   "mes_fecha": 7,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-08",
   "anio_mes": "2019-07",
   "institucion_notificacion": 7,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3189,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "TANTOYUCA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "TUXPAN",
   "fecha_texto": "10/23/2019",
   "mes_fecha": 10,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-23",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3190,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "SAN RAFAEL",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "7/3/2019",
   "mes_fecha": 7,
   "dia_fecha": 3,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-03",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3191,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "MALTRATA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "RIO BLANCO",
   "fecha_texto": "9/10/2019",
   "mes_fecha": 9,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-10",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3192,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "COATZACOALCOS",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "COATZACOALCOS",
   "fecha_texto": "3/10/2019",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-10",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3197,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "COTAXTLA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "VERACRUZ",
   "fecha_texto": "4/30/2019",
   "mes_fecha": 4,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-30",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3199,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "ALPATLAHUAC",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "COSCOMATEPEC",
   "fecha_texto": "8/5/2019",
   "mes_fecha": 8,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-05",
   "anio_mes": "2019-08",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3200,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "VERACRUZ",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "VERACRUZ",
   "fecha_texto": "12/5/2019",
   "mes_fecha": 12,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-05",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3201,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "TEZONAPA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "TEZONAPA",
   "fecha_texto": "1/16/2019",
   "mes_fecha": 1,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-16",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3202,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "NOGALES",
   "fecha_texto": "2/13/2019",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-13",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3205,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "RIO BLANCO",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "ORIZABA",
   "fecha_texto": "5/15/2019",
   "mes_fecha": 5,
   "dia_fecha": 15,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-15",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "22/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3206,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "TAMIAHUA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "TUXPAN",
   "fecha_texto": "8/11/2019",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-11",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3211,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "XICO",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "9/4/2019",
   "mes_fecha": 9,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-04",
   "anio_mes": "2019-09",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "24/06/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3215,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "CORDOBA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "CORDOBA",
   "fecha_texto": "8/16/2019",
   "mes_fecha": 8,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-16",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "16/07/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3217,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "TEQUILA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "RIO BLANCO",
   "fecha_texto": "8/7/2019",
   "mes_fecha": 8,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-07",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3219,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "VERACRUZ",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "VERACRUZ",
   "fecha_texto": "3/26/2019",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-26",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3220,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "COTAXTLA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "CORDOBA",
   "fecha_texto": "11/21/2019",
   "mes_fecha": 11,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-21",
   "anio_mes": "2019-11",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3221,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "COATZACOALCOS",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "COATZACOALCOS",
   "fecha_texto": "12/27/2019",
   "mes_fecha": 12,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-27",
   "anio_mes": "2019-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "04/12/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3226,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "ISLA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "ISLA",
   "fecha_texto": "9/4/2019",
   "mes_fecha": 9,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-04",
   "anio_mes": "2019-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3230,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "4/30/2019",
   "mes_fecha": 4,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-30",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3234,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MUXUPIP",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "6/1/2019",
   "mes_fecha": 6,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-01",
   "anio_mes": "2019-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "18/04/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3235,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "HALACHO",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "3/9/2019",
   "mes_fecha": 3,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-09",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3238,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "10/8/2019",
   "mes_fecha": 10,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-08",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3239,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MOTUL",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "2/24/2019",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-24",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3241,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "CHEMAX",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "VALLADOLID",
   "fecha_texto": "4/30/2019",
   "mes_fecha": 4,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-30",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3242,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "TIZIMIN",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "TIZIMIN",
   "fecha_texto": "4/14/2019",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-14",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3244,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "BUCTZOTZ",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "2/4/2019",
   "mes_fecha": 2,
   "dia_fecha": 4,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-04",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3246,
   "edad": "11",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "CHEMAX",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "VALLADOLID",
   "fecha_texto": "8/5/2019",
   "mes_fecha": 8,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-05",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "25/05/2009",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3248,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MUNA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "8/5/2019",
   "mes_fecha": 8,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-05",
   "anio_mes": "2019-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/07/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3250,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "PETO",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "1/22/2019",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-22",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3253,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "DZONCAUICH",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "2/7/2019",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-07",
   "anio_mes": "2019-02",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3254,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "TICUL",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "6/6/2019",
   "mes_fecha": 6,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-06",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3261,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "1/14/2019",
   "mes_fecha": 1,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-14",
   "anio_mes": "2019-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3265,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "10/9/2019",
   "mes_fecha": 10,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-10-09",
   "anio_mes": "2019-10",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3266,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "UCU",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "11/5/2019",
   "mes_fecha": 11,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-11-05",
   "anio_mes": "2019-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3269,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MOTUL",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MOTUL",
   "fecha_texto": "9/2/2019",
   "mes_fecha": 9,
   "dia_fecha": 2,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-02",
   "anio_mes": "2019-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3271,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "5/23/2019",
   "mes_fecha": 5,
   "dia_fecha": 23,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-23",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3273,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "DZITAS",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "VALLADOLID",
   "fecha_texto": "6/9/2019",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-09",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "13/05/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3281,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "1/8/2020",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-08",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3283,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "HUNUCMA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "3/9/2019",
   "mes_fecha": 3,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-09",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3291,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "9/11/2019",
   "mes_fecha": 9,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-09-11",
   "anio_mes": "2019-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3292,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "HOMUN",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "1/3/2020",
   "mes_fecha": 1,
   "dia_fecha": 3,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-03",
   "anio_mes": "2020-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3293,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "TIXCACALCUPUL",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "VALLADOLID",
   "fecha_texto": "5/16/2019",
   "mes_fecha": 5,
   "dia_fecha": 16,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-16",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "21/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3295,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "2/26/2019",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-26",
   "anio_mes": "2019-02",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3296,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "KINCHIL",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "5/9/2019",
   "mes_fecha": 5,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-09",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3298,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "IZAMAL",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "12/24/2019",
   "mes_fecha": 12,
   "dia_fecha": 24,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-24",
   "anio_mes": "2019-12",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3304,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "TIXCACALCUPUL",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "VALLADOLID",
   "fecha_texto": "1/26/2019",
   "mes_fecha": 1,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-26",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "21/09/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3305,
   "edad": "16",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "2/27/2019",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-27",
   "anio_mes": "2019-02",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "12/05/2006",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3310,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "RIO GRANDE",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "1/18/2019",
   "mes_fecha": 1,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-18",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3311,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "5/9/2019",
   "mes_fecha": 5,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-09",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3315,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "5/20/2019",
   "mes_fecha": 5,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-20",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "23/04/2019",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3318,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VETAGRANDE",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "4/14/2019",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-14",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3320,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "5/5/2019",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-05",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3324,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "RIO GRANDE",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "RIO GRANDE",
   "fecha_texto": "3/26/2019",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-26",
   "anio_mes": "2019-03",
   "institucion_notificacion": 5,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "15/03/2019",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3326,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "PINOS",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "5/8/2019",
   "mes_fecha": 5,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-08",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3328,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "6/11/2019",
   "mes_fecha": 6,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-11",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3329,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "TEPETONGO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "JEREZ",
   "fecha_texto": "6/6/2019",
   "mes_fecha": 6,
   "dia_fecha": 6,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-06",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3330,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "PANUCO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "3/17/2019",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-17",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3333,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "5/21/2019",
   "mes_fecha": 5,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-21",
   "anio_mes": "2019-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3334,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "2/12/2019",
   "mes_fecha": 2,
   "dia_fecha": 12,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-12",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3335,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "2/28/2019",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-28",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3337,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "4/25/2019",
   "mes_fecha": 4,
   "dia_fecha": 25,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-25",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3342,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "CALERA",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "4/7/2019",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-07",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3346,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "6/11/2019",
   "mes_fecha": 6,
   "dia_fecha": 11,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-11",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3350,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "TRANCOSO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "12/9/2019",
   "mes_fecha": 12,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-12-09",
   "anio_mes": "2019-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3354,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VILLA DE COS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "3/18/2019",
   "mes_fecha": 3,
   "dia_fecha": 18,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-03-18",
   "anio_mes": "2019-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3355,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "OJCALIENTE",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "6/9/2019",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-09",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3359,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "MORELOS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "4/9/2019",
   "mes_fecha": 4,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-09",
   "anio_mes": "2019-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3362,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "2/8/2019",
   "mes_fecha": 2,
   "dia_fecha": 8,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-08",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3365,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "ZACATECAS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "2/19/2019",
   "mes_fecha": 2,
   "dia_fecha": 19,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-19",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3375,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "PANFILO NATERA",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "GENERAL PANFILO NATERA",
   "fecha_texto": "8/9/2019",
   "mes_fecha": 8,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-08-09",
   "anio_mes": "2019-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3376,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "TLALTENANGO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "JEREZ",
   "fecha_texto": "5/31/2019",
   "mes_fecha": 5,
   "dia_fecha": 31,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-05-31",
   "anio_mes": "2019-05",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3378,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "PINOS",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "1/30/2019",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-01-30",
   "anio_mes": "2019-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3379,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VILLA DE COS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "4/1/2019",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-04-01",
   "anio_mes": "2019-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3381,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "ZACATECAS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "2/20/2019",
   "mes_fecha": 2,
   "dia_fecha": 20,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-20",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3388,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "2/27/2019",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-27",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3395,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "TEPECHITLAN",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "JEREZ",
   "fecha_texto": "7/9/2019",
   "mes_fecha": 7,
   "dia_fecha": 9,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-07-09",
   "anio_mes": "2019-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3399,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "ZACATECAS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "2/21/2019",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-02-21",
   "anio_mes": "2019-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2019,
   "fila_archivo": 3400,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "CALERA",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "6/28/2019",
   "mes_fecha": 6,
   "dia_fecha": 28,
   "anio_fecha": 2019,
   "fecha_notificacion": "2019-06-28",
   "anio_mes": "2019-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 6,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/10/2020",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-10",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 7,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "PABELLON DE ARTEAGA",
   "fecha_texto": "1/15/2020",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-15",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 8,
   "edad": "13",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/27/2020",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-27",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 9,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/27/2020",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-27",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 11,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/7/2020",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-07",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "30/12/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 14,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "2/12/2020",
   "mes_fecha": 2,
   "dia_fecha": 12,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-12",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 17,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "2/21/2020",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-21",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 30,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TECATE",
   "fecha_texto": "2/5/2020",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-05",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "20/03/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 35,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "3/2/2020",
   "mes_fecha": 3,
   "dia_fecha": 2,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-02",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "19/02/2020",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 36,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "2/27/2020",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-27",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "30/01/2020",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 37,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "5/16/2020",
   "mes_fecha": 5,
   "dia_fecha": 16,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-05-16",
   "anio_mes": "2020-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 38,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "2/21/2020",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-21",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "17/02/2019",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 42,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "4/4/2020",
   "mes_fecha": 4,
   "dia_fecha": 4,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-04",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 47,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "2/19/2020",
   "mes_fecha": 2,
   "dia_fecha": 19,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-19",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 52,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "PLAYAS DE ROSARITO",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "PLAYAS DE ROSARITO",
   "fecha_texto": "1/21/2020",
   "mes_fecha": 1,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-21",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 54,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "4/27/2020",
   "mes_fecha": 4,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-27",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 55,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "1/23/2020",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-23",
   "anio_mes": "2020-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 56,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "PLAYAS DE ROSARITO",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "PLAYAS DE ROSARITO",
   "fecha_texto": "2/24/2020",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-24",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 57,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "PLAYAS DE ROSARITO",
   "fecha_texto": "2/12/2020",
   "mes_fecha": 2,
   "dia_fecha": 12,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-12",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 59,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LOS CABOS",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LOS CABOS",
   "fecha_texto": "3/12/2020",
   "mes_fecha": 3,
   "dia_fecha": 12,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-12",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "3",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 64,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "4/13/2020",
   "mes_fecha": 4,
   "dia_fecha": 13,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-13",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 66,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OCOZOCOAUTLA DE ESPINOSA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "3/18/2020",
   "mes_fecha": 3,
   "dia_fecha": 18,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-18",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 67,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SIMOJOVEL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/25/2020",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-25",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 69,
   "edad": "17",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "3/5/2020",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-05",
   "anio_mes": "2020-03",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 70,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/9/2020",
   "mes_fecha": 2,
   "dia_fecha": 9,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-09",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 71,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TAPACHULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TAPACHULA",
   "fecha_texto": "5/4/2020",
   "mes_fecha": 5,
   "dia_fecha": 4,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-05-04",
   "anio_mes": "2020-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 72,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TAPACHULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TAPACHULA",
   "fecha_texto": "6/9/2020",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-06-09",
   "anio_mes": "2020-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 75,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "1/9/2020",
   "mes_fecha": 1,
   "dia_fecha": 9,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-09",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 77,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SIMOJOVEL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "3/7/2020",
   "mes_fecha": 3,
   "dia_fecha": 7,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-07",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 79,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHAMULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "CHAMULA",
   "fecha_texto": "5/5/2020",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-05-05",
   "anio_mes": "2020-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 81,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "3/5/2020",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-05",
   "anio_mes": "2020-03",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 84,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SIMOJOVEL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/5/2020",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-05",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 85,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SAN FERNANDO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/29/2020",
   "mes_fecha": 2,
   "dia_fecha": 29,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-29",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 86,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SAN FERNANDO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/29/2020",
   "mes_fecha": 2,
   "dia_fecha": 29,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-29",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 87,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "PALENQUE",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "PALENQUE",
   "fecha_texto": "2/22/2020",
   "mes_fecha": 2,
   "dia_fecha": 22,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-22",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 88,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "MOTOZINTLA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "MOTOZINTLA",
   "fecha_texto": "8/19/2020",
   "mes_fecha": 8,
   "dia_fecha": 19,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-08-19",
   "anio_mes": "2020-08",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 90,
   "edad": "35",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHAMULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "CHAMULA",
   "fecha_texto": "5/5/2020",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-05-05",
   "anio_mes": "2020-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 94,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TAPACHULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TAPACHULA",
   "fecha_texto": "3/20/2020",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-20",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 97,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "1/26/2020",
   "mes_fecha": 1,
   "dia_fecha": 26,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-26",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 98,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "MOTOZINTLA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TAPACHULA",
   "fecha_texto": "1/14/2020",
   "mes_fecha": 1,
   "dia_fecha": 14,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-14",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 100,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "BERRIOZABAL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/28/2020",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-28",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 101,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/24/2020",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-24",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 108,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SUCHIAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "3/27/2020",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-27",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 109,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "BERRIOZABAL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "3/18/2020",
   "mes_fecha": 3,
   "dia_fecha": 18,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-18",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 115,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "3/5/2020",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-05",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 125,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "3/18/2020",
   "mes_fecha": 3,
   "dia_fecha": 18,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-18",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 126,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "3/30/2020",
   "mes_fecha": 3,
   "dia_fecha": 30,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-30",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 129,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CU8AUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "4/16/2020",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-16",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 138,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "NAMIQUIPA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "3/30/2020",
   "mes_fecha": 3,
   "dia_fecha": 30,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-30",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 147,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "3/26/2020",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-26",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 150,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GUADALUPE Y CALVO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "4/19/2020",
   "mes_fecha": 4,
   "dia_fecha": 19,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-19",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 151,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "5/29/2020",
   "mes_fecha": 5,
   "dia_fecha": 29,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-05-29",
   "anio_mes": "2020-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 158,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "4/15/2020",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-15",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 161,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CARICHI",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "5/25/2020",
   "mes_fecha": 5,
   "dia_fecha": 25,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-05-25",
   "anio_mes": "2020-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 166,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JIMENEZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JIMENEZ",
   "fecha_texto": "2/28/2020",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-28",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 173,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "2/3/2020",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-03",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "13/01/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 177,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "2/13/2020",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-13",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 179,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLAHUAC",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "6/1/2020",
   "mes_fecha": 6,
   "dia_fecha": 1,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-06-01",
   "anio_mes": "2020-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 181,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "7/2/2020",
   "mes_fecha": 7,
   "dia_fecha": 2,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-07-02",
   "anio_mes": "2020-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "17/06/2020",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 186,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "VENUSTIANO CARRANZA",
   "fecha_texto": "3/17/2020",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-17",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 189,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "COYOACAN",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "2/18/2020",
   "mes_fecha": 2,
   "dia_fecha": 18,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-18",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 191,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MIGUEL HIDALGO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "2/10/2020",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-10",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 192,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "AZCAPOTZALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "AZCAPOTZALCO",
   "fecha_texto": "2/6/2020",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-06",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 193,
   "edad": "71",
   "grupo_edad": "70 - 74",
   "demografia_edad": "MAYOR",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "5/18/2020",
   "mes_fecha": 5,
   "dia_fecha": 18,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-05-18",
   "anio_mes": "2020-05",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 195,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTACALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "2/19/2020",
   "mes_fecha": 2,
   "dia_fecha": 19,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-19",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 197,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "AZCAPOTZALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "1/24/2020",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-24",
   "anio_mes": "2020-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "20/11/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 199,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "6/19/2020",
   "mes_fecha": 6,
   "dia_fecha": 19,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-06-19",
   "anio_mes": "2020-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 200,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "3/4/2020",
   "mes_fecha": 3,
   "dia_fecha": 4,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-04",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "29/10/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 201,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "2/26/2020",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-26",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 203,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "3/3/2020",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-03",
   "anio_mes": "2020-03",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 206,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MAGDALENA CONTRERAS",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "MAGDALENA CONTRERAS",
   "fecha_texto": "2/14/2020",
   "mes_fecha": 2,
   "dia_fecha": 14,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-14",
   "anio_mes": "2020-02",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 214,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "1/20/2020",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-20",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 221,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "TORREON",
   "fecha_texto": "11/10/2020",
   "mes_fecha": 11,
   "dia_fecha": 10,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-11-10",
   "anio_mes": "2020-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 224,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "3/2/2020",
   "mes_fecha": 3,
   "dia_fecha": 2,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-02",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 227,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SAN PEDRO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SAN PEDRO",
   "fecha_texto": "2/19/2020",
   "mes_fecha": 2,
   "dia_fecha": 19,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-19",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "23/01/2020",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 237,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COLIMA",
   "municipio_residencia": "TECOMAN",
   "estado_notificacion": "COLIMA",
   "municipio_notificacion": "VILLA DE ALVAREZ",
   "fecha_texto": "1/13/2020",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-13",
   "anio_mes": "2020-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 240,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "MEZQUITEL",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "3/8/2020",
   "mes_fecha": 3,
   "dia_fecha": 8,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-08",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "23/02/2020",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 241,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "SIMÓN BOLIVAR",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "CUENCAMÉ",
   "fecha_texto": "3/20/2020",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-20",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 243,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "4/1/2020",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-01",
   "anio_mes": "2020-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 245,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "GÓMEZ PALACIO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "GÓMEZ PALACIO",
   "fecha_texto": "3/10/2020",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-10",
   "anio_mes": "2020-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 248,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "2/12/2020",
   "mes_fecha": 2,
   "dia_fecha": 12,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-12",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 252,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "MANUEL DOBLADO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "MANUEL DOBLADO",
   "fecha_texto": "2/12/2020",
   "mes_fecha": 2,
   "dia_fecha": 12,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-12",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "05/09/2018",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 265,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "3/3/2020",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-03",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 271,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SAN MIGUEL DE ALLENDE",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "SAN MIGUEL DE ALLENDE",
   "fecha_texto": "1/20/2020",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-20",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 275,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "12/22/2020",
   "mes_fecha": 12,
   "dia_fecha": 22,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-12-22",
   "anio_mes": "2020-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/11/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 291,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "DOLORES HIDALGO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "SAN LUIS DE LA PAZ",
   "fecha_texto": "2/17/2020",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-17",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 300,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "DOCTOR MORA",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "SAN LUIS DE LA PAZ",
   "fecha_texto": "3/17/2020",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-17",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 320,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "IRAPUATO",
   "fecha_texto": "1/21/2020",
   "mes_fecha": 1,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-21",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 359,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "ZEMPOALA",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "PACHUCA",
   "fecha_texto": "3/23/2020",
   "mes_fecha": 3,
   "dia_fecha": 23,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-23",
   "anio_mes": "2020-03",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "05/11/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 360,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "ZEMPOALA",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "ZEMPOALA",
   "fecha_texto": "3/24/2020",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-24",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "29/07/2019",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 362,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "HUICHAPAN",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "HUICHAPAN",
   "fecha_texto": "1/28/2020",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-28",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "06/01/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 363,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TEPATITLAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "TEPATITLÁN DE MORELOS",
   "fecha_texto": "1/30/2020",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-30",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 365,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ATOTONILCO EL ALTO",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ATOTONILCO",
   "fecha_texto": "3/21/2020",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-21",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 367,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "1/31/2020",
   "mes_fecha": 1,
   "dia_fecha": 31,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-31",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 370,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "3/29/2020",
   "mes_fecha": 3,
   "dia_fecha": 29,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-29",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 374,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "EL SALTO",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "4/12/2020",
   "mes_fecha": 4,
   "dia_fecha": 12,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-12",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 378,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "4/8/2020",
   "mes_fecha": 4,
   "dia_fecha": 8,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-08",
   "anio_mes": "2020-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "25/02/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 382,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAQUEPAQUE",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "1/26/2020",
   "mes_fecha": 1,
   "dia_fecha": 26,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-26",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 392,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "2/27/2020",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-27",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 397,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "6/12/2020",
   "mes_fecha": 6,
   "dia_fecha": 12,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-06-12",
   "anio_mes": "2020-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "07/06/2019",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 398,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "1/30/2020",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-30",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 399,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "YAHUALICA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "2/7/2020",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-07",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 401,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "OCOTLAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "LA BARCA",
   "fecha_texto": "2/5/2020",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-05",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 404,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "2/11/2020",
   "mes_fecha": 2,
   "dia_fecha": 11,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-11",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 405,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TALA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "1/7/2020",
   "mes_fecha": 1,
   "dia_fecha": 7,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-07",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2DA.",
   "fecha_ultima_dosis": "14/10/2019",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 414,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "CHAPALA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "1/15/2020",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-15",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 417,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOTLAN EL REY",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "1/23/2020",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-23",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 418,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TALA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "3/13/2020",
   "mes_fecha": 3,
   "dia_fecha": 13,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-13",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 419,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ZUMPANGO",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "PACHUCA",
   "fecha_texto": "2/21/2020",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-21",
   "anio_mes": "2020-02",
   "institucion_notificacion": 6,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 421,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CHIMALHUACAN",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "CHIMALHUACAN",
   "fecha_texto": "3/6/2020",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-06",
   "anio_mes": "2020-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 423,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TEOLOYUCAN",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "PACHUCA",
   "fecha_texto": "7/11/2020",
   "mes_fecha": 7,
   "dia_fecha": 11,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-07-11",
   "anio_mes": "2020-07",
   "institucion_notificacion": 6,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "6/23/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 425,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "VALLE DE CHALCO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "CHALCO",
   "fecha_texto": "1/23/2020",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-23",
   "anio_mes": "2020-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 426,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "VALLE DE CHALCO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "VALLE DE CHALCO",
   "fecha_texto": "3/6/2020",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-06",
   "anio_mes": "2020-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "12/01/2019",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 427,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CHALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "4/8/2020",
   "mes_fecha": 4,
   "dia_fecha": 8,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-08",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 428,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "ECATEPEC",
   "fecha_texto": "2/28/2020",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-28",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 430,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NAUCALPAN",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "5/20/2020",
   "mes_fecha": 5,
   "dia_fecha": 20,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-05-20",
   "anio_mes": "2020-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 431,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "LERMA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "ZITACUARO",
   "fecha_texto": "2/20/2020",
   "mes_fecha": 2,
   "dia_fecha": 20,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-20",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 433,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TLALNEPANTLA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "2/27/2020",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-27",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 436,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "LOS REYES LA PAZ",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "1/21/2020",
   "mes_fecha": 1,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-21",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 442,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TIZAYUCA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "2/21/2020",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-21",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 443,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NEZAHUALCOYOTL",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "2/27/2020",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-27",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 444,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "2/4/2020",
   "mes_fecha": 2,
   "dia_fecha": 4,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-04",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 447,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "PARACUARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "APATZINGAN",
   "fecha_texto": "4/7/2020",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-07",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 450,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "URUAPAN",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "URUAPAN",
   "fecha_texto": "1/20/2020",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-20",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 451,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "OCAMPO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "OCAMPO",
   "fecha_texto": "2/10/2020",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-10",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 453,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "OCAMPO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "ZITACUARO",
   "fecha_texto": "3/5/2020",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-05",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 455,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "TARETAN",
   "estado_notificacion": "MICHOACACN",
   "municipio_notificacion": "TARETAN",
   "fecha_texto": "4/21/2020",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-21",
   "anio_mes": "2020-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "31/03/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 456,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "TUZANTLA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "ZITACUARO",
   "fecha_texto": "1/23/2020",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-23",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 458,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "HIDALGO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "HIDALGO",
   "fecha_texto": "3/3/2020",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-03",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 459,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "COAHUAYANA",
   "estado_notificacion": "COLIMA",
   "municipio_notificacion": "TECOMAN",
   "fecha_texto": "4/8/2020",
   "mes_fecha": 4,
   "dia_fecha": 8,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-08",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 460,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "ZITACUARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "ZITACUARO",
   "fecha_texto": "2/10/2020",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-10",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 461,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "PATZCUARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "PATZCUARO",
   "fecha_texto": "3/16/2020",
   "mes_fecha": 3,
   "dia_fecha": 16,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-16",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 462,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "CHURUMUCO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "2/13/2020",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-13",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 463,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "PATZCUARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "PATZCUARO",
   "fecha_texto": "2/13/2020",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-13",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 464,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "PICHATARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "PATZCUARO",
   "fecha_texto": "3/3/2020",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-03",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 465,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "URUAPAN",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "URUAPAN",
   "fecha_texto": "1/29/2020",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-29",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 466,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "PATZCUARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "PATZCUARO",
   "fecha_texto": "2/28/2020",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-28",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 472,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "AQUILA",
   "estado_notificacion": "COLIMA",
   "municipio_notificacion": "TECOMAN",
   "fecha_texto": "3/9/2020",
   "mes_fecha": 3,
   "dia_fecha": 9,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-09",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 473,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "AQUILA",
   "estado_notificacion": "COLIMA",
   "municipio_notificacion": "TECOMAN",
   "fecha_texto": "3/12/2020",
   "mes_fecha": 3,
   "dia_fecha": 12,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-12",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 478,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "YAUTEPEC",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "CUAUTLA",
   "fecha_texto": "1/22/2020",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-22",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 479,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "AXOCHIAPN",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "AXOCHIAPAN",
   "fecha_texto": "4/27/2020",
   "mes_fecha": 4,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-27",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "04/10/2019",
   "tipo_vacuna": "3",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 480,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "AXOCHIAPN",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "AXOCHIAPAN",
   "fecha_texto": "4/27/2020",
   "mes_fecha": 4,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-27",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "08/04/2020",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 484,
   "edad": "49",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEPIC",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "1/29/2020",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-29",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 489,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "SANTIAGO IXCUINTLA",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "1/23/2020",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-23",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 490,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "SAN BLAS",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "4/16/2020",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-16",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "18/03/2020",
   "tipo_vacuna": "4",
   "complicaciones": 4,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 491,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "JESUS MARIA",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "DEL NAYAR",
   "fecha_texto": "6/15/2020",
   "mes_fecha": 6,
   "dia_fecha": 15,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-06-15",
   "anio_mes": "2020-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 500,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "3/23/2020",
   "mes_fecha": 3,
   "dia_fecha": 23,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-23",
   "anio_mes": "2020-03",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "18/02/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 502,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "CADEREYTA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "4/8/2020",
   "mes_fecha": 4,
   "dia_fecha": 8,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-08",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "03/03/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 510,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GALEANA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GALEANA",
   "fecha_texto": "3/27/2020",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-27",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "19/03/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 524,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "CADEREYTA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "4/13/2020",
   "mes_fecha": 4,
   "dia_fecha": 13,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-13",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 557,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "9/2/2020",
   "mes_fecha": 9,
   "dia_fecha": 2,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-09-02",
   "anio_mes": "2020-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 559,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "2/5/2020",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-05",
   "anio_mes": "2020-02",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 562,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/25/2020",
   "mes_fecha": 5,
   "dia_fecha": 25,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-05-25",
   "anio_mes": "2020-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 572,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ZARAGOZA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "2/21/2020",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-21",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 573,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "2/14/2020",
   "mes_fecha": 2,
   "dia_fecha": 14,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-14",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 574,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "3/23/2020",
   "mes_fecha": 3,
   "dia_fecha": 23,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-23",
   "anio_mes": "2020-03",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 583,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SAN NICOLAS DE LOS GARZA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "2/4/2020",
   "mes_fecha": 2,
   "dia_fecha": 4,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-04",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 584,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "CIENEGA DE FLORES",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "3/18/2020",
   "mes_fecha": 3,
   "dia_fecha": 18,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-18",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 591,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTO DOMINGO ALBARRADAS",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "OAXACA DE JUAREZ",
   "fecha_texto": "2/26/2020",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-26",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 594,
   "edad": "7",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN MARTIN PERAS",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "OAXACA DE JUAREZ",
   "fecha_texto": "3/24/2020",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-24",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 596,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "CUILAPAM DE GUERRERO",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "OAXACA DE JUAREZ",
   "fecha_texto": "4/3/2020",
   "mes_fecha": 4,
   "dia_fecha": 3,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-03",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 597,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN PEDRO MIXTEPEC",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN PEDRO MIXTEPEC",
   "fecha_texto": "2/10/2020",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-10",
   "anio_mes": "2020-02",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "21/10/2014",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 600,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "ACATLAN DE PEREZ FIGUEROA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "CORDOBA",
   "fecha_texto": "2/25/2020",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-25",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 601,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "YEHUALTEPEC",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "CDMX",
   "fecha_texto": "2/10/2020",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-10",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 602,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "ESPERANZA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "CORDOVA",
   "fecha_texto": "1/24/2020",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-24",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 604,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "SN.P. CHOLULA",
   "estado_notificacion": "PUEBLA",
   "municipio_notificacion": "PUEBLA",
   "fecha_texto": "8/26/2020",
   "mes_fecha": 8,
   "dia_fecha": 26,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-08-26",
   "anio_mes": "2020-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 605,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "CADERYTA",
   "fecha_texto": "2/13/2020",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-13",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "02/12/2019",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 606,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "AMEALCO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "SAN JUAN DEL RIO",
   "fecha_texto": "4/1/2020",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-01",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 608,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "9/21/2020",
   "mes_fecha": 9,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-09-21",
   "anio_mes": "2020-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 609,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "2/24/2020",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-24",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 610,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "AMEALCO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "SAN JUAN DEL RIO",
   "fecha_texto": "2/11/2020",
   "mes_fecha": 2,
   "dia_fecha": 11,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-11",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 612,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "2/10/2020",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-10",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 614,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "1/23/2020",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-23",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 617,
   "edad": "53",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "CADEREYTA",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "CADERYTA",
   "fecha_texto": "2/14/2020",
   "mes_fecha": 2,
   "dia_fecha": 14,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-14",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 618,
   "edad": "44",
   "grupo_edad": "40 - 44",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "SAN JUAN DEL RIO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "SAN JUAN DEL RIO",
   "fecha_texto": "3/30/2020",
   "mes_fecha": 3,
   "dia_fecha": 30,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-30",
   "anio_mes": "2020-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 620,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "EL MARQUES",
   "fecha_texto": "1/30/2020",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-30",
   "anio_mes": "2020-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 621,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "CADEREYTA",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "CADERYTA",
   "fecha_texto": "1/30/2020",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-30",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 622,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "EL MARQUES",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "3/2/2020",
   "mes_fecha": 3,
   "dia_fecha": 2,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-02",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 624,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "3/23/2020",
   "mes_fecha": 3,
   "dia_fecha": 23,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-23",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 626,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "EL MARQUES",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "2/26/2020",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-26",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 627,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "CORREGIDORA",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "2/12/2020",
   "mes_fecha": 2,
   "dia_fecha": 12,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-12",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 631,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "FELIPE CARRILLO PUERTO",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "FELIPE CARRILLO PUERTO",
   "fecha_texto": "1/30/2020",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-30",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 635,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "5/19/2020",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-05-19",
   "anio_mes": "2020-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 638,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "FELIPE CARRILLO PUERTO",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "FELIPE CARRILLO PUERTO",
   "fecha_texto": "4/20/2020",
   "mes_fecha": 4,
   "dia_fecha": 20,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-20",
   "anio_mes": "2020-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 642,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSÍ",
   "fecha_texto": "3/5/2020",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-05",
   "anio_mes": "2020-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 653,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSÍ",
   "fecha_texto": "1/29/2020",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-29",
   "anio_mes": "2020-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 681,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SAN LUIS POTOSI",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSÍ",
   "fecha_texto": "2/7/2020",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-07",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/11/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 685,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SOLEDAD DE GRACIANO SANCHEZ",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSÍ",
   "fecha_texto": "1/28/2020",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-28",
   "anio_mes": "2020-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 704,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULIACAN",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "CULIACAN",
   "fecha_texto": "4/21/2020",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-21",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 727,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "SAN LUIS RIO COLORADO",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "2/21/2020",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-21",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 731,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "1/22/2020",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-22",
   "anio_mes": "2020-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 733,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "3/6/2020",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-06",
   "anio_mes": "2020-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 738,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "2/27/2020",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-27",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 739,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "2/27/2020",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-27",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 740,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "9/1/2020",
   "mes_fecha": 9,
   "dia_fecha": 1,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-09-01",
   "anio_mes": "2020-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 742,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "4/29/2020",
   "mes_fecha": 4,
   "dia_fecha": 29,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-29",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 749,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "3/2/2020",
   "mes_fecha": 3,
   "dia_fecha": 2,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-02",
   "anio_mes": "2020-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 756,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "1/7/2020",
   "mes_fecha": 1,
   "dia_fecha": 7,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-07",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 759,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "2/8/2020",
   "mes_fecha": 2,
   "dia_fecha": 8,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-08",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 760,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "1/23/2020",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-23",
   "anio_mes": "2020-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 764,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NOGALES",
   "fecha_texto": "2/21/2020",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-21",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 768,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "3/9/2020",
   "mes_fecha": 3,
   "dia_fecha": 9,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-09",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "18/02/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 769,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "4/30/2020",
   "mes_fecha": 4,
   "dia_fecha": 30,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-30",
   "anio_mes": "2020-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 774,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "3/9/2020",
   "mes_fecha": 3,
   "dia_fecha": 9,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-09",
   "anio_mes": "2020-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 782,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "4/30/2020",
   "mes_fecha": 4,
   "dia_fecha": 30,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-30",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 784,
   "edad": "13",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "JALPA DE MENDEZ",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "JALPA DE MENDEZ",
   "fecha_texto": "2/5/2020",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-05",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "15/08/2010",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 785,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "CENTLA",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CENTRO",
   "fecha_texto": "6/15/2020",
   "mes_fecha": 6,
   "dia_fecha": 15,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-06-15",
   "anio_mes": "2020-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 787,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "CENTLA",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CENTRO",
   "fecha_texto": "8/24/2020",
   "mes_fecha": 8,
   "dia_fecha": 24,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-08-24",
   "anio_mes": "2020-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 790,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "MADERO",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "MADERO",
   "fecha_texto": "3/30/2020",
   "mes_fecha": 3,
   "dia_fecha": 30,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-30",
   "anio_mes": "2020-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 792,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "3/3/2020",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-03",
   "anio_mes": "2020-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 799,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "2/25/2020",
   "mes_fecha": 2,
   "dia_fecha": 25,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-25",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 803,
   "edad": "55",
   "grupo_edad": "55 - 59",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "SANTA CRUZ TLAXCALA",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
   "fecha_texto": "4/1/2020",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-01",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 804,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "TENANZINGO",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
   "fecha_texto": "2/27/2020",
   "mes_fecha": 2,
   "dia_fecha": 27,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-27",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 805,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "YAUHQUEMECAN",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
   "fecha_texto": "2/26/2020",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-26",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 807,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "HUEYOTLIPAN",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
   "fecha_texto": "1/29/2020",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-29",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 809,
   "edad": "22",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "HUEYOTLIPAN",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
   "fecha_texto": "1/29/2020",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-29",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "01/01/2010",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 810,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "SANTA CRUZ TLAXCALA",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
   "fecha_texto": "4/1/2020",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-01",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 811,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "SANTA CRUZ TLAXCALA",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
   "fecha_texto": "4/1/2020",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-01",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "31/12/2019",
   "tipo_vacuna": "3",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 812,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "TEPETITLA DE LA ARDIZABAL",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
   "fecha_texto": "2/17/2020",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-17",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "25/01/2020",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 813,
   "edad": "27",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "TEPETITLA DE LA ARDIZABAL",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "SAN PABLO APETATITLAN DE ANTONIO CARVAJAL",
   "fecha_texto": "2/17/2020",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-17",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 814,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "COSOLEACAQUE",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "MINATITLAN",
   "fecha_texto": "1/17/2020",
   "mes_fecha": 1,
   "dia_fecha": 17,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-17",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 816,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "OTATITLAN",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "OAXACA",
   "fecha_texto": "2/17/2020",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-17",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "03/01/2020",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 819,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "TEHUIPANGO",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "TLAQUILPA",
   "fecha_texto": "3/2/2020",
   "mes_fecha": 3,
   "dia_fecha": 2,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-02",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 824,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "MINATITLAN",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "MINATITLAN",
   "fecha_texto": "2/24/2020",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-24",
   "anio_mes": "2020-02",
   "institucion_notificacion": 7,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "31/01/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 825,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "IXTACZOQUITLAN",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "RIO BLANCO",
   "fecha_texto": "2/11/2020",
   "mes_fecha": 2,
   "dia_fecha": 11,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-11",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 826,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "ATZACAN",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "RIO BLANCO",
   "fecha_texto": "3/23/2020",
   "mes_fecha": 3,
   "dia_fecha": 23,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-23",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 828,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "MOLOACAN",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "COATZACOALCOS",
   "fecha_texto": "2/24/2020",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-24",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 832,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "JUAN RODRIGUEZ CLARA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "ISLA",
   "fecha_texto": "5/7/2020",
   "mes_fecha": 5,
   "dia_fecha": 7,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-05-07",
   "anio_mes": "2020-05",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 834,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "LAS VIGAS",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "3/9/2020",
   "mes_fecha": 3,
   "dia_fecha": 9,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-09",
   "anio_mes": "2020-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 835,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "COATZACOALCOS",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "COATZACOALCOS",
   "fecha_texto": "2/24/2020",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-24",
   "anio_mes": "2020-02",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "15/08/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 836,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "COTAXTLA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "BOCA DEL RIO",
   "fecha_texto": "2/13/2020",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-13",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "20/01/2020",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 838,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "LAS CHOAPAS",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "LAS CHOAPAS",
   "fecha_texto": "1/22/2020",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-22",
   "anio_mes": "2020-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 839,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "VERACRUZ",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "VERACRUZ",
   "fecha_texto": "2/11/2020",
   "mes_fecha": 2,
   "dia_fecha": 11,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-11",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "07/01/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 841,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "TEHUIPANGO",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "TLAQUILPA",
   "fecha_texto": "4/28/2020",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-28",
   "anio_mes": "2020-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 843,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "COATZACOALCOS",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "COATZACOALCOS",
   "fecha_texto": "9/11/2020",
   "mes_fecha": 9,
   "dia_fecha": 11,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-09-11",
   "anio_mes": "2020-09",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "14/08/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 845,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "4/30/2020",
   "mes_fecha": 4,
   "dia_fecha": 30,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-30",
   "anio_mes": "2020-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 846,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "TECOH",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "2/7/2020",
   "mes_fecha": 2,
   "dia_fecha": 7,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-07",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 851,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "TAHDZIU",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "7/29/2020",
   "mes_fecha": 7,
   "dia_fecha": 29,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-07-29",
   "anio_mes": "2020-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 853,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "2/10/2020",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-10",
   "anio_mes": "2020-02",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "08/01/2020",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 855,
   "edad": "74",
   "grupo_edad": "70 - 74",
   "demografia_edad": "MAYOR",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "3/20/2020",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-20",
   "anio_mes": "2020-03",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 857,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "2/12/2020",
   "mes_fecha": 2,
   "dia_fecha": 12,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-12",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 858,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "IZAMAL",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "2/12/2020",
   "mes_fecha": 2,
   "dia_fecha": 12,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-12",
   "anio_mes": "2020-02",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 860,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "1/23/2020",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-01-23",
   "anio_mes": "2020-01",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 866,
   "edad": "52",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "4/1/2020",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-04-01",
   "anio_mes": "2020-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 867,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "2/21/2020",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-21",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 876,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "ZACATECAS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "3/26/2020",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-26",
   "anio_mes": "2020-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 881,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VILLA DE COS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "2/20/2020",
   "mes_fecha": 2,
   "dia_fecha": 20,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-20",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 882,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "ZACATECAS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "3/11/2020",
   "mes_fecha": 3,
   "dia_fecha": 11,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-03-11",
   "anio_mes": "2020-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "25/02/2020",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 883,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "PINOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/5/2020",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-05",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "03/01/2020",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 886,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "GUADALUPE",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "2/21/2020",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-21",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2020,
   "fila_archivo": 894,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "LORETO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "LORETO",
   "fecha_texto": "2/26/2020",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2020,
   "fecha_notificacion": "2020-02-26",
   "anio_mes": "2020-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 7,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 8,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TECATE",
   "fecha_texto": "7/21/2021",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-07-21",
   "anio_mes": "2021-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 49,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "ZINACANTAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "3/7/2021",
   "mes_fecha": 3,
   "dia_fecha": 7,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-03-07",
   "anio_mes": "2021-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 56,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GUADALUPE Y CALVO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "12/31/2021",
   "mes_fecha": 12,
   "dia_fecha": 31,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-12-31",
   "anio_mes": "2021-12",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 57,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "2/4/2021",
   "mes_fecha": 2,
   "dia_fecha": 4,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-02-04",
   "anio_mes": "2021-02",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 62,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GUADALUPE Y CALVO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "GUADALUPE Y CALVO",
   "fecha_texto": "4/8/2021",
   "mes_fecha": 4,
   "dia_fecha": 8,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-04-08",
   "anio_mes": "2021-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 98,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "10/18/2021",
   "mes_fecha": 10,
   "dia_fecha": 18,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-10-18",
   "anio_mes": "2021-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 101,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "8/24/2021",
   "mes_fecha": 8,
   "dia_fecha": 24,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-08-24",
   "anio_mes": "2021-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 103,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "8/27/2021",
   "mes_fecha": 8,
   "dia_fecha": 27,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-08-27",
   "anio_mes": "2021-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/20/2021",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 278,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "7/30/2021",
   "mes_fecha": 7,
   "dia_fecha": 30,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-07-30",
   "anio_mes": "2021-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/22/2021",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 279,
   "edad": "33",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "7/30/2021",
   "mes_fecha": 7,
   "dia_fecha": 30,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-07-30",
   "anio_mes": "2021-07",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 280,
   "edad": "47",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "JUVEMTINO ROSAS",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "JUVENTINO ROSAS",
   "fecha_texto": "10/18/2021",
   "mes_fecha": 10,
   "dia_fecha": 18,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-10-18",
   "anio_mes": "2021-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/28/2014",
   "tipo_vacuna": "3",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 455,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "LAZARO CARDENAS",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "LAZARO CARDENAS",
   "fecha_texto": "4/30/2021",
   "mes_fecha": 4,
   "dia_fecha": 30,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-04-30",
   "anio_mes": "2021-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 473,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "COMPOSTELA",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "COMPOSTELA",
   "fecha_texto": "11/8/2021",
   "mes_fecha": 11,
   "dia_fecha": 8,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-11-08",
   "anio_mes": "2021-11",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 474,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEPIC",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "9/27/2021",
   "mes_fecha": 9,
   "dia_fecha": 27,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-09-27",
   "anio_mes": "2021-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 476,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEPIC",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "6/28/2021",
   "mes_fecha": 6,
   "dia_fecha": 28,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-06-28",
   "anio_mes": "2021-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "6/21/2021",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 645,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "ETCHOJOA",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "5/6/2021",
   "mes_fecha": 5,
   "dia_fecha": 6,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-05-06",
   "anio_mes": "2021-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 647,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "12/9/2021",
   "mes_fecha": 12,
   "dia_fecha": 9,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-12-09",
   "anio_mes": "2021-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 667,
   "edad": "24",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "4/20/2021",
   "mes_fecha": 4,
   "dia_fecha": 20,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-04-20",
   "anio_mes": "2021-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 670,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "12/14/2021",
   "mes_fecha": 12,
   "dia_fecha": 14,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-12-14",
   "anio_mes": "2021-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "10/18/2021",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 686,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "CENTRO",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CENTRO",
   "fecha_texto": "11/19/2021",
   "mes_fecha": 11,
   "dia_fecha": 19,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-11-19",
   "anio_mes": "2021-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 714,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "TIXKOKOB",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "9/8/2021",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-09-08",
   "anio_mes": "2021-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2021,
   "fila_archivo": 729,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "7/29/2021",
   "mes_fecha": 7,
   "dia_fecha": 29,
   "anio_fecha": 2021,
   "fecha_notificacion": "2021-07-29",
   "anio_mes": "2021-07",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 8,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "JESUS MARIA",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "12/16/2022",
   "mes_fecha": 12,
   "dia_fecha": 16,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-12-16",
   "anio_mes": "2022-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 11,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "12/16/2022",
   "mes_fecha": 12,
   "dia_fecha": 16,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-12-16",
   "anio_mes": "2022-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 14,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "12/16/2022",
   "mes_fecha": 12,
   "dia_fecha": 16,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-12-16",
   "anio_mes": "2022-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 41,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "5/3/2022",
   "mes_fecha": 5,
   "dia_fecha": 3,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-05-03",
   "anio_mes": "2022-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 76,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "12/5/2022",
   "mes_fecha": 12,
   "dia_fecha": 5,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-12-05",
   "anio_mes": "2022-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 79,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "ZINACANTAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "8/26/2022",
   "mes_fecha": 8,
   "dia_fecha": 26,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-08-26",
   "anio_mes": "2022-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 83,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHAMULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "7/27/2022",
   "mes_fecha": 7,
   "dia_fecha": 27,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-07-27",
   "anio_mes": "2022-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 84,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHAMULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "8/22/2022",
   "mes_fecha": 8,
   "dia_fecha": 22,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-08-22",
   "anio_mes": "2022-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 85,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "IXTAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "12/23/2022",
   "mes_fecha": 12,
   "dia_fecha": 23,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-12-23",
   "anio_mes": "2022-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 94,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHANAL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "5/24/2022",
   "mes_fecha": 5,
   "dia_fecha": 24,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-05-24",
   "anio_mes": "2022-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 98,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SAN CRISTOBAL DE LAS CASAS",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "6/22/2022",
   "mes_fecha": 6,
   "dia_fecha": 22,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-06-22",
   "anio_mes": "2022-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 99,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "AMATENANGO DEL VALLE",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "9/12/2022",
   "mes_fecha": 9,
   "dia_fecha": 12,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-09-12",
   "anio_mes": "2022-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 104,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "LARRAINZAR",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "7/12/2022",
   "mes_fecha": 7,
   "dia_fecha": 12,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-07-12",
   "anio_mes": "2022-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 105,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "BERRIOZABAL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "11/14/2022",
   "mes_fecha": 11,
   "dia_fecha": 14,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-11-14",
   "anio_mes": "2022-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 107,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "ZINACANTAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "6/16/2022",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-06-16",
   "anio_mes": "2022-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 111,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "LARRAINZAR",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "3/29/2022",
   "mes_fecha": 3,
   "dia_fecha": 29,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-03-29",
   "anio_mes": "2022-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 112,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "IXTAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "6/27/2022",
   "mes_fecha": 6,
   "dia_fecha": 27,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-06-27",
   "anio_mes": "2022-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 113,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHENALHO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "8/29/2022",
   "mes_fecha": 8,
   "dia_fecha": 29,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-08-29",
   "anio_mes": "2022-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 114,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TECPATAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "8/16/2022",
   "mes_fecha": 8,
   "dia_fecha": 16,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-08-16",
   "anio_mes": "2022-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 118,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VILLAFLORES",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "VILLAFLORES",
   "fecha_texto": "9/1/2022",
   "mes_fecha": 9,
   "dia_fecha": 1,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-09-01",
   "anio_mes": "2022-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "6/1/2021",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 119,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "LARRAINZAR",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "10/14/2022",
   "mes_fecha": 10,
   "dia_fecha": 14,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-10-14",
   "anio_mes": "2022-10",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 123,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TEOPISCA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "11/18/2022",
   "mes_fecha": 11,
   "dia_fecha": 18,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-11-18",
   "anio_mes": "2022-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 126,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TENEJAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "11/17/2022",
   "mes_fecha": 11,
   "dia_fecha": 17,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-11-17",
   "anio_mes": "2022-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 128,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHANAL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "7/7/2022",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-07-07",
   "anio_mes": "2022-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 139,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TENEJAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "10/5/2022",
   "mes_fecha": 10,
   "dia_fecha": 5,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-10-05",
   "anio_mes": "2022-10",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 140,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TEOPISCA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "11/7/2022",
   "mes_fecha": 11,
   "dia_fecha": 7,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-11-07",
   "anio_mes": "2022-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 156,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHAMULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "10/14/2022",
   "mes_fecha": 10,
   "dia_fecha": 14,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-10-14",
   "anio_mes": "2022-10",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 157,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SAN CRISTOBAL DE LAS CASAS",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "12/1/2022",
   "mes_fecha": 12,
   "dia_fecha": 1,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-12-01",
   "anio_mes": "2022-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 158,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHENALHO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "5/5/2022",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-05-05",
   "anio_mes": "2022-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 159,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "LARRAINZAR",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "9/16/2022",
   "mes_fecha": 9,
   "dia_fecha": 16,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-09-16",
   "anio_mes": "2022-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 166,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SAN CRISTOBAL DE LAS CASAS",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "7/27/2022",
   "mes_fecha": 7,
   "dia_fecha": 27,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-07-27",
   "anio_mes": "2022-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 167,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "IXTAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "11/28/2022",
   "mes_fecha": 11,
   "dia_fecha": 28,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-11-28",
   "anio_mes": "2022-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 172,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TEOPISCA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "11/29/2022",
   "mes_fecha": 11,
   "dia_fecha": 29,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-11-29",
   "anio_mes": "2022-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 176,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHENALHO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "CHAMULA",
   "fecha_texto": "4/19/2022",
   "mes_fecha": 4,
   "dia_fecha": 19,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-04-19",
   "anio_mes": "2022-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 177,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OXCHUC",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "10/25/2022",
   "mes_fecha": 10,
   "dia_fecha": 25,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-10-25",
   "anio_mes": "2022-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 180,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHANAL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL DE LAS CASAS",
   "fecha_texto": "5/20/2022",
   "mes_fecha": 5,
   "dia_fecha": 20,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-05-20",
   "anio_mes": "2022-05",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "NO APLICA",
   "fecha_ultima_dosis": "NO APLICA",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 281,
   "edad": "46",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "2/20/2023",
   "mes_fecha": 2,
   "dia_fecha": 20,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-02-20",
   "anio_mes": "2023-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 283,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "12/5/2022",
   "mes_fecha": 12,
   "dia_fecha": 5,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-12-05",
   "anio_mes": "2022-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 286,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "ARTEAGA",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "9/20/2022",
   "mes_fecha": 9,
   "dia_fecha": 20,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-09-20",
   "anio_mes": "2022-09",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "24/05/2017",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 305,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "10/11/2022",
   "mes_fecha": 10,
   "dia_fecha": 11,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-10-11",
   "anio_mes": "2022-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "05/09/2022",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 306,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "5/23/2022",
   "mes_fecha": 5,
   "dia_fecha": 23,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-05-23",
   "anio_mes": "2022-05",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "3/30/2022",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 308,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "10/31/2022",
   "mes_fecha": 10,
   "dia_fecha": 31,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-10-31",
   "anio_mes": "2022-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "13/04/2021",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 309,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "DURANGO",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "10/17/2022",
   "mes_fecha": 10,
   "dia_fecha": 17,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-10-17",
   "anio_mes": "2022-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "14/09/2022",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 362,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "ROMITA",
   "fecha_texto": "5/23/2022",
   "mes_fecha": 5,
   "dia_fecha": 23,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-05-23",
   "anio_mes": "2022-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 5,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 457,
   "edad": "46",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "ROMITA",
   "fecha_texto": "6/29/2022",
   "mes_fecha": 6,
   "dia_fecha": 29,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-06-29",
   "anio_mes": "2022-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 619,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN GABRIEL",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOTLAN EL GRANDE",
   "fecha_texto": "9/7/2022",
   "mes_fecha": 9,
   "dia_fecha": 7,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-09-07",
   "anio_mes": "2022-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "SD",
   "fecha_ultima_dosis": "SD",
   "tipo_vacuna": "SD",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 620,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN GABRIEL",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOTLAN EL GRANDE",
   "fecha_texto": "9/7/2022",
   "mes_fecha": 9,
   "dia_fecha": 7,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-09-07",
   "anio_mes": "2022-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "SD",
   "fecha_ultima_dosis": "SD",
   "tipo_vacuna": "SD",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 621,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN GABRIEL",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOTLAN EL GRANDE",
   "fecha_texto": "9/8/2022",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-09-08",
   "anio_mes": "2022-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "SD",
   "fecha_ultima_dosis": "SD",
   "tipo_vacuna": "SD",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 622,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN GABRIEL",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOTLAN EL GRANDE",
   "fecha_texto": "9/19/2022",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-09-19",
   "anio_mes": "2022-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "SD",
   "fecha_ultima_dosis": "SD",
   "tipo_vacuna": "SD",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 627,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN GABRIEL",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOTLAN EL GRANDE",
   "fecha_texto": "9/7/2022",
   "mes_fecha": 9,
   "dia_fecha": 7,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-09-07",
   "anio_mes": "2022-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "SD",
   "fecha_ultima_dosis": "SD",
   "tipo_vacuna": "SD",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 655,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN GABRIEL",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "8/4/2022",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-08-04",
   "anio_mes": "2022-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "SD",
   "fecha_ultima_dosis": "SD",
   "tipo_vacuna": "SD",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 668,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TOLUCA",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TOLUCA",
   "fecha_texto": "1/3/2023",
   "mes_fecha": 1,
   "dia_fecha": 3,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-01-03",
   "anio_mes": "2023-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "07/11/2022",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 669,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TOLUCA",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TOLUCA",
   "fecha_texto": "12/30/2022",
   "mes_fecha": 12,
   "dia_fecha": 30,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-12-30",
   "anio_mes": "2022-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 671,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "XONACATLAN",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TOLUCA",
   "fecha_texto": "12/9/2022",
   "mes_fecha": 12,
   "dia_fecha": 9,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-12-09",
   "anio_mes": "2022-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 689,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "TEOTIHUACAN",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "PACHUCA",
   "fecha_texto": "12/27/2022",
   "mes_fecha": 12,
   "dia_fecha": 27,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-12-27",
   "anio_mes": "2022-12",
   "institucion_notificacion": 6,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "12/5/2022",
   "tipo_vacuna": "4",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 700,
   "edad": "63",
   "grupo_edad": "60 - 64",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NEZAHUALCOYOTL",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "NEZAHUALCOYOTL",
   "fecha_texto": "9/5/2022",
   "mes_fecha": 9,
   "dia_fecha": 5,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-09-05",
   "anio_mes": "2022-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 711,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TENANGO DEL VALLE",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "METEPEC",
   "fecha_texto": "11/1/2022",
   "mes_fecha": 11,
   "dia_fecha": 1,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-11-01",
   "anio_mes": "2022-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 716,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "YURECUARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "LA PIEDAD",
   "fecha_texto": "9/22/2022",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-09-22",
   "anio_mes": "2022-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 775,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEPIC",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "10/15/2022",
   "mes_fecha": 10,
   "dia_fecha": 15,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-10-15",
   "anio_mes": "2022-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/11/2022",
   "tipo_vacuna": "4 (hexavalente)",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 777,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEPIC",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "11/14/2022",
   "mes_fecha": 11,
   "dia_fecha": 14,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-11-14",
   "anio_mes": "2022-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 1101,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "CENTRO",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CENTRO",
   "fecha_texto": "10/28/2022",
   "mes_fecha": 10,
   "dia_fecha": 28,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-10-28",
   "anio_mes": "2022-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "10/28/2022",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 1103,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "CENTRO",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CENTRO",
   "fecha_texto": "6/20/2022",
   "mes_fecha": 6,
   "dia_fecha": 20,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-06-20",
   "anio_mes": "2022-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 1113,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "11/25/2022",
   "mes_fecha": 11,
   "dia_fecha": 25,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-11-25",
   "anio_mes": "2022-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/6/2022",
   "tipo_vacuna": "3",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 1118,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "11/22/2022",
   "mes_fecha": 11,
   "dia_fecha": 22,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-11-22",
   "anio_mes": "2022-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 1119,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "MATAMOROS",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "MATAMOROS",
   "fecha_texto": "6/23/2022",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-06-23",
   "anio_mes": "2022-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "10/02/2022",
   "tipo_vacuna": "4",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 1121,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "RÍO BRAVO",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "12/26/2022",
   "mes_fecha": 12,
   "dia_fecha": 26,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-12-26",
   "anio_mes": "2022-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 1166,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "AKIL",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "10/30/2022",
   "mes_fecha": 10,
   "dia_fecha": 30,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-10-30",
   "anio_mes": "2022-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 1185,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "11/7/2022",
   "mes_fecha": 11,
   "dia_fecha": 7,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-11-07",
   "anio_mes": "2022-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2022,
   "fila_archivo": 1192,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "ENRIQUE ESTRADA",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "1/11/2022",
   "mes_fecha": 1,
   "dia_fecha": 11,
   "anio_fecha": 2022,
   "fecha_notificacion": "2022-01-11",
   "anio_mes": "2022-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1,
   "edad": "33",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "ASIENTOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "RINCON DE ROMOS",
   "fecha_texto": "10/4/2023",
   "mes_fecha": 10,
   "dia_fecha": 4,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-04",
   "anio_mes": "2023-10",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 2,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "11/13/2023",
   "mes_fecha": 11,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-13",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "9",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 3,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "ASIENTOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "PABELLON DE ARTEAGA",
   "fecha_texto": "8/18/2023",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-18",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 6,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "12/10/2023",
   "mes_fecha": 12,
   "dia_fecha": 10,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-10",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1/22/2023",
   "tipo_vacuna": "4",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 7,
   "edad": "67",
   "grupo_edad": "65 - 69",
   "demografia_edad": "MAYOR",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "11/21/2023",
   "mes_fecha": 11,
   "dia_fecha": 21,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-21",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "9",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 11,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "12/1/2023",
   "mes_fecha": 12,
   "dia_fecha": 1,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-01",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "08/11/2021",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 18,
   "edad": "19",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "12/8/2023",
   "mes_fecha": 12,
   "dia_fecha": 8,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-08",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 19,
   "edad": "7",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "12/8/2023",
   "mes_fecha": 12,
   "dia_fecha": 8,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-08",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 23,
   "edad": "8",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "SAN FCO DE LOS ROMO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "11/13/2023",
   "mes_fecha": 11,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-13",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "1/8/1900",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 30,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "8/11/2023",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-11",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 46,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "TIJUANA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "9/14/2023",
   "mes_fecha": 9,
   "dia_fecha": 14,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-14",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 47,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "9/14/2023",
   "mes_fecha": 9,
   "dia_fecha": 14,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-14",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/31/2023",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 48,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "SAN QUINTIN",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "11/5/2023",
   "mes_fecha": 11,
   "dia_fecha": 5,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-05",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 59,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "7/18/2023",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-18",
   "anio_mes": "2023-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 63,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "12/22/2023",
   "mes_fecha": 12,
   "dia_fecha": 22,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-22",
   "anio_mes": "2023-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 65,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "12/3/2023",
   "mes_fecha": 12,
   "dia_fecha": 3,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-03",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "9/19/2022",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 71,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "TIJUANA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "5/30/2023",
   "mes_fecha": 5,
   "dia_fecha": 30,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-05-30",
   "anio_mes": "2023-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 79,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "TIJUANA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "2/14/2023",
   "mes_fecha": 2,
   "dia_fecha": 14,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-02-14",
   "anio_mes": "2023-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 93,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "11/6/2023",
   "mes_fecha": 11,
   "dia_fecha": 6,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-06",
   "anio_mes": "2023-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 95,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "MEXICALI",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "11/29/2023",
   "mes_fecha": 11,
   "dia_fecha": 29,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-29",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "11/21/2023",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 98,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "12/28/2023",
   "mes_fecha": 12,
   "dia_fecha": 28,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-28",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 121,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "12/13/2023",
   "mes_fecha": 12,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-13",
   "anio_mes": "2023-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/7/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 142,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHAMULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "10/13/2023",
   "mes_fecha": 10,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-13",
   "anio_mes": "2023-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 147,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SAN CRISTOBAL DE LAS CASAS",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "9/9/2023",
   "mes_fecha": 9,
   "dia_fecha": 9,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-09",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 149,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "ZINACANTAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "6/19/2023",
   "mes_fecha": 6,
   "dia_fecha": 19,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-19",
   "anio_mes": "2023-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 150,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OCOZOCOAUTLA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "12/7/2023",
   "mes_fecha": 12,
   "dia_fecha": 7,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-07",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 152,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OCOZOCOAUTLA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "OCOZOCOAUTLA DE ESPINOSA",
   "fecha_texto": "7/1/2023",
   "mes_fecha": 7,
   "dia_fecha": 1,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-01",
   "anio_mes": "2023-07",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 153,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VILLAFLORES",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "9/11/2023",
   "mes_fecha": 9,
   "dia_fecha": 11,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-11",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 155,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "PALENQUE",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "PALENQUE",
   "fecha_texto": "10/5/2023",
   "mes_fecha": 10,
   "dia_fecha": 5,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-05",
   "anio_mes": "2023-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 156,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VILLACORZO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "CHIAPAS",
   "fecha_texto": "9/22/2023",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-22",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 159,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/19/2023",
   "mes_fecha": 2,
   "dia_fecha": 19,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-02-19",
   "anio_mes": "2023-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 161,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "COMITAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "COMITAN",
   "fecha_texto": "12/7/2023",
   "mes_fecha": 12,
   "dia_fecha": 7,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-07",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 162,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OCOSINGO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "11/22/2023",
   "mes_fecha": 11,
   "dia_fecha": 22,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-22",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 163,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TENEJAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "3/19/2023",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-03-19",
   "anio_mes": "2023-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 165,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SAN CRISTOBAL DE LAS CASAS",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "1/25/2023",
   "mes_fecha": 1,
   "dia_fecha": 25,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-01-25",
   "anio_mes": "2023-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 168,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SAN CRISTOBAL DE LAS CASAS",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "4/3/2023",
   "mes_fecha": 4,
   "dia_fecha": 3,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-04-03",
   "anio_mes": "2023-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 169,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHAMULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "4/19/2023",
   "mes_fecha": 4,
   "dia_fecha": 19,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-04-19",
   "anio_mes": "2023-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 181,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VENUSTIANO CARRANZA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "10/13/2023",
   "mes_fecha": 10,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-13",
   "anio_mes": "2023-10",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 182,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "11/20/2023",
   "mes_fecha": 11,
   "dia_fecha": 20,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-20",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 185,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SAN CRISTOBAL DE LAS CASAS",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "2/20/2023",
   "mes_fecha": 2,
   "dia_fecha": 20,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-02-20",
   "anio_mes": "2023-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 186,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SIMOJOVEL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "1/31/2023",
   "mes_fecha": 1,
   "dia_fecha": 31,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-01-31",
   "anio_mes": "2023-01",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 189,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "JIQUIPILAS",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "4/24/2023",
   "mes_fecha": 4,
   "dia_fecha": 24,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-04-24",
   "anio_mes": "2023-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 190,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHAMULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "5/5/2023",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-05-05",
   "anio_mes": "2023-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/28/2023",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 191,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHIAPA DE CORZO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "5/18/2023",
   "mes_fecha": 5,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-05-18",
   "anio_mes": "2023-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 205,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "LAS MARGARITAS",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "COMITAN",
   "fecha_texto": "2/10/2023",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-02-10",
   "anio_mes": "2023-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 207,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VILLAFLORES",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "VILLAFLORES",
   "fecha_texto": "2/28/2023",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-02-28",
   "anio_mes": "2023-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 208,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHAMULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "3/15/2023",
   "mes_fecha": 3,
   "dia_fecha": 15,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-03-15",
   "anio_mes": "2023-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 210,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CINTALAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "11/9/2023",
   "mes_fecha": 11,
   "dia_fecha": 9,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-09",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 211,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VILLAFLORES",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "VILLAFLORES",
   "fecha_texto": "1/18/2023",
   "mes_fecha": 1,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-01-18",
   "anio_mes": "2023-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 212,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "BOCHIL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "1/30/2023",
   "mes_fecha": 1,
   "dia_fecha": 30,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-01-30",
   "anio_mes": "2023-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 214,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OCOSINGO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "OCOSINGO",
   "fecha_texto": "5/9/2023",
   "mes_fecha": 5,
   "dia_fecha": 9,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-05-09",
   "anio_mes": "2023-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 215,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SIMOJOVEL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "5/25/2023",
   "mes_fecha": 5,
   "dia_fecha": 25,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-05-25",
   "anio_mes": "2023-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 216,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "COMITAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "COMITAN",
   "fecha_texto": "7/17/2023",
   "mes_fecha": 7,
   "dia_fecha": 17,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-17",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 219,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "ZINACANTAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "10/9/2023",
   "mes_fecha": 10,
   "dia_fecha": 9,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-09",
   "anio_mes": "2023-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 220,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "BENEMERITO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "PALENQUE",
   "fecha_texto": "10/31/2023",
   "mes_fecha": 10,
   "dia_fecha": 31,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-31",
   "anio_mes": "2023-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 222,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "JITOTOL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "11/17/2023",
   "mes_fecha": 11,
   "dia_fecha": 17,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-17",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 224,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "PUEBLO NUEVO SOLISTAHUACAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "BOCHIL",
   "fecha_texto": "3/1/2024",
   "mes_fecha": 3,
   "dia_fecha": 1,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-01",
   "anio_mes": "2024-03",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 232,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "5/25/2023",
   "mes_fecha": 5,
   "dia_fecha": 25,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-05-25",
   "anio_mes": "2023-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 234,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SAN CRISTOBAL DE LAS CASAS",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "7/4/2023",
   "mes_fecha": 7,
   "dia_fecha": 4,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-04",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 237,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "MITONTIC",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "4/10/2023",
   "mes_fecha": 4,
   "dia_fecha": 10,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-04-10",
   "anio_mes": "2023-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 240,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VENUSTIANO CARRANZA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "COMITAN",
   "fecha_texto": "7/26/2023",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-26",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 242,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VILLAFLORES",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "VILLAFLORES",
   "fecha_texto": "3/21/2023",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-03-21",
   "anio_mes": "2023-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 245,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VILLAFLORES",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "10/29/2023",
   "mes_fecha": 10,
   "dia_fecha": 29,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-29",
   "anio_mes": "2023-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 250,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OCOZOCOAUTLA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/17/2023",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-02-17",
   "anio_mes": "2023-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 251,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHAMULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "4/14/2023",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-04-14",
   "anio_mes": "2023-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 253,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SIMOJOVEL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "4/30/2023",
   "mes_fecha": 4,
   "dia_fecha": 30,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-04-30",
   "anio_mes": "2023-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 258,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TOTOLAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "12/14/2023",
   "mes_fecha": 12,
   "dia_fecha": 14,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-14",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 259,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TOTOLAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "12/11/2023",
   "mes_fecha": 12,
   "dia_fecha": 11,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-11",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 260,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TOTOLAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "12/28/2023",
   "mes_fecha": 12,
   "dia_fecha": 28,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-28",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 261,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHAMULA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "2/9/2023",
   "mes_fecha": 2,
   "dia_fecha": 9,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-02-09",
   "anio_mes": "2023-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 262,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHENALHO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "7/22/2023",
   "mes_fecha": 7,
   "dia_fecha": 22,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-22",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 267,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "LAS ROSAS",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "8/8/2023",
   "mes_fecha": 8,
   "dia_fecha": 8,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-08",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 268,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "LAS ROSAS",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "8/8/2023",
   "mes_fecha": 8,
   "dia_fecha": 8,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-08",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 271,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OXCHUC",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "6/27/2023",
   "mes_fecha": 6,
   "dia_fecha": 27,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-27",
   "anio_mes": "2023-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 273,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHENALHO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "1/13/2023",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-01-13",
   "anio_mes": "2023-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 275,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TOTOLAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "1/7/2024",
   "mes_fecha": 1,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-07",
   "anio_mes": "2024-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 276,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "9/22/2023",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-22",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "11/18/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 280,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "5/20/2023",
   "mes_fecha": 5,
   "dia_fecha": 20,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-05-20",
   "anio_mes": "2023-05",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 281,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "DELICIAS",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "DELICIAS",
   "fecha_texto": "5/30/2023",
   "mes_fecha": 5,
   "dia_fecha": 30,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-05-30",
   "anio_mes": "2023-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 286,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GUERRERO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "3/24/2023",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-03-24",
   "anio_mes": "2023-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 292,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JIMENEZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JIMENEZ",
   "fecha_texto": "8/15/2023",
   "mes_fecha": 8,
   "dia_fecha": 15,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-15",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "5/25/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 293,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "OJINAGA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "OJINAGA",
   "fecha_texto": "11/27/2023",
   "mes_fecha": 11,
   "dia_fecha": 27,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-27",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 297,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "DELICIAS",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "DELICIAS",
   "fecha_texto": "7/31/2023",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-31",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 299,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "OJINAGA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "OJINAGA",
   "fecha_texto": "11/17/2023",
   "mes_fecha": 11,
   "dia_fecha": 17,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-17",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 300,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "OJINAGA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "OJINAGA",
   "fecha_texto": "11/17/2023",
   "mes_fecha": 11,
   "dia_fecha": 17,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-17",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 302,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "BUENAVENTURA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "NCG",
   "fecha_texto": "4/18/2023",
   "mes_fecha": 4,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-04-18",
   "anio_mes": "2023-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 307,
   "edad": "11",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "7/11/2023",
   "mes_fecha": 7,
   "dia_fecha": 11,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-11",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 308,
   "edad": "9",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "7/11/2023",
   "mes_fecha": 7,
   "dia_fecha": 11,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-11",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 309,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "7/11/2023",
   "mes_fecha": 7,
   "dia_fecha": 11,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-11",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 314,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "11/14/2023",
   "mes_fecha": 11,
   "dia_fecha": 14,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-14",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "3/24/2017",
   "tipo_vacuna": "1",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 315,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "BUENAVENTURA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "NCG",
   "fecha_texto": "7/28/2023",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-28",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 316,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "4/24/2023",
   "mes_fecha": 4,
   "dia_fecha": 24,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-04-24",
   "anio_mes": "2023-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 317,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "RIVA PALACIO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "11/3/2023",
   "mes_fecha": 11,
   "dia_fecha": 3,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-03",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 319,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "BUENAVENTURA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "BUENAVENTURA",
   "fecha_texto": "8/7/2023",
   "mes_fecha": 8,
   "dia_fecha": 7,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-07",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 331,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "DELICIAS",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "DELICIAS",
   "fecha_texto": "8/10/2023",
   "mes_fecha": 8,
   "dia_fecha": 10,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-10",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/7/2023",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 332,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "DELICIAS",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "DELICIAS",
   "fecha_texto": "8/18/2023",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-18",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "8/7/2023",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 333,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "12/5/2023",
   "mes_fecha": 12,
   "dia_fecha": 5,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-05",
   "anio_mes": "2023-12",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 336,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "OJINAGA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "11/9/2023",
   "mes_fecha": 11,
   "dia_fecha": 9,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-09",
   "anio_mes": "2023-11",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 337,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "6/23/2023",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-23",
   "anio_mes": "2023-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/30/2023",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 339,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "DELICIAS",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "DELICIAS",
   "fecha_texto": "7/5/2023",
   "mes_fecha": 7,
   "dia_fecha": 5,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-05",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 340,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "DELICIAS",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "DELICIAS",
   "fecha_texto": "7/5/2023",
   "mes_fecha": 7,
   "dia_fecha": 5,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-05",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 342,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "VILLA AHUMADA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/13/2023",
   "mes_fecha": 7,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-13",
   "anio_mes": "2023-07",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 343,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "VILLA AHUMADA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "7/18/2023",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-18",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 346,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "6/13/2023",
   "mes_fecha": 6,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-13",
   "anio_mes": "2023-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 347,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "6/13/2023",
   "mes_fecha": 6,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-13",
   "anio_mes": "2023-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 348,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "6/13/2023",
   "mes_fecha": 6,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-13",
   "anio_mes": "2023-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 349,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "6/18/2023",
   "mes_fecha": 6,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-18",
   "anio_mes": "2023-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 356,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "VILLA AHUMADA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/13/2023",
   "mes_fecha": 7,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-13",
   "anio_mes": "2023-07",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 357,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "BUENAVENTURA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "6/8/2023",
   "mes_fecha": 6,
   "dia_fecha": 8,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-08",
   "anio_mes": "2023-06",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 358,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "11/28/2023",
   "mes_fecha": 11,
   "dia_fecha": 28,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-28",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 367,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A. MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "10/25/2023",
   "mes_fecha": 10,
   "dia_fecha": 25,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-25",
   "anio_mes": "2023-10",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 375,
   "edad": "50",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "2/20/2023",
   "mes_fecha": 2,
   "dia_fecha": 20,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-02-20",
   "anio_mes": "2023-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 376,
   "edad": "48",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "2/15/2023",
   "mes_fecha": 2,
   "dia_fecha": 15,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-02-15",
   "anio_mes": "2023-02",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 391,
   "edad": "30",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "2/10/2023",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-02-10",
   "anio_mes": "2023-02",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 397,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "CUAJIMALPA DE MORELOS",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAJIMALPA",
   "fecha_texto": "9/28/2023",
   "mes_fecha": 9,
   "dia_fecha": 28,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-28",
   "anio_mes": "2023-09",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "00/00/0000",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 411,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MAGDALENA CONTRERAS",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "ALVARO OBREGON",
   "fecha_texto": "8/14/2023",
   "mes_fecha": 8,
   "dia_fecha": 14,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-14",
   "anio_mes": "2023-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "7/12/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 419,
   "edad": "46",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLALPAN",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "2/20/2023",
   "mes_fecha": 2,
   "dia_fecha": 20,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-02-20",
   "anio_mes": "2023-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 443,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "MEZQUITAL",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "7/11/2023",
   "mes_fecha": 7,
   "dia_fecha": 11,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-11",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 445,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "MEZQUITAL",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "8/10/2023",
   "mes_fecha": 8,
   "dia_fecha": 10,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-10",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 450,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "MEZQUITAL",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "8/12/2023",
   "mes_fecha": 8,
   "dia_fecha": 12,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-12",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 451,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "MEZQUITAL",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "8/12/2023",
   "mes_fecha": 8,
   "dia_fecha": 12,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-12",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 452,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "MEZUQUITAL",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "8/29/2023",
   "mes_fecha": 8,
   "dia_fecha": 29,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-29",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 454,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "MEZQUITAL",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "9/8/2023",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-08",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 582,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "ABASOLO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "IRAPUATO",
   "fecha_texto": "11/7/2023",
   "mes_fecha": 11,
   "dia_fecha": 7,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-07",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 618,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "DOLORES HIDALGO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "DOLORES HIDALGO",
   "fecha_texto": "9/26/2023",
   "mes_fecha": 9,
   "dia_fecha": 26,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-26",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 679,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "CELAYA",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "APASEO EL GRANDE",
   "fecha_texto": "11/13/2023",
   "mes_fecha": 11,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-13",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "10/22/2022",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 698,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUERRERO",
   "municipio_residencia": "ALCOZAUCA",
   "estado_notificacion": "GUERRERO",
   "municipio_notificacion": "ALCOZAUCA",
   "fecha_texto": "11/16/2023",
   "mes_fecha": 11,
   "dia_fecha": 16,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-16",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 729,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "3/15/2023",
   "mes_fecha": 3,
   "dia_fecha": 15,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-03-15",
   "anio_mes": "2023-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 755,
   "edad": "49",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "11/16/2023",
   "mes_fecha": 11,
   "dia_fecha": 16,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-16",
   "anio_mes": "2023-11",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 769,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ENCARNACIÓN DE DIAZ",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "11/20/2023",
   "mes_fecha": 11,
   "dia_fecha": 20,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-20",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 776,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "3/15/2023",
   "mes_fecha": 3,
   "dia_fecha": 15,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-03-15",
   "anio_mes": "2023-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/9/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 800,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TOLIMAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOTLAN EL GRANDE",
   "fecha_texto": "10/18/2023",
   "mes_fecha": 10,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-18",
   "anio_mes": "2023-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 829,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "OZUMBA",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "CHALCO",
   "fecha_texto": "10/13/2023",
   "mes_fecha": 10,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-13",
   "anio_mes": "2023-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 832,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "VALLE DE CHALCO SOLIDARIADA",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "CHALCO",
   "fecha_texto": "11/7/2023",
   "mes_fecha": 11,
   "dia_fecha": 7,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-07",
   "anio_mes": "2023-11",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 851,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "VALLE DE CHALCO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "CHALCO",
   "fecha_texto": "11/3/2023",
   "mes_fecha": 11,
   "dia_fecha": 3,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-03",
   "anio_mes": "2023-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 864,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "VALLE DE CHALCO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "CHALCO",
   "fecha_texto": "11/3/2023",
   "mes_fecha": 11,
   "dia_fecha": 3,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-03",
   "anio_mes": "2023-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 895,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "SALVADOR ESCALANTE",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "PATZCUARO",
   "fecha_texto": "10/25/2023",
   "mes_fecha": 10,
   "dia_fecha": 25,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-25",
   "anio_mes": "2023-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 898,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "YURECUARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "YURECUARO",
   "fecha_texto": "9/8/2023",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-08",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 899,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "YURECUARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "YURECUARO",
   "fecha_texto": "9/8/2023",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-08",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 911,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "SALVADOR ESCALANTE",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "PATZCUARO",
   "fecha_texto": "11/9/2023",
   "mes_fecha": 11,
   "dia_fecha": 9,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-09",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 921,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "GUERRERO",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "12/12/2023",
   "mes_fecha": 12,
   "dia_fecha": 12,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-12",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 926,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "HUIXILAC",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "12/8/2023",
   "mes_fecha": 12,
   "dia_fecha": 8,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-08",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 935,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "EL NAYAR",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "23/5/2023",
   "mes_fecha": 23,
   "dia_fecha": 5,
   "anio_fecha": 2023,
   "fecha_notificacion": "2024-11-05",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "6",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 937,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "HUAJICORI",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "3/20/2023",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-03-20",
   "anio_mes": "2023-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 939,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "COMPOSTELA",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "6/21/2023",
   "mes_fecha": 6,
   "dia_fecha": 21,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-21",
   "anio_mes": "2023-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 943,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "EL NAYAR",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "7/24/2023",
   "mes_fecha": 7,
   "dia_fecha": 24,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-24",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 948,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "DEL NAYAR",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "DEL NAYAR",
   "fecha_texto": "3/17/2023",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-03-17",
   "anio_mes": "2023-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 951,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "SAN BLAS",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "6/20/2023",
   "mes_fecha": 6,
   "dia_fecha": 20,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-20",
   "anio_mes": "2023-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 952,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "DEL NAYAR",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "DEL NAYAR",
   "fecha_texto": "8/7/2023",
   "mes_fecha": 8,
   "dia_fecha": 7,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-07",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 955,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEPIC",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "3/29/2023",
   "mes_fecha": 3,
   "dia_fecha": 29,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-03-29",
   "anio_mes": "2023-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "2/15/2023",
   "tipo_vacuna": "3 HEXAVALENTE",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 960,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "DEL NAYAR",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "DEL NAYAR",
   "fecha_texto": "11/9/2023",
   "mes_fecha": 11,
   "dia_fecha": 9,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-09",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "3/18/2023",
   "tipo_vacuna": "HEXAVALENTE",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 961,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEPIC",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "10/9/2023",
   "mes_fecha": 10,
   "dia_fecha": 9,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-09",
   "anio_mes": "2023-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "9/11/2023",
   "tipo_vacuna": "HEXAVALENTE",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 962,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "DEL NAYAR",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "DEL NAYAR",
   "fecha_texto": "10/31/2023",
   "mes_fecha": 10,
   "dia_fecha": 31,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-31",
   "anio_mes": "2023-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 965,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEPIC",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "10/9/2023",
   "mes_fecha": 10,
   "dia_fecha": 9,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-09",
   "anio_mes": "2023-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 967,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "BAHIA DE BANDERAS",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "BAHIA DE BANDERAS",
   "fecha_texto": "10/5/2023",
   "mes_fecha": 10,
   "dia_fecha": 5,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-05",
   "anio_mes": "2023-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "09/07/2023",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 968,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "DEL NAYAR",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "DEL NAYAR",
   "fecha_texto": "9/7/2023",
   "mes_fecha": 9,
   "dia_fecha": 7,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-07",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 969,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "MEZQUITAL",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "DEL NAYAR",
   "fecha_texto": "7/3/2023",
   "mes_fecha": 7,
   "dia_fecha": 3,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-03",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 971,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "DEL NAYAR",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "DEL NAYAR",
   "fecha_texto": "10/20/2023",
   "mes_fecha": 10,
   "dia_fecha": 20,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-20",
   "anio_mes": "2023-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1117,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "TULUM",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "SOLIDARIDAD",
   "fecha_texto": "11/7/2023",
   "mes_fecha": 11,
   "dia_fecha": 7,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-07",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1149,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SOLEDAD DE GRACIANO SANCHEZ",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "12/12/2023",
   "mes_fecha": 12,
   "dia_fecha": 12,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-12",
   "anio_mes": "2023-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "04/01/2023",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1158,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SANTA CATARINA",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "RIOVERDE",
   "fecha_texto": "6/14/2023",
   "mes_fecha": 6,
   "dia_fecha": 14,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-14",
   "anio_mes": "2023-06",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "04/05/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1241,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "ESCUINAPA",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "ESCUINAPA",
   "fecha_texto": "5/26/2023",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-05-26",
   "anio_mes": "2023-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1251,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "ETCHOJOA",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "1/8/2023",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-01-08",
   "anio_mes": "2023-01",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "12/22/2022",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1257,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "11/29/2023",
   "mes_fecha": 11,
   "dia_fecha": 29,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-29",
   "anio_mes": "2023-11",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1258,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "12/21/2023",
   "mes_fecha": 12,
   "dia_fecha": 21,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-21",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1277,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "12/13/2023",
   "mes_fecha": 12,
   "dia_fecha": 13,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-13",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 9,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1333,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "11/8/2023",
   "mes_fecha": 11,
   "dia_fecha": 8,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-11-08",
   "anio_mes": "2023-11",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "9/7/2023",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1335,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "1/3/2024",
   "mes_fecha": 1,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-03",
   "anio_mes": "2024-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1337,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "1/3/2024",
   "mes_fecha": 1,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-03",
   "anio_mes": "2024-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1375,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "UMAN",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "10/18/2023",
   "mes_fecha": 10,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-18",
   "anio_mes": "2023-10",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1376,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MOTUL",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "10/24/2023",
   "mes_fecha": 10,
   "dia_fecha": 24,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-24",
   "anio_mes": "2023-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1377,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "10/24/2023",
   "mes_fecha": 10,
   "dia_fecha": 24,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-10-24",
   "anio_mes": "2023-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/28/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1380,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "3/8/2023",
   "mes_fecha": 3,
   "dia_fecha": 8,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-03-08",
   "anio_mes": "2023-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1386,
   "edad": "24",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VALPARAISO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "VALPARAISO",
   "fecha_texto": "9/18/2023",
   "mes_fecha": 9,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-18",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1387,
   "edad": "24",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VALPARAISO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "VALPARAISO",
   "fecha_texto": "9/18/2023",
   "mes_fecha": 9,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-18",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1389,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "5/14/2023",
   "mes_fecha": 5,
   "dia_fecha": 14,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-05-14",
   "anio_mes": "2023-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1399,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VALPARAISO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "9/9/2023",
   "mes_fecha": 9,
   "dia_fecha": 9,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-09",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "9/29/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1401,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VILLA DE COS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "8/11/2023",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-11",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1404,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "6/22/2023",
   "mes_fecha": 6,
   "dia_fecha": 22,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-22",
   "anio_mes": "2023-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1405,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VILLA DE COS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "6/20/2023",
   "mes_fecha": 6,
   "dia_fecha": 20,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-20",
   "anio_mes": "2023-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1406,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "6/22/2023",
   "mes_fecha": 6,
   "dia_fecha": 22,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-06-22",
   "anio_mes": "2023-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1408,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "ZACATECAS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "7/23/2023",
   "mes_fecha": 7,
   "dia_fecha": 23,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-07-23",
   "anio_mes": "2023-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1409,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "2/18/2023",
   "mes_fecha": 2,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-02-18",
   "anio_mes": "2023-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/7/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1410,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "LORETO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "12/12/2023",
   "mes_fecha": 12,
   "dia_fecha": 12,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-12-12",
   "anio_mes": "2023-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1421,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "5/11/2023",
   "mes_fecha": 5,
   "dia_fecha": 11,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-05-11",
   "anio_mes": "2023-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1435,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VILLA DE COS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "8/16/2023",
   "mes_fecha": 8,
   "dia_fecha": 16,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-08-16",
   "anio_mes": "2023-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2023,
   "fila_archivo": 1440,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "CALERA",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "9/18/2023",
   "mes_fecha": 9,
   "dia_fecha": 18,
   "anio_fecha": 2023,
   "fecha_notificacion": "2023-09-18",
   "anio_mes": "2023-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 9,
   "ev_etiqueta": "OTRO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "10/4/2024",
   "mes_fecha": 10,
   "dia_fecha": 4,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-04",
   "anio_mes": "2024-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 2,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "11/5/2024",
   "mes_fecha": 11,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-05",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 4,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "10/24/2024",
   "mes_fecha": 10,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-24",
   "anio_mes": "2024-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 5,
   "edad": "53",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "10/30/2024",
   "mes_fecha": 10,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-30",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 7,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "11/8/2024",
   "mes_fecha": 11,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-08",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 8,
   "edad": "17",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "11/9/2024",
   "mes_fecha": 11,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-09",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 9,
   "edad": "35",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "11/13/2024",
   "mes_fecha": 11,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-13",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 10,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "EL LLANO",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "3/4/2024",
   "mes_fecha": 3,
   "dia_fecha": 4,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-04",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 11,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "10/21/2024",
   "mes_fecha": 10,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-21",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 12,
   "edad": "21",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "10/21/2024",
   "mes_fecha": 10,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-21",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 13,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "10/21/2024",
   "mes_fecha": 10,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-21",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 15,
   "edad": "7",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "7/29/2024",
   "mes_fecha": 7,
   "dia_fecha": 29,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-29",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 18,
   "edad": "8",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "4/22/2024",
   "mes_fecha": 4,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-22",
   "anio_mes": "2024-04",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1/26/2017",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 19,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "CALVILLO",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "CALVILLO",
   "fecha_texto": "6/24/2024",
   "mes_fecha": 6,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-24",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 20,
   "edad": "18",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "CALVILLO",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "CALVILLO",
   "fecha_texto": "6/25/2024",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-25",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 21,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "11/25/2024",
   "mes_fecha": 11,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-25",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 22,
   "edad": "42",
   "grupo_edad": "40 - 44",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "11/27/2024",
   "mes_fecha": 11,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-27",
   "anio_mes": "2024-11",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 24,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMO",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "RINCON DE ROMO",
   "fecha_texto": "12/17/2024",
   "mes_fecha": 12,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-17",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 25,
   "edad": "14",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMO",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "RINCON DE ROMO",
   "fecha_texto": "12/20/2024",
   "mes_fecha": 12,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-20",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 27,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "ASIENTOS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "12/18/2024",
   "mes_fecha": 12,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-18",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 29,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "10/17/2024",
   "mes_fecha": 10,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-17",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 30,
   "edad": "18",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "10/17/2024",
   "mes_fecha": 10,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-17",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 31,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "12/2/2024",
   "mes_fecha": 12,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-02",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 32,
   "edad": "40",
   "grupo_edad": "40 - 44",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "12/2/2024",
   "mes_fecha": 12,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-02",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 34,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "7/15/2024",
   "mes_fecha": 7,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-15",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 36,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "SAN FRANCISCO DE LOS ROMO",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "12/11/2024",
   "mes_fecha": 12,
   "dia_fecha": 11,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-11",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 37,
   "edad": "33",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "7/18/2024",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-18",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 38,
   "edad": "19",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "10/17/2024",
   "mes_fecha": 10,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-17",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 39,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "10/24/2024",
   "mes_fecha": 10,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-24",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 40,
   "edad": "30",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "10/24/2024",
   "mes_fecha": 10,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-24",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 43,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "12/5/2024",
   "mes_fecha": 12,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-05",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 44,
   "edad": "18",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "11/26/2024",
   "mes_fecha": 11,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-26",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 45,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "10/16/2024",
   "mes_fecha": 10,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-16",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 46,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGS",
   "estado_notificacion": "AGS",
   "municipio_notificacion": "AGS",
   "fecha_texto": "12/5/2024",
   "mes_fecha": 12,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-05",
   "anio_mes": "2024-12",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 47,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "5/16/2024",
   "mes_fecha": 5,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-16",
   "anio_mes": "2024-05",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 48,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "5/24/2024",
   "mes_fecha": 5,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-24",
   "anio_mes": "2024-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/26/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 51,
   "edad": "16",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "12/9/2024",
   "mes_fecha": 12,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-09",
   "anio_mes": "2024-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 52,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "8/21/2024",
   "mes_fecha": 8,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-21",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 55,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "10/31/2024",
   "mes_fecha": 10,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-31",
   "anio_mes": "2024-10",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 56,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "6/13/2024",
   "mes_fecha": 6,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-13",
   "anio_mes": "2024-06",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 57,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "7/31/2024",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-31",
   "anio_mes": "2024-07",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 58,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "5/22/2024",
   "mes_fecha": 5,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-22",
   "anio_mes": "2024-05",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "8/2/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 59,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "5/22/2024",
   "mes_fecha": 5,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-22",
   "anio_mes": "2024-05",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "8/2/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 61,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "9/30/2024",
   "mes_fecha": 9,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-30",
   "anio_mes": "2024-09",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 62,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "4/17/2024",
   "mes_fecha": 4,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-17",
   "anio_mes": "2024-04",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 64,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "11/21/2024",
   "mes_fecha": 11,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-21",
   "anio_mes": "2024-11",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "4/24/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 69,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "6/6/2024",
   "mes_fecha": 6,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-06",
   "anio_mes": "2024-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 70,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "9/26/2024",
   "mes_fecha": 9,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-26",
   "anio_mes": "2024-09",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 71,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "6/17/2024",
   "mes_fecha": 6,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-17",
   "anio_mes": "2024-06",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 74,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "12/30/2024",
   "mes_fecha": 12,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-30",
   "anio_mes": "2024-12",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 77,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "11/19/2024",
   "mes_fecha": 11,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-19",
   "anio_mes": "2024-11",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/4/2024",
   "tipo_vacuna": "4",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 79,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "8/7/2024",
   "mes_fecha": 8,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-07",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 80,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "SAN FELIPE",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "10/3/2024",
   "mes_fecha": 10,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-03",
   "anio_mes": "2024-10",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 84,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "7/25/2024",
   "mes_fecha": 7,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-25",
   "anio_mes": "2024-07",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "2/11/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 85,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "3/4/2024",
   "mes_fecha": 3,
   "dia_fecha": 4,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-04",
   "anio_mes": "2024-03",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 86,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "8/6/2024",
   "mes_fecha": 8,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-06",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 89,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "4/17/2024",
   "mes_fecha": 4,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-17",
   "anio_mes": "2024-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 91,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "5/7/2024",
   "mes_fecha": 5,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-07",
   "anio_mes": "2024-05",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 92,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "SAN QUINTIN",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "9/9/2024",
   "mes_fecha": 9,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-09",
   "anio_mes": "2024-09",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 93,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "8/5/2024",
   "mes_fecha": 8,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-05",
   "anio_mes": "2024-08",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 99,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "7/18/2024",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-18",
   "anio_mes": "2024-07",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 100,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "5/2/2024",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-02",
   "anio_mes": "2024-05",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 101,
   "edad": "17",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "5/31/2024",
   "mes_fecha": 5,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-31",
   "anio_mes": "2024-05",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/11/1905",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 102,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TECATE",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "5/30/2024",
   "mes_fecha": 5,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-30",
   "anio_mes": "2024-05",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 103,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "5/22/2024",
   "mes_fecha": 5,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-22",
   "anio_mes": "2024-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/26/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 106,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "11/27/2024",
   "mes_fecha": 11,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-27",
   "anio_mes": "2024-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 110,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "8/5/2024",
   "mes_fecha": 8,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-05",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "7/17/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 111,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "7/1/2024",
   "mes_fecha": 7,
   "dia_fecha": 1,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-01",
   "anio_mes": "2024-07",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 112,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "3/29/2024",
   "mes_fecha": 3,
   "dia_fecha": 29,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-29",
   "anio_mes": "2024-03",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 115,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "PLAYAS DE ROSARITO",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "PLAYAS DE ROSARITO",
   "fecha_texto": "5/22/2024",
   "mes_fecha": 5,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-22",
   "anio_mes": "2024-05",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 119,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "2/19/2024",
   "mes_fecha": 2,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-19",
   "anio_mes": "2024-02",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 120,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "7/23/2024",
   "mes_fecha": 7,
   "dia_fecha": 23,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-23",
   "anio_mes": "2024-07",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "6/24/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 122,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "5/28/2024",
   "mes_fecha": 5,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-28",
   "anio_mes": "2024-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 124,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "8/1/2024",
   "mes_fecha": 8,
   "dia_fecha": 1,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-01",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/21/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 125,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "8/6/2024",
   "mes_fecha": 8,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-06",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/4/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 129,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "8/2/2024",
   "mes_fecha": 8,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-02",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 130,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "3/28/2024",
   "mes_fecha": 3,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-28",
   "anio_mes": "2024-03",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 137,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "12/13/2024",
   "mes_fecha": 12,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-13",
   "anio_mes": "2024-12",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 142,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "7/2/2024",
   "mes_fecha": 7,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-02",
   "anio_mes": "2024-07",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 144,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "8/18/2024",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-18",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 150,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TECATE",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TECATE",
   "fecha_texto": "8/5/2024",
   "mes_fecha": 8,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-05",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 151,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "7/17/2024",
   "mes_fecha": 7,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-17",
   "anio_mes": "2024-07",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 153,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "7/26/2024",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-26",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 155,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "4/8/2024",
   "mes_fecha": 4,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-08",
   "anio_mes": "2024-04",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 160,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "PLAYAS DE ROSARITO",
   "fecha_texto": "9/18/2024",
   "mes_fecha": 9,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-18",
   "anio_mes": "2024-09",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/15/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 162,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "5/17/2024",
   "mes_fecha": 5,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-17",
   "anio_mes": "2024-05",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 163,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "8/22/2024",
   "mes_fecha": 8,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-22",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "6/22/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 166,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "7/15/2024",
   "mes_fecha": 7,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-15",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "9/17/2021",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 169,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "3/11/2024",
   "mes_fecha": 3,
   "dia_fecha": 11,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-11",
   "anio_mes": "2024-03",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/23/2024",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 171,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "6/11/2024",
   "mes_fecha": 6,
   "dia_fecha": 11,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-11",
   "anio_mes": "2024-06",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 172,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "8/17/2024",
   "mes_fecha": 8,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-17",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 176,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "3/22/2024",
   "mes_fecha": 3,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-22",
   "anio_mes": "2024-03",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/7/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 180,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "10/28/2024",
   "mes_fecha": 10,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-28",
   "anio_mes": "2024-10",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "9/25/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 182,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "8/28/2024",
   "mes_fecha": 8,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-28",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 183,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "9/18/2024",
   "mes_fecha": 9,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-18",
   "anio_mes": "2024-09",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 186,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "8/21/2024",
   "mes_fecha": 8,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-21",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 187,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "7/21/2024",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-21",
   "anio_mes": "2024-07",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 188,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "7/31/2024",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-31",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 190,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "10/6/2024",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-06",
   "anio_mes": "2024-10",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "11/16/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 191,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "4/2/2024",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-02",
   "anio_mes": "2024-04",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/1/2023",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 192,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "8/19/2024",
   "mes_fecha": 8,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-19",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/31/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 193,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "8/20/2024",
   "mes_fecha": 8,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-20",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/20/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 196,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "6/13/2024",
   "mes_fecha": 6,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-13",
   "anio_mes": "2024-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 204,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "12/8/2024",
   "mes_fecha": 12,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-08",
   "anio_mes": "2024-12",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 209,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "8/16/2024",
   "mes_fecha": 8,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-16",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 211,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "7/19/2024",
   "mes_fecha": 7,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-19",
   "anio_mes": "2024-07",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 212,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "6/7/2024",
   "mes_fecha": 6,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-07",
   "anio_mes": "2024-06",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 218,
   "edad": "11",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "2/2/2024",
   "mes_fecha": 2,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-02",
   "anio_mes": "2024-02",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 226,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LOS CABOS",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LOS CABOS",
   "fecha_texto": "9/10/2024",
   "mes_fecha": 9,
   "dia_fecha": 10,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-10",
   "anio_mes": "2024-09",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "2/2/2024",
   "tipo_vacuna": "4",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 229,
   "edad": "23",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "9/19/2024",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-19",
   "anio_mes": "2024-09",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 237,
   "edad": "17",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LOS CABOS",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LOS CABOS",
   "fecha_texto": "5/7/2024",
   "mes_fecha": 5,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-07",
   "anio_mes": "2024-05",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 239,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LOS CABOS",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LOS CABOS",
   "fecha_texto": "9/12/2024",
   "mes_fecha": 9,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-12",
   "anio_mes": "2024-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 240,
   "edad": "22",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LOS CABOS",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LOS CABOS",
   "fecha_texto": "8/1/2024",
   "mes_fecha": 8,
   "dia_fecha": 1,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-01",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "12/1/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 242,
   "edad": "9",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "4/2/2024",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-02",
   "anio_mes": "2024-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "3/25/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 246,
   "edad": "37",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "7/12/2024",
   "mes_fecha": 7,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-12",
   "anio_mes": "2024-07",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 249,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA SUR",
   "municipio_residencia": "LA PAZ",
   "estado_notificacion": "BAJA CALIFORNIA SUR",
   "municipio_notificacion": "LA PAZ",
   "fecha_texto": "3/21/2024",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-21",
   "anio_mes": "2024-03",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 255,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CAMPECHE",
   "municipio_residencia": "CARMEN",
   "estado_notificacion": "CAMPECHE",
   "municipio_notificacion": "CARMEN",
   "fecha_texto": "9/10/2024",
   "mes_fecha": 9,
   "dia_fecha": 10,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-10",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 256,
   "edad": "11",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CAMPECHE",
   "municipio_residencia": "CARMEN",
   "estado_notificacion": "CAMPECHE",
   "municipio_notificacion": "CARMEN",
   "fecha_texto": "9/10/2024",
   "mes_fecha": 9,
   "dia_fecha": 10,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-10",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "9/10/2020",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 264,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CAMPECHE",
   "municipio_residencia": "CAMPECHE",
   "estado_notificacion": "CAMPECHE",
   "municipio_notificacion": "CAMPECHE",
   "fecha_texto": "12/6/2024",
   "mes_fecha": 12,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-06",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 266,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CAMPECHE",
   "municipio_residencia": "HOPELCHEN",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "4/5/2024",
   "mes_fecha": 4,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-05",
   "anio_mes": "2024-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 269,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CAMPECHE",
   "municipio_residencia": "CAMPECHE",
   "estado_notificacion": "CAMPECHE",
   "municipio_notificacion": "CAMPECHE",
   "fecha_texto": "7/26/2024",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-26",
   "anio_mes": "2024-07",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 270,
   "edad": "47",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CAMPECHE",
   "municipio_residencia": "CAMPECHE",
   "estado_notificacion": "CAMPECHE",
   "municipio_notificacion": "CAMPECHE",
   "fecha_texto": "8/1/2024",
   "mes_fecha": 8,
   "dia_fecha": 1,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-01",
   "anio_mes": "2024-08",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 271,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CAMPECHE",
   "municipio_residencia": "ESCARCEGA",
   "estado_notificacion": "CAMPECHE",
   "municipio_notificacion": "CAMPECHE",
   "fecha_texto": "8/23/2024",
   "mes_fecha": 8,
   "dia_fecha": 23,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-23",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 273,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CAMPECHE",
   "municipio_residencia": "CARMEN",
   "estado_notificacion": "CAMPECHE",
   "municipio_notificacion": "CARMEN",
   "fecha_texto": "8/27/2024",
   "mes_fecha": 8,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-27",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 274,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CAMPECHE",
   "municipio_residencia": "ESCARCEGA",
   "estado_notificacion": "CAMPECHE",
   "municipio_notificacion": "CAMPECHE",
   "fecha_texto": "8/21/2024",
   "mes_fecha": 8,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-21",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 289,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VILLA CORZO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "VILLAFLORES",
   "fecha_texto": "7/3/2024",
   "mes_fecha": 7,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-03",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/22/2022",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 292,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OCOSINGO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "OCOSINGO",
   "fecha_texto": "7/10/2024",
   "mes_fecha": 7,
   "dia_fecha": 10,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-10",
   "anio_mes": "2024-07",
   "institucion_notificacion": 5,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 293,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "8/8/2024",
   "mes_fecha": 8,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-08",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "8/11/2023",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 295,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "3/8/2024",
   "mes_fecha": 3,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-08",
   "anio_mes": "2024-03",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 297,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "BOCHIL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "10/6/2024",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-06",
   "anio_mes": "2024-10",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 301,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "BERRIOZABAL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "BERRIOZABAL",
   "fecha_texto": "4/26/2024",
   "mes_fecha": 4,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-26",
   "anio_mes": "2024-04",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 302,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/21/2024",
   "mes_fecha": 2,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-21",
   "anio_mes": "2024-02",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 303,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VESNUSTIANO CARRANZA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "10/7/2024",
   "mes_fecha": 10,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-07",
   "anio_mes": "2024-10",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 305,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/28/2024",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-28",
   "anio_mes": "2024-02",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 309,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "6/6/2024",
   "mes_fecha": 6,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-06",
   "anio_mes": "2024-06",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 311,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "MEZCALAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "7/26/2024",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-26",
   "anio_mes": "2024-07",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 312,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SILTEPEC",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "MOTOZINTLA",
   "fecha_texto": "9/19/2024",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-19",
   "anio_mes": "2024-09",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 315,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CENTRO",
   "fecha_texto": "4/9/2024",
   "mes_fecha": 4,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-09",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "02/02/2024",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 316,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "5/9/2024",
   "mes_fecha": 5,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-09",
   "anio_mes": "2024-05",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 317,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VILLA CORZO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "VILLAFLORES",
   "fecha_texto": "8/27/2024",
   "mes_fecha": 8,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-27",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "7/11/2023",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 318,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OCOZOCOAUTLA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "CINTALAPA",
   "fecha_texto": "9/5/2024",
   "mes_fecha": 9,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-05",
   "anio_mes": "2024-09",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 319,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CINTALAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "CINTALAPA",
   "fecha_texto": "10/16/2024",
   "mes_fecha": 10,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-16",
   "anio_mes": "2024-10",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 320,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "8/14/2024",
   "mes_fecha": 8,
   "dia_fecha": 14,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-14",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 321,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "REFORMA",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CENTRO",
   "fecha_texto": "6/23/2024",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-23",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 322,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "11/12/2024",
   "mes_fecha": 11,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-12",
   "anio_mes": "2024-11",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 324,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "ANGEL ALBINO CORZO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "5/7/2024",
   "mes_fecha": 5,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-07",
   "anio_mes": "2024-05",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 325,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "4/9/2024",
   "mes_fecha": 4,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-09",
   "anio_mes": "2024-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 326,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "PUEBLO NUEVO SOLISTAHUACAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "BOCHIL",
   "fecha_texto": "1/3/2024",
   "mes_fecha": 1,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-03",
   "anio_mes": "2024-01",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 329,
   "edad": "31",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "HUITIUPAN",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "HUITIUPAN",
   "fecha_texto": "6/13/2024",
   "mes_fecha": 6,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-13",
   "anio_mes": "2024-06",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 330,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "MONTECRISTO DE GUERRERO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "VILLAFLORES",
   "fecha_texto": "7/9/2024",
   "mes_fecha": 7,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-09",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1/23/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 331,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "LA INDEPENDENCIA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "COMITAN DE DOMINGUEZ",
   "fecha_texto": "8/25/2024",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-25",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 332,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "LAS MARGARITAS",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "COMITAN DE DOMINGUEZ",
   "fecha_texto": "10/2/2024",
   "mes_fecha": 10,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-02",
   "anio_mes": "2024-10",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 334,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OXCHUC",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "11/15/2024",
   "mes_fecha": 11,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-15",
   "anio_mes": "2024-11",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 335,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "PALENQUE",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "11/26/2024",
   "mes_fecha": 11,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-26",
   "anio_mes": "2024-11",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 337,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "12/12/2024",
   "mes_fecha": 12,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-12",
   "anio_mes": "2024-12",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 339,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "4/30/2024",
   "mes_fecha": 4,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-30",
   "anio_mes": "2024-04",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 341,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TENEJAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "12/20/2024",
   "mes_fecha": 12,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-20",
   "anio_mes": "2024-12",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 342,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "LA TRINITARIA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "4/15/2024",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-15",
   "anio_mes": "2024-04",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "2/5/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 343,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "VILLA CORZO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "VILLAFLORES",
   "fecha_texto": "1/15/2024",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-15",
   "anio_mes": "2024-01",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 345,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "5/30/2024",
   "mes_fecha": 5,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-30",
   "anio_mes": "2024-05",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 346,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "LA TRINITARIA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "LA TRINITARIA",
   "fecha_texto": "11/8/2024",
   "mes_fecha": 11,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-08",
   "anio_mes": "2024-11",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 354,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "IXTAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "9/4/2024",
   "mes_fecha": 9,
   "dia_fecha": 4,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-04",
   "anio_mes": "2024-09",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 357,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OCOZOCOAUTLA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "OCOZOCOAUTLA",
   "fecha_texto": "12/3/2024",
   "mes_fecha": 12,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-03",
   "anio_mes": "2024-12",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 358,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "SUCHIAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "8/18/2024",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-18",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 359,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "BERRIOZABAL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "BERRIOZABAL",
   "fecha_texto": "3/15/2024",
   "mes_fecha": 3,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-15",
   "anio_mes": "2024-03",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 360,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TOTOLAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "2/2/2024",
   "mes_fecha": 2,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-02",
   "anio_mes": "2024-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/1/2024",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 364,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OCOZOCOAUTLA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "8/30/2024",
   "mes_fecha": 8,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-30",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 371,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "COMITAN DE DOMINGUEZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "COMITAN DE DOMINGUEZ",
   "fecha_texto": "12/18/2024",
   "mes_fecha": 12,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-18",
   "anio_mes": "2024-12",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 372,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "MOTOZINTLA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "MOTOZINTLA",
   "fecha_texto": "4/26/2024",
   "mes_fecha": 4,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-26",
   "anio_mes": "2024-04",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 374,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TILA",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CENTRO",
   "fecha_texto": "4/12/2024",
   "mes_fecha": 4,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-12",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 376,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TUXTLA GUTIERREZ",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "9/19/2024",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-19",
   "anio_mes": "2024-09",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "9/4/2024",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 377,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "CHENALHO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "SAN CRISTOBAL",
   "fecha_texto": "12/20/2024",
   "mes_fecha": 12,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-20",
   "anio_mes": "2024-12",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/10/2024",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 378,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TZIMOL",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "COMITAN DE DOMINGUEZ",
   "fecha_texto": "7/25/2024",
   "mes_fecha": 7,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-25",
   "anio_mes": "2024-07",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 379,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TOTOLAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "1/7/2024",
   "mes_fecha": 1,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-07",
   "anio_mes": "2024-01",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 380,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "TOTOLAPA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "1/18/2024",
   "mes_fecha": 1,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-18",
   "anio_mes": "2024-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 381,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "ANGEL ALBINO CORZO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TUXTLA GUTIERREZ",
   "fecha_texto": "12/10/2024",
   "mes_fecha": 12,
   "dia_fecha": 10,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-10",
   "anio_mes": "2024-12",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 383,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "OCOSINGO",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "OCOSINGO",
   "fecha_texto": "3/12/2024",
   "mes_fecha": 3,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-12",
   "anio_mes": "2024-03",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 385,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "MOTOZINTLA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "TAPACHULA",
   "fecha_texto": "2/13/2024",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-13",
   "anio_mes": "2024-02",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 388,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIAPAS",
   "municipio_residencia": "HUIXTLA",
   "estado_notificacion": "CHIAPAS",
   "municipio_notificacion": "HUIXTLA",
   "fecha_texto": "5/17/2024",
   "mes_fecha": 5,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-17",
   "anio_mes": "2024-05",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 392,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "DELICIAS",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "DELICIAS",
   "fecha_texto": "6/28/2024",
   "mes_fecha": 6,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-28",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 394,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "DELICIAS",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "DELICIAS",
   "fecha_texto": "5/20/2024",
   "mes_fecha": 5,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-20",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "5/13/2024",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 395,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "7/17/2024",
   "mes_fecha": 7,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-17",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "3/7/2024",
   "tipo_vacuna": "6",
   "complicaciones": 3,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 397,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "8/9/2024",
   "mes_fecha": 8,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-09",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "5/24/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 400,
   "edad": "7",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "11/6/2024",
   "mes_fecha": 11,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-06",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/5/2024",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 401,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "11/5/2024",
   "mes_fecha": 11,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-05",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/31/2023",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 402,
   "edad": "32",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "11/5/2024",
   "mes_fecha": 11,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-05",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 405,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/18/2024",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-18",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 406,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "3/5/2024",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-05",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 407,
   "edad": "52",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "BOCOYNA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "BOCOYNA",
   "fecha_texto": "11/19/2024",
   "mes_fecha": 11,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-19",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/4/2024",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 415,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/9/2024",
   "mes_fecha": 7,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-09",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 416,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "8/2/2024",
   "mes_fecha": 8,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-02",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 417,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GUACHOCHI",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "8/31/2024",
   "mes_fecha": 8,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-31",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 422,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "3/21/2024",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-21",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 423,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "12/29/2024",
   "mes_fecha": 12,
   "dia_fecha": 29,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-29",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 424,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "12/30/2024",
   "mes_fecha": 12,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-30",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 426,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GUADALUPE Y CALVO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "10/16/2024",
   "mes_fecha": 10,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-16",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 434,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/19/2024",
   "mes_fecha": 7,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-19",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 436,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GUADALUPE Y CALVO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "GUADALUPE Y CALVO",
   "fecha_texto": "10/15/2024",
   "mes_fecha": 10,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-15",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 437,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GUADALUPE Y CALVO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "GUADALUPE Y CALVO",
   "fecha_texto": "10/15/2024",
   "mes_fecha": 10,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-15",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 439,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "ROSALES",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "DELICIAS",
   "fecha_texto": "3/5/2024",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-05",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 440,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "3/19/2024",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-19",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 442,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "BACHINIVA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "6/20/2024",
   "mes_fecha": 6,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-20",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 443,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "BACHINIVA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/3/2024",
   "mes_fecha": 7,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-03",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 445,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "VILLA LOPEZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "11/24/2024",
   "mes_fecha": 11,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-24",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 446,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "6/17/2024",
   "mes_fecha": 6,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-17",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 447,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "NUEVO CASAS GRANDES",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "NUEVO CASAS GRANDES",
   "fecha_texto": "7/18/2024",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-18",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 448,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "8/9/2024",
   "mes_fecha": 8,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-09",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 449,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "BUENA AVENTURA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "NUEVO CASAS GRANDES",
   "fecha_texto": "7/8/2024",
   "mes_fecha": 7,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-08",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 454,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/31/2024",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-31",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 455,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "VILLA AHUMADA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "4/19/2024",
   "mes_fecha": 4,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-19",
   "anio_mes": "2024-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 462,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "1/4/2024",
   "mes_fecha": 1,
   "dia_fecha": 4,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-04",
   "anio_mes": "2024-01",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 463,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "1/19/2024",
   "mes_fecha": 1,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-19",
   "anio_mes": "2024-01",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 464,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "BOCOYNA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "BOCOYNA",
   "fecha_texto": "12/3/2024",
   "mes_fecha": 12,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-03",
   "anio_mes": "2024-12",
   "institucion_notificacion": 3,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 465,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "1/2/2025",
   "mes_fecha": 1,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-02",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 472,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "4/16/2024",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-16",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 474,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "6/25/2024",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-25",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 478,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "5/6/2024",
   "mes_fecha": 5,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-06",
   "anio_mes": "2024-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/16/2024",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 480,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "BUENA AVENTURA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "2/2/2024",
   "mes_fecha": 2,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-02",
   "anio_mes": "2024-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 487,
   "edad": "27",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "1/17/2025",
   "mes_fecha": 1,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-17",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/21/2024",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 488,
   "edad": "7",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "1/17/2025",
   "mes_fecha": 1,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-17",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 490,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/29/2024",
   "mes_fecha": 7,
   "dia_fecha": 29,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-29",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 491,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/29/2024",
   "mes_fecha": 7,
   "dia_fecha": 29,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-29",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 494,
   "edad": "11",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "URIQUE",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "GUAZAPARES",
   "fecha_texto": "2/19/2024",
   "mes_fecha": 2,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-19",
   "anio_mes": "2024-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/11/2017",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 495,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "9/3/2024",
   "mes_fecha": 9,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-03",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 499,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "3/21/2024",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-21",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 503,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "4/3/2024",
   "mes_fecha": 4,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-03",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 504,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "8/5/2024",
   "mes_fecha": 8,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-05",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 505,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "5/15/2024",
   "mes_fecha": 5,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-15",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 510,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "12/9/2024",
   "mes_fecha": 12,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-09",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 513,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "4/22/2024",
   "mes_fecha": 4,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-22",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 514,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GUADALUPE Y CALVO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "PARRAL",
   "fecha_texto": "8/6/2024",
   "mes_fecha": 8,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-06",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 516,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "NUEVO CASAS GRANDES",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "NUEVO CASAS GRANDES",
   "fecha_texto": "3/20/2024",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-20",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/26/2024",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 517,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "URIQUE",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "BOCOYNA",
   "fecha_texto": "2/8/2024",
   "mes_fecha": 2,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-08",
   "anio_mes": "2024-02",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1/29/2024",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 519,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "4/9/2024",
   "mes_fecha": 4,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-09",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 520,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "4/9/2024",
   "mes_fecha": 4,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-09",
   "anio_mes": "2024-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 521,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "ALDAMA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "4/8/2024",
   "mes_fecha": 4,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-08",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/20/2024",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 523,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "BOCOYNA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "5/2/2024",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-02",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 525,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "12/31/2024",
   "mes_fecha": 12,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-31",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 526,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "10/28/2024",
   "mes_fecha": 10,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-28",
   "anio_mes": "2024-10",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "9/10/2021",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 527,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "DELICIAS",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "9/30/2024",
   "mes_fecha": 9,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-30",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "8/5/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 529,
   "edad": "14",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GUACHOCHI",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "BOCOYNA",
   "fecha_texto": "12/13/2024",
   "mes_fecha": 12,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-13",
   "anio_mes": "2024-12",
   "institucion_notificacion": 5,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 532,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "4/22/2024",
   "mes_fecha": 4,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-22",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/15/2024",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 533,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "NAMIQUIPA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "5/27/2024",
   "mes_fecha": 5,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-27",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "4/15/2024",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 538,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "9/23/2024",
   "mes_fecha": 9,
   "dia_fecha": 23,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-23",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 540,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GUACHOCHI",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "6/3/2024",
   "mes_fecha": 6,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-03",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 542,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "3/6/2024",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-06",
   "anio_mes": "2024-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 544,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "1/22/2024",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-22",
   "anio_mes": "2024-01",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 545,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "3/11/2024",
   "mes_fecha": 3,
   "dia_fecha": 11,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-11",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 547,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "ROSALES",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "10/6/2024",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-06",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 548,
   "edad": "19",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "NUEVO CASAS GRANDES",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "NUEVO CASAS GRANDES",
   "fecha_texto": "3/20/2024",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-20",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 550,
   "edad": "35",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CAMARGO",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "11/5/2024",
   "mes_fecha": 11,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-05",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 553,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "12/31/2024",
   "mes_fecha": 12,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-31",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 558,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "GALEANA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "NUEVO CASAS GRANDES",
   "fecha_texto": "6/20/2024",
   "mes_fecha": 6,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-20",
   "anio_mes": "2024-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 561,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "5/9/2024",
   "mes_fecha": 5,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-09",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/6/2024",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 562,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/23/2024",
   "mes_fecha": 7,
   "dia_fecha": 23,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-23",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "3/19/2024",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 566,
   "edad": "39",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "11/27/2024",
   "mes_fecha": 11,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-27",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/12/2024",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 567,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CARICHI",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CUAUHTEMOC",
   "fecha_texto": "8/12/2024",
   "mes_fecha": 8,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-12",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 569,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "NUEVO CASAS GRANDES",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "NUEVO CASAS GRANDES",
   "fecha_texto": "4/30/2024",
   "mes_fecha": 4,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-30",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 570,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/10/2024",
   "mes_fecha": 7,
   "dia_fecha": 10,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-10",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/9/2024",
   "tipo_vacuna": "4",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 571,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "3/6/2024",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-06",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 572,
   "edad": "23",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/24/2024",
   "mes_fecha": 7,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-24",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 573,
   "edad": "32",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "8/6/2024",
   "mes_fecha": 8,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-06",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 575,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "5/24/2024",
   "mes_fecha": 5,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-24",
   "anio_mes": "2024-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 576,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/26/2024",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-26",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 578,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "DELICIAS",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/30/2024",
   "mes_fecha": 7,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-30",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 579,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "DELICIAS",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/30/2024",
   "mes_fecha": 7,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-30",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 581,
   "edad": "27",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "1/17/2025",
   "mes_fecha": 1,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-17",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 585,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "6/25/2024",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-25",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 586,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "6/28/2024",
   "mes_fecha": 6,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-28",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 587,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "URUACHI",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "10/9/2024",
   "mes_fecha": 10,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-09",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 588,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "9/13/2024",
   "mes_fecha": 9,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-13",
   "anio_mes": "2024-09",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 4,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 590,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/26/2024",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-26",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 591,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "CHIHUAHUA",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CHIHUAHUA",
   "fecha_texto": "7/31/2024",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-31",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 594,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "DELICIAS",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "DELICIAS",
   "fecha_texto": "5/16/2024",
   "mes_fecha": 5,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-16",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/10/2024",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 596,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "9/2/2024",
   "mes_fecha": 9,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-02",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 597,
   "edad": "31",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "9/2/2024",
   "mes_fecha": 9,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-02",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 601,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "SAN FRANCISCO DE CONCHOS",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "CAMARGO",
   "fecha_texto": "7/2/2024",
   "mes_fecha": 7,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-02",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 602,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CHIHUAHUA",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "CHIHUAHUA",
   "municipio_notificacion": "JUAREZ",
   "fecha_texto": "10/24/2024",
   "mes_fecha": 10,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-24",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 606,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MÉXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "1/7/2025",
   "mes_fecha": 1,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-07",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 614,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "XOCHIMILCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "11/29/2024",
   "mes_fecha": 11,
   "dia_fecha": 29,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-29",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 616,
   "edad": "35",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "CUAUHTEMOC",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTÉMOC",
   "fecha_texto": "9/6/2024",
   "mes_fecha": 9,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-06",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 619,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "VENUSTIANO CARRANZA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTACALCO",
   "fecha_texto": "2/23/2024",
   "mes_fecha": 2,
   "dia_fecha": 23,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-23",
   "anio_mes": "2024-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 621,
   "edad": "36",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "TLAHUAC",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLAHUAC",
   "fecha_texto": "12/18/2024",
   "mes_fecha": 12,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-18",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 623,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "AZCAPOTZALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "AZCAPOTZALCO",
   "fecha_texto": "7/26/2024",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-26",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/8/2024",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 636,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTACALCO",
   "fecha_texto": "12/10/2024",
   "mes_fecha": 12,
   "dia_fecha": 10,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-10",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 641,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "CUAJIMALPA",
   "estado_notificacion": "CIUDAD DE MÉXICO",
   "municipio_notificacion": "BENITO JUÁREZ",
   "fecha_texto": "1/8/2025",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-08",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "1/4/2025",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 648,
   "edad": "28",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "AZCAPOTZALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTÉMOC",
   "fecha_texto": "9/3/2024",
   "mes_fecha": 9,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-03",
   "anio_mes": "2024-09",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 649,
   "edad": "13",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTACALCO",
   "estado_notificacion": "CIUDAD DE MÉXICO",
   "municipio_notificacion": "VENUSTIANO CARRANZA",
   "fecha_texto": "1/20/2025",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "10/15/2012",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 654,
   "edad": "22",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALARO OBREGON",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTÉMOC",
   "fecha_texto": "10/28/2024",
   "mes_fecha": 10,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-28",
   "anio_mes": "2024-10",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 656,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "12/5/2024",
   "mes_fecha": 12,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-05",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 666,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTACALCO",
   "estado_notificacion": "CIUDAD DE MÉXICO",
   "municipio_notificacion": "IZTACALCO",
   "fecha_texto": "1/12/2025",
   "mes_fecha": 1,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-12",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 673,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "8/28/2024",
   "mes_fecha": 8,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-28",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 684,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "VENUSTIANO CARRANZA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTÉMOC",
   "fecha_texto": "9/14/2024",
   "mes_fecha": 9,
   "dia_fecha": 14,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-14",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "8/12/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 687,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "9/26/2024",
   "mes_fecha": 9,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-26",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 690,
   "edad": "31",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "VENUSTIANO CARRANZA",
   "fecha_texto": "11/20/2024",
   "mes_fecha": 11,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-20",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 692,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "12/16/2024",
   "mes_fecha": 12,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-16",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 693,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "9/12/0204",
   "mes_fecha": 9,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-12",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 697,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "9/12/2024",
   "mes_fecha": 9,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-12",
   "anio_mes": "2024-09",
   "institucion_notificacion": 3,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 702,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "ALVARO OBREGON",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "6/24/2024",
   "mes_fecha": 6,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-24",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 703,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MÉXICO",
   "municipio_notificacion": "COYOACAN",
   "fecha_texto": "12/30/2024",
   "mes_fecha": 12,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-30",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 705,
   "edad": "13",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "12/9/2024",
   "mes_fecha": 12,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-09",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "2/26/2016",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 707,
   "edad": "14",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "GUSTAVO A MADERO",
   "estado_notificacion": "CIUDAD DE MÉXICO",
   "municipio_notificacion": "GUSTAVO A MADERO",
   "fecha_texto": "2/11/2025",
   "mes_fecha": 2,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-11",
   "anio_mes": "2025-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 712,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MÉXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "1/13/2024",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-13",
   "anio_mes": "2024-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 715,
   "edad": "74",
   "grupo_edad": "70 - 74",
   "demografia_edad": "MAYOR",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "11/13/2024",
   "mes_fecha": 11,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-13",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 719,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "XOCHIMILCO",
   "estado_notificacion": "CIUDAD DE MÉXICO",
   "municipio_notificacion": "XOCHIMILCO",
   "fecha_texto": "1/9/2025",
   "mes_fecha": 1,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-09",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/15/2023",
   "tipo_vacuna": "4",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 725,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "IZTAPALAPA",
   "fecha_texto": "11/26/2024",
   "mes_fecha": 11,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-26",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/11/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 726,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTACALCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "12/17/2024",
   "mes_fecha": 12,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-17",
   "anio_mes": "2024-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 729,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "XOCHIMILCO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "XOCHIMILCO",
   "fecha_texto": "10/25/2024",
   "mes_fecha": 10,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-25",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/7/2024",
   "tipo_vacuna": "4",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 730,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "IZTAPALAPA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTÉMOC",
   "fecha_texto": "10/27/2024",
   "mes_fecha": 10,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-27",
   "anio_mes": "2024-10",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 736,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "CIUDAD DE MEXICO",
   "municipio_residencia": "MIGUEL HIDALGO",
   "estado_notificacion": "CIUDAD DE MÉXICO",
   "municipio_notificacion": "AZCAPOTZALCO",
   "fecha_texto": "1/7/2025",
   "mes_fecha": 1,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-07",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "28/10/2024",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 740,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "8/14/2024",
   "mes_fecha": 8,
   "dia_fecha": 14,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-14",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 744,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "GALEANA",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "1/21/2024",
   "mes_fecha": 1,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-21",
   "anio_mes": "2024-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 747,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "ACUÑA",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "ACUÑA",
   "fecha_texto": "10/7/2024",
   "mes_fecha": 10,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-07",
   "anio_mes": "2024-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 751,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "1/23/2024",
   "mes_fecha": 1,
   "dia_fecha": 23,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-23",
   "anio_mes": "2024-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 754,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "ACUÑA",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "ACUÑA",
   "fecha_texto": "8/12/2024",
   "mes_fecha": 8,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-12",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "8/5/2024",
   "tipo_vacuna": "1",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 762,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "9/2/2024",
   "mes_fecha": 9,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-02",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 764,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "10/8/2024",
   "mes_fecha": 10,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-08",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 767,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "ACUÑA",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "ACUÑA",
   "fecha_texto": "10/25/2024",
   "mes_fecha": 10,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-25",
   "anio_mes": "2024-10",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 772,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "SALTILLO",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "SALTILLO",
   "fecha_texto": "7/29/2024",
   "mes_fecha": 7,
   "dia_fecha": 29,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-29",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/3/2024",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 778,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "PIEDRAS NEGRAS",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "PIEDRAS NEGRAS",
   "fecha_texto": "8/9/2024",
   "mes_fecha": 8,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-09",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 779,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "COAHUILA",
   "municipio_residencia": "PIEDRAS NEGRAS",
   "estado_notificacion": "COAHUILA",
   "municipio_notificacion": "PIEDRAS NEGRAS",
   "fecha_texto": "8/9/2024",
   "mes_fecha": 8,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-09",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 794,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "DURANGO",
   "municipio_residencia": "MEZQUITAL",
   "estado_notificacion": "DURANGO",
   "municipio_notificacion": "DURANGO",
   "fecha_texto": "4/27/2024",
   "mes_fecha": 4,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-27",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 816,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "SAN LUIS DE LA PAZ",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "SAN LUIS DE LA PAZ",
   "fecha_texto": "4/17/2024",
   "mes_fecha": 4,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-17",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 849,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "IRAPUATO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "IRAPUATO",
   "fecha_texto": "11/4/2024",
   "mes_fecha": 11,
   "dia_fecha": 4,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-04",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 864,
   "edad": "49",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "CELAYA",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "CELAYA",
   "fecha_texto": "11/4/2024",
   "mes_fecha": 11,
   "dia_fecha": 4,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-04",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 886,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "ACAMBARO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "ACAMBARO",
   "fecha_texto": "3/27/2024",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-27",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "1/1/2012",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 887,
   "edad": "77",
   "grupo_edad": "75 - 79",
   "demografia_edad": "MAYOR",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "ACAMBARO",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "ACAMBARO",
   "fecha_texto": "3/27/2024",
   "mes_fecha": 3,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-27",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 894,
   "edad": "17",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "LEON",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "6/28/2024",
   "mes_fecha": 6,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-28",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 912,
   "edad": "14",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUANAJUATO",
   "municipio_residencia": "ROMITA",
   "estado_notificacion": "GUANAJUATO",
   "municipio_notificacion": "LEON",
   "fecha_texto": "11/15/2024",
   "mes_fecha": 11,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-15",
   "anio_mes": "2024-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 978,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUERRERO",
   "municipio_residencia": "ACAPULCO DE JUAREZ",
   "estado_notificacion": "GUERRERO",
   "municipio_notificacion": "ACAPULCO DE JUAREZ",
   "fecha_texto": "9/23/2024",
   "mes_fecha": 9,
   "dia_fecha": 23,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-23",
   "anio_mes": "2024-09",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 981,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "GUERRERO",
   "municipio_residencia": "ACAPULCO DE JUAREZ",
   "estado_notificacion": "GUERRERO",
   "municipio_notificacion": "ACAPULCO DE JUAREZ",
   "fecha_texto": "7/3/2024",
   "mes_fecha": 7,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-03",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "11/16/2022",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 988,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUERRERO",
   "municipio_residencia": "AJUCHITLAN DEL PROGRESO",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "TLALPAN",
   "fecha_texto": "8/21/2024",
   "mes_fecha": 8,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-21",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 995,
   "edad": "30",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "GUERRERO",
   "municipio_residencia": "ACAPULCO DE JUAREZ",
   "estado_notificacion": "GUERRERO",
   "municipio_notificacion": "ACAPULCO DE JUAREZ",
   "fecha_texto": "12/6/2024",
   "mes_fecha": 12,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-06",
   "anio_mes": "2024-12",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 996,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "GUERRERO",
   "municipio_residencia": "ARCELIA",
   "estado_notificacion": "CIUDAD DE MEXICO",
   "municipio_notificacion": "CUAUHTÉMOC",
   "fecha_texto": "11/26/2024",
   "mes_fecha": 11,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-26",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 998,
   "edad": "69",
   "grupo_edad": "65 - 69",
   "demografia_edad": "MAYOR",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "MINERAL DE LA REFORMA",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "PACHUCA DE SOTO",
   "fecha_texto": "12/20/2024",
   "mes_fecha": 12,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-20",
   "anio_mes": "2024-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1000,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "ATITALAQUIA",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "PACHUCA DE SOTO",
   "fecha_texto": "1/6/2025",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "11/5/2024",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1013,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "FRANCISCO I MADERO",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "PACHUCA DE SOTO",
   "fecha_texto": "1/1/2025",
   "mes_fecha": 1,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-01",
   "anio_mes": "2025-01",
   "institucion_notificacion": 6,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "11/13/2024",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1015,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "HIDALGO",
   "municipio_residencia": "AGUA BLANCA DE ITURBIDE",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "PACHUCA DE SOTO",
   "fecha_texto": "11/4/2024",
   "mes_fecha": 11,
   "dia_fecha": 4,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-04",
   "anio_mes": "2024-11",
   "institucion_notificacion": 6,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1024,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TONALÁ",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "11/20/2024",
   "mes_fecha": 11,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-20",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1026,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "PUERTO VALLARTA",
   "fecha_texto": "12/2/2024",
   "mes_fecha": 12,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-02",
   "anio_mes": "2024-12",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "10/20/2024",
   "tipo_vacuna": "1",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1032,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "6/13/2024",
   "mes_fecha": 6,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-13",
   "anio_mes": "2024-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "6/11/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1033,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "6/13/2024",
   "mes_fecha": 6,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-13",
   "anio_mes": "2024-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "6/11/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1040,
   "edad": "49",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "9/6/2024",
   "mes_fecha": 9,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-06",
   "anio_mes": "2024-09",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "6/26/1979",
   "tipo_vacuna": "1",
   "complicaciones": 9,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1045,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TONALÁ",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "9/5/2024",
   "mes_fecha": 9,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-05",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1049,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "MEZQUITIC",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "2/5/2024",
   "mes_fecha": 2,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-05",
   "anio_mes": "2024-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1050,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "PUERTO VALLARTA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "PUERTO VALLARTA",
   "fecha_texto": "6/12/2024",
   "mes_fecha": 6,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-12",
   "anio_mes": "2024-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/23/2022",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1051,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "PUERTO VALLARTA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "PUERTO VALLARTA",
   "fecha_texto": "6/21/2024",
   "mes_fecha": 6,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-21",
   "anio_mes": "2024-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "7/27/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1054,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "5/31/2024",
   "mes_fecha": 5,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-31",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1061,
   "edad": "58",
   "grupo_edad": "55 - 59",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "6/25/2024",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-25",
   "anio_mes": "2024-06",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1065,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN PEDRO TLAQUEPAQUE",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "10/16/2024",
   "mes_fecha": 10,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-16",
   "anio_mes": "2024-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1069,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN PEDRO TLAQUEPAQUE",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "7/9/2024",
   "mes_fecha": 7,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-09",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1074,
   "edad": "48",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "PUERTO VALLARTA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "PUERTO VALLARTA",
   "fecha_texto": "6/20/2024",
   "mes_fecha": 6,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-20",
   "anio_mes": "2024-06",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1077,
   "edad": "59",
   "grupo_edad": "55 - 59",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "PUERTO VALLARTA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "PUERTO VALLARTA",
   "fecha_texto": "6/21/2024",
   "mes_fecha": 6,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-21",
   "anio_mes": "2024-06",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1078,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN PEDRO TLAQUEPAQUE",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "1/29/2025",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-29",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1081,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "1/21/2025",
   "mes_fecha": 1,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-21",
   "anio_mes": "2025-01",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "2/13/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1085,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN PEDRO TLAQUEPAQUE",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "12/20/2024",
   "mes_fecha": 12,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-20",
   "anio_mes": "2024-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1087,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "4/15/2024",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-15",
   "anio_mes": "2024-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1100,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "3/24/2024",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-24",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1101,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "1/27/2025",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/30/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1102,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "LAGOS DE MORENO",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "LAGOS DE MORENO",
   "fecha_texto": "11/21/2024",
   "mes_fecha": 11,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-21",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1106,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "12/26/2024",
   "mes_fecha": 12,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-26",
   "anio_mes": "2024-12",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "9/12/2024",
   "tipo_vacuna": "1",
   "complicaciones": 9,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1114,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "1/15/2025",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-15",
   "anio_mes": "2025-01",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "6/26/1970",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1116,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TOLIMAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOTLAN EL GRANDE",
   "fecha_texto": "5/21/2024",
   "mes_fecha": 5,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-21",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1133,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN PEDRO TLAQUEPAQUE",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "5/29/2024",
   "mes_fecha": 5,
   "dia_fecha": 29,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-29",
   "anio_mes": "2024-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1136,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TLAJOMULCO DE ZUÑIGA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "11/29/2024",
   "mes_fecha": 11,
   "dia_fecha": 29,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-29",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/30/2024",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1139,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "IXTLAHUACAN DE LOS MEMBRILLOS",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "6/9/2024",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-09",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1147,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "PUERTO VALLARTA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "PUERTO VALLARTA",
   "fecha_texto": "7/1/2024",
   "mes_fecha": 7,
   "dia_fecha": 1,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-01",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "2/22/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1154,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "12/30/2024",
   "mes_fecha": 12,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-30",
   "anio_mes": "2024-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1159,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "9/12/2024",
   "mes_fecha": 9,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-12",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1161,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "3/1/2024",
   "mes_fecha": 3,
   "dia_fecha": 1,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-01",
   "anio_mes": "2024-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1166,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "1/7/2025",
   "mes_fecha": 1,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-07",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "2/14/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1167,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "1/15/2025",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-15",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "2/14/2019",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1169,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "9/15/2024",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-15",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1177,
   "edad": "7",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "6/11/2024",
   "mes_fecha": 6,
   "dia_fecha": 11,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-11",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1178,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "10/16/2024",
   "mes_fecha": 10,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-16",
   "anio_mes": "2024-10",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1180,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "TALA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "AMECA",
   "fecha_texto": "10/9/2024",
   "mes_fecha": 10,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-09",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1181,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "ZAPOPAN",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "8/27/2024",
   "mes_fecha": 8,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-27",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1186,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "GUADALAJARA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "ZAPOPAN",
   "fecha_texto": "7/7/2024",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-07",
   "anio_mes": "2024-07",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1196,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "COLOTLAN",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "5/1/2024",
   "mes_fecha": 5,
   "dia_fecha": 1,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-01",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/5/2024",
   "tipo_vacuna": "3",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1200,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "JALISCO",
   "municipio_residencia": "SAN PEDRO TLAQUEPAQUE",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "12/12/2024",
   "mes_fecha": 12,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-12",
   "anio_mes": "2024-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1208,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CHALCO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "AMECAMECA",
   "fecha_texto": "11/15/2024",
   "mes_fecha": 11,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-15",
   "anio_mes": "2024-11",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1209,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "LOS REYES LA PAZ",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "IXTAPALUCA",
   "fecha_texto": "9/18/2024",
   "mes_fecha": 9,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-18",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/22/2024",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1223,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "SANTA MARIA RAYON",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "METEPEC",
   "fecha_texto": "12/11/2024",
   "mes_fecha": 12,
   "dia_fecha": 11,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-11",
   "anio_mes": "2024-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "28/11/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1226,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "TECAMAC",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TECAMAC",
   "fecha_texto": "12/9/2024",
   "mes_fecha": 12,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-09",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "31/10/2024",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1230,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "COACALCO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "COACALCO",
   "fecha_texto": "1/3/2025",
   "mes_fecha": 1,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-03",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1235,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "SANTA MARIA RAYON",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "METEPEC",
   "fecha_texto": "12/27/2024",
   "mes_fecha": 12,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-27",
   "anio_mes": "2024-12",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "05/10/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1239,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "NAUCALPAN",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "NAUCALPAN",
   "fecha_texto": "6/21/2024",
   "mes_fecha": 6,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-21",
   "anio_mes": "2024-06",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1240,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "GUSTAVO A. MADERO",
   "fecha_texto": "9/24/2024",
   "mes_fecha": 9,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-24",
   "anio_mes": "2024-09",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/22/2023",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1246,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ZUMPANGO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "ZUMPANGO",
   "fecha_texto": "6/10/2024",
   "mes_fecha": 6,
   "dia_fecha": 10,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-10",
   "anio_mes": "2024-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1249,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ZUMPANGO",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "TECAMAC",
   "fecha_texto": "11/21/2024",
   "mes_fecha": 11,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-21",
   "anio_mes": "2024-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1252,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "ECATEPEC",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "ECATEPEC",
   "fecha_texto": "11/6/2024",
   "mes_fecha": 11,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-06",
   "anio_mes": "2024-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1253,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "IXTAPALUCA",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "IXTAPALUCA",
   "fecha_texto": "11/26/2024",
   "mes_fecha": 11,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-26",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1255,
   "edad": "32",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "CUAUTITLAN",
   "estado_notificacion": "CDMX",
   "municipio_notificacion": "",
   "fecha_texto": "10/17/2024",
   "mes_fecha": 10,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-17",
   "anio_mes": "2024-10",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1256,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ESTADO DE MEXICO",
   "municipio_residencia": "IXTAPALUCA",
   "estado_notificacion": "MEXICO",
   "municipio_notificacion": "IXTAPALUCA",
   "fecha_texto": "11/6/2024",
   "mes_fecha": 11,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-06",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1257,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "NUEVO SAN JUAN PARANGARICUTIRO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "URUAPAN",
   "fecha_texto": "2/15/2024",
   "mes_fecha": 2,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-15",
   "anio_mes": "2024-02",
   "institucion_notificacion": 5,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "8/26/2024",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1258,
   "edad": "26",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "NUEVO SAN JUAN PARANGARICUTIRO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "URUAPAN",
   "fecha_texto": "2/15/2024",
   "mes_fecha": 2,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-15",
   "anio_mes": "2024-02",
   "institucion_notificacion": 5,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "1/16/2023",
   "tipo_vacuna": "3",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1265,
   "edad": "43",
   "grupo_edad": "40 - 44",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "TARIMBARO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "11/26/2024",
   "mes_fecha": 11,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-26",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1266,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "MORELIA",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "MORELIA",
   "fecha_texto": "11/8/2024",
   "mes_fecha": 11,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-08",
   "anio_mes": "2024-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1271,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "LA PIEDAD",
   "estado_notificacion": "MICHOACÁN",
   "municipio_notificacion": "LA PIEDAD",
   "fecha_texto": "12/13/2024",
   "mes_fecha": 12,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-13",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/31/2024",
   "tipo_vacuna": "6",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1277,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "SAHUAYO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "SAHUAYO",
   "fecha_texto": "11/15/2024",
   "mes_fecha": 11,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-15",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1280,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "ZAMORA",
   "estado_notificacion": "MICHOACÁN",
   "municipio_notificacion": "ZAMORA",
   "fecha_texto": "12/2/2024",
   "mes_fecha": 12,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-02",
   "anio_mes": "2024-12",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1283,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "NUEVO SAN JUAN PARANGARICUTIRO",
   "estado_notificacion": "MICHOACAN",
   "municipio_notificacion": "URUAPAN",
   "fecha_texto": "2/15/2024",
   "mes_fecha": 2,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-15",
   "anio_mes": "2024-02",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "1/8/1900",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1284,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "MICHOACAN",
   "municipio_residencia": "SAN JUAN TLALPUJAHUILLA",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "4/22/2024",
   "mes_fecha": 4,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-22",
   "anio_mes": "2024-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1300,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "TEPOZTLAN",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "9/17/2024",
   "mes_fecha": 9,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-17",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1301,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "TEPOZTLAN",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "10/2/2024",
   "mes_fecha": 10,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-02",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1308,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "TEMOAC",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "9/8/2024",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-08",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1309,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "MORELOS",
   "municipio_residencia": "TOTOLOAPAN",
   "estado_notificacion": "MORELOS",
   "municipio_notificacion": "EMILIANO ZAPATA",
   "fecha_texto": "9/9/2024",
   "mes_fecha": 9,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-09",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1315,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEPIC",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "5/28/2024",
   "mes_fecha": 5,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-28",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/24/2024",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1318,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "EL NAYAR",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "DEL NAYAR",
   "fecha_texto": "7/17/2024",
   "mes_fecha": 7,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-17",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1319,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "LA YESCA",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "1/15/2024",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-15",
   "anio_mes": "2024-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1320,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEUALA",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "5/7/2024",
   "mes_fecha": 5,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-07",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1321,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "BAHIA DE BANDERAS",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "BAHIA DE BANDERAS",
   "fecha_texto": "3/7/2024",
   "mes_fecha": 3,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-07",
   "anio_mes": "2024-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1324,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEPIC",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "8/20/2024",
   "mes_fecha": 8,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-20",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1325,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "TEPIC",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "TEPIC",
   "fecha_texto": "10/28/2024",
   "mes_fecha": 10,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-28",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1326,
   "edad": "11",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "SAN BLAS",
   "estado_notificacion": "JALISCO",
   "municipio_notificacion": "GUADALAJARA",
   "fecha_texto": "4/12/2024",
   "mes_fecha": 4,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-12",
   "anio_mes": "2024-04",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1328,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "JALA",
   "estado_notificacion": "NYARIT",
   "municipio_notificacion": "IXTLAN DEL RIO",
   "fecha_texto": "4/2/2024",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-02",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "10/27/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1335,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NAYARIT",
   "municipio_residencia": "JALA",
   "estado_notificacion": "NAYARIT",
   "municipio_notificacion": "IXTLAN DEL RIO",
   "fecha_texto": "1/24/2024",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-24",
   "anio_mes": "2024-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1339,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GENERAL ESCOBEDO",
   "fecha_texto": "10/28/2024",
   "mes_fecha": 10,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-28",
   "anio_mes": "2024-10",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1344,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "10/2/2024",
   "mes_fecha": 10,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-02",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1347,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "9/11/2024",
   "mes_fecha": 9,
   "dia_fecha": 11,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-11",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1350,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GARCIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "10/24/2024",
   "mes_fecha": 10,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-24",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1351,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "JUAREZ",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/28/2024",
   "mes_fecha": 5,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-28",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/22/2024",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1352,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "4/12/2024",
   "mes_fecha": 4,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-12",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1356,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "9/9/2024",
   "mes_fecha": 9,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-09",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1359,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "MONTERREY",
   "fecha_texto": "3/26/2024",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-26",
   "anio_mes": "2024-03",
   "institucion_notificacion": 4,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1366,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "10/28/2024",
   "mes_fecha": 10,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-28",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1367,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "PESQUERIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "8/21/2024",
   "mes_fecha": 8,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-21",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1371,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "CIENEGA DE FLORES",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "10/4/2024",
   "mes_fecha": 10,
   "dia_fecha": 4,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-04",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1374,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "8/15/2024",
   "mes_fecha": 8,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-15",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1376,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "9/2/2024",
   "mes_fecha": 9,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-02",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1377,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "GENERAL ESCOBEDO",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "9/19/2024",
   "mes_fecha": 9,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-19",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "9/2/2024",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1383,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "EL CARMEN",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "1/26/2024",
   "mes_fecha": 1,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-26",
   "anio_mes": "2024-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/4/2023",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1386,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "APODACA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "7/17/2024",
   "mes_fecha": 7,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-17",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "6/28/2024",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1387,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SALINAS VICTORIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "10/7/2024",
   "mes_fecha": 10,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-07",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1393,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "MONTERREY",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "7/18/2024",
   "mes_fecha": 7,
   "dia_fecha": 18,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-18",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/24/2024",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1397,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "NUEVO LEON",
   "municipio_residencia": "SALINAS VICTORIA",
   "estado_notificacion": "NUEVO LEON",
   "municipio_notificacion": "SAN NICOLAS DE LOS GARZA",
   "fecha_texto": "8/30/2024",
   "mes_fecha": 8,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-30",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1403,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "ZIMATLAN DE ALVAREZ",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN BARTOLO COYOTEPEC",
   "fecha_texto": "12/3/2024",
   "mes_fecha": 12,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-03",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "9/29/2024",
   "tipo_vacuna": "4",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1406,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SANTIAGO JUXTLAHUACA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SANTIAGO JUXTLAHUACA",
   "fecha_texto": "9/6/2024",
   "mes_fecha": 9,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-06",
   "anio_mes": "2024-09",
   "institucion_notificacion": 5,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "19/08/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1407,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "CORRAL DE PIEDRA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SANTIAGO JUXTLAHUACA",
   "fecha_texto": "11/27/2024",
   "mes_fecha": 11,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-27",
   "anio_mes": "2024-11",
   "institucion_notificacion": 5,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/26/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1410,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN JUAN BAUTISTA TUXTEPEC",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN JUAN BAUTISTA TUXTEPEC",
   "fecha_texto": "7/8/2024",
   "mes_fecha": 7,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-08",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "3/8/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1411,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN ANTONINO CASTILLO VELASCO",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN BARTOLO COYOTEPEC",
   "fecha_texto": "10/31/2024",
   "mes_fecha": 10,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-31",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "10/16/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1412,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "CUILAPAM DE GUERRERO",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "OAXACA DE JUAREZ",
   "fecha_texto": "12/2/2024",
   "mes_fecha": 12,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-02",
   "anio_mes": "2024-12",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "9/28/2024",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1413,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "CANDELARIA LOXICHA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "MIAHUATLAN",
   "fecha_texto": "12/14/2024",
   "mes_fecha": 12,
   "dia_fecha": 14,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-14",
   "anio_mes": "2024-12",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1414,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "CANDELARIA LOXICHA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "MIAHUATLAN",
   "fecha_texto": "12/14/2024",
   "mes_fecha": 12,
   "dia_fecha": 14,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-14",
   "anio_mes": "2024-12",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1415,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "CANDELARIA LOXICHA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "MIAHUATLAN",
   "fecha_texto": "12/14/2024",
   "mes_fecha": 12,
   "dia_fecha": 14,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-14",
   "anio_mes": "2024-12",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1416,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "CANDELARIA LOXICHA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "MIAHUATLAN",
   "fecha_texto": "12/14/2024",
   "mes_fecha": 12,
   "dia_fecha": 14,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-14",
   "anio_mes": "2024-12",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1417,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN MATEO RIO HONDO",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN BARTOLO COYOTEPEC",
   "fecha_texto": "7/26/2024",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-26",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1422,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "OAXACA",
   "municipio_residencia": "SAN ANTONIO HUITEPEC",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN BARTOLO COYOTEPEC",
   "fecha_texto": "11/13/2024",
   "mes_fecha": 11,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-13",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1424,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "PUEBLA",
   "estado_notificacion": "OAXACA",
   "municipio_notificacion": "SAN PEDRO MIXTEPEC",
   "fecha_texto": "8/5/2024",
   "mes_fecha": 8,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-05",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1425,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "CHICHIQUILA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "HUATUSCO",
   "fecha_texto": "12/15/2024",
   "mes_fecha": 12,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-15",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1426,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "QUIMIXTLAN",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "7/10/2024",
   "mes_fecha": 7,
   "dia_fecha": 10,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-10",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1430,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "PUEBLA",
   "municipio_residencia": "VENUSTIANO CARRANZA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "POZA RICA DE HGO",
   "fecha_texto": "1/8/2025",
   "mes_fecha": 1,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-08",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/17/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1435,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "HUIMILPAN",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "HUIMILPAN",
   "fecha_texto": "8/25/2024",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-25",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/14/2024",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1437,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "EL MARQUES",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "1/22/2024",
   "mes_fecha": 1,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-22",
   "anio_mes": "2024-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "1/26/2023",
   "tipo_vacuna": "3",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1448,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "12/26/2024",
   "mes_fecha": 12,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-26",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1453,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "AMEALCO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "11/6/2024",
   "mes_fecha": 11,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-06",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1457,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "PEDRO ESCOBEDO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "1/2/2025",
   "mes_fecha": 1,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-02",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "12/11/2024",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1459,
   "edad": "9",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "EL MARQUES",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "8/19/2024",
   "mes_fecha": 8,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-19",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1460,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "7/22/2024",
   "mes_fecha": 7,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-22",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "7/10/2024",
   "tipo_vacuna": "4",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1463,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUERETARO",
   "municipio_residencia": "QUERETARO",
   "estado_notificacion": "QUERETARO",
   "municipio_notificacion": "QUERETARO",
   "fecha_texto": "12/9/2025",
   "mes_fecha": 12,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-12-09",
   "anio_mes": "2025-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1468,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "8/30/2024",
   "mes_fecha": 8,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-30",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "6/21/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1495,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "FELIPE CARRILLO PUERTO",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "FELIPE CARRILLO PUERTO",
   "fecha_texto": "8/17/2024",
   "mes_fecha": 8,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-17",
   "anio_mes": "2024-08",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "6/25/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1496,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "FELIPE CARRILLO PUERTO",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "FELIPE CARRILLO PUERTO",
   "fecha_texto": "8/30/2024",
   "mes_fecha": 8,
   "dia_fecha": 30,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-30",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1507,
   "edad": "22",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "OTHON P. BLANCO",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "OTHON P. BLANCO",
   "fecha_texto": "11/28/2024",
   "mes_fecha": 11,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-28",
   "anio_mes": "2024-11",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "11/10/2022",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1512,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "SOLIDARIDAD",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "SOLIDARIDAD",
   "fecha_texto": "6/24/2024",
   "mes_fecha": 6,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-24",
   "anio_mes": "2024-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "2/21/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1513,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "SOLIDARIDAD",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "SOLIDARIDAD",
   "fecha_texto": "7/4/2024",
   "mes_fecha": 7,
   "dia_fecha": 4,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-04",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/10/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1516,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "7/6/2024",
   "mes_fecha": 7,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-06",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1517,
   "edad": "36",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "7/10/2024",
   "mes_fecha": 7,
   "dia_fecha": 10,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-10",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1522,
   "edad": "32",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "OTHON P. BLANCO",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "OTHON P. BLANCO",
   "fecha_texto": "7/11/2024",
   "mes_fecha": 7,
   "dia_fecha": 11,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-11",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "2/14/1993",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1532,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "SOLIDARIDAD",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "SOLIDARIDAD",
   "fecha_texto": "7/26/2024",
   "mes_fecha": 7,
   "dia_fecha": 26,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-26",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1539,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "8/15/2024",
   "mes_fecha": 8,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-15",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "7/12/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1544,
   "edad": "7",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "9/13/2024",
   "mes_fecha": 9,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-13",
   "anio_mes": "2024-09",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1546,
   "edad": "29",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "8/27/2024",
   "mes_fecha": 8,
   "dia_fecha": 27,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-27",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1548,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "SOLIDARIDAD",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "SOLIDARIDAD",
   "fecha_texto": "7/24/2024",
   "mes_fecha": 7,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-24",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1552,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "7/25/2024",
   "mes_fecha": 7,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-25",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "1/23/2018",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1553,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "BENITO JUAREZ",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "BENITO JUAREZ",
   "fecha_texto": "8/5/2024",
   "mes_fecha": 8,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-05",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "10/6/2015",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1558,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "SOLIDARIDAD",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "SOLIDARIDAD",
   "fecha_texto": "7/19/2024",
   "mes_fecha": 7,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-19",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1559,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "OTHON P. BLANCO",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "OTHON P. BLANCO",
   "fecha_texto": "11/28/2024",
   "mes_fecha": 11,
   "dia_fecha": 28,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-28",
   "anio_mes": "2024-11",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1561,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "OTHON P. BLANCO",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "OTHON P. BLANCO",
   "fecha_texto": "11/1/2024",
   "mes_fecha": 11,
   "dia_fecha": 1,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-01",
   "anio_mes": "2024-11",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1562,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "OTHON P. BLANCO",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "OTHON P. BLANCO",
   "fecha_texto": "11/7/2024",
   "mes_fecha": 11,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-07",
   "anio_mes": "2024-11",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "4/25/2022",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1563,
   "edad": "7",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "QUINTANA ROO",
   "municipio_residencia": "SOLIDARIDAD",
   "estado_notificacion": "QUINTANA ROO",
   "municipio_notificacion": "SOLIDARIDAD",
   "fecha_texto": "7/24/2024",
   "mes_fecha": 7,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-24",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/21/2021",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1577,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SALINAS",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSI",
   "fecha_texto": "1/17/2024",
   "mes_fecha": 1,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-17",
   "anio_mes": "2024-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1602,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "RAYON",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "RIOVERDE",
   "fecha_texto": "10/3/2024",
   "mes_fecha": 10,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-03",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1604,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "TIERRA NUEVA",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSÍ",
   "fecha_texto": "8/20/2024",
   "mes_fecha": 8,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-20",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1620,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SAN LUIS POTOSI",
   "municipio_residencia": "SDGS",
   "estado_notificacion": "SAN LUIS POTOSI",
   "municipio_notificacion": "SAN LUIS POTOSÍ",
   "fecha_texto": "8/25/2024",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-25",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1628,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULICAN",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "CULIACAN",
   "fecha_texto": "7/10/2024",
   "mes_fecha": 7,
   "dia_fecha": 10,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-10",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1648,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULIACAN",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "CULIACAN",
   "fecha_texto": "8/21/2024",
   "mes_fecha": 8,
   "dia_fecha": 21,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-21",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "12/20/2023",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1656,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULIACAN",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "CULIACAN",
   "fecha_texto": "8/22/2024",
   "mes_fecha": 8,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-22",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "20/012/2023",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1671,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "MOCORITO",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "CULIACAN",
   "fecha_texto": "7/4/2024",
   "mes_fecha": 7,
   "dia_fecha": 4,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-04",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/20/2024",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1679,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "NAVOLATO",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "NAVOLATO",
   "fecha_texto": "8/7/2024",
   "mes_fecha": 8,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-07",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "10/30/2024",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1682,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULIACAN",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "CULIACAN",
   "fecha_texto": "9/15/2024",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-15",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/22/2024",
   "tipo_vacuna": "1",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1688,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULIACAN",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "CULIACAN",
   "fecha_texto": "8/1/2024",
   "mes_fecha": 8,
   "dia_fecha": 1,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-01",
   "anio_mes": "2024-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1698,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULIACAN",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "CULIACAN",
   "fecha_texto": "5/19/2024",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-19",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "5/17/2024",
   "tipo_vacuna": "2",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1701,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULIACAN",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "CULIACAN",
   "fecha_texto": "7/29/2024",
   "mes_fecha": 7,
   "dia_fecha": 29,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-29",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1705,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "AHOME",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "AHOME",
   "fecha_texto": "11/12/2024",
   "mes_fecha": 11,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-12",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1717,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULIACAN",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "CULIACAN",
   "fecha_texto": "4/12/2024",
   "mes_fecha": 4,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-12",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1719,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SINALOA",
   "municipio_residencia": "CULIACAN",
   "estado_notificacion": "SINALOA",
   "municipio_notificacion": "CULIACAN",
   "fecha_texto": "12/17/2024",
   "mes_fecha": 12,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-17",
   "anio_mes": "2024-12",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1734,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "GUAYMAS",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "GUAYMAS",
   "fecha_texto": "7/9/2024",
   "mes_fecha": 7,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-09",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1735,
   "edad": "40",
   "grupo_edad": "40 - 44",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NOGALES",
   "fecha_texto": "7/5/2024",
   "mes_fecha": 7,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-05",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1736,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "11/11/2024",
   "mes_fecha": 11,
   "dia_fecha": 11,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-11",
   "anio_mes": "2024-11",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "24/06/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1747,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "AGUA PRIETA",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "10/23/2024",
   "mes_fecha": 10,
   "dia_fecha": 23,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-23",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1749,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "4/15/2024",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-15",
   "anio_mes": "2024-04",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1750,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "6/20/2024",
   "mes_fecha": 6,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-20",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1761,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "5/7/2024",
   "mes_fecha": 5,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-07",
   "anio_mes": "2024-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "07/04/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1765,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "7/16/2024",
   "mes_fecha": 7,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-16",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1767,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "5/15/2024",
   "mes_fecha": 5,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-15",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1774,
   "edad": "52",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "URES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "URES",
   "fecha_texto": "7/31/2024",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-31",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1777,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "5/16/2024",
   "mes_fecha": 5,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-16",
   "anio_mes": "2024-05",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "14/05/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1779,
   "edad": "18",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NOGALES",
   "fecha_texto": "7/5/2024",
   "mes_fecha": 7,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-05",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "0",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1785,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "HERMOSILLO",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "5/2/2024",
   "mes_fecha": 5,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-02",
   "anio_mes": "2024-05",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 7,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1790,
   "edad": "22",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "GUAYMAS",
   "estado_notificacion": "sonora",
   "municipio_notificacion": "Guaymas",
   "fecha_texto": "9/9/2024",
   "mes_fecha": 9,
   "dia_fecha": 9,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-09",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1795,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "NOGALES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "NOGALES",
   "fecha_texto": "6/20/2024",
   "mes_fecha": 6,
   "dia_fecha": 20,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-20",
   "anio_mes": "2024-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1796,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "URES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "HERMOSILLO",
   "fecha_texto": "7/6/2024",
   "mes_fecha": 7,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-06",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "6/5/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1797,
   "edad": "18",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "URES",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "URES",
   "fecha_texto": "7/31/2024",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-31",
   "anio_mes": "2024-07",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "16/02/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1800,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "4/29/2024",
   "mes_fecha": 4,
   "dia_fecha": 29,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-29",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1801,
   "edad": "48",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "SONORA",
   "municipio_residencia": "CAJEME",
   "estado_notificacion": "SONORA",
   "municipio_notificacion": "CAJEME",
   "fecha_texto": "5/16/2024",
   "mes_fecha": 5,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-16",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/16/2000",
   "tipo_vacuna": "1",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1811,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "CENTRO",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CENTRO",
   "fecha_texto": "9/7/2024",
   "mes_fecha": 9,
   "dia_fecha": 7,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-07",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/8/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1813,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "CÁRDENAS",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CENTRO",
   "fecha_texto": "4/2/2024",
   "mes_fecha": 4,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-02",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 1,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1814,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "JALPA DE MENDEZ",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CENTRO",
   "fecha_texto": "4/23/2024",
   "mes_fecha": 4,
   "dia_fecha": 23,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-23",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "4",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1815,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "JALPA DE MENDEZ",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CENTRO",
   "fecha_texto": "4/23/2024",
   "mes_fecha": 4,
   "dia_fecha": 23,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-23",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "4",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1822,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TABASCO",
   "municipio_residencia": "CÁRDENAS",
   "estado_notificacion": "TABASCO",
   "municipio_notificacion": "CÁRDENAS",
   "fecha_texto": "6/3/2024",
   "mes_fecha": 6,
   "dia_fecha": 3,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-03",
   "anio_mes": "2024-06",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1827,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "1/5/2024",
   "mes_fecha": 1,
   "dia_fecha": 5,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-05",
   "anio_mes": "2024-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1840,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "REYNOSA",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "REYNOSA",
   "fecha_texto": "2/2/2024",
   "mes_fecha": 2,
   "dia_fecha": 2,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-02",
   "anio_mes": "2024-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1841,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "TAMAULIPAS",
   "municipio_residencia": "EL MANTE",
   "estado_notificacion": "TAMAULIPAS",
   "municipio_notificacion": "EL MANTE",
   "fecha_texto": "1/24/2024",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-01-24",
   "anio_mes": "2024-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1/9/2024",
   "tipo_vacuna": "3",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1859,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "HUAMANTLA",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "HUAMANTLA",
   "fecha_texto": "3/6/2025",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-06",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1860,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "TLAXCALA",
   "municipio_residencia": "HUAMANTLA",
   "estado_notificacion": "TLAXCALA",
   "municipio_notificacion": "HUAMANTLA",
   "fecha_texto": "1/13/2025",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1861,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "LA PERLA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "RIO BLANCO",
   "fecha_texto": "6/12/2024",
   "mes_fecha": 6,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-12",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1863,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "MISANTLA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "10/12/2024",
   "mes_fecha": 10,
   "dia_fecha": 12,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-10-12",
   "anio_mes": "2024-10",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "9/3/2024",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1869,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "HUAYACOCOTLA",
   "estado_notificacion": "HIDALGO",
   "municipio_notificacion": "PACHUCA DE SOTO",
   "fecha_texto": "2/6/2024",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-02-06",
   "anio_mes": "2024-02",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "9/21/2023",
   "tipo_vacuna": "1",
   "complicaciones": 7,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1871,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "SOLEDAD DE DOBLADO",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "SOLEDAD DE DOBLADO",
   "fecha_texto": "11/22/2024",
   "mes_fecha": 11,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-22",
   "anio_mes": "2024-11",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1879,
   "edad": "31",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "XALAPA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "12/4/2024",
   "mes_fecha": 12,
   "dia_fecha": 4,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-04",
   "anio_mes": "2024-12",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1890,
   "edad": "27",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "XALAPA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "12/4/2024",
   "mes_fecha": 12,
   "dia_fecha": 4,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-04",
   "anio_mes": "2024-12",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1893,
   "edad": "44",
   "grupo_edad": "40 - 44",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "EMILIANO ZAPATA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "12/13/2024",
   "mes_fecha": 12,
   "dia_fecha": 13,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-12-13",
   "anio_mes": "2024-12",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1894,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "XALAPA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "XALAPA",
   "fecha_texto": "9/25/2024",
   "mes_fecha": 9,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-25",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1895,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "TLAQUILPA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "RIO BLANCO",
   "fecha_texto": "4/16/2024",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-04-16",
   "anio_mes": "2024-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1899,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "AMATITLAN",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "VERACRUZ",
   "fecha_texto": "6/25/2024",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-25",
   "anio_mes": "2024-06",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1910,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "VERACRUZ",
   "municipio_residencia": "SAN ANDRES TUXTLA",
   "estado_notificacion": "VERACRUZ",
   "municipio_notificacion": "SAN ANDRES TUXTLA",
   "fecha_texto": "1/17/2025",
   "mes_fecha": 1,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-17",
   "anio_mes": "2025-01",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1912,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "KANASIN",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "8/8/2024",
   "mes_fecha": 8,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-08",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "12/14/2012",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1914,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "5/23/2024",
   "mes_fecha": 5,
   "dia_fecha": 23,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-23",
   "anio_mes": "2024-05",
   "institucion_notificacion": 4,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/9/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1921,
   "edad": "44",
   "grupo_edad": "40 - 44",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "9/17/2024",
   "mes_fecha": 9,
   "dia_fecha": 17,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-17",
   "anio_mes": "2024-09",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1926,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "6/29/2024",
   "mes_fecha": 6,
   "dia_fecha": 29,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-06-29",
   "anio_mes": "2024-06",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1929,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MAYAPAN",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "3/16/2024",
   "mes_fecha": 3,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-16",
   "anio_mes": "2024-03",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1931,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "7/31/2024",
   "mes_fecha": 7,
   "dia_fecha": 31,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-07-31",
   "anio_mes": "2024-07",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/23/2016",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1932,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "9/11/2024",
   "mes_fecha": 9,
   "dia_fecha": 11,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-09-11",
   "anio_mes": "2024-09",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1943,
   "edad": "35",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "11/8/2024",
   "mes_fecha": 11,
   "dia_fecha": 8,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-11-08",
   "anio_mes": "2024-11",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 9,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1947,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "YUCATAN",
   "municipio_residencia": "MERIDA",
   "estado_notificacion": "YUCATAN",
   "municipio_notificacion": "MERIDA",
   "fecha_texto": "8/16/2024",
   "mes_fecha": 8,
   "dia_fecha": 16,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-08-16",
   "anio_mes": "2024-08",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "7/26/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1951,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "VILLA DE COS",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "ZACATECAS",
   "fecha_texto": "5/22/2024",
   "mes_fecha": 5,
   "dia_fecha": 22,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-22",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1953,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "GUADALUPE",
   "fecha_texto": "5/15/2024",
   "mes_fecha": 5,
   "dia_fecha": 15,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-05-15",
   "anio_mes": "2024-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2024,
   "fila_archivo": 1967,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "ZACATECAS",
   "municipio_residencia": "FRESNILLO",
   "estado_notificacion": "ZACATECAS",
   "municipio_notificacion": "FRESNILLO",
   "fecha_texto": "3/11/2024",
   "mes_fecha": 3,
   "dia_fecha": 11,
   "anio_fecha": 2024,
   "fecha_notificacion": "2024-03-11",
   "anio_mes": "2024-03",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 4,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/15/2025",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-15",
   "anio_mes": "2025-01",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 5,
   "edad": "29",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/15/2025",
   "mes_fecha": 1,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-15",
   "anio_mes": "2025-01",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 6,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/20/2025",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 11,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/24/2025",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-24",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 12,
   "edad": "19",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/24/2025",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-24",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 13,
   "edad": "43",
   "grupo_edad": "40 - 44",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/24/2025",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-24",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 14,
   "edad": "48",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/24/2025",
   "mes_fecha": 1,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-24",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 18,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "JESUS MARIA",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/28/2025",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-28",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 20,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "1/29/2025",
   "mes_fecha": 1,
   "dia_fecha": 29,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-29",
   "anio_mes": "2025-01",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 21,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "JESUS MARIA",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/6/2025",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-06",
   "anio_mes": "2025-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 22,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "JESUS MARIA",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/6/2025",
   "mes_fecha": 2,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-06",
   "anio_mes": "2025-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 24,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/10/2025",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/4/2025",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 25,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/10/2025",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "2/4/2025",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 26,
   "edad": "54",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/10/2025",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 27,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/11/2025",
   "mes_fecha": 2,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-11",
   "anio_mes": "2025-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 29,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/12/2025",
   "mes_fecha": 2,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-12",
   "anio_mes": "2025-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 30,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "CALVILLO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "CALVILLO",
   "fecha_texto": "2/13/2025",
   "mes_fecha": 2,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-13",
   "anio_mes": "2025-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 34,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "RINCON DE ROMOS",
   "fecha_texto": "2/19/2025",
   "mes_fecha": 2,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-19",
   "anio_mes": "2025-02",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1/15/2025",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 35,
   "edad": "13",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "RINCON DE ROMOS",
   "fecha_texto": "2/19/2025",
   "mes_fecha": 2,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-19",
   "anio_mes": "2025-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 36,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "RINCON DE ROMOS",
   "fecha_texto": "2/19/2025",
   "mes_fecha": 2,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-19",
   "anio_mes": "2025-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 40,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/26/2025",
   "mes_fecha": 2,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-26",
   "anio_mes": "2025-02",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 41,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/28/2025",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-28",
   "anio_mes": "2025-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 42,
   "edad": "13",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "2/28/2025",
   "mes_fecha": 2,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-28",
   "anio_mes": "2025-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 47,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "JESUS MARIA",
   "fecha_texto": "3/5/2025",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-05",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "1/21/2025",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 48,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "JESUS MARIA",
   "fecha_texto": "3/5/2025",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-05",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "5/30/2024",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 49,
   "edad": "41",
   "grupo_edad": "40 - 44",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "ASIENTOS",
   "fecha_texto": "3/5/2025",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-05",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 50,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "ASIENTOS",
   "fecha_texto": "3/5/2025",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-05",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "9/28/2023",
   "tipo_vacuna": "1, 2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 51,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "ASIENTOS",
   "fecha_texto": "3/5/2025",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-05",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 52,
   "edad": "22",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "RINCON DE ROMOS",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "ASIENTOS",
   "fecha_texto": "3/5/2025",
   "mes_fecha": 3,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-05",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 53,
   "edad": "39",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/6/2025",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-06",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 54,
   "edad": "12",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/6/2025",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-06",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 55,
   "edad": "67",
   "grupo_edad": "65 - 69",
   "demografia_edad": "MAYOR",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/6/2025",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-06",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 56,
   "edad": "86",
   "grupo_edad": "85 - 89",
   "demografia_edad": "MAYOR",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/6/2025",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-06",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 57,
   "edad": "38",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/6/2025",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-06",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 58,
   "edad": "49",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/6/2025",
   "mes_fecha": 3,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-06",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 61,
   "edad": "16",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/10/2025",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 62,
   "edad": "53",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/10/2025",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 64,
   "edad": "37",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/11/2025",
   "mes_fecha": 3,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-11",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 71,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/14/2025",
   "mes_fecha": 3,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-14",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 72,
   "edad": "32",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "JESUS MARIA",
   "fecha_texto": "3/14/2025",
   "mes_fecha": 3,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-14",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "5/28/1996",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 73,
   "edad": "36",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "JESUS MARIA",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "JESUS MARIA",
   "fecha_texto": "3/14/2025",
   "mes_fecha": 3,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-14",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 74,
   "edad": "27",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/14/2025",
   "mes_fecha": 3,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-14",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 75,
   "edad": "23",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/14/2025",
   "mes_fecha": 3,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-14",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 76,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/14/2025",
   "mes_fecha": 3,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-14",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 81,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/19/2025",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-19",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "3/8/2023",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 82,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/20/2025",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-20",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 83,
   "edad": "6",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/20/2025",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-20",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 84,
   "edad": "22",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/20/2025",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-20",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 85,
   "edad": "59",
   "grupo_edad": "55 - 59",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/18/2025",
   "mes_fecha": 3,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-18",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 86,
   "edad": "65",
   "grupo_edad": "65 - 69",
   "demografia_edad": "MAYOR",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/18/2025",
   "mes_fecha": 3,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-18",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 91,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/18/2025",
   "mes_fecha": 3,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-18",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "1/24/2025",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 92,
   "edad": "17",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/18/2025",
   "mes_fecha": 3,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-18",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 93,
   "edad": "19",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/18/2025",
   "mes_fecha": 3,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-18",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 94,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/19/2025",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-19",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 95,
   "edad": "37",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/19/2025",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-19",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 97,
   "edad": "36",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/19/2025",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-19",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "8/14/2025",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 98,
   "edad": "49",
   "grupo_edad": "45 - 49",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/19/2025",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-19",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 99,
   "edad": "37",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/19/2025",
   "mes_fecha": 3,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-19",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 100,
   "edad": "32",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/20/2025",
   "mes_fecha": 3,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-20",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "1/8/1900",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 103,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/21/2025",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-21",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 104,
   "edad": "52",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/21/2025",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-21",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 105,
   "edad": "25",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/21/2025",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-21",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "6",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 119,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/25/2025",
   "mes_fecha": 3,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-25",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 120,
   "edad": "16",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/25/2025",
   "mes_fecha": 3,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-25",
   "anio_mes": "2025-03",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 125,
   "edad": "23",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/25/2025",
   "mes_fecha": 3,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-25",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 134,
   "edad": "63",
   "grupo_edad": "60 - 64",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/28/2025",
   "mes_fecha": 3,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-28",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 135,
   "edad": "37",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "3/28/2025",
   "mes_fecha": 3,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-28",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 141,
   "edad": "69",
   "grupo_edad": "65 - 69",
   "demografia_edad": "MAYOR",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "JESUS MARIA",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "JESUS MARIA",
   "fecha_texto": "4/1/2025",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-01",
   "anio_mes": "2025-04",
   "institucion_notificacion": 1,
   "vacunado": 9,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 142,
   "edad": "66",
   "grupo_edad": "65 - 69",
   "demografia_edad": "MAYOR",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "JESUS MARIA",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "JESUS MARIA",
   "fecha_texto": "4/1/2025",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-01",
   "anio_mes": "2025-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "4/1/2025",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 143,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/1/2025",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-01",
   "anio_mes": "2025-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 144,
   "edad": "18",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/1/2025",
   "mes_fecha": 4,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-01",
   "anio_mes": "2025-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 149,
   "edad": "14",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/3/2025",
   "mes_fecha": 4,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-03",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 150,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/3/2025",
   "mes_fecha": 4,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-03",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 151,
   "edad": "8",
   "grupo_edad": "5 - 9",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/3/2025",
   "mes_fecha": 4,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-03",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 154,
   "edad": "58",
   "grupo_edad": "55 - 59",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/4/2025",
   "mes_fecha": 4,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-04",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 158,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/7/2025",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "1/26/2025",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 159,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/7/2025",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 168,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/10/2025",
   "mes_fecha": 4,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-10",
   "anio_mes": "2025-04",
   "institucion_notificacion": 3,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/28/2025",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 169,
   "edad": "27",
   "grupo_edad": "25 - 29",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/10/2025",
   "mes_fecha": 4,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-10",
   "anio_mes": "2025-04",
   "institucion_notificacion": 3,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "3",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 172,
   "edad": "14",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/11/2025",
   "mes_fecha": 4,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-11",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "5",
   "fecha_ultima_dosis": "2/22/2015",
   "tipo_vacuna": "1",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 173,
   "edad": "38",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/11/2025",
   "mes_fecha": 4,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-11",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 182,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "CALVILLO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "CALVILLO",
   "fecha_texto": "4/15/2025",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-15",
   "anio_mes": "2025-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 183,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "CALVILLO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "CALVILLO",
   "fecha_texto": "4/15/2025",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-15",
   "anio_mes": "2025-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 184,
   "edad": "13",
   "grupo_edad": "10 - 14",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "CALVILLO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "CALVILLO",
   "fecha_texto": "4/15/2025",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-15",
   "anio_mes": "2025-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 185,
   "edad": "73",
   "grupo_edad": "70 - 74",
   "demografia_edad": "MAYOR",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "CALVILLO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "CALVILLO",
   "fecha_texto": "4/15/2025",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-15",
   "anio_mes": "2025-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 186,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/15/2025",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-15",
   "anio_mes": "2025-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 187,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/15/2025",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-15",
   "anio_mes": "2025-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 188,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/15/2025",
   "mes_fecha": 4,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-15",
   "anio_mes": "2025-04",
   "institucion_notificacion": 4,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 191,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/16/2025",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-16",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 192,
   "edad": "34",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/16/2025",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-16",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 193,
   "edad": "30",
   "grupo_edad": "30 - 34",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/16/2025",
   "mes_fecha": 4,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-16",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 195,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "EL LLANO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/21/2025",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 196,
   "edad": "62",
   "grupo_edad": "60 - 64",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "EL LLANO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/21/2025",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 197,
   "edad": "3",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "CALVILLO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "CALVILLO",
   "fecha_texto": "4/21/2025",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": 1,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "9/20/2023",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 198,
   "edad": "63",
   "grupo_edad": "60 - 64",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "CALVILLO",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "CALVILLO",
   "fecha_texto": "4/21/2025",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 208,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "4/30/2025",
   "mes_fecha": 4,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-30",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "3",
   "fecha_ultima_dosis": "2/12/2025",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 217,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "5/19/2025",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 219,
   "edad": "55",
   "grupo_edad": "55 - 59",
   "demografia_edad": "ADULTO",
   "sexo": 1,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "JESUS MARIA",
   "fecha_texto": "5/22/2025",
   "mes_fecha": 5,
   "dia_fecha": 22,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-22",
   "anio_mes": "2025-05",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 220,
   "edad": "54",
   "grupo_edad": "50 - 54",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "JESUS MARIA",
   "fecha_texto": "5/22/2025",
   "mes_fecha": 5,
   "dia_fecha": 22,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-22",
   "anio_mes": "2025-05",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "9",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 229,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "8/8/2025",
   "mes_fecha": 8,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-08",
   "anio_mes": "2025-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 230,
   "edad": "39",
   "grupo_edad": "35 - 39",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "8/8/2025",
   "mes_fecha": 8,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-08",
   "anio_mes": "2025-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 231,
   "edad": "22",
   "grupo_edad": "20 - 24",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "AGUASCALIENTES",
   "municipio_residencia": "AGUASCALIENTES",
   "estado_notificacion": "AGUASCALIENTES",
   "municipio_notificacion": "AGUASCALIENTES",
   "fecha_texto": "8/8/2025",
   "mes_fecha": 8,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-08",
   "anio_mes": "2025-08",
   "institucion_notificacion": 1,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 235,
   "edad": "2",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "1/11/2025",
   "mes_fecha": 1,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-11",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "8/22/2022",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 240,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "1/17/2025",
   "mes_fecha": 1,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-17",
   "anio_mes": "2025-01",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 245,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "1/26/2025",
   "mes_fecha": 1,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-26",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 251,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "1/28/2025",
   "mes_fecha": 1,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-28",
   "anio_mes": "2025-01",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "11/20/2024",
   "tipo_vacuna": "4",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 257,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "2/4/2025",
   "mes_fecha": 2,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-04",
   "anio_mes": "2025-02",
   "institucion_notificacion": 2,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 1,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 264,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "2/11/2025",
   "mes_fecha": 2,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-11",
   "anio_mes": "2025-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 266,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "2/10/2025",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 287,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "2/23/2025",
   "mes_fecha": 2,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-23",
   "anio_mes": "2025-02",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 300,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "3/2/2025",
   "mes_fecha": 3,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-02",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 322,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "3/14/2025",
   "mes_fecha": 3,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-14",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 327,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "3/21/2025",
   "mes_fecha": 3,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-21",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 345,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "ENSENADA",
   "fecha_texto": "4/3/2025",
   "mes_fecha": 4,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-03",
   "anio_mes": "2025-04",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 352,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "4/5/2025",
   "mes_fecha": 4,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-05",
   "anio_mes": "2025-04",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 354,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TECATE",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TECATE",
   "fecha_texto": "4/4/2025",
   "mes_fecha": 4,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-04",
   "anio_mes": "2025-04",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 356,
   "edad": "18",
   "grupo_edad": "15 - 19",
   "demografia_edad": "ADULTO",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "4/10/2025",
   "mes_fecha": 4,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-10",
   "anio_mes": "2025-04",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 1,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 370,
   "edad": "4",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "3/26/2025",
   "mes_fecha": 3,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-26",
   "anio_mes": "2025-03",
   "institucion_notificacion": 2,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 2,
   "ev_etiqueta": "SANO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 372,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "5/12/2025",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "3/24/2025",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 381,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "5/29/2025",
   "mes_fecha": 5,
   "dia_fecha": 29,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-29",
   "anio_mes": "2025-05",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 384,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "5/29/2025",
   "mes_fecha": 5,
   "dia_fecha": 29,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-29",
   "anio_mes": "2025-05",
   "institucion_notificacion": 20,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 390,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "6/11/2025",
   "mes_fecha": 6,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-11",
   "anio_mes": "2025-06",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 391,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "6/16/2025",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": 20,
   "vacunado": 9,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "9",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 394,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "6/25/2025",
   "mes_fecha": 6,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-25",
   "anio_mes": "2025-06",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "2",
   "fecha_ultima_dosis": "6/12/2025",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 395,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 1,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "TIJUANA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "TIJUANA",
   "fecha_texto": "6/27/2025",
   "mes_fecha": 6,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-27",
   "anio_mes": "2025-06",
   "institucion_notificacion": 2,
   "vacunado": 1,
   "dosis_vacuna": "4",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 400,
   "edad": "1",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "ENSENADA",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "SAN QUINTIN",
   "fecha_texto": "7/8/2025",
   "mes_fecha": 7,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-08",
   "anio_mes": "2025-07",
   "institucion_notificacion": 5,
   "vacunado": 2,
   "dosis_vacuna": "0",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "5",
   "complicaciones": 2,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 401,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "JOVEN",
   "sexo": 2,
   "entidad_residencia": "BAJA CALIFORNIA",
   "municipio_residencia": "MEXICALI",
   "estado_notificacion": "BAJA CALIFORNIA",
   "municipio_notificacion": "MEXICALI",
   "fecha_texto": "7/14/2025",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": 20,
   "vacunado": 1,
   "dosis_vacuna": "1",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "2",
   "complicaciones": 1,
   "evolucion": 4,
   "ev_etiqueta": "HOSPITALIZADO",
   "clasificacion": "TOS FERINA",
   "tipo": "desagregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000000,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000001,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000002,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000003,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000004,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000005,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000006,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000007,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000008,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000009,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000010,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000011,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000012,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000013,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000014,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000015,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000016,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000017,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000018,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000019,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000020,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000021,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000022,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000023,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000024,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000025,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000026,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000027,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000028,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000029,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000030,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000031,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000032,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000033,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000034,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000035,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000036,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000037,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000038,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000039,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000040,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000041,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000042,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000043,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000044,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000045,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000046,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000047,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000048,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-10",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000049,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000050,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000051,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000052,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000053,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000054,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000055,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000056,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000057,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000058,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000059,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000060,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000061,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000062,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000063,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000064,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000065,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000066,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000067,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000068,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000069,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000070,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000071,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000072,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000073,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000074,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000075,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000076,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000077,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000078,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000079,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000080,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000081,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000082,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000083,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000084,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000085,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000086,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000087,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000088,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000089,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000090,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000091,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000092,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000093,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000094,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000095,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000096,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-10",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000097,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000098,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000099,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000100,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000101,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000102,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000103,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-13",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000104,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-20",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000105,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000106,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000107,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000108,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000109,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000110,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-10",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000111,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000112,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000113,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000114,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000115,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000116,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000117,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000118,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000119,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000120,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000121,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000122,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000123,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000124,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-01",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000125,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000126,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000127,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000128,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000129,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000130,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000131,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000132,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000133,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000134,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-22",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000135,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000136,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000137,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000138,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000139,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000140,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000141,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000142,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000143,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000144,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000145,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000146,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-22",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000147,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000148,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000149,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000150,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000151,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000152,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000153,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000154,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000155,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000156,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000157,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000158,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-01",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000159,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000160,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000161,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000162,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000163,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000164,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000165,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000166,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000167,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000168,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000169,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000170,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000171,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000172,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000173,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000174,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000175,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000176,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000177,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000178,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000179,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-22",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000180,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000181,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000182,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000183,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000184,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000185,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000186,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000187,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000188,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000189,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000190,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000191,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000192,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000193,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000194,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000195,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000196,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000197,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000198,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000199,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000200,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000201,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000202,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000203,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000204,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000205,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000206,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000207,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000208,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000209,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000210,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000211,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000212,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000213,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000214,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000215,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000216,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000217,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000218,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000219,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000220,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000221,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000222,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000223,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000224,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000225,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000226,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000227,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000228,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000229,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000230,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000231,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000232,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000233,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000234,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000235,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000236,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 29,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-29",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000237,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000238,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000239,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000240,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000241,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000242,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000243,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000244,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000245,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000246,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000247,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000248,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000249,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000250,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000251,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000252,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000253,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000254,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000255,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000256,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000257,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000258,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000259,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000260,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000261,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000262,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000263,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000264,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000265,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000266,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000267,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-22",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000268,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000269,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000270,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000271,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-01",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000272,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-01",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000273,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-01",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000274,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000275,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000276,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000277,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000278,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000279,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000280,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000281,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000282,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000283,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000284,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000285,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000286,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000287,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000288,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000289,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000290,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000291,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000292,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000293,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000294,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000295,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000296,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000297,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000298,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000299,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000300,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000301,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000302,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000303,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000304,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-22",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000305,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000306,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000307,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000308,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000309,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000310,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000311,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000312,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000313,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000314,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000315,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000316,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000317,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000318,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000319,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000320,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000321,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000322,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000323,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000324,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000325,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000326,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000327,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000328,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000329,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000330,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-01",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000331,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000332,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000333,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000334,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000335,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000336,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000337,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000338,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000339,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000340,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000341,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000342,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000343,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000344,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000345,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000346,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000347,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000348,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000349,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000350,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000351,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000352,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000353,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000354,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000355,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000356,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000357,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000358,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000359,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000360,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000361,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000362,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000363,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000364,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000365,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000366,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000367,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000368,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000369,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000370,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000371,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000372,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000373,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000374,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000375,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000376,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000377,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000378,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000379,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000380,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000381,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000382,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000383,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-27",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000384,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000385,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000386,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000387,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000388,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-01",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000389,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000390,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-01",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000391,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000392,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000393,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000394,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000395,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000396,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000397,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000398,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000399,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000400,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000401,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000402,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000403,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000404,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000405,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000406,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000407,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000408,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000409,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000410,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000411,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000412,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000413,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000414,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000415,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000416,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000417,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000418,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000419,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000420,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000421,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000422,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000423,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000424,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000425,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000426,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000427,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000428,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000429,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000430,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000431,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000432,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000433,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000434,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000435,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000436,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000437,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000438,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000439,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000440,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000441,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000442,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000443,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000444,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000445,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000446,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000447,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000448,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-01",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000449,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000450,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000451,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000452,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000453,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000454,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000455,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000456,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000457,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000458,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000459,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000460,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000461,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000462,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000463,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000464,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000465,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000466,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000467,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000468,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000469,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000470,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000471,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000472,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000473,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000474,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000475,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000476,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000477,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-03",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000478,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000479,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000480,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000481,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000482,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000483,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000484,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000485,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000486,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000487,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000488,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000489,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000490,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000491,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000492,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000493,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000494,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000495,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000496,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000497,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000498,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000499,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000500,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000501,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000502,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000503,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000504,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000505,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000506,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000507,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000508,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000509,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000510,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000511,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000512,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000513,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000514,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000515,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000516,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000517,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000518,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000519,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000520,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000521,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000522,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000523,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-01",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000524,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000525,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000526,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000527,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000528,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000529,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-27",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000530,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000531,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000532,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000533,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000534,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000535,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000536,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000537,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000538,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000539,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000540,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000541,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000542,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000543,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000544,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000545,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000546,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000547,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000548,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000549,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000550,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000551,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000552,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000553,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-22",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000554,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-22",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000555,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000556,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000557,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000558,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000559,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000560,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000561,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000562,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000563,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000564,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000565,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000566,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000567,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000568,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000569,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000570,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000571,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000572,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000573,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000574,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000575,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000576,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000577,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000578,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000579,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000580,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000581,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000582,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000583,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000584,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000585,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000586,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000587,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000588,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000589,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000590,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000591,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000592,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000593,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000594,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000595,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000596,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000597,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000598,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000599,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000600,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000601,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000602,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000603,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000604,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000605,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000606,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000607,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000608,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000609,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000610,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000611,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000612,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000613,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000614,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000615,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000616,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000617,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000618,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000619,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000620,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000621,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000622,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000623,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000624,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000625,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000626,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-27",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000627,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000628,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000629,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000630,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000631,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000632,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000633,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000634,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000635,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000636,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000637,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000638,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000639,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000640,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000641,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000642,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000643,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000644,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000645,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000646,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000647,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000648,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000649,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000650,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000651,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000652,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000653,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000654,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000655,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000656,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000657,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000658,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000659,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000660,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000661,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000662,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000663,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000664,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000665,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000666,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000667,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000668,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000669,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000670,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000671,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000672,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000673,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000674,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000675,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000676,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000677,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000678,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000679,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000680,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000681,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000682,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000683,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000684,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000685,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000686,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000687,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000688,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000689,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000690,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000691,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000692,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000693,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000694,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000695,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000696,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000697,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000698,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000699,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000700,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000701,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000702,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000703,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000704,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000705,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000706,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000707,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000708,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000709,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000710,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000711,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000712,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000713,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000714,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000715,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000716,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000717,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000718,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000719,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000720,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000721,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000722,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000723,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000724,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000725,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000726,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000727,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000728,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000729,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000730,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000731,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000732,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000733,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000734,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000735,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000736,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000737,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000738,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000739,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000740,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000741,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000742,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000743,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000744,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000745,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000746,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000747,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000748,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000749,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000750,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000751,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000752,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000753,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000754,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000755,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000756,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000757,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000758,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000759,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000760,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000761,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000762,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000763,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000764,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000765,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000766,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000767,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000768,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000769,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000770,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000771,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000772,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000773,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000774,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000775,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000776,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000777,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000778,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000779,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000780,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000781,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000782,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000783,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000784,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-10",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000785,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000786,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000787,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000788,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000789,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000790,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000791,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000792,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000793,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000794,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000795,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000796,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000797,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000798,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000799,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000800,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000801,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000802,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000803,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000804,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000805,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000806,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-13",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000807,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000808,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000809,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000810,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000811,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000812,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000813,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 29,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-29",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000814,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-03",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000815,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000816,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000817,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000818,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000819,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000820,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000821,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000822,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000823,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000824,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-03",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000825,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000826,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000827,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000828,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000829,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000830,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000831,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000832,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000833,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000834,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000835,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000836,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000837,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000838,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000839,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000840,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000841,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000842,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000843,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000844,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000845,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000846,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000847,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000848,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000849,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000850,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000851,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000852,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000853,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-27",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000854,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000855,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000856,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000857,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000858,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000859,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000860,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000861,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000862,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000863,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000864,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000865,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000866,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-27",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000867,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000868,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000869,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000870,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000871,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000872,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000873,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000874,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000875,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000876,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000877,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000878,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-01",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000879,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000880,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000881,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000882,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000883,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-22",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000884,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000885,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000886,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000887,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000888,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000889,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000890,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000891,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000892,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000893,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000894,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000895,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000896,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000897,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000898,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000899,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000900,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000901,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000902,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000903,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000904,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000905,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000906,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000907,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000908,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000909,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000910,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000911,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000912,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000913,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000914,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000915,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000916,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000917,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000918,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000919,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000920,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000921,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000922,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000923,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000924,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000925,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000926,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000927,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000928,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000929,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000930,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000931,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000932,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000933,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000934,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000935,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000936,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000937,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000938,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000939,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000940,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000941,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000942,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000943,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-01",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000944,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000945,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000946,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000947,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000948,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000949,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000950,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000951,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000952,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000953,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000954,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000955,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000956,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000957,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000958,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000959,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000960,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000961,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000962,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000963,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-13",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000964,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000965,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000966,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000967,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000968,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000969,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000970,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000971,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000972,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000973,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000974,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000975,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000976,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000977,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000978,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000979,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000980,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000981,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000982,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000983,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000984,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000985,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000986,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000987,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000988,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000989,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000990,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000991,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000992,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000993,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000994,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000995,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000996,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000997,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000998,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1000999,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001000,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001001,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001002,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001003,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001004,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001005,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001006,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001007,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001008,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001009,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001010,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001011,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001012,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001013,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001014,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001015,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001016,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001017,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001018,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001019,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001020,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001021,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001022,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001023,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001024,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001025,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001026,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001027,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001028,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001029,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001030,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001031,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001032,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-27",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001033,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-27",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001034,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-10",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001035,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001036,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001037,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001038,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001039,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001040,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001041,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001042,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001043,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001044,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001045,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001046,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001047,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001048,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001049,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001050,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001051,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001052,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001053,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001054,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001055,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001056,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001057,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001058,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001059,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001060,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001061,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001062,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001063,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001064,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001065,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001066,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001067,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001068,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001069,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001070,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001071,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001072,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001073,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001074,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001075,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001076,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001077,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001078,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001079,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001080,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001081,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001082,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001083,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001084,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001085,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001086,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001087,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001088,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001089,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001090,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001091,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001092,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001093,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001094,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001095,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001096,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001097,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001098,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001099,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001100,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001101,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001102,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001103,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001104,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001105,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001106,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001107,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001108,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001109,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001110,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001111,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001112,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001113,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001114,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001115,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001116,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001117,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001118,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-01",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001119,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001120,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001121,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001122,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001123,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001124,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001125,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001126,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-13",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001127,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-13",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001128,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-13",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001129,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001130,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001131,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001132,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001133,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001134,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001135,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001136,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001137,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001138,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001139,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001140,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001141,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001142,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001143,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001144,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001145,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-01",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001146,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001147,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001148,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001149,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001150,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001151,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001152,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001153,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001154,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001155,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001156,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001157,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001158,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001159,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001160,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001161,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001162,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001163,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001164,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001165,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-27",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001166,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-03",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001167,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-10",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001168,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001169,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001170,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001171,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001172,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001173,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-10",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001174,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001175,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001176,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001177,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-22",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001178,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001179,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001180,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001181,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001182,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001183,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001184,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001185,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001186,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001187,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001188,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001189,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001190,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001191,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001192,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001193,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001194,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001195,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001196,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-22",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001197,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 29,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-29",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001198,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001199,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001200,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001201,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001202,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001203,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001204,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001205,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001206,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001207,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001208,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 29,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-29",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001209,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001210,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001211,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001212,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001213,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001214,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001215,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001216,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001217,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001218,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001219,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001220,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001221,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001222,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001223,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001224,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001225,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001226,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001227,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001228,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001229,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001230,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001231,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001232,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001233,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001234,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001235,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001236,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001237,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001238,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001239,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001240,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001241,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001242,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001243,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-10",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001244,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001245,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001246,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001247,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001248,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001249,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001250,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001251,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001252,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001253,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001254,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001255,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001256,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001257,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001258,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001259,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001260,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001261,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001262,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001263,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001264,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001265,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001266,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001267,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001268,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001269,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001270,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001271,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001272,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001273,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001274,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001275,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001276,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001277,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001278,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001279,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001280,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001281,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001282,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001283,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001284,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001285,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001286,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001287,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001288,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001289,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001290,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001291,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001292,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-01",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001293,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001294,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001295,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001296,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001297,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001298,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001299,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001300,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001301,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001302,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001303,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001304,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001305,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001306,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001307,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001308,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001309,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001310,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001311,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001312,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001313,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001314,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001315,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001316,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001317,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001318,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001319,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001320,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001321,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001322,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001323,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001324,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001325,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001326,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001327,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001328,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001329,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001330,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001331,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001332,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001333,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001334,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001335,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001336,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001337,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001338,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001339,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001340,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001341,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001342,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001343,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001344,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001345,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001346,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001347,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001348,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001349,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001350,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001351,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001352,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-27",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001353,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001354,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001355,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001356,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001357,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001358,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001359,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001360,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001361,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001362,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001363,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001364,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001365,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001366,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001367,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001368,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001369,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001370,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001371,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001372,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001373,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001374,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001375,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001376,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001377,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001378,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001379,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001380,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001381,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001382,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001383,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001384,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001385,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001386,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001387,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001388,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001389,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001390,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001391,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001392,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001393,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001394,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001395,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001396,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001397,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001398,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001399,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001400,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001401,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001402,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001403,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001404,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001405,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001406,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001407,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001408,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001409,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001410,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001411,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001412,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-10",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001413,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001414,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-07",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001415,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001416,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001417,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001418,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001419,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001420,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001421,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001422,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001423,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001424,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001425,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001426,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 29,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-29",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001427,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001428,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001429,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001430,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001431,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001432,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001433,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001434,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001435,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001436,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001437,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001438,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001439,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001440,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001441,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001442,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001443,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001444,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001445,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001446,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001447,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001448,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 4,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-04",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001449,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001450,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001451,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001452,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001453,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001454,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001455,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001456,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001457,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001458,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001459,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001460,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001461,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001462,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001463,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001464,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001465,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001466,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001467,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001468,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001469,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001470,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001471,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001472,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001473,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001474,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001475,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001476,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001477,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001478,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001479,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001480,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 19,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-19",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001481,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001482,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001483,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 29,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-29",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001484,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001485,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001486,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001487,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001488,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001489,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001490,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001491,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001492,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001493,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001494,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001495,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001496,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001497,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001498,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001499,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 26,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-26",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001500,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001501,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-27",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001502,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001503,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001504,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001505,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001506,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001507,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001508,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001509,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001510,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001511,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001512,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 12,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-12",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001513,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001514,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001515,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001516,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001517,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001518,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001519,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001520,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001521,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001522,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001523,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001524,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001525,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-15",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001526,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-10",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001527,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001528,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-28",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001529,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001530,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-06",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001531,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001532,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001533,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-17",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001534,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001535,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001536,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001537,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001538,
   "edad": "60",
   "grupo_edad": "60 - 64",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001539,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001540,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001541,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-25",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001542,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-20",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001543,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001544,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001545,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001546,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-21",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001547,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001548,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 21,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-21",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001549,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-28",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001550,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-13",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001551,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001552,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 27,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-27",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001553,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001554,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001555,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 16,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-16",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001556,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-11",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001557,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001558,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001559,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001560,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001561,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001562,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001563,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001564,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-03",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001565,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 3,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-03",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001566,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001567,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001568,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 31,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-31",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001569,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001570,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001571,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001572,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001573,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 1,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-01",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001574,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 5,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-05",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001575,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001576,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-10",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001577,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001578,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001579,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 2,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-02",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001580,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 9,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-09",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001581,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001582,
   "edad": "15",
   "grupo_edad": "15 - 19",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-08",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001583,
   "edad": "50",
   "grupo_edad": "50 - 59",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 9,
   "dia_fecha": 22,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-09-22",
   "anio_mes": "2025-09",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001584,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-10",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001585,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001586,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001587,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001588,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001589,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001590,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001591,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 1,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-01-20",
   "anio_mes": "2025-01",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001592,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 30,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-30",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001593,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001594,
   "edad": "5",
   "grupo_edad": "5 - 9",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 7,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-07",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001595,
   "edad": "25",
   "grupo_edad": "25 - 44",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-10",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001596,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-10",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001597,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001598,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001599,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-14",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001600,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 14,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-14",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001601,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 10,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-10-06",
   "anio_mes": "2025-10",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001602,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-18",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001603,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-23",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001604,
   "edad": "45",
   "grupo_edad": "45 - 49",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 17,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-17",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001605,
   "edad": "10",
   "grupo_edad": "10 - 14",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001606,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 2,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-02-24",
   "anio_mes": "2025-02",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001607,
   "edad": "20",
   "grupo_edad": "20 - 24",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001608,
   "edad": "65",
   "grupo_edad": "> 65",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 3,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-03-24",
   "anio_mes": "2025-03",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": null,
   "ev_etiqueta": "",
   "clasificacion": "TOS FERINA",
   "tipo": "agregadodef"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001609,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 12,
   "dia_fecha": 28,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-12-28",
   "anio_mes": "2025-12",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001610,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-23",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001611,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-23",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001612,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-23",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001613,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-23",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001614,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-23",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001615,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-23",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001616,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-23",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001617,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-23",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001618,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 11,
   "dia_fecha": 23,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-11-23",
   "anio_mes": "2025-11",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001619,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-24",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001620,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 24,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-24",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001621,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 8,
   "dia_fecha": 10,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-08-10",
   "anio_mes": "2025-08",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001622,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 7,
   "dia_fecha": 20,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-07-20",
   "anio_mes": "2025-07",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001623,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-15",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001624,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 15,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-15",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001625,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 6,
   "dia_fecha": 8,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-06-08",
   "anio_mes": "2025-06",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001626,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-25",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001627,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 25,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-25",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001628,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-18",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001629,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 18,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-18",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001630,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-11",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001631,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-11",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001632,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 5,
   "dia_fecha": 11,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-05-11",
   "anio_mes": "2025-05",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001633,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-13",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001634,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-13",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001635,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 13,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-13",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001636,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001637,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001638,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001639,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001640,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001641,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001642,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001643,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001644,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001645,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001646,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001647,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001648,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001649,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001650,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001651,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001652,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001653,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001654,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001655,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001656,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001657,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001658,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001659,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001660,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001661,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 2,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001662,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001663,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001664,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001665,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001666,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001667,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001668,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001669,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001670,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001671,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001672,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001673,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001674,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001675,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001676,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001677,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001678,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001679,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 },
 {
   "anio": 2025,
   "fila_archivo": 1001680,
   "edad": "0",
   "grupo_edad": "< 5",
   "demografia_edad": "",
   "sexo": 1,
   "entidad_residencia": "",
   "municipio_residencia": "",
   "estado_notificacion": "",
   "municipio_notificacion": "",
   "fecha_texto": "",
   "mes_fecha": 4,
   "dia_fecha": 6,
   "anio_fecha": 2025,
   "fecha_notificacion": "2025-04-06",
   "anio_mes": "2025-04",
   "institucion_notificacion": null,
   "vacunado": null,
   "dosis_vacuna": "",
   "fecha_ultima_dosis": "",
   "tipo_vacuna": "",
   "complicaciones": null,
   "evolucion": 3,
   "ev_etiqueta": "DEFUNCION",
   "clasificacion": "TOS FERINA",
   "tipo": "agregado"
 }
];
  Data.getData = function () {
    return arreglo2025;
  };
})();
